import React, { useEffect, useState, useRef, useCallback, createElement, useMemo, Fragment, useContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import Container from '@material-ui/core/Container';
import LoadingIndicator from '@scoir/components-core/dist/components/LoadingIndicator';
import { EmptyStateWithAction } from '@scoir/empty-state';
import { faChevronDown, faTelescope, faMapMarkerAlt, faBook, faLightbulb, faFarm as faFarm$1, faElephant as faElephant$1, faCity as faCity$1, faDna as faDna$1, faBriefcase as faBriefcase$1, faFlask as faFlask$1, faBroadcastTower as faBroadcastTower$1, faRobot as faRobot$1, faUserHardHat as faUserHardHat$1, faBalanceScale as faBalanceScale$1, faLandmark as faLandmark$1, faTransporter as faTransporter$1, faLeaf as faLeaf$1, faSchool as faSchool$1, faCogs as faCogs$1, faBooks as faBooks$1, faSeedling as faSeedling$1, faPencilRuler as faPencilRuler$1, faUser as faUser$1, faComet as faComet$1, faHeartbeat as faHeartbeat$1, faHistory as faHistory$1, faNewspaper as faNewspaper$1, faLanguage as faLanguage$1, faGavel as faGavel$1, faMegaphone as faMegaphone$1, faCalculatorAlt as faCalculatorAlt$1, faStethoscope as faStethoscope$1, faShield as faShield$1, faMusic as faMusic$1, faUserNurse as faUserNurse$1, faHeadSideBrain as faHeadSideBrain$1, faAtom as faAtom$1, faPersonSign as faPersonSign$1, faBrain as faBrain$1, faPlaceOfWorship as faPlaceOfWorship$1, faMicroscope as faMicroscope$1, faHandsHeart as faHandsHeart$1, faUsers as faUsers$1, faRunning as faRunning$1, faPhoneLaptop as faPhoneLaptop$1, faCameraMovie as faCameraMovie$1, faTheaterMasks as faTheaterMasks$1, faCarBus as faCarBus$1, faPalette as faPalette$1, faUniversity as faUniversity$1, faHandHoldingSeedling as faHandHoldingSeedling$1, faPlanetMoon as faPlanetMoon$1, faCog as faCog$1, faPenNib as faPenNib$1, faStars as faStars$1, faUmbrellaBeach as faUmbrellaBeach$1, faWalking as faWalking$1, faHouse as faHouse$1, faTree as faTree$1, faHatChef as faHatChef$1, faUserShield as faUserShield$1, faPen as faPen$1, faSearch as faSearch$1, faTshirt as faTshirt$1, faLips as faLips$1, faCoffin as faCoffin$1, faPresentation as faPresentation$1, faChalkboard as faChalkboard$1, faDesktop as faDesktop$1, faUniversalAccess as faUniversalAccess$1, faUtensilsAlt as faUtensilsAlt$1, faBed as faBed$1, faDumbbell as faDumbbell$1, faMedkit as faMedkit$1, faVial as faVial$1, faPallet as faPallet$1, faHandshake as faHandshake$1, faPlay as faPlay$1, faGlobe as faGlobe$1, faCommentAltExclamation as faCommentAltExclamation$1, faCar as faCar$1, faPie as faPie$1, faSparkles as faSparkles$1, faChess as faChess$1, faAnchor as faAnchor$1, faCampground as faCampground$1, faHandScissors as faHandScissors$1, faPodium as faPodium$1, faPlane as faPlane$1, faGamepadAlt as faGamepadAlt$1, faChartLine as faChartLine$1, faSpinner as faSpinner$1, faMotorcycle as faMotorcycle$1, faGhost as faGhost$1, faRocket as faRocket$1, faHorseSaddle as faHorseSaddle$1, faUfo as faUfo$1, faAxe as faAxe$1, faPennant as faPennant$1, faFish as faFish$1, faMicrophone as faMicrophone$1, faMap as faMap$1, faImage as faImage$1, faShoppingBag as faShoppingBag$1, faMonkey as faMonkey$1, faDrum as faDrum$1, faListMusic as faListMusic$1, faChild as faChild$1, faLaugh as faLaugh$1, faGuitar as faGuitar$1, faSaxophone as faSaxophone$1, faCamera as faCamera$1, faUserHeadset as faUserHeadset$1, faViolin as faViolin$1, faTrumpet as faTrumpet$1, faPiano as faPiano$1, faBookOpen as faBookOpen$1, faRadio as faRadio$1, faSigma as faSigma$1, faAward as faAward$1, faHandHoldingUsd as faHandHoldingUsd$1, faGlobeStand as faGlobeStand$1, faHandsHelping as faHandsHelping$1, faChalkboardTeacher as faChalkboardTeacher$1, faPaw as faPaw$1, faVenusMars as faVenusMars$1, faHandHoldingHeart as faHandHoldingHeart$1, faRainbow as faRainbow$1, faHands as faHands$1, faComments as faComments$1, faPrayingHands as faPrayingHands$1, faMedal as faMedal$1, faBowArrow as faBowArrow$1, faShuttlecock as faShuttlecock$1, faBaseballBall as faBaseballBall$1, faBasketballBall as faBasketballBall$1, faVolleyballBall as faVolleyballBall$1, faBallPile as faBallPile$1, faBowlingPins as faBowlingPins$1, faBoxingGlove as faBoxingGlove$1, faStar as faStar$1, faWater as faWater$1, faCricket as faCricket$1, faBicycle as faBicycle$1, faCircle as faCircle$1, faSwimmer as faSwimmer$1, faSwords as faSwords$1, faFieldHockey as faFieldHockey$1, faSkating as faSkating$1, faFootballBall as faFootballBall$1, faGolfClub as faGolfClub$1, faFutbol as faFutbol$1, faHiking as faHiking$1, faHockeySticks as faHockeySticks$1, faBullseye as faBullseye$1, faSkiJump as faSkiJump$1, faQuidditch as faQuidditch$1, faRacquet as faRacquet$1, faHandRock as faHandRock$1, faSkiing as faSkiing$1, faParachuteBox as faParachuteBox$1, faSnowboarding as faSnowboarding$1, faBaseball as faBaseball$1, faTableTennis as faTableTennis$1, faTriangle as faTriangle$1, faSnowflake as faSnowflake$1, faFileVideo as faFileVideo$1, faMug as faMug$1, faPencil as faPencil$1, faPaintBrush as faPaintBrush$1, faFilm as faFilm$1, faFeather as faFeather$1, faPrint as faPrint$1, faCaretDown, faUserEdit, faTachometerSlowest as faTachometerSlowest$1, faTachometerSlow as faTachometerSlow$1, faTachometerAverage as faTachometerAverage$1, faTachometerFast as faTachometerFast$1, faTachometerFastest as faTachometerFastest$1, faVoteYea as faVoteYea$1, faMoonStars as faMoonStars$1, faBullseyeArrow as faBullseyeArrow$1, faSmile as faSmile$1, faSmileWink as faSmileWink$1, faPaperPlane as faPaperPlane$1, faBasketballHoop, faSkullCow, faFileCertificate as faFileCertificate$1, faDiploma as faDiploma$1, faRv as faRv$1, faPlaneDeparture as faPlaneDeparture$1, faCarBuilding as faCarBuilding$1, faTrees as faTrees$1, faFighterJet as faFighterJet$1, faShieldAlt as faShieldAlt$1, faSort } from '@fortawesome/pro-solid-svg-icons';
import cn from 'classnames';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faFarm, faElephant, faCity, faDna, faBriefcase, faFlask, faBroadcastTower, faRobot, faUserHardHat, faBalanceScale, faLandmark, faTransporter, faLeaf, faSchool, faCogs, faBooks, faSeedling, faBook as faBook$1, faPencilRuler, faUser, faComet, faHeartbeat, faHistory, faNewspaper, faLanguage, faGavel, faMegaphone, faCalculatorAlt, faStethoscope, faShield, faMusic, faUserNurse, faHeadSideBrain, faAtom, faPersonSign, faBrain, faPlaceOfWorship, faMicroscope, faHandsHeart, faUsers, faRunning, faPhoneLaptop, faCameraMovie, faTheaterMasks, faCarBus, faPalette, faUniversity, faHandHoldingSeedling, faPlanetMoon, faCog, faPenNib, faStars, faUmbrellaBeach, faWalking, faHouse, faTree, faHatChef, faUserShield, faPen, faSearch, faTshirt, faLips, faCoffin, faPresentation, faChalkboard, faDesktop, faUniversalAccess, faUtensilsAlt, faBed, faDumbbell, faMedkit, faVial, faPallet, faHandshake, faPlay, faGlobe, faCommentAltExclamation, faCar, faPie, faSparkles, faChess, faAnchor, faCampground, faHandScissors, faPodium, faPlane, faGamepadAlt, faLightbulb as faLightbulb$1, faChartLine, faSpinner, faMotorcycle, faTelescope as faTelescope$1, faGhost, faRocket, faHorseSaddle, faUfo, faAxe, faPennant, faFish, faMicrophone, faMap, faImage, faShoppingBag, faMonkey, faDrum, faListMusic, faChild, faLaugh, faGuitar, faSaxophone, faCamera, faUserHeadset, faViolin, faTrumpet, faPiano, faBookOpen, faRadio, faSigma, faAward, faHandHoldingUsd, faGlobeStand, faHandsHelping, faChalkboardTeacher, faPaw, faVenusMars, faHandHoldingHeart, faRainbow, faHands, faComments, faPrayingHands, faMedal, faBowArrow, faShuttlecock, faBaseballBall, faBasketballBall, faVolleyballBall, faBallPile, faBowlingPins, faBoxingGlove, faStar, faWater, faCricket, faBicycle, faCircle, faSwimmer, faSwords, faFieldHockey, faSkating, faFootballBall, faGolfClub, faFutbol, faHiking, faHockeySticks, faBullseye, faSkiJump, faQuidditch, faRacquet, faHandRock, faSkiing, faParachuteBox, faSnowboarding, faBaseball, faTableTennis, faTriangle, faSnowflake, faFileVideo, faMug, faPencil, faPaintBrush, faFilm, faFeather, faPrint, faTachometerSlowest, faTachometerSlow, faTachometerAverage, faTachometerFast, faTachometerFastest, faVoteYea, faMoonStars, faBullseyeArrow, faSmile, faSmileWink, faPaperPlane, faPlus, faFileCertificate, faDiploma, faMapMarkerAlt as faMapMarkerAlt$1, faRv, faPlaneDeparture, faCarBuilding, faTrees, faFlagUsa, faFighterJet, faShieldAlt } from '@fortawesome/pro-regular-svg-icons';
import without from 'lodash/without';
import get from 'lodash/get';
import size from 'lodash/size';
import remove from 'lodash/remove';
import isObject from 'lodash/isObject';
import isArray from 'lodash/isArray';
import isUndefined from 'lodash/isUndefined';
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';
import _extends from '@babel/runtime/helpers/extends';
import defaultTo from 'lodash/defaultTo';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import { jsx, jsxs, Fragment as Fragment$1 } from 'react/jsx-runtime';
import { isEmpty as isEmpty$1, get as get$1, size as size$1, head as head$1, isUndefined as isUndefined$1, isNumber as isNumber$1, map as map$1, filter as filter$1, includes as includes$1, isArray as isArray$1, forEach as forEach$1, isString as isString$1, some as some$1, remove as remove$1, isEqual as isEqual$1, keyBy as keyBy$1, orderBy, min, max, sortBy, without as without$1, every, mapKeys, uniq as uniq$1, union, concat, reduce as reduce$1, isNull as isNull$1, noop as noop$1, intersection as intersection$1, reject as reject$1 } from 'lodash';
import map from 'lodash/map';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import noop from 'lodash/noop';
import forEach from 'lodash/forEach';
import Box from '@material-ui/core/Box';
import Chip$1 from '@material-ui/core/Chip';
import { Autocomplete } from '@material-ui/lab';
import { TextField, Typography as Typography$1, CardHeader, Grid as Grid$1, Box as Box$1, CardContent, Divider as Divider$1, Card as Card$1, Collapse as Collapse$1, Button as Button$1, ListSubheader as ListSubheader$1, ListItem as ListItem$1, Chip as Chip$2, List as List$1, Checkbox as Checkbox$1, Paper } from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Divider from '@material-ui/core/Divider';
import isEqual from 'lodash/isEqual';
import includes from 'lodash/includes';
import intersection from 'lodash/intersection';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import head from 'lodash/head';
import produce from 'immer';
import keyBy from 'lodash/keyBy';
import findIndex from 'lodash/findIndex';
import update from '@scoir/immutability';
import reduce from 'lodash/reduce';
import isString from 'lodash/isString';
import take from 'lodash/take';
import trim from 'lodash/trim';
import ToggleBox from '@scoir/components-core/dist/components/ToggleBox';
import Card from '@material-ui/core/Card';
import filter from 'lodash/filter';
import some from 'lodash/some';
import InfiniteScroll from '@scoir/components-core/dist/components/InfiniteScroll';
import { Link } from 'react-router-dom';
import Popover from '@material-ui/core/Popover';
import { Pill } from '@scoir/pills';
import CollegeCrest from '@scoir/college-crest';
import SvgIcon from '@material-ui/core/SvgIcon';
import { Info } from '@scoir/tooltips';
import IconButton from '@material-ui/core/IconButton';
import { faTimes as faTimes$1 } from '@fortawesome/pro-light-svg-icons';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import mapValues from 'lodash/mapValues';
import omitBy from 'lodash/omitBy';
import flatten from 'lodash/flatten';
import reject from 'lodash/reject';
import toString from 'lodash/toString';
import pick from 'lodash/pick';
import uniq from 'lodash/uniq';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import each from 'lodash/each';
import camelCase from 'lodash/camelCase';
import slice from 'lodash/slice';
import CloseIcon from '@material-ui/icons/Close';
import pull from 'lodash/pull';
import uniqBy from 'lodash/uniqBy';
import { ControlledAutocomplete } from '@scoir/autocomplete';
import isNull from 'lodash/isNull';
import times from 'lodash/times';
import random from 'lodash/random';
import Skeleton from '@material-ui/lab/Skeleton';
import { useGranularEffect } from 'granular-hooks';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Switch from '@material-ui/core/Switch';
import { regions, statesByAbbrev, states as states$1 } from '@scoir/states';
import sortBy$1 from 'lodash/sortBy';
import { SectionTitle } from '@scoir/headers';
import omit from 'lodash/omit';
import Toolbar from '@material-ui/core/Toolbar';
import { ScrollHideAppBar } from '@scoir/tabs';
import Avatar from '@scoir/avatar';
import Tooltip from '@material-ui/core/Tooltip';
import { DismissibleDialog } from '@scoir/modals';
import Badge from '@material-ui/core/Badge';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Backdrop from '@material-ui/core/Backdrop';
import Pagination from '@material-ui/lab/Pagination';
import CircularProgress from '@material-ui/core/CircularProgress';

class CollapsableRailSearch extends React.Component {
  static propTypes = {
    railContent: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired
  };
  state = {
    isResponsiveSidebarToggled: false
  };
  toggleResponsiveSidebar() {
    this.setState({
      isResponsiveSidebarToggled: !this.state.isResponsiveSidebarToggled
    });
  }
  render() {
    const {
      isResponsiveSidebarToggled
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      className: "rcsc-collapsable-rail-search-comp"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rcsc-responsive-filter-toggle-container"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      className: cn('rcsc-responsive-rail-toggle-btn', {
        'rcsc-show-responsive-scrim': isResponsiveSidebarToggled
      }),
      onClick: () => this.toggleResponsiveSidebar(),
      startIcon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        size: "sm",
        fixedWidth: true,
        icon: faBars
      })
    }, "Filters")), /*#__PURE__*/React.createElement("div", {
      className: cn('rcsc-college-search-wrapper', {
        'rcsc-responsive-sidebar-hidden': !isResponsiveSidebarToggled
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "rcsc-college-search-rail-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rcsc-college-search-rail"
    }, /*#__PURE__*/React.createElement("div", {
      className: "rcsc-responsive-rail-toggle-container"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      color: "primary",
      className: "rcsc-responsive-rail-toggle-btn",
      onClick: () => this.toggleResponsiveSidebar(),
      startIcon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        size: "sm",
        fixedWidth: true,
        icon: faTimes
      })
    }, "Close")), this.props.railContent)), /*#__PURE__*/React.createElement("div", {
      className: "rcsc-results-container"
    }, this.props.children)));
  }
}

const useDebouncedEffect = (effect, deps, delay) => {
  const dependencies = defaultTo(deps, []);
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);
    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencies, delay]);
};

const withScaleUnit = (value, units) => {
  if (!isUndefined(units)) {
    return `${value}${units}`;
  }
  return value;
};
const RangeSlider = _ref => {
  let {
    defaultMinValue,
    defaultMaxValue,
    rangeMin,
    rangeMax,
    infoId,
    units,
    canValuesExceedDisplayedMax,
    onUpdateRange,
    stepValue,
    disabled
  } = _ref;
  const [value, setValue] = useState([defaultMinValue || rangeMin, defaultMaxValue || rangeMax]);
  useDebouncedEffect(() => {
    onUpdateRange(value[0], value[1]);
  }, [value], 250);
  const getMaxValueDisplay = (maxValue, units) => {
    if (canValuesExceedDisplayedMax && maxValue === rangeMax) {
      return `${withScaleUnit(Math.round(maxValue), units)}+`;
    }
    return withScaleUnit(Math.round(maxValue), units);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    id: infoId
  }, withScaleUnit(Math.round(value[0]), units), /*#__PURE__*/React.createElement(Typography, {
    variant: "srOnly"
  }, " to"), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, " - "), getMaxValueDisplay(value[1], units)), /*#__PURE__*/React.createElement(Slider, {
    disabled: disabled,
    "aria-labelledby": infoId,
    max: rangeMax,
    min: rangeMin,
    step: stepValue,
    value: value,
    onChange: (event, newValue) => setValue(newValue)
  }));
};
RangeSlider.propTypes = {
  infoId: PropTypes.string.isRequired,
  rangeMin: PropTypes.number,
  rangeMax: PropTypes.number.isRequired,
  stepValue: PropTypes.number,
  onUpdateRange: PropTypes.func.isRequired,
  canValuesExceedDisplayedMax: PropTypes.bool,
  defaultMinValue: PropTypes.number,
  defaultMaxValue: PropTypes.number,
  units: PropTypes.string,
  disabled: PropTypes.bool
};
RangeSlider.defaultProps = {
  rangeMin: 0,
  stepValue: 1,
  canValuesExceedDisplayedMax: false
};

const MIN_SAT = 0;
const MAX_SAT = 1600;
class SATRangeSlider extends React.Component {
  static propTypes = {
    defaultMaxValue: RangeSlider.propTypes.defaultMaxValue,
    defaultMinValue: RangeSlider.propTypes.defaultMinValue,
    onUpdateRange: RangeSlider.propTypes.onUpdateRange
  };
  static defaultProps = {
    defaultMinValue: MIN_SAT,
    defaultMaxValue: MAX_SAT
  };
  render() {
    return /*#__PURE__*/React.createElement(RangeSlider, _extends({
      infoId: "sat-range-slider"
    }, this.props, {
      rangeMax: MAX_SAT,
      stepValue: 50
    }));
  }
}

const MIN_ACT = 0;
const MAX_ACT = 36;
class ACTRangeSlider extends React.Component {
  static propTypes = {
    defaultMaxValue: RangeSlider.propTypes.defaultMaxValue,
    defaultMinValue: RangeSlider.propTypes.defaultMinValue,
    onUpdateRange: RangeSlider.propTypes.onUpdateRange
  };
  static defaultProps = {
    defaultMinValue: MIN_ACT,
    defaultMaxValue: MAX_ACT
  };
  render() {
    return /*#__PURE__*/React.createElement(RangeSlider, _extends({
      infoId: "distance-range-slider"
    }, this.props, {
      rangeMax: MAX_ACT
    }));
  }
}

const MIN_ACCEPTANCE_RATE = 0;
const MAX_ACCEPTANCE_RATE = 100;
class AcceptanceRateSlider extends React.Component {
  static propTypes = {
    defaultMaxValue: RangeSlider.propTypes.defaultMaxValue,
    defaultMinValue: RangeSlider.propTypes.defaultMinValue,
    onUpdateRange: RangeSlider.propTypes.onUpdateRange
  };
  static defaultProps = {
    defaultMinValue: MIN_ACCEPTANCE_RATE,
    defaultMaxValue: MAX_ACCEPTANCE_RATE
  };
  render() {
    return /*#__PURE__*/React.createElement(RangeSlider, _extends({
      infoId: "acceptance-range-slider"
    }, this.props, {
      rangeMax: MAX_ACCEPTANCE_RATE,
      stepValue: 10,
      units: "%"
    }));
  }
}

const updateArrayOfObjects = (array, value) => {
  const byLabel = item => item.label === value.label;
  const shouldAddToArray = !value.isChecked && array.filter(byLabel).length === 0;
  if (shouldAddToArray) {
    return [...array, value];
  } else {
    const newValues = [...array];
    remove(newValues, byLabel);
    return size(newValues) === 0 ? undefined : newValues;
  }
};
const updateArray = function () {
  let array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let value = arguments.length > 1 ? arguments[1] : undefined;
  const isObj = isObject(value) && !isArray(value);
  if (isObj) {
    return updateArrayOfObjects(array, value);
  } else if (array.includes(value)) {
    const filteredArr = without(array, value);
    return isEmpty(filteredArr) ? undefined : filteredArr;
  }
  return [...array, value];
};
const undergradEnrollUpdateArray = function () {
  let array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let value = arguments.length > 1 ? arguments[1] : undefined;
  const undergradArray = updateArray(array, value);
  const newUndergradArray = undergradArray && undergradArray.map(item => ({
    label: item.label,
    from: item.from.toString(),
    to: item.to.toString()
  }));
  return newUndergradArray;
};
const updateSports = (currentValue, selectedValue) => {
  const currentStr = isArray(currentValue) ? JSON.stringify(currentValue[0]) : JSON.stringify(currentValue);
  const selectedStr = JSON.stringify(selectedValue);
  if (currentStr === selectedStr) {
    return undefined;
  }
  return selectedValue;
};
const updateRange = (array, range) => {
  const from = get(range, 'from');
  const to = get(range, 'to');
  if (isNumber(from) && isNumber(to)) {
    range.from = from.toString();
    range.to = to.toString();
    return [range];
  }
  return undefined;
};
const updateACTAvg = (array, range) => {
  const isMin = get(range, 'from') === MIN_ACT;
  const isMax = get(range, 'to') === MAX_ACT;
  return isMin && isMax ? undefined : updateRange(array, range);
};
const updateSATAvg = (array, range) => {
  const isMin = get(range, 'from') === MIN_SAT;
  const isMax = get(range, 'to') === MAX_SAT;
  return isMin && isMax ? undefined : updateRange(array, range);
};
const updateSelectivity = (array, range) => {
  const isMin = get(range, 'from') === MIN_ACCEPTANCE_RATE;
  const isMax = get(range, 'to') === MAX_ACCEPTANCE_RATE;
  return isMin && isMax ? undefined : updateRange(array, range);
};
const updateLocation = function () {
  let array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let location = arguments.length > 1 ? arguments[1] : undefined;
  const nameHasChanged = get(location, 'name') !== get(array[0], 'name');
  const fromHasChanged = get(location, 'from') !== get(array[0], 'from');
  const toHasChanged = get(location, 'to') !== get(array[0], 'to');
  const shouldRemove = isUndefined(location) || !nameHasChanged && !fromHasChanged && !toHasChanged;
  return shouldRemove ? undefined : [location];
};
const updateFilter = {
  Tags: updateArray,
  Majors: updateArray,
  AcademicFocus: updateArray,
  State: updateArray,
  Setting: updateArray,
  Rotc: updateArray,
  TestOptional: updateArray,
  ApplicationMethod: updateArray,
  Religious: updateArray,
  MinorityServingInst: updateArray,
  Degrees: updateArray,
  UnivType: updateArray,
  SchoolClassifier: updateArray,
  Control: updateArray,
  LocationCategory: updateArray,
  Location: updateLocation,
  UnderGradEnroll: undergradEnrollUpdateArray,
  Sports: updateSports,
  ACTAvg: updateACTAvg,
  SATAvg: updateSATAvg,
  Selectivity: updateSelectivity,
  ScoirApplyApplicantTypes: updateArray,
  CoalitionMember: updateArray
};
const updateQuery = function () {
  let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let name = arguments.length > 1 ? arguments[1] : undefined;
  let value = arguments.length > 2 ? arguments[2] : undefined;
  const modifier = updateFilter[name];
  const currentValue = query[name];
  const output = {
    ...query,
    [name]: modifier(currentValue, value)
  };
  return pickBy(output, identity);
};
const getDefaultQuery = () => ({
  LocationCategory: ['Domestic'],
  Degrees: ['Bachelors']
});

const useStyles$u = makeStyles(theme => ({
  icon: {
    minWidth: theme.spacing(4)
  },
  indented: {
    padding: '8px 32px 8px 32px'
  }
}));
const getId = (idx, option) => {
  const title = get(option, 'title', '').toLowerCase().replace(/ /g, '-');
  return `label-checklist-${idx}-${title}`;
};

/**
 * This is the checklist for search filters
 * @prop {string} title
 * @prop {string} subtitle
 * @prop {array} options
 * @prop {bool} isTwoColumnAtSm
 * @prop {func} onSelect
 * @returns checklist Component
 */
const Checklist = _ref => {
  let {
    title = '',
    subtitle,
    options,
    isTwoColumnAtSm = true,
    indented,
    onSelect,
    listSubheaderProps,
    spacing = 1
  } = _ref;
  const classes = useStyles$u();
  return isEmpty(options) ? null : /*#__PURE__*/React.createElement(List, {
    dense: true
  }, title && /*#__PURE__*/React.createElement(ListSubheader, _extends({
    role: "sectionhead",
    disableSticky: true,
    disableGutters: true
  }, listSubheaderProps), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    color: "textPrimary"
  }, title), subtitle && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, subtitle)), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: spacing
  }, map(options, (option, idx) => {
    const labelId = getId(idx, option);
    const optionTitle = get(option, 'title');
    const optionSubtitle = get(option, 'subtitle');
    const optionValue = get(option, 'value');
    const isChecked = get(option, 'checked');
    const isDisabled = get(option, 'disabled', false);
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: isTwoColumnAtSm ? 6 : 12,
      key: idx
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ListItem, {
      role: "listitem",
      dense: true,
      button: true,
      "aria-label": `${isChecked ? 'Selected:' : 'Not Selected:'} ${optionTitle}`,
      onClick: () => !isDisabled && onSelect(optionValue, option),
      className: cn({
        [classes.indented]: indented
      })
    }, /*#__PURE__*/React.createElement(ListItemIcon, {
      className: isTwoColumnAtSm ? classes.icon : undefined
    }, /*#__PURE__*/React.createElement(Checkbox, {
      edge: "start",
      color: "primary",
      checked: isChecked,
      tabIndex: -1,
      disabled: isDisabled,
      disableRipple: true,
      inputProps: {
        'aria-labelledby': labelId
      }
    })), /*#__PURE__*/React.createElement(ListItemText, {
      id: labelId,
      primary: /*#__PURE__*/React.createElement(Typography, {
        variant: "body1"
      }, optionTitle),
      secondary: optionSubtitle
    }))));
  })));
};
Checklist.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.any,
  isTwoColumnAtSm: PropTypes.bool,
  indented: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    value: PropTypes.any,
    checked: PropTypes.bool,
    disabled: PropTypes.bool
  })),
  onSelect: PropTypes.func.isRequired,
  listSubheaderProps: PropTypes.object,
  listItemProps: PropTypes.object,
  spacing: PropTypes.number
};

const useStyles$t = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    height: '100%'
  },
  label: {
    whiteSpace: 'normal'
  }
}));
const Chip = _ref => {
  let {
    label,
    ...rest
  } = _ref;
  const classes = useStyles$t();
  return /*#__PURE__*/React.createElement(Chip$1, _extends({}, rest, {
    className: classes.root,
    label: /*#__PURE__*/React.createElement(Typography, {
      className: classes.label
    }, label),
    clickable: false,
    size: "small"
  }));
};
Chip.propTypes = {
  label: PropTypes.string
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const SimpleAutocomplete = (_a) => {
    var { onSearch, onChange, label, inputProps, clearOnSelect, labelKey = 'name', helperText, defaultValue = '' } = _a, rest = __rest(_a, ["onSearch", "onChange", "label", "inputProps", "clearOnSelect", "labelKey", "helperText", "defaultValue"]);
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState(defaultValue);
    const key = useRef(0);
    const handleSearch = useCallback((value) => {
        setInputValue(value);
        if (isEmpty$1(value)) {
            setOptions([]);
        }
        else {
            onSearch(value).then((res) => setOptions(res));
        }
    }, [onSearch]);
    const onSelect = useCallback((val) => {
        if (clearOnSelect || val === null) {
            key.current++;
            setInputValue('');
            setOptions([]);
        }
        else {
            setInputValue(val[labelKey]);
        }
        onChange(val, inputValue);
    }, [inputValue, labelKey, clearOnSelect, onChange]);
    return (createElement(Autocomplete, Object.assign({}, rest, { key: String(key.current), disablePortal: true, options: options, onChange: (e, val, type) => type === 'select-option' && onSelect(val), noOptionsText: "No matches found.", inputValue: inputValue, freeSolo: true, clearOnBlur: false, onInputChange: (e, val, type) => {
            if (type === 'input') {
                handleSearch(val);
            }
            else if (type === 'clear') {
                onSelect(null);
            }
        }, getOptionLabel: (option) => get$1(option, labelKey, ''), renderInput: (params) => (jsx(TextField, Object.assign({}, params, { helperText: helperText, autoFocus: key.current > 0, inputProps: Object.assign(Object.assign({}, params.inputProps), inputProps), label: label, variant: "outlined" }))) })));
};

const useStyles$s = makeStyles(theme => ({
  toggleButton: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  bold: {
    fontWeight: 'bold'
  },
  previousIcon: {
    marginRight: theme.spacing(1)
  },
  tagWrapper: {
    maxHeight: '300px',
    overflow: 'scroll'
  },
  checkboxItem: {
    paddingTop: 0,
    paddingBottom: 0
  },
  checkboxLabel: {
    margin: 0
  },
  numSelected: {
    display: 'inline-block',
    marginRight: theme.spacing(0.5)
  },
  selectedInfo: {
    fontWeight: 'normal',
    fontStyle: 'italic',
    color: get(theme, 'palette.text.disabled')
  }
}));
const Categories$2 = _ref => {
  let {
    onChange,
    categories,
    selectedInterests
  } = _ref;
  const classes = useStyles$s();
  const [openCategory, setOpenCategory] = useState();
  const handleToggle = newCategory => {
    isEqual(newCategory, openCategory) ? setOpenCategory(undefined) : setOpenCategory(newCategory);
  };
  return /*#__PURE__*/React.createElement(List, {
    className: "category-explorer",
    dense: true
  }, map(categories, item => {
    const numSelected = size(intersection(selectedInterests, item.Tags));
    const hasSelections = numSelected > 0;
    const hasOpenCategory = isEqual(openCategory, item.Category);
    if (!openCategory || hasOpenCategory) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: item.Category
      }, /*#__PURE__*/React.createElement(ListItem, {
        button: true,
        className: classes.toggleButton,
        onClick: () => handleToggle(item.Category)
      }, /*#__PURE__*/React.createElement(Box, {
        display: "flex",
        alignItems: "center"
      }, openCategory && /*#__PURE__*/React.createElement(ChevronLeftIcon, {
        className: cn(classes.previousIcon, classes.icon),
        "aria-hidden": "true"
      }), /*#__PURE__*/React.createElement(Typography, {
        className: cn({
          [classes.bold]: hasOpenCategory
        }),
        component: "span"
      }, item.Category)), /*#__PURE__*/React.createElement(Box, {
        display: "flex",
        alignItems: "center"
      }, hasSelections && /*#__PURE__*/React.createElement("span", {
        className: classes.selectedInfo
      }, /*#__PURE__*/React.createElement(Typography, {
        component: "span",
        className: classes.numSelected
      }, /*#__PURE__*/React.createElement("strong", null, numSelected), " selected")), !openCategory && /*#__PURE__*/React.createElement(ChevronRightIcon, {
        "aria-hidden": "true",
        className: classes.icon
      }))), isUndefined(openCategory) && /*#__PURE__*/React.createElement(Divider, null), hasOpenCategory && /*#__PURE__*/React.createElement(List, {
        className: classes.tagWrapper,
        dense: true,
        disablePadding: true
      }, map(item.Tags, tag => {
        const isChecked = includes(selectedInterests, tag);
        return /*#__PURE__*/React.createElement(ListItem, {
          key: tag,
          className: classes.checkboxItem
        }, /*#__PURE__*/React.createElement(FormControlLabel, {
          className: classes.checkboxLabel,
          label: tag,
          control: /*#__PURE__*/React.createElement(Checkbox, {
            color: "primary",
            size: "small",
            disableRipple: false,
            checked: isChecked,
            onChange: () => onChange(tag)
          })
        }));
      })));
    }
  }));
};
Categories$2.propTypes = {
  onChange: PropTypes.func.isRequired,
  categories: PropTypes.array.isRequired,
  selectedInterests: PropTypes.array.isRequired
};

const CategoryExplorer$1 = _ref => {
  let {
    categories,
    selectedInterests,
    onChange
  } = _ref;
  const [open, setOpen] = useState(false);
  return /*#__PURE__*/React.createElement(Box, {
    border: 1,
    borderColor: "divider"
  }, /*#__PURE__*/React.createElement(List, {
    dense: true,
    "aria-label": "Student Life"
  }, /*#__PURE__*/React.createElement(ListItem, {
    "aria-label": "Student Life"
  }, /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement("strong", null, "Student Life")), /*#__PURE__*/React.createElement(ListItemSecondaryAction, null, /*#__PURE__*/React.createElement(Button, {
    onClick: () => setOpen(!open),
    color: "primary"
  }, open ? 'Hide' : 'Show'))), open && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Collapse, {
    in: open,
    timeout: "auto"
  }, /*#__PURE__*/React.createElement(Categories$2, {
    categories: categories,
    selectedInterests: selectedInterests,
    onChange: onChange
  }))));
};
CategoryExplorer$1.propTypes = {
  onChange: PropTypes.func.isRequired,
  categories: PropTypes.array.isRequired,
  selectedInterests: PropTypes.array.isRequired
};

const processResults = results => {
  const newResults = [];
  forEach(results, result => {
    forEach(result.Tags, Tag => {
      const newResult = {
        Tag
      };
      newResult.Category = result.Category;
      newResults.push(newResult);
    });
  });
  return newResults;
};
class PersonalInterestsTypeahead$1 extends React.Component {
  static propTypes = {
    selectedValues: PropTypes.array,
    onQueryUpdate: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    onGetAllInterests: PropTypes.func.isRequired,
    inputProps: PropTypes.object
  };
  static defaultProps = {
    selectedValues: []
  };
  state = {
    allInterests: []
  };
  componentDidMount() {
    this.getAllInterests();
  }
  getAllInterests() {
    this.props.onGetAllInterests().then(allInterests => {
      this.setState({
        allInterests
      });
    }).catch(noop);
  }
  search(name) {
    return this.props.onSearch(name).then(options => processResults(options));
  }
  render() {
    const {
      onQueryUpdate,
      selectedValues,
      inputProps
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: "personal-interests-comp"
    }, /*#__PURE__*/React.createElement(SimpleAutocomplete, {
      label: "Interests & Activities",
      clearOnSelect: true,
      inputProps: inputProps,
      groupBy: option => option.Category,
      onSearch: value => this.search(value),
      onChange: val => val && onQueryUpdate(get(val, 'Tag')),
      labelKey: "Tag"
    }), /*#__PURE__*/React.createElement(Box, {
      mt: 1,
      className: "rcsc-pill-container"
    }, map(selectedValues, item => /*#__PURE__*/React.createElement(Chip, {
      key: item,
      label: item,
      onDelete: () => onQueryUpdate(item)
    }))), !isEmpty(this.state.allInterests) && /*#__PURE__*/React.createElement(Box, {
      mt: 2
    }, /*#__PURE__*/React.createElement(CategoryExplorer$1, {
      categories: get(this.state, 'allInterests', []),
      selectedInterests: selectedValues,
      onChange: val => onQueryUpdate(val)
    })));
  }
}

class LocationTypeahead extends React.Component {
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    onReset: PropTypes.func
  };
  render() {
    const {
      onSelect,
      onReset = noop,
      onSearch,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: "location-typeahead-wrapper"
    }, /*#__PURE__*/React.createElement(SimpleAutocomplete, _extends({}, rest, {
      onChange: val => val === null ? onReset() : onSelect(val.name, val.value),
      onSearch: value => onSearch(value)
    })));
  }
}

const useStyles$r = makeStyles(() => ({
  legend: {
    borderBottom: 0,
    margin: 0
  }
}));
const Legend = _ref => {
  let {
    children,
    className
  } = _ref;
  const classes = useStyles$r();
  return /*#__PURE__*/React.createElement("legend", {
    className: cn(classes.legend, className)
  }, children);
};
Legend.defaultProps = {
  variant: 'subtitle1'
};
Legend.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string
};

const FORM_IDS$1 = {
  location: 'cpref-location-starting-point-form-id'
};
const getCoordinatesArray$1 = str => {
  return str.match(/[0-9.-]+/g).map(str => parseFloat(str));
};
const MAX_MI = 500;
class DistanceLocation extends React.Component {
  static propTypes = {
    onUpdate: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    selectedValues: PropTypes.array
  };
  state = {
    minRange: 0,
    maxRange: 1000,
    coordinates: get(head(this.props.selectedValues), 'coordinates'),
    locationName: get(head(this.props.selectedValues), 'name')
  };
  queryUpdate(name, coordinates) {
    const {
      minRange,
      maxRange
    } = this.state;
    this.props.onUpdate({
      from: `${minRange}mi`,
      to: `${maxRange}mi`,
      name,
      coordinates
    });
  }
  updateRange(newMinRange, newMaxRange) {
    const {
      maxRange,
      minRange,
      locationName,
      coordinates
    } = this.state;
    const isMAX_MI = newMaxRange === MAX_MI;
    const isMutatedMax = isMAX_MI && maxRange === 1000;
    const maxChanged = newMaxRange !== maxRange && !isMutatedMax;
    const minChanged = newMinRange !== minRange;
    const hasSelectedLocation = !isUndefined(locationName) && !isUndefined(coordinates);
    if ((minChanged || maxChanged) && hasSelectedLocation) {
      const adjustedMaxRange = isMAX_MI ? 1000 : newMaxRange;
      this.setState({
        minRange: newMinRange,
        maxRange: adjustedMaxRange
      });
      this.queryUpdate(locationName, coordinates);
    }
  }
  updateLocation(location, coordinates) {
    coordinates = getCoordinatesArray$1(coordinates);
    this.setState({
      locationName: location,
      coordinates
    });
    this.queryUpdate(location, coordinates);
  }
  clear() {
    this.setState({
      locationName: undefined,
      coordinates: undefined
    });
    this.props.onUpdate(undefined);
  }
  render() {
    const {
      onSearch,
      selectedValues
    } = this.props;
    const firstValue = head(selectedValues);
    const selectedLocation = get(firstValue, 'name');
    const defaultMaxValue = parseInt(get(firstValue, 'to', `${MAX_MI}mi`).replace('mi', ''));
    const defaultMinValue = parseInt(get(firstValue, 'from', '0mi').replace('mi', ''));
    return /*#__PURE__*/React.createElement("div", {
      className: "rcsc-distance-location-comp"
    }, /*#__PURE__*/React.createElement("div", {
      className: "location-wrapper"
    }, /*#__PURE__*/React.createElement(Box, {
      my: 1
    }, /*#__PURE__*/React.createElement(LocationTypeahead, {
      defaultValue: selectedLocation,
      inputProps: {
        'aria-labelledby': FORM_IDS$1.location
      },
      label: "Location (starting point)",
      helperText: "City or Zip code",
      onSelect: (name, coordinates) => this.updateLocation(name, coordinates),
      onSearch: onSearch,
      onReset: () => this.clear()
    })), /*#__PURE__*/React.createElement(Box, {
      component: "fieldset",
      mt: 3
    }, /*#__PURE__*/React.createElement(Legend, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1",
      gutterBottom: true
    }, "Distance in Miles:")), /*#__PURE__*/React.createElement(RangeSlider, {
      disabled: isUndefined(this.state.locationName),
      infoId: "distance-range-slider",
      rangeMax: MAX_MI,
      stepValue: 25,
      defaultMaxValue: defaultMaxValue > MAX_MI ? MAX_MI : defaultMaxValue,
      defaultMinValue: defaultMinValue,
      onUpdateRange: (minRange, maxRange) => this.updateRange(minRange, maxRange),
      canValuesExceedDisplayedMax: true
    }))));
  }
}

class SportsTypeahead extends React.Component {
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    onSearch: PropTypes.func.isRequired,
    onReset: PropTypes.func
  };
  render() {
    const {
      onSelect,
      onSearch,
      onReset = noop,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SimpleAutocomplete, _extends({}, rest, {
      label: "Sport name",
      helperText: "e.g. basketball",
      onChange: value => value === null ? onReset() : onSelect(value),
      onSearch: value => onSearch(value)
    })));
  }
}

const Sports = ({ selectedValues = [], onQueryUpdate, onSearch }) => {
    const hasSport = size$1(selectedValues) > 0;
    const selectedValue = head$1(selectedValues);
    const divisions = useMemo(() => {
        const Divisions = get$1(selectedValue, 'Divisions', []);
        return Divisions.map((division) => {
            return Object.assign(Object.assign({}, division), { checked: division.Selected, title: division.Name, value: division });
        });
    }, [selectedValue]);
    const hasDivisions = hasSport && size$1(divisions) > 0;
    const onSelectSport = useCallback((value) => {
        const updated = produce(value, (draft) => {
            const tokens = get$1(draft, 'tokens', []);
            const Divisions = [];
            tokens.forEach((token) => {
                if (token !== draft.name) {
                    Divisions.push({
                        Name: token,
                        Selected: true,
                        label: token,
                    });
                }
            });
            return {
                Divisions,
                Name: draft.name,
                value,
            };
        });
        onQueryUpdate([updated]);
    }, [onQueryUpdate]);
    const onSelectDivision = useCallback((value) => {
        const updated = produce(selectedValue, (draft) => {
            draft.Divisions = draft.Divisions.map((division) => {
                if (division.Name === value.Name) {
                    return Object.assign(Object.assign({}, division), { Selected: !division.Selected });
                }
                return division;
            });
        });
        onQueryUpdate([updated]);
    }, [selectedValue, onQueryUpdate]);
    return (jsxs("div", Object.assign({ className: "acs-sports-comp" }, { children: [jsx(SportsTypeahead, { defaultValue: get$1(selectedValue, 'Name'), onSelect: (value) => onSelectSport(value), onSearch: (value) => onSearch(value), onReset: () => onQueryUpdate(undefined) }), hasDivisions && (jsx(Checklist, { title: "Divisions", onSelect: (value) => onSelectDivision(value), options: divisions }))] })));
};

const states = [{
  name: 'Alabama',
  tokens: ['Alabama'],
  value: 'AL'
}, {
  name: 'Alaska',
  tokens: ['Alaska'],
  value: 'AK'
}, {
  name: 'Arizona',
  tokens: ['Arizona'],
  value: 'AZ'
}, {
  name: 'Arkansas',
  tokens: ['Arkansas'],
  value: 'AR'
}, {
  name: 'California',
  tokens: ['California'],
  value: 'CA'
}, {
  name: 'Colorado',
  tokens: ['Colorado'],
  value: 'CO'
}, {
  name: 'Connecticut',
  tokens: ['Connecticut'],
  value: 'CT'
}, {
  name: 'Delaware',
  tokens: ['Delaware'],
  value: 'DE'
}, {
  name: 'District of Columbia',
  tokens: ['District of Columbia'],
  value: 'DC'
}, {
  name: 'Florida',
  tokens: ['Florida'],
  value: 'FL'
}, {
  name: 'Georgia',
  tokens: ['Georgia'],
  value: 'GA'
}, {
  name: 'Hawaii',
  tokens: ['Hawaii'],
  value: 'HI'
}, {
  name: 'Idaho',
  tokens: ['Idaho'],
  value: 'ID'
}, {
  name: 'Illinois',
  tokens: ['Illinois'],
  value: 'IL'
}, {
  name: 'Indiana',
  tokens: ['Indiana'],
  value: 'IN'
}, {
  name: 'Iowa',
  tokens: ['Iowa'],
  value: 'IA'
}, {
  name: 'Kansas',
  tokens: ['Kansas'],
  value: 'KS'
}, {
  name: 'Kentucky',
  tokens: ['Kentucky'],
  value: 'KY'
}, {
  name: 'Louisiana',
  tokens: ['Louisiana'],
  value: 'LA'
}, {
  name: 'Maine',
  tokens: ['Maine'],
  value: 'ME'
}, {
  name: 'Maryland',
  tokens: ['Maryland'],
  value: 'MD'
}, {
  name: 'Massachusetts',
  tokens: ['Massachusetts'],
  value: 'MA'
}, {
  name: 'Michigan',
  tokens: ['Michigan'],
  value: 'MI'
}, {
  name: 'Minnesota',
  tokens: ['Minnesota'],
  value: 'MN'
}, {
  name: 'Mississippi',
  tokens: ['Mississippi'],
  value: 'MS'
}, {
  name: 'Missouri',
  tokens: ['Missouri'],
  value: 'MO'
}, {
  name: 'Montana',
  tokens: ['Montana'],
  value: 'MT'
}, {
  name: 'Nebraska',
  tokens: ['Nebraska'],
  value: 'NE'
}, {
  name: 'Nevada',
  tokens: ['Nevada'],
  value: 'NV'
}, {
  name: 'New Hampshire',
  tokens: ['New Hampshire'],
  value: 'NH'
}, {
  name: 'New Jersey',
  tokens: ['New Jersey'],
  value: 'NJ'
}, {
  name: 'New Mexico',
  tokens: ['New Mexico'],
  value: 'NM'
}, {
  name: 'New York',
  tokens: ['New York'],
  value: 'NY'
}, {
  name: 'North Carolina',
  tokens: ['North Carolina'],
  value: 'NC'
}, {
  name: 'North Dakota',
  tokens: ['North Dakota'],
  value: 'ND'
}, {
  name: 'Ohio',
  tokens: ['Ohio'],
  value: 'OH'
}, {
  name: 'Oklahoma',
  tokens: ['Oklahoma'],
  value: 'OK'
}, {
  name: 'Oregon',
  tokens: ['Oregon'],
  value: 'OR'
}, {
  name: 'Pennsylvania',
  tokens: ['Pennsylvania'],
  value: 'PA'
}, {
  name: 'Rhode Island',
  tokens: ['Rhode Island'],
  value: 'RI'
}, {
  name: 'South Carolina',
  tokens: ['South Carolina'],
  value: 'SC'
}, {
  name: 'South Dakota',
  tokens: ['South Dakota'],
  value: 'SD'
}, {
  name: 'Tennessee',
  tokens: ['Tennessee'],
  value: 'TN'
}, {
  name: 'Texas',
  tokens: ['Texas'],
  value: 'TX'
}, {
  name: 'Utah',
  tokens: ['Utah'],
  value: 'UT'
}, {
  name: 'Vermont',
  tokens: ['Vermont'],
  value: 'VT'
}, {
  name: 'Virginia',
  tokens: ['Virginia'],
  value: 'VA'
}, {
  name: 'Washington',
  tokens: ['Washington'],
  value: 'WA'
}, {
  name: 'West Virginia',
  tokens: ['West Virginia'],
  value: 'WV'
}, {
  name: 'Wisconsin',
  tokens: ['Wisconsin'],
  value: 'WI'
}, {
  name: 'Wyoming',
  tokens: ['Wyoming'],
  value: 'WY'
}];

const statesByAbbr = keyBy(states, 'value');
const STATE_FORM_ID = 'cpref-state-typeahead-form-id';
class StatesTypeahead$1 extends React.Component {
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    selectedValues: PropTypes.array
  };
  static defaultProps = {
    selectedValues: []
  };
  search(inputValue) {
    const lowerVal = inputValue.toLowerCase();
    const states$1 = states.filter(state => {
      const name = state.name.toLowerCase();
      const value = state.value.toLowerCase();
      return name.match(lowerVal) || value.match(lowerVal);
    });
    return Promise.resolve(states$1);
  }
  selectState(state) {
    if (!includes(this.props.selectedValues, state)) {
      this.props.onSelect(state);
    }
  }
  render() {
    const {
      selectedValues,
      onSelect
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: "rcsc-state-typeahead-wrapper"
    }, /*#__PURE__*/React.createElement(SimpleAutocomplete, {
      id: STATE_FORM_ID,
      label: "State",
      clearOnSelect: true,
      onChange: item => this.selectState(item.value),
      onSearch: value => this.search(value)
    }), /*#__PURE__*/React.createElement(Box, {
      mt: 1,
      className: "rcsc-pill-container"
    }, map(selectedValues, item => {
      const stateDef = statesByAbbr[item];
      return /*#__PURE__*/React.createElement(Chip, {
        key: stateDef.value,
        label: stateDef.name,
        onDelete: () => onSelect(stateDef.value)
      });
    })));
  }
}

const getNumberValue = value => isUndefined(value) ? undefined : parseInt(value, 10);
const getMinRangeValue = selectedRange => getNumberValue(get(head(selectedRange), 'from'));
const getMaxRangeValue = selectedRange => getNumberValue(get(head(selectedRange), 'to'));
class TestScoresAcceptanceRate extends React.Component {
  static propTypes = {
    onUpdateSAT: PropTypes.func.isRequired,
    onUpdateACT: PropTypes.func.isRequired,
    onUpdateAcceptanceRate: PropTypes.func.isRequired,
    selectedAcceptanceRate: PropTypes.array,
    selectedSAT: PropTypes.array,
    selectedACT: PropTypes.array
  };
  render() {
    const {
      onUpdateSAT,
      onUpdateACT,
      onUpdateAcceptanceRate,
      selectedAcceptanceRate,
      selectedSAT,
      selectedACT
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: "acs-test-scores-acceptance-rate-comp"
    }, /*#__PURE__*/React.createElement("h3", null, "Average SAT"), /*#__PURE__*/React.createElement(SATRangeSlider, {
      defaultMaxValue: getMaxRangeValue(selectedSAT),
      defaultMinValue: getMinRangeValue(selectedSAT),
      onUpdateRange: (minRange, maxRange) => onUpdateSAT({
        from: minRange,
        to: maxRange
      })
    }), /*#__PURE__*/React.createElement("hr", {
      className: "rcsc-filter-section-separator"
    }), /*#__PURE__*/React.createElement("h3", null, "Average ACT"), /*#__PURE__*/React.createElement(ACTRangeSlider, {
      defaultMaxValue: getMaxRangeValue(selectedACT),
      defaultMinValue: getMinRangeValue(selectedACT),
      onUpdateRange: (minRange, maxRange) => onUpdateACT({
        from: minRange,
        to: maxRange
      })
    }), /*#__PURE__*/React.createElement("hr", {
      className: "rcsc-filter-section-separator"
    }), /*#__PURE__*/React.createElement("h3", null, "Admission Rate"), /*#__PURE__*/React.createElement(AcceptanceRateSlider, {
      defaultMaxValue: getMaxRangeValue(selectedAcceptanceRate),
      defaultMinValue: getMinRangeValue(selectedAcceptanceRate),
      onUpdateRange: (minRange, maxRange) => onUpdateAcceptanceRate({
        from: minRange,
        to: maxRange
      })
    }));
  }
}

var InternalContext$1 = /*#__PURE__*/React.createContext(null);

class Provider$1 extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    onAcademicFocusSearch: PropTypes.func.isRequired,
    onPageMajors: PropTypes.func.isRequired
  };
  render() {
    const {
      children,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(InternalContext$1.Provider, {
      value: {
        ...rest
      }
    }, children);
  }
}

var withContext$1 = config => {
  let workingConfig = config;
  if (isString(workingConfig)) {
    workingConfig = [workingConfig];
  }
  if (isArray(workingConfig)) {
    workingConfig = keyBy(workingConfig, identity);
  }
  const mapValueViaConfig = context => reduce(workingConfig, (result, propField, contextField) => {
    result[propField] = get(context, contextField);
    return result;
  }, {});
  return WrappedComponent => {
    const HoC = props => /*#__PURE__*/React.createElement(InternalContext$1.Consumer, null, value => /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, mapValueViaConfig(value), props)));
    HoC.displayName = `CollegeSearchContext(${WrappedComponent.displayName || WrappedComponent.name})`;
    return HoC;
  };
};

const linedInput = Symbol('lined-input');
const base = Symbol('base');
const themeDefinitions = {
  [linedInput]: {
    componentClass: 'lined-typeahead-input'
  },
  [base]: {}
};
const themes$1 = {
  linedInput,
  base
};

const themes = themes$1;
const formatFocusResults = results => map(results, result => ({
  name: result.name,
  type: 'focus',
  typeLabel: 'General Academic Focus',
  key: `focus-${result.name}`
}));
const formatMajorResults = results => map(results, result => ({
  name: result.name,
  cip: result.type,
  type: 'major',
  typeLabel: 'Specific Majors',
  key: `major-${result.name}`
}));
class AcademicFocusTypeahead extends React.Component {
  static propTypes = {
    maxResults: PropTypes.number.isRequired,
    onSearch: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    theme: PropTypes.oneOf(Object.values(themes)),
    inputProps: PropTypes.object
  };
  static defaultProps = {
    placeholder: 'Enter a general focus or major',
    theme: themes.base
  };
  search(name) {
    const trimmedName = trim(name);
    if (trimmedName.length > 0) {
      return this.props.onSearch(trimmedName).then(options => {
        const focus = formatFocusResults(options.Focus);
        const majors = formatMajorResults(options.Majors);
        return take([...focus, ...majors], this.props.maxResults);
      });
    }
  }
  render() {
    const themeClass = themeDefinitions[this.props.theme].componentClass;
    return /*#__PURE__*/React.createElement("div", {
      className: cn('rcsc-academic-focus-typeahead-comp', themeClass)
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "srOnly"
    }, "navigate typeahead using arrow keys"), /*#__PURE__*/React.createElement(SimpleAutocomplete, {
      label: "Focuses & Majors",
      clearOnSelect: true,
      groupBy: option => option.typeLabel,
      onSearch: value => this.search(value),
      onChange: val => {
        if (!isEmpty(val)) {
          this.props.onSelect(val);
        }
      }
    }));
  }
}
AcademicFocusTypeahead.themes = themes;

const ApiBoundAcademicFocusTypeahead$1 = withContext$1({
  onAcademicFocusSearch: 'onSearch',
  onPageMajors: 'onPageMajors',
  majorsMaxResults: 'maxResults'
})(AcademicFocusTypeahead);
const academicTypeLabel = {
  major: 'Major',
  focus: 'Focus'
};
class AcademicFocus$1 extends React.Component {
  static propTypes = {
    selectedAcademicFocusValues: PropTypes.array,
    selectedSpecificMajorsValues: PropTypes.array,
    onAcademicFocusQueryUpdate: PropTypes.func.isRequired,
    onSpecificMajorQueryUpdate: PropTypes.func.isRequired
  };
  static defaultProps = {
    selectedAcademicFocusValues: [],
    selectedSpecificMajorsValues: []
  };
  state = {
    selections: []
  };
  componentDidMount() {
    this.setSelections();
  }
  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.selectedAcademicFocusValues, this.props.selectedAcademicFocusValues) || !isEqual(prevProps.selectedSpecificMajorsValues, this.props.selectedSpecificMajorsValues)) {
      this.setSelections();
    }
  }
  setSelections() {
    const propSelections = [...this.props.selectedAcademicFocusValues, ...this.props.selectedSpecificMajorsValues];
    const selections = map(this.state.selections, 'displayValue');
    if (!isEqual(propSelections, selections)) {
      const majors = map(this.props.selectedSpecificMajorsValues, major => ({
        displayName: academicTypeLabel.major,
        displayValue: major,
        type: 'major'
      }));
      const focus = map(this.props.selectedAcademicFocusValues, foci => ({
        displayName: academicTypeLabel.focus,
        displayValue: foci,
        type: 'focus'
      }));
      this.setState({
        selections: [...focus, ...majors]
      });
    }
  }
  handleSelection(selection) {
    const value = selection.name;
    if (findIndex(this.state.selections, {
      displayValue: value,
      type: selection.type
    }) === -1) {
      selection.type === 'focus' ? this.props.onAcademicFocusQueryUpdate(value) : this.props.onSpecificMajorQueryUpdate(value);
      const newState = update(this.state, {
        selections: {
          $push: [{
            type: selection.type,
            displayValue: value,
            displayName: academicTypeLabel[selection.type]
          }]
        }
      });
      this.setState(newState);
    }
  }
  dismissPill(pill) {
    const displayValue = pill.displayValue;
    const idx = findIndex(this.state.selections, pill);
    const newState = update(this.state, {
      selections: {
        $splice: [[idx, 1]]
      }
    });
    pill.type === 'focus' ? this.props.onAcademicFocusQueryUpdate(displayValue) : this.props.onSpecificMajorQueryUpdate(displayValue);
    this.setState(newState);
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "acs-academic-focus-comp"
    }, /*#__PURE__*/React.createElement(ApiBoundAcademicFocusTypeahead$1, {
      onSelect: selection => this.handleSelection(selection),
      hasCompactView: true
    }), /*#__PURE__*/React.createElement(Box, {
      mt: 1,
      className: "academic-focus-pills"
    }, map(this.state.selections, item => /*#__PURE__*/React.createElement(Chip, {
      key: item.displayName,
      label: `${item.displayName} - ${item.displayValue}`,
      onDelete: () => this.dismissPill(item)
    }))));
  }
}

class FilterItem extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
    isOpenByDefault: PropTypes.bool,
    className: PropTypes.string
  };
  static defaultProps = {
    isOpenByDefault: false
  };
  state = {
    collapsed: true
  };
  componentDidMount() {
    if (this.props.isOpenByDefault) {
      this.setState({
        collapsed: false
      });
    }
  }
  render() {
    const {
      children,
      title,
      className
    } = this.props;
    const {
      collapsed
    } = this.state;
    return /*#__PURE__*/React.createElement(Box, {
      mb: 2
    }, /*#__PURE__*/React.createElement(Card, {
      className: cn("acs-filter-item-comp", className),
      width: "300px",
      variant: "outlined"
    }, /*#__PURE__*/React.createElement("button", {
      className: cn("acs-filter-title acs-filter-item-toggle", {
        collapsed: collapsed
      }),
      onClick: () => this.setState({
        collapsed: !collapsed
      })
    }, title, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      size: "sm",
      className: cn('acs-filter-item-arrow', {
        'inverted': !collapsed
      }),
      icon: faChevronDown
    })), /*#__PURE__*/React.createElement(ToggleBox, {
      collapsed: collapsed,
      animationDurationSeconds: 0.25
    }, /*#__PURE__*/React.createElement("div", {
      className: "acs-filter-wrapper"
    }, children))));
  }
}

const pillNames = {
  Tags: {
    name: 'Tags',
    displayName: 'Tag',
    getDisplayValue: value => value
  },
  AcademicFocus: {
    name: 'AcademicFocus',
    displayName: 'Academic Focus',
    getDisplayValue: value => value
  },
  Degrees: {
    name: 'Degrees',
    displayName: 'Undergraduate Degrees',
    getDisplayValue: value => {
      const opts = {
        Bachelors: "4-Year Bachelor's",
        Associates: '2-Year Associate',
        Masters: "Master's",
        Doctorate: 'Doctorate',
        DoctorateProfessional: 'Professional',
        DoctorateResearch: 'Research'
      };
      return opts[value];
    }
  },
  UnivType: {
    name: 'UnivType',
    displayName: 'College Level',
    getDisplayValue: value => {
      const opts = {
        '4 year': '4-Year',
        '2 year': '2-Year'
      };
      return opts[value];
    }
  },
  SchoolClassifier: {
    name: 'SchoolClassifier',
    displayName: 'Special Focus',
    getDisplayValue: value => {
      const opts = {
        CareerAndTrade: 'Career & Trade'
      };
      return opts[value];
    }
  },
  UnderGradEnroll: {
    name: 'UnderGradEnroll',
    displayName: 'Size',
    getDisplayValue: value => value.label
  },
  Sports: {
    name: 'Sports',
    displayName: 'Athletics',
    getDisplayValue: value => {
      const divisionList = [];
      const {
        Divisions
      } = value;
      for (var i = 0; i < Divisions.length; i++) {
        const division = Divisions[i];
        if (division.Selected) {
          divisionList.push(division.Name);
        }
      }
      if (divisionList.length === 0) {
        return '(No Divisions Selected)';
      }
      return `${value.Name} ${divisionList.join(', ')}`;
    }
  },
  Religious: {
    name: 'Religious',
    displayName: 'Religious Affiliation',
    getDisplayValue: value => value === '' ? 'None' : value
  },
  MinorityServingInst: {
    name: 'MinorityServingInst',
    displayName: 'Special-Mission',
    getDisplayValue: value => value
  },
  Control: {
    name: 'Control',
    displayName: 'Institution Type',
    getDisplayValue: value => value === '' ? 'None' : value
  },
  Setting: {
    name: 'Setting',
    displayName: 'Campus Setting',
    getDisplayValue: value => value
  },
  Majors: {
    name: 'Majors',
    displayName: 'Major',
    getDisplayValue: value => value
  },
  Rotc: {
    name: 'Rotc',
    displayName: 'ROTC Programs',
    getDisplayValue: value => value
  },
  ApplicationMethod: {
    name: 'ApplicationMethod',
    displayName: 'Application Method',
    getDisplayValue: value => value
  },
  TestOptional: {
    name: 'TestOptional',
    displayName: undefined,
    getDisplayValue: () => 'Test Optional'
  },
  Location: {
    name: 'Location',
    displayName: 'Location',
    getDisplayValue: value => {
      const maxRange = value.to === '1000mi' ? '500mi+' : value.to;
      return `${value.name} (${value.from} - ${maxRange})`;
    }
  },
  LocationCategory: {
    name: 'LocationCategory',
    displayName: 'Country',
    getDisplayValue: value => {
      if (value === '') {
        return 'None';
      }
      const opts = {
        Domestic: 'United States of America',
        International: 'International & Territories'
      };
      return opts[value];
    }
  },
  State: {
    name: 'State',
    displayName: 'State',
    getDisplayValue: value => states.filter(obj => obj.value === value)[0].name
  },
  ACTAvg: {
    name: 'ACTAvg',
    displayName: 'ACT Range',
    getDisplayValue: value => `${value.from} - ${value.to}`
  },
  SATAvg: {
    name: 'SATAvg',
    displayName: 'SAT Range',
    getDisplayValue: value => `${value.from} - ${value.to}`
  },
  Selectivity: {
    name: 'Selectivity',
    displayName: 'Admission Rate',
    getDisplayValue: value => `${value.from} - ${value.to}`
  },
  ScoirApplyApplicantTypes: {
    name: 'ScoirApplyApplicantTypes',
    displayName: 'Apply with Scoir',
    getDisplayValue: value => {
      const opts = {
        first: 'First Year',
        transfer: 'Transfer'
      };
      return opts[value];
    }
  },
  CoalitionMember: {
    name: 'CoalitionMember',
    displayName: 'Special-Mission',
    getDisplayValue: () => 'Coalition for College'
  }
};

const stateNames = reduce(states, (stateNames, state) => {
  stateNames[state.value] = state.name;
  return stateNames;
}, {});
const degreesLabels = {
  Bachelors: "4-Year Bachelor's",
  Associates: '2-Year Associate',
  Certificate: 'Certificate',
  Masters: "Master's",
  Doctorate: 'Doctorate',
  DoctorateProfessional: 'Professional',
  DoctorateResearch: 'Research'
};
const univTypeLabels = {
  '4 year': '4-Year',
  '2 year': '2-Year',
  'Less than 2 year': 'Less than 2-Year',
  CareerAndTrade: 'Career & Trade'
};
const schoolClassifierLabels = {
  CareerAndTrade: 'Career & Trade'
};
const locationCategoryLabels = {
  Domestic: 'United States of America',
  International: 'International & Territories'
};
const minorityServingInstLabels = {
  HBCU: 'Historically Black Colleges and Universities'
};
const getChecked = (selected, term) => {
  return some(selected, current => {
    if (isObject(term) && isObject(current)) {
      return current.label === term.label;
    } else {
      return current === term;
    }
  });
};
const getCheckListItems = _ref => {
  let {
    facets,
    selected = [],
    key = 'label',
    labels = {},
    disabled = false
  } = _ref;
  return map(facets, facet => {
    const term = facet.term;
    const count = facet.count;
    const value = term || facet;
    const checked = getChecked(selected, value);
    const label = get(labels, term, get(facet, key, term));
    const title = isNumber(count) ? `${label} (${count})` : label;
    return {
      title,
      value: {
        ...facet,
        value
      },
      checked,
      disabled
    };
  });
};
const checkTermsAgainstStrings = function (facets) {
  let selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let disabled = arguments.length > 2 ? arguments[2] : undefined;
  return getCheckListItems({
    facets,
    selected,
    disabled
  });
};
const getDegrees = function () {
  let facets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return getCheckListItems({
    facets,
    selected,
    labels: degreesLabels,
    disabled
  });
};
const getUndergrads = function () {
  let facets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return getCheckListItems({
    facets,
    selected
  });
};
const getUnivTypes = function (facets) {
  let selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return getCheckListItems({
    facets,
    selected,
    labels: univTypeLabels,
    disabled
  });
};
const getLocationCategories = function (facets) {
  let selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return getCheckListItems({
    facets,
    selected,
    labels: locationCategoryLabels
  });
};
const getMinorityServingInstCategories = function (facets) {
  let selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return getCheckListItems({
    facets,
    selected,
    labels: minorityServingInstLabels
  });
};
const getBooleanData = (facets, selected, label) => {
  const items = getCheckListItems({
    facets,
    selected,
    labels: {
      T: label,
      F: label
    },
    key: 'name'
  });
  const data = items.filter(item => item.value.term === 'T');
  if (size(data) > 0) {
    data[0].label = label;
  }
  return data;
};
const getCoalitionMember = (terms, value) => {
  return getBooleanData(terms, value, 'Coalition for College');
};
const getLabels = (group, term) => {
  const displayLabels = {
    degrees: degreesLabels[term],
    univType: univTypeLabels[term],
    countries: locationCategoryLabels[term],
    states: stateNames[term]
  };
  return displayLabels[group];
};

const getPillItemsByFilterName = (filterName, queryValue) => {
  if (pillNames[filterName]) {
    const {
      name,
      displayName,
      getDisplayValue
    } = pillNames[filterName];
    return map(queryValue, value => ({
      name,
      value,
      displayName,
      displayValue: getDisplayValue(value)
    }));
  }
  return [];
};
const getPillItemsFromQuery = query => {
  const keys = Object.keys(query);
  let arr = [];
  keys.forEach(filterName => {
    const queryValue = query[filterName];
    arr = [...arr, ...getPillItemsByFilterName(filterName, queryValue)];
  });
  return arr;
};
const createFacetsObject = function () {
  let facetsArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  const obj = {};
  facetsArray.forEach(facet => {
    obj[facet.name] = facet;
  });
  return obj;
};
const labels = {
  stateNames,
  Degrees: degreesLabels,
  UnivType: univTypeLabels,
  SchoolClassifier: schoolClassifierLabels,
  LocationCategory: locationCategoryLabels,
  MinorityServingInst: minorityServingInstLabels
};
const filterUnwantedSettingsFacets = term => {
  const isNotAvailable = isString(term) && term.toLowerCase() === 'not available';
  return isNotAvailable;
};
const filterUnwantedControlFacets = term => {
  const isNone = isEmpty(term);
  return isNone;
};
const filterBadTerms = (fieldName, facetTerms) => {
  return filter(facetTerms, _ref => {
    let {
      term
    } = _ref;
    if (fieldName === 'Setting' && filterUnwantedSettingsFacets(term)) {
      return false;
    }
    if (fieldName === 'Control' && filterUnwantedControlFacets(term)) {
      return false;
    }
    return true;
  });
};
const getFilterDisplayData = function (searchFacets) {
  let query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const facets = createFacetsObject(searchFacets);
  const getFacetTerms = fieldName => {
    const facetTerms = get(facets, `${fieldName}.terms`, []);
    return filterBadTerms(fieldName, facetTerms);
  };
  const getConfig = fieldName => {
    return {
      facets: getFacetTerms(fieldName),
      selected: query[fieldName],
      labels: get(labels, fieldName)
    };
  };
  return {
    Degrees: getCheckListItems(getConfig('Degrees')),
    UnivType: getCheckListItems(getConfig('UnivType')),
    SchoolClassifier: getCheckListItems(getConfig('SchoolClassifier')),
    Control: getCheckListItems(getConfig('Control')),
    LocationCategory: getCheckListItems(getConfig('LocationCategory')),
    UnderGradEnroll: getCheckListItems(getConfig('UnderGradEnroll')),
    Religious: getCheckListItems(getConfig('Religious')),
    Setting: getCheckListItems(getConfig('Setting')),
    Rotc: getCheckListItems(getConfig('Rotc')),
    ApplicationMethod: getCheckListItems(getConfig('ApplicationMethod')),
    ScoirApplyApplicantTypes: getCheckListItems(getConfig('ScoirApplyApplicantTypes')),
    MinorityServingInst: getCheckListItems(getConfig('MinorityServingInst')),
    CoalitionMember: getBooleanData(getFacetTerms('CoalitionMember'), query.CoalitionMember, 'Coalition for College'),
    TestOptional: getBooleanData(getFacetTerms('TestOptional'), query.TestOptional, 'Test Optional')
  };
};

const ConfiguredChecklist = ({ fieldName, title, onUpdateQuery, displayData }) => {
    return (jsx(Checklist, { title: title, spacing: 0, isTwoColumnAtSm: false, onSelect: (option) => onUpdateQuery(fieldName, option.value), options: displayData[fieldName] }));
};
const CollegeSearchFilters = ({ facets, query, onQueryUpdate, onPersonalInterestSearch, onSportsSearch, onLocationSearch, onGetAllInterests, }) => {
    const onUpdateQuery = useCallback((name, value) => {
        const updated = updateQuery(query, name, value);
        onQueryUpdate(updated);
    }, [onQueryUpdate, query]);
    const displayData = useMemo(() => getFilterDisplayData(facets, query), [facets, query]);
    const hasUnivType = useMemo(() => displayData.UnivType && displayData.UnivType.length > 0, [displayData]);
    const hasSchoolClassifier = useMemo(() => displayData.SchoolClassifier && displayData.SchoolClassifier.length > 0, [displayData]);
    return (jsxs("div", Object.assign({ className: "acs-filters-comp" }, { children: [isUndefined$1(onPersonalInterestSearch) ? null : (jsx(FilterItem, Object.assign({ title: "Personal Interests & Activities", isOpenByDefault: true, className: "acs-filter-personal-interests" }, { children: jsx(PersonalInterestsTypeahead$1, { selectedValues: query.Tags, onQueryUpdate: (value) => onUpdateQuery('Tags', value), onSearch: onPersonalInterestSearch, onGetAllInterests: onGetAllInterests }) }))), jsx(FilterItem, Object.assign({ title: "Academic Focus", isOpenByDefault: true, className: "acs-filter-academic-focus" }, { children: jsx(AcademicFocus$1, { selectedAcademicFocusValues: query.AcademicFocus, selectedSpecificMajorsValues: query.Majors, onAcademicFocusQueryUpdate: (value) => onUpdateQuery('AcademicFocus', value), onSpecificMajorQueryUpdate: (value) => onUpdateQuery('Majors', value) }) })), jsxs(FilterItem, Object.assign({ title: "Degrees", className: "acs-filter-degrees" }, { children: [!hasUnivType ? null : (jsx(ConfiguredChecklist, { fieldName: 'UnivType', title: "College Level", onUpdateQuery: onUpdateQuery, displayData: displayData })), !hasSchoolClassifier ? null : (jsx(ConfiguredChecklist, { fieldName: 'SchoolClassifier', title: "Special Focus", onUpdateQuery: onUpdateQuery, displayData: displayData })), jsx(ConfiguredChecklist, { fieldName: 'Degrees', title: hasUnivType || hasSchoolClassifier ? 'Degrees Offered' : undefined, onUpdateQuery: onUpdateQuery, displayData: displayData })] })), jsxs(FilterItem, Object.assign({ title: "Distance & Location", className: "acs-filter-location" }, { children: [isUndefined$1(onLocationSearch) ? null : (jsx(DistanceLocation, { onUpdate: (value) => onUpdateQuery('Location', value), onSearch: onLocationSearch, selectedValues: query.Location })), jsx(StatesTypeahead$1, { selectedValues: query.State, onSelect: (value) => onUpdateQuery('State', value) }), isUndefined$1(displayData.LocationCategory) ? null : (jsx(ConfiguredChecklist, { fieldName: 'LocationCategory', title: 'Country', onUpdateQuery: onUpdateQuery, displayData: displayData }))] })), jsx(FilterItem, Object.assign({ title: "Undergraduate Students", className: "acs-filter-undergrad-enrolled" }, { children: jsx(ConfiguredChecklist, { fieldName: 'UnderGradEnroll', onUpdateQuery: onUpdateQuery, displayData: displayData }) })), isUndefined$1(onSportsSearch) ? null : (jsx(FilterItem, Object.assign({ title: "Athletics", className: "acs-filter-sports" }, { children: jsx(Sports, { onSearch: onSportsSearch, onQueryUpdate: (value) => onUpdateQuery('Sports', value), selectedValues: query.Sports }) }))), jsx(FilterItem, Object.assign({ title: "Test Scores & Admission Rate", className: "acs-filter-test-scores" }, { children: jsx(TestScoresAcceptanceRate, { onUpdateSAT: (satRange) => onUpdateQuery('SATAvg', satRange), onUpdateACT: (actRange) => onUpdateQuery('ACTAvg', actRange), onUpdateAcceptanceRate: (acceptanceRate) => onUpdateQuery('Selectivity', acceptanceRate), selectedAcceptanceRate: query.Selectivity, selectedSAT: query.SATAvg, selectedACT: query.ACTAvg }) })), jsxs(FilterItem, Object.assign({ title: "School Type", className: "acs-filter-type-and-religious-affiliation" }, { children: [jsx(ConfiguredChecklist, { title: "Public or Private", fieldName: 'Control', onUpdateQuery: onUpdateQuery, displayData: displayData }), jsx(ConfiguredChecklist, { title: "Religious Affiliation", fieldName: 'Religious', onUpdateQuery: onUpdateQuery, displayData: displayData }), jsx(ConfiguredChecklist, { title: "Special-Mission", fieldName: 'CoalitionMember', onUpdateQuery: onUpdateQuery, displayData: displayData }), jsx(ConfiguredChecklist, { fieldName: 'MinorityServingInst', onUpdateQuery: onUpdateQuery, displayData: displayData })] })), jsx(FilterItem, Object.assign({ title: "Campus Setting", className: "acs-filter-setting" }, { children: jsx(ConfiguredChecklist, { fieldName: 'Setting', onUpdateQuery: onUpdateQuery, displayData: displayData }) })), jsx(FilterItem, Object.assign({ title: "ROTC Programs", className: "acs-filter-rotc" }, { children: jsx(ConfiguredChecklist, { fieldName: 'Rotc', onUpdateQuery: onUpdateQuery, displayData: displayData }) })), jsxs(FilterItem, Object.assign({ title: "Application Info", className: "acs-filter-application-info" }, { children: [jsx(ConfiguredChecklist, { fieldName: 'ScoirApplyApplicantTypes', title: "Apply with Scoir", onUpdateQuery: onUpdateQuery, displayData: displayData }), jsx(ConfiguredChecklist, { fieldName: 'ApplicationMethod', title: "Other Application Methods", onUpdateQuery: onUpdateQuery, displayData: displayData }), jsx(ConfiguredChecklist, { fieldName: 'TestOptional', title: "Test Policy", onUpdateQuery: onUpdateQuery, displayData: displayData })] }))] })));
};

class CollegeResultsHeader extends React.Component {
  static propTypes = {
    total: PropTypes.number,
    topOfResultsComponent: PropTypes.node
  };
  static defaultProps = {
    total: 0
  };
  render() {
    const {
      total,
      topOfResultsComponent
    } = this.props;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      role: "status",
      "aria-live": "polite",
      className: "sr-only"
    }, total, " ", `College${total !== 1 ? 's' : ''}`, " found"), /*#__PURE__*/React.createElement("h2", {
      className: "rcsc-search-summary-container"
    }, /*#__PURE__*/React.createElement("span", {
      className: "rcsc-summary-count-container"
    }, /*#__PURE__*/React.createElement("span", {
      className: "rcsc-summary-count"
    }, total.toLocaleString()), " College", total !== 1 && 's'), topOfResultsComponent));
  }
}

const NAME_SEARCH_PILL_KEY = 'name-search-pill';
class CollegeSearchSummary extends React.Component {
  static propTypes = {
    total: PropTypes.number,
    query: PropTypes.object.isRequired,
    onQueryUpdate: PropTypes.func.isRequired,
    nameSearch: PropTypes.string,
    onNameSearchDismiss: PropTypes.func.isRequired,
    topOfResultsComponent: PropTypes.node,
    showError: PropTypes.bool
  };
  static defaultProps = {
    total: 0
  };
  getNameSearchPill() {
    if (this.props.nameSearch) {
      return [{
        name: NAME_SEARCH_PILL_KEY,
        displayName: 'Name',
        displayValue: this.props.nameSearch
      }];
    }
    return [];
  }
  dismissPill(pill) {
    if (pill.name === NAME_SEARCH_PILL_KEY) {
      return this.props.onNameSearchDismiss();
    }
    return this.props.onQueryUpdate(updateQuery(this.props.query, pill.name, pill.value));
  }
  render() {
    const {
      total,
      query,
      topOfResultsComponent,
      showError
    } = this.props;
    const pills = [...this.getNameSearchPill(), ...getPillItemsFromQuery(query)];
    return /*#__PURE__*/React.createElement(Box, {
      mb: 0.5
    }, /*#__PURE__*/React.createElement(CollegeResultsHeader, {
      total: total,
      topOfResultsComponent: topOfResultsComponent
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Box, {
      my: 1.5,
      display: "flex",
      flexWrap: "wrap",
      gridGap: 8
    }, pills?.map((pill, index) => /*#__PURE__*/React.createElement(Chip$1, {
      size: "small",
      color: "primary",
      onDelete: () => this.dismissPill(pill),
      key: index,
      label: `${pill.displayName} - ${pill.displayValue}`
    })))), showError && /*#__PURE__*/React.createElement("div", {
      className: "acs-error-message"
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
      role: "alert",
      color: "error"
    }, "There was an error opening the modal. Please try again later."))));
  }
}

const CollegeSearchResultsList = _ref => {
  let {
    total = 0,
    colleges = [],
    renderResultTile,
    emptyState,
    onLoadMore
  } = _ref;
  const collegeCount = size(colleges);
  const canLoadMore = collegeCount < total;
  return /*#__PURE__*/React.createElement(InfiniteScroll.Window, {
    onHitBottom: () => canLoadMore && onLoadMore(),
    bottomThreshold: 60
  }, /*#__PURE__*/React.createElement("div", null, total > 0 ? map(colleges, (college, idx) => renderResultTile(college, idx)) : emptyState));
};
CollegeSearchResultsList.propTypes = {
  colleges: PropTypes.arrayOf(PropTypes.object),
  total: PropTypes.number,
  renderResultTile: PropTypes.func.isRequired,
  emptyState: PropTypes.node.isRequired,
  onLoadMore: PropTypes.func.isRequired
};

const CollegeSearchProvider = Provider$1;
class AbstractCollegeSearch extends React.Component {
  static propTypes = {
    topOfRailComponent: PropTypes.node,
    topOfResultsComponent: PropTypes.node,
    onQueryChange: PropTypes.func.isRequired,
    onPageChange: PropTypes.func.isRequired,
    renderResultTile: PropTypes.func.isRequired,
    colleges: PropTypes.arrayOf(PropTypes.object).isRequired,
    total: PropTypes.number.isRequired,
    query: PropTypes.object,
    facets: PropTypes.arrayOf(PropTypes.object).isRequired,
    nameSearch: PropTypes.string,
    onNameSearchDismiss: PropTypes.func.isRequired,
    onResetSearch: PropTypes.func.isRequired,
    onPersonalInterestSearch: PropTypes.func,
    onSportsSearch: PropTypes.func,
    onLocationSearch: PropTypes.func,
    onGetAllInterests: PropTypes.func,
    onShowError: PropTypes.bool
  };
  static defaultProps = {
    query: getDefaultQuery(),
    colleges: []
  };
  state = {
    isLoading: true
  };
  componentDidMount() {
    this.props.onQueryChange(this.props.query).then(() => {
      this.setState({
        isLoading: false
      });
    });
  }
  render() {
    const {
      colleges,
      facets,
      total,
      onPageChange,
      onQueryChange,
      query,
      renderResultTile,
      nameSearch,
      onNameSearchDismiss,
      topOfRailComponent,
      topOfResultsComponent,
      onPersonalInterestSearch,
      onSportsSearch,
      onLocationSearch,
      onGetAllInterests
    } = this.props;
    return /*#__PURE__*/React.createElement(CollapsableRailSearch, {
      railContent: /*#__PURE__*/React.createElement(Fragment, null, topOfRailComponent, /*#__PURE__*/React.createElement(CollegeSearchFilters, {
        query: query,
        facets: facets,
        onPersonalInterestSearch: input => onPersonalInterestSearch(input),
        onSportsSearch: input => onSportsSearch(input),
        onLocationSearch: input => onLocationSearch(input),
        onQueryUpdate: query => onQueryChange(query),
        onGetAllInterests: onGetAllInterests
      }))
    }, /*#__PURE__*/React.createElement(Container, {
      maxWidth: "lg"
    }, this.state.isLoading ? /*#__PURE__*/React.createElement("div", {
      className: "acs-loading-search-container"
    }, /*#__PURE__*/React.createElement(LoadingIndicator, {
      size: "lg",
      enabled: true
    })) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(CollegeSearchSummary, {
      query: query,
      total: total,
      onQueryUpdate: query => onQueryChange(query),
      nameSearch: nameSearch,
      onNameSearchDismiss: () => onNameSearchDismiss(),
      topOfResultsComponent: topOfResultsComponent,
      showError: this.props.onShowError
    }), /*#__PURE__*/React.createElement(CollegeSearchResultsList, {
      total: total,
      colleges: colleges,
      renderResultTile: renderResultTile,
      onLoadMore: () => onPageChange(),
      emptyState: /*#__PURE__*/React.createElement(EmptyStateWithAction, {
        title: "No matches found",
        subTitle: "Try removing some filters to expand your search",
        icon: faTelescope,
        actionProps: {
          children: "Clear All Filters",
          onClick: () => this.props.onResetSearch({})
        }
      })
    }))));
  }
}

const useStyles$q = makeStyles(theme => ({
  box: {
    display: 'flex',
    padding: theme.spacing(2, 2, 0, 2),
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    flexFlow: 'wrap'
  },
  pills: {
    display: 'flex',
    gap: theme.spacing(0.5),
    '&:hover': {
      cursor: 'pointer',
      background: '#D3EAFD'
    }
  },
  disabledPill: {
    display: 'flex',
    gap: theme.spacing(0.5)
  },
  popover: {
    maxHeight: '300px'
  },
  pillTrunc: {
    maxWidth: '145px' /* About 25 characters */,
    textOverflow: 'ellipsis',
    textWrap: 'nowrap',
    overflow: 'hidden',
    margin: 0
  }
}));
const CollegeSearchTags = _ref => {
  let {
    college,
    topLabels
  } = _ref;
  const classes = useStyles$q();
  const fields = college.CalculatedFields || {};
  const interests = fields.TagMatch ? fields.TagMatch[0] : null;
  const majors = fields.Majors;
  const distance = fields.Distance;
  const hasInterests = interests && interests.length > 0;
  const hasMajors = majors && majors.length > 0;
  const hasDistance = distance && distance.length > 0;
  const [interestsPopover, setInterestsPopover] = useState({
    ref: null,
    open: false
  });
  const [majorsPopover, setMajorsPopover] = useState({
    ref: null,
    open: false
  });
  const shouldShow = hasInterests || hasMajors || hasDistance || topLabels;
  return !shouldShow ? null : /*#__PURE__*/React.createElement(Box, {
    className: classes.box
  }, topLabels, !hasDistance ? null : /*#__PURE__*/React.createElement(Pill, {
    color: "info",
    className: classes.disabledPill
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faMapMarkerAlt,
    size: "sm"
  }), distance[0].toFixed(1), " mi away"), !hasMajors ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Pill, {
    className: classes.pills,
    color: "info",
    ref: majorsPopover.ref,
    onClick: e => setMajorsPopover({
      ref: e.currentTarget,
      open: true
    })
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faBook,
    size: "sm"
  }), /*#__PURE__*/React.createElement("p", {
    className: classes.pillTrunc
  }, majors[0]), " ", `${majors.length > 1 ? `+${majors.length - 1}` : ''}`), /*#__PURE__*/React.createElement(Popover, {
    className: classes.popover,
    open: majorsPopover.open,
    anchorEl: majorsPopover.ref,
    onClose: () => setMajorsPopover({
      ref: null,
      open: false
    }),
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, /*#__PURE__*/React.createElement(List, {
    dense: true
  }, majors.map((item, idx) => /*#__PURE__*/React.createElement(ListItem, {
    key: idx
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: item
  })))))), !hasInterests ? null : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Pill, {
    className: classes.pills,
    color: "info",
    ref: interestsPopover.ref,
    onClick: e => setInterestsPopover({
      ref: e.currentTarget,
      open: true
    })
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faLightbulb,
    size: "sm"
  }), /*#__PURE__*/React.createElement("p", {
    className: classes.pillTrunc
  }, interests[0]), ' ', `${interests.length > 1 ? `+${interests.length - 1}` : ''}`), /*#__PURE__*/React.createElement(Popover, {
    className: classes.popover,
    open: interestsPopover.open,
    anchorEl: interestsPopover.ref,
    onClose: () => setInterestsPopover({
      ref: null,
      open: false
    }),
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, /*#__PURE__*/React.createElement(List, {
    dense: true
  }, interests.map((item, idx) => /*#__PURE__*/React.createElement(ListItem, {
    key: idx
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: item
  })))))));
};
CollegeSearchTags.propTypes = {
  college: PropTypes.object.isRequired,
  topLabels: PropTypes.node
};

const useStyles$p = makeStyles(() => ({
  applyIcon: {
    fontSize: '1.4rem'
  }
}));
const ScoirApplyIcon = () => {
  const classes = useStyles$p();
  return /*#__PURE__*/React.createElement(SvgIcon, {
    classes: {
      root: classes.applyIcon
    },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#C3E369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2422 13.0859L10.2656 18.3125C10.1016 18.4531 9.91406 18.5 9.75 18.5C9.58594 18.5 9.42188 18.4531 9.30469 18.3594C9.02344 18.1719 8.90625 17.7969 9.04688 17.4688L10.8516 13.25H8.25C7.92188 13.25 7.64062 13.0625 7.54688 12.7812C7.42969 12.4766 7.5 12.1484 7.73438 11.9375L13.7344 6.71094C13.9922 6.47656 14.3672 6.47656 14.6484 6.6875C14.9531 6.875 15.0469 7.25 14.9062 7.57812L13.1016 11.7734H15.7266C16.0312 11.7734 16.3125 11.9844 16.4297 12.2656C16.5469 12.5469 16.4766 12.875 16.2422 13.0859Z",
    fill: "white"
  }));
};

const useStyles$o = makeStyles((theme) => ({
    subtitle: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
    },
}));
const getUnivTypeLabel = (univType) => {
    switch (univType) {
        case '4 year':
            return '4-Year';
        case '2 year':
            return '2-Year';
        case 'Less than 2 year':
            return '< 2-Year';
        default:
            return undefined;
    }
};
const Subheader = ({ city, state, control, setting, displayAsScoirApply, univType, schoolClassifier, isTnTSearchFilterEnabled = false, }) => {
    const classes = useStyles$o();
    const univTypeLabel = getUnivTypeLabel(univType);
    let subTitle = `${city}, ${state}`;
    if (univTypeLabel && isTnTSearchFilterEnabled)
        subTitle = subTitle.concat(` • ${univTypeLabel}`);
    if (schoolClassifier && schoolClassifier === 'CareerAndTrade' && isTnTSearchFilterEnabled) {
        subTitle = subTitle.concat(` • Career & Trade`);
    }
    if (control)
        subTitle = subTitle.concat(` • ${control}`);
    if (setting && setting !== 'Not available')
        subTitle = subTitle.concat(` • ${setting}`);
    if (displayAsScoirApply)
        subTitle = subTitle.concat(` • `);
    return (jsxs(Typography$1, Object.assign({ variant: "body2", color: "textSecondary", className: classes.subtitle }, { children: [subTitle, displayAsScoirApply && jsx(ScoirApplyIcon, {})] })));
};

const useStyles$n = makeStyles(() => ({
    crest: {
        width: '50px',
        height: '50px',
    },
}));
const Header$1 = ({ college, titleClassName, isTnTSearchFilterEnabled = false }) => {
    const classes = useStyles$n();
    return (jsx(CardHeader, { avatar: jsx(CollegeCrest, { className: classes.crest, alt: `${college.Name} logo`, scid: college.Scid }), title: jsx(Typography$1, Object.assign({ variant: "h5", className: titleClassName }, { children: college.Name })), subheader: jsx(Subheader, { city: college.City, state: college.State, control: college.Control, setting: college.Setting, displayAsScoirApply: college.DisplayAsScoirApply, univType: college.UnivType, schoolClassifier: college.SchoolClassifier, isTnTSearchFilterEnabled: isTnTSearchFilterEnabled }) }));
};

const EMPTY_DATA = '—';
const formatPrice = (price) => {
    let formatted = null;
    if (price) {
        formatted = `$${price.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
    }
    return formatted;
};
const formatPercentage = (percentage) => {
    let output = EMPTY_DATA;
    const value = parseFloat(`${percentage}`);
    if (value > 0 && percentage) {
        output = `${Math.round(value)}%`;
    }
    return output;
};

var formatters = /*#__PURE__*/Object.freeze({
    __proto__: null,
    EMPTY_DATA: EMPTY_DATA,
    formatPrice: formatPrice,
    formatPercentage: formatPercentage
});

const useStyles$m = makeStyles((theme) => ({
    overview: {
        display: 'flex',
        margin: 0,
    },
    item: {
        paddingRight: 0,
        paddingLeft: 0,
        marginRight: 'auto',
        marginLeft: 0,
    },
    crossOut: {
        textDecoration: 'line-through',
    },
    yourPrice: {
        display: 'flex',
        gap: theme.spacing(0.5),
    },
}));
const Overview = ({ dataOverviewClassName, dataPoints, fullWidth }) => {
    const classes = useStyles$m();
    return (jsx(Grid$1, Object.assign({ container: true, item: true, sm: fullWidth ? 12 : 8, className: cn(classes.overview, dataOverviewClassName) }, { children: dataPoints.map((point, i) => {
            const hasStat = point.stat !== EMPTY_DATA;
            return (jsxs(Grid$1, Object.assign({ item: true, className: classes.item }, { children: [jsx(Typography$1, Object.assign({ variant: "caption", color: "textSecondary" }, { children: jsxs(Box$1, Object.assign({ component: "span", position: "relative" }, { children: [point.title, !point.tooltip ? null : (jsx(Box$1, Object.assign({ top: "-4px", position: "absolute", ml: "calc(100% + 4px)", style: { transform: 'scale(0.9)' } }, { children: jsx(Info, Object.assign({ tooltipProps: { placement: 'top' }, outlinedIcon: true, color: "default" }, { children: point.tooltip })) })))] })) })), point.secondary ? (jsxs(Box$1, Object.assign({ className: classes.yourPrice }, { children: [!hasStat ? null : jsx(Typography$1, Object.assign({ className: classes.crossOut }, { children: point.stat })), jsx(Typography$1, { children: point.secondary })] }))) : (jsx(Typography$1, { children: point.stat }))] }), i));
        }) }), "overview"));
};

const useStyles$l = makeStyles((theme) => ({
    cardContent: {
        /** Override card content padding */
        paddingBottom: `${theme.spacing(2)}px!important`,
    },
    more: {
        color: theme.palette.primary.dark,
    },
    moreContainer: {
        backgroundColor: '#7491FF14',
        margin: theme.spacing(1.5, -2, -2, -2),
        padding: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
            '& $more': {
                textDecoration: 'underline',
            },
        },
    },
    bulletPoint: {
        fontWeight: 300,
        width: '90%',
        textOverflow: 'ellipsis',
        textWrap: 'nowrap',
        overflow: 'hidden',
    },
}));
const getRandomBullet = (points) => {
    const index = Math.floor(Math.random() * points.length);
    return points[index];
};
const useDefaultDataPoints = (college, dataPoints) => {
    return useMemo(() => {
        if (!isEmpty$1(dataPoints))
            return dataPoints; // consumers can provide their own data points
        const underGradEnroll = college.UnderGradEnroll;
        const isNum = isNumber$1(underGradEnroll);
        const undergrads = isNum ? underGradEnroll.toLocaleString() : EMPTY_DATA;
        return [
            { title: 'Admission Rate', stat: formatPercentage(college.Selectivity) },
            { title: 'Average SAT / ACT', stat: `${college.SATAvg} / ${college.ACTAvg}` },
            { title: 'Undergraduate Students', stat: undergrads },
        ];
    }, [college, dataPoints]);
};
const Content$2 = ({ dataOverviewClassName, dataPoints, bulletPoints, additionalContent, noContent, college, }) => {
    const classes = useStyles$l();
    const data = useDefaultDataPoints(college, dataPoints);
    return (jsxs(CardContent, Object.assign({ className: classes.cardContent }, { children: [jsx(Overview, { dataOverviewClassName: dataOverviewClassName, dataPoints: data, fullWidth: !!additionalContent || !!noContent }), isEmpty$1(bulletPoints) ? null : (jsxs("div", Object.assign({ className: classes.moreContainer }, { children: [jsx(Typography$1, Object.assign({ className: classes.bulletPoint }, { children: getRandomBullet(bulletPoints) })), jsx(Typography$1, Object.assign({ variant: "body1", className: classes.more }, { children: "More" }))] })))] })));
};

const useStyles$k = makeStyles((theme) => ({
    actions: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: theme.spacing(1),
        /* Override default card last-child padding */
        padding: `${theme.spacing(2)}px!important`,
        /* Override last button to align to the left of the card*/
        '&>*:nth-last-child(1)': {
            marginLeft: '0!important',
            marginRight: '0!important',
        },
        /* Override second to last button to align to the left of the card in large screens and to the right in smaller screens*/
        '&>*:nth-child(2)': {
            marginLeft: 'auto',
            [theme.breakpoints.down('xs')]: {
                marginRight: 'auto',
                marginLeft: 0,
            },
        },
    },
}));
const Actions$2 = ({ actions }) => {
    const classes = useStyles$k();
    return !actions ? null : (jsxs(Fragment$1, { children: [jsx(Divider$1, {}), jsx(CardContent, Object.assign({ className: classes.actions }, { children: actions }))] }));
};

const useStyles$j = makeStyles((theme) => ({
    content: {
        width: '33%',
        padding: 0,
        /** Override card content padding */
        paddingBottom: '0px!important',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            margin: 0,
        },
    },
}));
const AdditionalContent = ({ additionalContent }) => {
    const classes = useStyles$j();
    return !additionalContent ? null : jsx(CardContent, Object.assign({ className: classes.content }, { children: additionalContent }));
};

const useStyles$i = makeStyles((theme) => ({
    cardContainer: {
        marginBottom: theme.spacing(2),
    },
    link: {
        color: 'inherit',
        textDecoration: 'none',
        '&:hover': {
            cursor: 'pointer',
            color: 'inherit',
            textDecoration: 'none',
            '& $title': {
                textDecoration: 'underline',
                color: '#0c4257',
            },
        },
    },
    title: {},
    details: {
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    withContent: {
        width: '67%',
        '&:hover': {
            cursor: 'pointer',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
    },
    withoutContent: {
        width: '100%',
        '&:hover': {
            cursor: 'pointer',
        },
    },
}));
const ResultTile = ({ college, dataOverviewClassName, dataPoints, additionalContent, actions, detailLink, topLabels, noContent, isTnTSearchFilterEnabled = false, }) => {
    const classes = useStyles$i();
    return (jsxs(Card$1, Object.assign({ className: classes.cardContainer, elevation: 1 }, { children: [jsxs(Box$1, Object.assign({ className: classes.details, display: "flex", flexDirection: "row" }, { children: [jsxs("div", Object.assign({ className: additionalContent ? classes.withContent : classes.withoutContent }, { children: [jsx(CollegeSearchTags, { college: college, topLabels: topLabels }), jsxs(Link, Object.assign({ to: detailLink, className: classes.link }, { children: [jsx(Header$1, { college: college, titleClassName: classes.title, isTnTSearchFilterEnabled: isTnTSearchFilterEnabled }), jsx(Divider$1, {}), jsx(Content$2, { college: college, dataOverviewClassName: dataOverviewClassName, dataPoints: dataPoints, bulletPoints: college === null || college === void 0 ? void 0 : college.BulletPoints, additionalContent: additionalContent, noContent: noContent })] }))] })), jsx(AdditionalContent, { additionalContent: additionalContent })] })), jsx(Actions$2, { actions: actions })] })));
};
ResultTile.formatters = formatters;

const icons = {
    //Academic Focus
    Agriculture: { icon: faFarm, selectedIcon: faFarm$1 },
    Animals: { icon: faElephant, selectedIcon: faElephant$1 },
    Architecture: { icon: faCity, selectedIcon: faCity$1 },
    Biology: { icon: faDna, selectedIcon: faDna$1 },
    Business: { icon: faBriefcase, selectedIcon: faBriefcase$1 },
    Chemistry: { icon: faFlask, selectedIcon: faFlask$1 },
    Communications: { icon: faBroadcastTower, selectedIcon: faBroadcastTower$1 },
    'Computer Science': { icon: faRobot, selectedIcon: faRobot$1 },
    Construction: { icon: faUserHardHat, selectedIcon: faUserHardHat$1 },
    'Criminal Justice': { icon: faBalanceScale, selectedIcon: faBalanceScale$1 },
    'Cultural Studies': { icon: faLandmark, selectedIcon: faLandmark$1 },
    Dance: { icon: faTransporter, selectedIcon: faTransporter$1 },
    Ecology: { icon: faLeaf, selectedIcon: faLeaf$1 },
    Education: { icon: faSchool, selectedIcon: faSchool$1 },
    Engineering: { icon: faCogs, selectedIcon: faCogs$1 },
    English: { icon: faBooks, selectedIcon: faBooks$1 },
    Environment: { icon: faSeedling, selectedIcon: faSeedling$1 },
    'Ethnic Studies': { icon: faBook$1, selectedIcon: faBook },
    'Fashion & Design': { icon: faPencilRuler, selectedIcon: faPencilRuler$1 },
    'Gender Studies': { icon: faUser, selectedIcon: faUser$1 },
    Geology: { icon: faComet, selectedIcon: faComet$1 },
    Government: { icon: faLandmark, selectedIcon: faLandmark$1 },
    Health: { icon: faHeartbeat, selectedIcon: faHeartbeat$1 },
    History: { icon: faHistory, selectedIcon: faHistory$1 },
    Journalism: { icon: faNewspaper, selectedIcon: faNewspaper$1 },
    Languages: { icon: faLanguage, selectedIcon: faLanguage$1 },
    Law: { icon: faGavel, selectedIcon: faGavel$1 },
    Literature: { icon: faBook$1, selectedIcon: faBook },
    Marketing: { icon: faMegaphone, selectedIcon: faMegaphone$1 },
    Math: { icon: faCalculatorAlt, selectedIcon: faCalculatorAlt$1 },
    Medicine: { icon: faStethoscope, selectedIcon: faStethoscope$1 },
    Military: { icon: faShield, selectedIcon: faShield$1 },
    Music: { icon: faMusic, selectedIcon: faMusic$1 },
    Nursing: { icon: faUserNurse, selectedIcon: faUserNurse$1 },
    Philosophy: { icon: faHeadSideBrain, selectedIcon: faHeadSideBrain$1 },
    Physics: { icon: faAtom, selectedIcon: faAtom$1 },
    'Political Science': { icon: faPersonSign, selectedIcon: faPersonSign$1 },
    Psychology: { icon: faBrain, selectedIcon: faBrain$1 },
    Religion: { icon: faPlaceOfWorship, selectedIcon: faPlaceOfWorship$1 },
    Science: { icon: faMicroscope, selectedIcon: faMicroscope$1 },
    'Social Work': { icon: faHandsHeart, selectedIcon: faHandsHeart$1 },
    Sociology: { icon: faUsers, selectedIcon: faUsers$1 },
    Sports: { icon: faRunning, selectedIcon: faRunning$1 },
    Technology: { icon: faPhoneLaptop, selectedIcon: faPhoneLaptop$1 },
    'Television & Film': { icon: faCameraMovie, selectedIcon: faCameraMovie$1 },
    Theatre: { icon: faTheaterMasks, selectedIcon: faTheaterMasks$1 },
    Theology: { icon: faPlaceOfWorship, selectedIcon: faPlaceOfWorship$1 },
    Transportation: { icon: faCarBus, selectedIcon: faCarBus$1 },
    'Visual Arts': { icon: faPalette, selectedIcon: faPalette$1 },
    Humanities: { icon: faUsers, selectedIcon: faUsers$1 },
    'Liberal Arts': { icon: faUniversity, selectedIcon: faUniversity$1 },
    Conservation: { icon: faHandHoldingSeedling, selectedIcon: faHandHoldingSeedling$1 },
    'Natural Resources': { icon: faPlanetMoon, selectedIcon: faPlanetMoon$1 },
    Software: { icon: faCog, selectedIcon: faCog$1 },
    Design: { icon: faPenNib, selectedIcon: faPenNib$1 },
    Art: { icon: faPalette, selectedIcon: faPalette$1 },
    Astronomy: { icon: faStars, selectedIcon: faStars$1 },
    Fitness: { icon: faRunning, selectedIcon: faRunning$1 },
    Leisure: { icon: faUmbrellaBeach, selectedIcon: faUmbrellaBeach$1 },
    Family: { icon: faUsers, selectedIcon: faUsers$1 },
    Recreation: { icon: faWalking, selectedIcon: faWalking$1 },
    'Home Economics': { icon: faHouse, selectedIcon: faHouse$1 },
    Parks: { icon: faTree, selectedIcon: faTree$1 },
    'Culinary Arts': { icon: faHatChef, selectedIcon: faHatChef$1 },
    Library: { icon: faBooks, selectedIcon: faBooks$1 },
    'Protective Services': { icon: faUserShield, selectedIcon: faUserShield$1 },
    Writing: { icon: faPen, selectedIcon: faPen$1 },
    Criminology: { icon: faSearch, selectedIcon: faSearch$1 },
    Apparel: { icon: faTshirt, selectedIcon: faTshirt$1 },
    Cosmetology: { icon: faLips, selectedIcon: faLips$1 },
    Funeral: { icon: faCoffin, selectedIcon: faCoffin$1 },
    Mortuary: { icon: faCoffin, selectedIcon: faCoffin$1 },
    Textiles: { icon: faTshirt, selectedIcon: faTshirt$1 },
    //Campus Tour
    Apartments: { icon: faHouse, selectedIcon: faHouse$1 },
    'Athletic Facilities': { icon: faRunning, selectedIcon: faRunning$1 },
    Auditorium: { icon: faPresentation, selectedIcon: faPresentation$1 },
    Classrooms: { icon: faChalkboard, selectedIcon: faChalkboard$1 },
    'Computer Labs': { icon: faDesktop, selectedIcon: faDesktop$1 },
    Disabilities: { icon: faUniversalAccess, selectedIcon: faUniversalAccess$1 },
    Dining: { icon: faUtensilsAlt, selectedIcon: faUtensilsAlt$1 },
    Dorms: { icon: faBed, selectedIcon: faBed$1 },
    'Fitness Center': { icon: faDumbbell, selectedIcon: faDumbbell$1 },
    'Health Center': { icon: faMedkit, selectedIcon: faMedkit$1 },
    Housing: { icon: faHouse, selectedIcon: faHouse$1 },
    Labs: { icon: faVial, selectedIcon: faVial$1 },
    Safety: { icon: faShield, selectedIcon: faShield$1 },
    Studios: { icon: faPallet, selectedIcon: faPallet$1 },
    Traditions: { icon: faHandshake, selectedIcon: faHandshake$1 },
    'Virtual Tour': { icon: faPlay, selectedIcon: faPlay$1 },
    Culture: { icon: faGlobe, selectedIcon: faGlobe$1 },
    //Hobbies
    Anime: { icon: faCommentAltExclamation, selectedIcon: faCommentAltExclamation$1 },
    Automotive: { icon: faCar, selectedIcon: faCar$1 },
    Baking: { icon: faPie, selectedIcon: faPie$1 },
    Beach: { icon: faUmbrellaBeach, selectedIcon: faUmbrellaBeach$1 },
    Blacksmithing: { icon: faSparkles, selectedIcon: faSparkles$1 },
    'Board Games': { icon: faChess, selectedIcon: faChess$1 },
    Boating: { icon: faAnchor, selectedIcon: faAnchor$1 },
    Camping: { icon: faCampground, selectedIcon: faCampground$1 },
    Circus: { icon: faCommentAltExclamation, selectedIcon: faCommentAltExclamation$1 },
    'Comic Books': { icon: faCommentAltExclamation, selectedIcon: faCommentAltExclamation$1 },
    Cooking: { icon: faHatChef, selectedIcon: faHatChef$1 },
    Cosplay: { icon: faTheaterMasks, selectedIcon: faTheaterMasks$1 },
    Crafts: { icon: faHandScissors, selectedIcon: faHandScissors$1 },
    Debate: { icon: faPodium, selectedIcon: faPodium$1 },
    Farming: { icon: faFarm, selectedIcon: faFarm$1 },
    Flying: { icon: faPlane, selectedIcon: faPlane$1 },
    Gaming: { icon: faGamepadAlt, selectedIcon: faGamepadAlt$1 },
    Gardening: { icon: faLeaf, selectedIcon: faLeaf$1 },
    'Glass Blowing': { icon: faLightbulb$1, selectedIcon: faLightbulb },
    'Graphic Novels': { icon: faCommentAltExclamation, selectedIcon: faCommentAltExclamation$1 },
    Investing: { icon: faChartLine, selectedIcon: faChartLine$1 },
    Juggling: { icon: faSpinner, selectedIcon: faSpinner$1 },
    Motorsports: { icon: faMotorcycle, selectedIcon: faMotorcycle$1 },
    Outdoors: { icon: faTree, selectedIcon: faTree$1 },
    'Outer Space': { icon: faTelescope$1, selectedIcon: faTelescope },
    Paranormal: { icon: faGhost, selectedIcon: faGhost$1 },
    Reading: { icon: faBook$1, selectedIcon: faBook },
    Robotics: { icon: faRobot, selectedIcon: faRobot$1 },
    Rocketry: { icon: faRocket, selectedIcon: faRocket$1 },
    Rodeo: { icon: faHorseSaddle, selectedIcon: faHorseSaddle$1 },
    'Role Playing': { icon: faTheaterMasks, selectedIcon: faTheaterMasks$1 },
    'Science Fiction': { icon: faUfo, selectedIcon: faUfo$1 },
    Travel: { icon: faPlane, selectedIcon: faPlane$1 },
    'Video Games': { icon: faGamepadAlt, selectedIcon: faGamepadAlt$1 },
    Welding: { icon: faSparkles, selectedIcon: faSparkles$1 },
    Woodworking: { icon: faAxe, selectedIcon: faAxe$1 },
    'Amusement Park': { icon: faPennant, selectedIcon: faPennant$1 },
    Aquarium: { icon: faFish, selectedIcon: faFish$1 },
    Attractions: { icon: faLandmark, selectedIcon: faLandmark$1 },
    Concerts: { icon: faMicrophone, selectedIcon: faMicrophone$1 },
    Film: { icon: faCameraMovie, selectedIcon: faCameraMovie$1 },
    'Local Tours': { icon: faMap, selectedIcon: faMap$1 },
    Museum: { icon: faImage, selectedIcon: faImage$1 },
    Shopping: { icon: faShoppingBag, selectedIcon: faShoppingBag$1 },
    Zoo: { icon: faMonkey, selectedIcon: faMonkey$1 },
    // Leisure
    'A Capella': { icon: faMusic, selectedIcon: faMusic },
    Acting: { icon: faTheaterMasks, selectedIcon: faTheaterMasks$1 },
    Band: { icon: faDrum, selectedIcon: faDrum$1 },
    Choir: { icon: faListMusic, selectedIcon: faListMusic$1 },
    Choreography: { icon: faChild, selectedIcon: faChild$1 },
    'Classical Music': { icon: faMusic, selectedIcon: faMusic$1 },
    'Color Guard': { icon: faMusic, selectedIcon: faMusic$1 },
    Comedy: { icon: faLaugh, selectedIcon: faLaugh$1 },
    Drama: { icon: faTheaterMasks, selectedIcon: faTheaterMasks$1 },
    Drumline: { icon: faDrum, selectedIcon: faDrum$1 },
    Guitar: { icon: faGuitar, selectedIcon: faGuitar$1 },
    Improv: { icon: faTheaterMasks, selectedIcon: faTheaterMasks$1 },
    Jazz: { icon: faSaxophone, selectedIcon: faSaxophone$1 },
    'Marching Band': { icon: faDrum, selectedIcon: faDrum$1 },
    Modeling: { icon: faCamera, selectedIcon: faCamera$1 },
    'Music Production': { icon: faUserHeadset, selectedIcon: faUserHeadset$1 },
    'Musical Theatre': { icon: faTheaterMasks, selectedIcon: faTheaterMasks$1 },
    Musicals: { icon: faMusic, selectedIcon: faMusic$1 },
    Orchestra: { icon: faViolin, selectedIcon: faViolin$1 },
    'Pep Band': { icon: faTrumpet, selectedIcon: faTrumpet$1 },
    'Performing Arts - General': { icon: faMusic, selectedIcon: faMusic$1 },
    Piano: { icon: faPiano, selectedIcon: faPiano$1 },
    'Public Speaking': { icon: faBookOpen, selectedIcon: faBookOpen$1 },
    Radio: { icon: faRadio, selectedIcon: faRadio$1 },
    'Stage Crew': { icon: faCog, selectedIcon: faCog$1 },
    Symphony: { icon: faMusic, selectedIcon: faMusic$1 },
    //School Programs
    'Career Development': { icon: faChartLine, selectedIcon: faChartLine$1 },
    'Greek Life': { icon: faSigma, selectedIcon: faSigma$1 },
    'Honors Societies': { icon: faAward, selectedIcon: faAward$1 },
    Internships: { icon: faBriefcase, selectedIcon: faBriefcase$1 },
    Mentoring: { icon: faHandshake, selectedIcon: faHandshake$1 },
    Research: { icon: faBook$1, selectedIcon: faBook },
    Scholarships: { icon: faHandHoldingUsd, selectedIcon: faHandHoldingUsd$1 },
    'School Spirit': { icon: faMegaphone, selectedIcon: faMegaphone$1 },
    'Student Government': { icon: faLandmark, selectedIcon: faLandmark$1 },
    'Student Involvement': { icon: faUsers, selectedIcon: faUsers$1 },
    'Study Abroad': { icon: faGlobeStand, selectedIcon: faGlobeStand$1 },
    'Support Groups': { icon: faHandsHelping, selectedIcon: faHandsHelping$1 },
    Tutoring: { icon: faChalkboardTeacher, selectedIcon: faChalkboardTeacher$1 },
    Volunteering: { icon: faHandsHeart, selectedIcon: faHandsHeart$1 },
    //Socioculture
    'Animal Welfare': { icon: faPaw, selectedIcon: faPaw$1 },
    Diversity: { icon: faGlobe, selectedIcon: faGlobe$1 },
    Equality: { icon: faBalanceScale, selectedIcon: faBalanceScale$1 },
    Faith: { icon: faPlaceOfWorship, selectedIcon: faPlaceOfWorship$1 },
    Fundraising: { icon: faHandHoldingUsd, selectedIcon: faHandHoldingUsd$1 },
    'Gender Identity': { icon: faVenusMars, selectedIcon: faVenusMars$1 },
    'Health + Wellness': { icon: faHeartbeat, selectedIcon: faHeartbeat$1 },
    'Human Rights': { icon: faHandHoldingHeart, selectedIcon: faHandHoldingHeart$1 },
    Leadership: { icon: faPodium, selectedIcon: faPodium$1 },
    LGBTQ: { icon: faRainbow, selectedIcon: faRainbow$1 },
    'Mock Trial': { icon: faGavel, selectedIcon: faGavel$1 },
    Politics: { icon: faLandmark, selectedIcon: faLandmark$1 },
    Secularism: { icon: faGlobe, selectedIcon: faGlobe$1 },
    'Sign Language': { icon: faHands, selectedIcon: faHands$1 },
    Speech: { icon: faComments, selectedIcon: faComments$1 },
    Spirituality: { icon: faPrayingHands, selectedIcon: faPrayingHands$1 },
    Veterans: { icon: faMedal, selectedIcon: faMedal$1 },
    //Sports and Leisure
    Archery: { icon: faBowArrow, selectedIcon: faBowArrow$1 },
    Athletics: { icon: faRunning, selectedIcon: faRunning$1 },
    Badminton: { icon: faShuttlecock, selectedIcon: faShuttlecock$1 },
    Baseball: { icon: faBaseballBall, selectedIcon: faBaseballBall$1 },
    Basketball: { icon: faBasketballBall, selectedIcon: faBasketballBall$1 },
    'Beach Volleyball': { icon: faVolleyballBall, selectedIcon: faVolleyballBall$1 },
    Billiards: { icon: faBallPile, selectedIcon: faBallPile$1 },
    Bowling: { icon: faBowlingPins, selectedIcon: faBowlingPins$1 },
    Boxing: { icon: faBoxingGlove, selectedIcon: faBoxingGlove$1 },
    Cheerleading: { icon: faMegaphone, selectedIcon: faMegaphone$1 },
    'Club Sports': { icon: faStar, selectedIcon: faStar$1 },
    Crew: { icon: faWater, selectedIcon: faWater$1 },
    Cricket: { icon: faCricket, selectedIcon: faCricket$1 },
    'Cross Country': { icon: faRunning, selectedIcon: faRunning$1 },
    Cycling: { icon: faBicycle, selectedIcon: faBicycle$1 },
    'Dance Team': { icon: faChild, selectedIcon: faChild$1 },
    'Disc Golf': { icon: faCircle, selectedIcon: faCircle$1 },
    Diving: { icon: faSwimmer, selectedIcon: faSwimmer$1 },
    Dodgeball: { icon: faVolleyballBall, selectedIcon: faVolleyballBall$1 },
    Equestrian: { icon: faHorseSaddle, selectedIcon: faHorseSaddle$1 },
    Fencing: { icon: faSwords, selectedIcon: faSwords$1 },
    'Field Hockey': { icon: faFieldHockey, selectedIcon: faFieldHockey$1 },
    'Figure Skating': { icon: faSkating, selectedIcon: faSkating$1 },
    Fishing: { icon: faFish, selectedIcon: faFish$1 },
    'Flag Football': { icon: faFootballBall, selectedIcon: faFootballBall$1 },
    Football: { icon: faFootballBall, selectedIcon: faFootballBall$1 },
    Golf: { icon: faGolfClub, selectedIcon: faGolfClub$1 },
    Gymnastics: { icon: faChild, selectedIcon: faChild$1 },
    'Hand Ball': { icon: faFutbol, selectedIcon: faFutbol$1 },
    Hiking: { icon: faHiking, selectedIcon: faHiking$1 },
    'Horseback Riding': { icon: faHorseSaddle, selectedIcon: faHorseSaddle$1 },
    Hunting: { icon: faBowArrow, selectedIcon: faBowArrow$1 },
    'Ice Hockey': { icon: faHockeySticks, selectedIcon: faHockeySticks$1 },
    'Intramural Sports': { icon: faStar, selectedIcon: faStar$1 },
    Lacrosse: { icon: faCircle, selectedIcon: faCircle$1 },
    'Martial Arts': { icon: faBoxingGlove, selectedIcon: faBoxingGlove$1 },
    Paddling: { icon: faWater, selectedIcon: faWater$1 },
    Paintball: { icon: faBullseye, selectedIcon: faBullseye$1 },
    Parkour: { icon: faSkiJump, selectedIcon: faSkiJump$1 },
    Polo: { icon: faHorseSaddle, selectedIcon: faHorseSaddle$1 },
    Quidditch: { icon: faQuidditch, selectedIcon: faQuidditch$1 },
    'Racquet Ball': { icon: faRacquet, selectedIcon: faRacquet$1 },
    'Rock Climbing': { icon: faHandRock, selectedIcon: faHandRock$1 },
    'Roller Hockey': { icon: faHockeySticks, selectedIcon: faHockeySticks$1 },
    'Roller Skating': { icon: faSkating, selectedIcon: faSkating$1 },
    Rowing: { icon: faWater, selectedIcon: faWater$1 },
    Rugby: { icon: faFootballBall, selectedIcon: faFootballBall$1 },
    Running: { icon: faRunning, selectedIcon: faRunning$1 },
    Sailing: { icon: faWater, selectedIcon: faWater$1 },
    'Scuba Diving': { icon: faSwimmer, selectedIcon: faSwimmer$1 },
    Shooting: { icon: faBullseye, selectedIcon: faBullseye$1 },
    Skateboarding: { icon: faSkating, selectedIcon: faSkating$1 },
    Skiing: { icon: faSkiing, selectedIcon: faSkiing$1 },
    Skydiving: { icon: faParachuteBox, selectedIcon: faParachuteBox$1 },
    Snowboarding: { icon: faSnowboarding, selectedIcon: faSnowboarding$1 },
    Soccer: { icon: faFutbol, selectedIcon: faFutbol$1 },
    Softball: { icon: faBaseball, selectedIcon: faBaseball$1 },
    Squash: { icon: faRacquet, selectedIcon: faRacquet$1 },
    Surfing: { icon: faWater, selectedIcon: faWater$1 },
    Swimming: { icon: faSwimmer, selectedIcon: faSwimmer$1 },
    'Table Tennis': { icon: faTableTennis, selectedIcon: faTableTennis$1 },
    Tennis: { icon: faRacquet, selectedIcon: faRacquet$1 },
    'Track and Field': { icon: faRunning, selectedIcon: faRunning$1 },
    Triathlon: { icon: faTriangle, selectedIcon: faTriangle$1 },
    'Ultimate Frisbee': { icon: faCircle, selectedIcon: faCircle$1 },
    Volleyball: { icon: faVolleyballBall, selectedIcon: faVolleyballBall$1 },
    'Water Polo': { icon: faVolleyballBall, selectedIcon: faVolleyballBall$1 },
    'Water Sports': { icon: faWater, selectedIcon: faWater$1 },
    'Weight Lifting': { icon: faDumbbell, selectedIcon: faDumbbell$1 },
    'Winter Sports': { icon: faSnowflake, selectedIcon: faSnowflake$1 },
    Wrestling: { icon: faHandshake, selectedIcon: faHandshake$1 },
    Yoga: { icon: faPrayingHands, selectedIcon: faPrayingHands$1 },
    //visual Arts
    Animation: { icon: faFileVideo, selectedIcon: faFileVideo$1 },
    Broadcasting: { icon: faMegaphone, selectedIcon: faMegaphone$1 },
    Ceramics: { icon: faMug, selectedIcon: faMug$1 },
    Drawing: { icon: faPencil, selectedIcon: faPencil$1 },
    Fashion: { icon: faTshirt, selectedIcon: faTshirt$1 },
    'Film Making': { icon: faCameraMovie, selectedIcon: faCameraMovie$1 },
    'Graphic Design': { icon: faPenNib, selectedIcon: faPenNib$1 },
    Painting: { icon: faPaintBrush, selectedIcon: faPaintBrush$1 },
    Photography: { icon: faCamera, selectedIcon: faCamera$1 },
    Pottery: { icon: faMug, selectedIcon: faMug$1 },
    Sculpting: { icon: faAxe, selectedIcon: faAxe$1 },
    'Video Production': { icon: faFilm, selectedIcon: faFilm$1 },
    'Visual Arts - General': { icon: faPalette, selectedIcon: faPalette$1 },
    //Writing
    'Creative Writing': { icon: faBookOpen, selectedIcon: faBookOpen$1 },
    Newspaper: { icon: faNewspaper, selectedIcon: faNewspaper$1 },
    Playwriting: { icon: faTheaterMasks, selectedIcon: faTheaterMasks$1 },
    Poetry: { icon: faFeather, selectedIcon: faFeather$1 },
    Publishing: { icon: faPrint, selectedIcon: faPrint$1 },
    'Writing - General': { icon: faPen, selectedIcon: faPen$1 },
    Yearbook: { icon: faBook$1, selectedIcon: faBook },
};

const useBreakpoint = function () {
  let breakpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'sm';
  let helper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'only';
  // https://v4.mui.com/customization/breakpoints/#css-media-queries
  const theme = useTheme();
  const fn = theme.breakpoints[helper];
  let bp;
  if (helper === 'between' && isArray(breakpoint)) {
    bp = fn(...breakpoint);
  } else {
    bp = fn(breakpoint);
  }
  return useMediaQuery(bp);
};

/**
 * This hook provides generic open/close functionality.
 * @param {bool} initial
 * @returns Object { open: true, onOpen: fn, onClose: fn }
 */
const useOpenClose = initial => {
  const [open, setOpen] = useState(initial);
  return {
    open,
    onOpen: () => setOpen(true),
    onClose: () => setOpen(false)
  };
};

const useStyles$h = makeStyles({
    root: {
        overflowY: 'auto',
        overflowX: 'hidden',
    },
});
const ScrollWrapper = (_a) => {
    var { maxHeight, children, className, stopPropagation } = _a, rest = __rest(_a, ["maxHeight", "children", "className", "stopPropagation"]);
    const classes = useStyles$h();
    return (jsx("div", Object.assign({}, rest, { className: cn(className, classes.root), style: { maxHeight }, onScroll: (e) => {
            if (stopPropagation) {
                e.stopPropagation();
            }
        } }, { children: children })));
};

const useStyles$g = makeStyles(theme => {
  return {
    filterButton: {
      borderColor: 'rgba(0, 125, 170, 0.5)',
      borderWidth: 1,
      '&:hover': {
        borderWidth: 1,
        borderColor: theme.palette.primary.main,
        background: 'rgba(0, 125, 170, 0.08)'
      }
    },
    active: {
      background: 'rgba(0, 125, 170, 0.08)',
      borderColor: theme.palette.primary.main
    },
    scrollWrapper: {
      flexGrow: '1',
      maxHeight: 'calc(80vh - 110px)',
      [theme.breakpoints.down('xs')]: {
        maxHeight: 'calc(100vh - 245px)',
        paddingBottom: '53px'
      }
    },
    paper: {
      width: '320px',
      display: 'flex',
      maxHeight: '80vh',
      flexDirection: 'column',
      [theme.breakpoints.down('xs')]: {
        marginTop: '0px',
        width: '100%',
        maxWidth: 'none',
        bottom: 0
      }
    },
    footer: {
      [theme.breakpoints.down('xs')]: {
        bottom: 0,
        position: 'absolute',
        marginTop: '60px',
        width: '100%',
        background: 'white'
      }
    }
  };
});
const getDisplayTextFromSelectedValues = (values, defaultLabel) => {
  let displayText = defaultLabel;
  const count = size(values);
  if (count) {
    displayText = values[0];
    if (count > 1) {
      displayText += ` +${count - 1}`;
    }
  }
  return displayText;
};
const getReference = isXs => isXs ? 'none' : 'anchorEl';
const getTransformOrigin = isXs => {
  if (isXs) {
    return {
      vertical: 'bottom',
      horizontal: 'center'
    };
  } else {
    return {
      vertical: 'top',
      horizontal: 'left'
    };
  }
};

/**
 * This is the dropdown for the search filter bar
 * @prop {string} fieldLabel
 * @prop {string} buttonLabel
 * @prop {array} selectionLabels
 * @prop {func} onClear
 * @prop {node} children
 * @returns dropdown Component
 */
const Dropdown = _ref => {
  let {
    fieldLabel,
    buttonLabel,
    selectionLabels,
    onClear,
    children,
    id
  } = _ref;
  const classes = useStyles$g();
  const {
    open: openPopover,
    onOpen: onOpenPopover,
    onClose: onClosePopover
  } = useOpenClose(false);
  const anchorEl = useRef(null);
  const buttonText = getDisplayTextFromSelectedValues(selectionLabels, buttonLabel);
  const hasSelections = size(selectionLabels) > 0;
  const isActive = openPopover || hasSelections;
  const isXs = useBreakpoint('xs', 'down');
  return /*#__PURE__*/React.createElement(Box, {
    position: "relative",
    zIndex: 0
  }, /*#__PURE__*/React.createElement(Box, {
    mr: 2
  }, /*#__PURE__*/React.createElement(Button, {
    id: id,
    className: cn(classes.filterButton, {
      [classes.active]: isActive
    }),
    ref: anchorEl,
    color: "primary",
    endIcon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faCaretDown,
      size: "xs"
    }),
    onClick: onOpenPopover,
    variant: "outlined"
  }, buttonText)), /*#__PURE__*/React.createElement(Popover, {
    classes: {
      paper: classes.paper
    },
    id: "filter-bar-dropdown",
    open: openPopover,
    marginThreshold: 0,
    anchorReference: getReference(isXs),
    BackdropProps: {
      invisible: !isXs
    },
    anchorEl: anchorEl.current,
    onClose: onClosePopover,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: getTransformOrigin(isXs)
  }, /*#__PURE__*/React.createElement(Box, {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "align-content": "flex-start"
  }, /*#__PURE__*/React.createElement(ListSubheader, {
    variant: "subtitle2",
    disableSticky: true
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }, fieldLabel, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: onClosePopover,
    "aria-label": "close"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faTimes$1
  })))), /*#__PURE__*/React.createElement(ScrollWrapper, {
    className: classes.scrollWrapper
  }, children), onClear && /*#__PURE__*/React.createElement(Box, {
    className: classes.footer
  }, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Box, {
    m: 1
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    variant: "text",
    disabled: !hasSelections,
    onClick: onClear
  }, "Clear All"))))));
};
Dropdown.propTypes = {
  fieldLabel: PropTypes.string,
  buttonLabel: PropTypes.string,
  selectionLabels: PropTypes.array,
  id: PropTypes.string,
  onClear: PropTypes.func,
  children: PropTypes.node
};

const mapData = rawData => {
  const universities = get(rawData, 'Universities');
  const content = get(rawData, 'ContentItemMap');
  const bullets = get(rawData, 'BulletPoints');
  return map(universities, (college, i) => ({
    ...college,
    BulletPoints: get(bullets, college.Scid),
    ContentItems: get(content, college.Scid),
    CalculatedFields: {
      ...(rawData.CalculatedFields ? rawData.CalculatedFields[i] : {}),
      Majors: rawData.Majors && rawData.Majors[i] ? map(rawData.Majors[i], 'CIPName') : []
    }
  }));
};

var compose = config => (preferences, facets) => omitBy(mapValues(config, fn => fn(preferences, facets)), isUndefined);

const api2internal$c = preferences => {
  return map(preferences.Location, pref => {
    const result = {
      state: reject(pref.State, isUndefined),
      country: reject(flatten([pref.LocationCategory]), isUndefined)
    };
    if (pref.Location) {
      result.geolocation = {
        name: pref.Location.name,
        coords: pref.Location.coordinates,
        from: pref.Location.from,
        to: pref.Location.to
      };
    }
    return result;
  });
};
const internal2api$9 = preferences => {
  if (preferences.location) {
    return map(preferences.location, pref => {
      const result = {
        State: pref.state,
        LocationCategory: pref.country
      };
      if (pref.geolocation) {
        result.Location = {
          name: pref.geolocation.name,
          coordinates: pref.geolocation.coords,
          from: pref.geolocation.from,
          to: pref.geolocation.to
        };
      }
      return result;
    });
  }
};

const formatRangeToNumber = range => ({
  from: parseInt(range.from, 10),
  to: parseInt(range.to, 10)
});
const formatRangeToString = range => ({
  from: `${range.from}`,
  to: `${range.to}`
});
const api2internal$b = preferences => map(preferences.TestsAndSelectivity, pref => {
  const result = {};
  if (pref.Selectivity) {
    result.acceptance = formatRangeToNumber(pref.Selectivity);
  }
  if (pref.SATAvg) {
    result.sat = formatRangeToNumber(pref.SATAvg);
  }
  if (pref.ACTAvg) {
    result.act = formatRangeToNumber(pref.ACTAvg);
  }
  return result;
});
const internal2api$8 = preferences => reject(map(preferences.scoresAcceptance, pref => {
  const result = {};
  if (pref.acceptance) {
    result.Selectivity = formatRangeToString(pref.acceptance);
  }
  if (pref.sat) {
    result.SATAvg = formatRangeToString(pref.sat);
  }
  if (pref.act) {
    result.ACTAvg = formatRangeToString(pref.act);
  }
  return result;
}), isEmpty);

const api2internal$a = preferences => {
  return map(preferences.Tags, pref => {
    return pref;
  });
};
const internal2api$7 = preferences => {
  return map(preferences.personalInterests, pref => {
    return pref;
  });
};

const api2internal$9 = preferences => {
  return map(preferences.UnderGradEnroll, identity);
};
const internal2api$6 = preferences => map(preferences.undergrads, pref => ({
  name: pref.name,
  to: pref.to.toString(),
  from: pref.from.toString()
}));

const api2internal$8 = preferences => map(preferences.Sports, pref => ({
  name: pref.Name,
  divisions: map(pref.Divisions, div => ({
    name: div.Name,
    selected: div.Selected
  }))
}));
const internal2api$5 = preferences => map(preferences.athletics, pref => ({
  Name: pref.name,
  Divisions: map(pref.divisions, div => ({
    Name: div.name,
    Selected: div.selected
  }))
}));

const api2internal$7 = preferences => {
  return flatten([map(preferences.AcademicFocus, focus => ({
    focus
  })), map(preferences.Majors, major => ({
    major
  }))]);
};
const internal2apiFocus = preferences => {
  if (preferences.academics) {
    return map(filter(preferences.academics, item => item.focus), 'focus');
  }
};
const internal2apiMajors = preferences => {
  if (preferences.academics) {
    return map(filter(preferences.academics, item => item.major), 'major');
  }
};

const api2internal$6 = preferences => {
  return flatten([map(preferences.Control, schoolType => ({
    schoolType
  })), map(preferences.Religious, religion => ({
    religion
  })), map(preferences.MinorityServingInst, minorityServingInst => ({
    minorityServingInst
  })), map(preferences.CoalitionMember, coalitionMember => ({
    coalitionMember
  }))]);
};
const internal2apiControl = preferences => {
  if (preferences.typeAffiliation) {
    return map(filter(preferences.typeAffiliation, item => item.schoolType), 'schoolType');
  }
};
const internal2apiReligious = preferences => {
  if (preferences.typeAffiliation) {
    return map(filter(preferences.typeAffiliation, item => item.religion), 'religion');
  }
};
const internal2apiMinorityServingInst = preferences => {
  if (preferences.typeAffiliation) {
    return map(filter(preferences.typeAffiliation, item => item.minorityServingInst), 'minorityServingInst');
  }
};
const internal2apiCoalitionMember = preferences => {
  if (preferences.typeAffiliation) {
    return map(filter(preferences.typeAffiliation, item => item.coalitionMember), 'coalitionMember');
  }
};

const api2internal$5 = preferences => {
  return map(preferences.Setting, identity);
};
const internal2api$4 = preferences => {
  return preferences.setting;
};

const api2internal$4 = preferences => {
  return map(preferences.Rotc, identity);
};
const internal2api$3 = preferences => {
  return preferences.rotc;
};

const api2internal$3 = preferences => {
  return map(preferences.Degrees, identity);
};
const internal2api$2 = preferences => {
  if (preferences.degrees) {
    return preferences.degrees;
  }
};

const api2internal$2 = preferences => {
  return flatten([map(preferences.UnivType, univType => ({
    univType
  })), map(preferences.SchoolClassifier, schoolClassifier => ({
    schoolClassifier
  }))]);
};
const internal2apiUnivType = preferences => {
  if (preferences.univType) {
    return map(filter(preferences.univType, item => item.univType), 'univType');
  }
};
const internal2apiSchoolClassifier = preferences => {
  if (preferences.univType) {
    return map(filter(preferences.univType, item => item.schoolClassifier), 'schoolClassifier');
  }
};

const api2internal$1 = preferences => {
  return map(preferences.ScoirApplyEnabled, scoirApplyEnabled => ({
    scoirApplyEnabled
  }));
};
const internal2api$1 = preferences => {
  if (preferences.appInfo) {
    return map(filter(preferences.appInfo, item => item.scoirApplyEnabled), 'scoirApplyEnabled');
  }
};

var api2internal = compose({
  location: api2internal$c,
  personalInterests: api2internal$a,
  undergrads: api2internal$9,
  athletics: api2internal$8,
  academics: api2internal$7,
  typeAffiliation: api2internal$6,
  setting: api2internal$5,
  rotc: api2internal$4,
  scoresAcceptance: api2internal$b,
  degrees: api2internal$3,
  univType: api2internal$2,
  appInfo: api2internal$1
});

var internal2api = compose({
  Location: internal2api$9,
  AcademicFocus: internal2apiFocus,
  Majors: internal2apiMajors,
  Degrees: internal2api$2,
  UnivType: internal2apiUnivType,
  SchoolClassifier: internal2apiSchoolClassifier,
  Rotc: internal2api$3,
  Sports: internal2api$5,
  UnderGradEnroll: internal2api$6,
  Tags: internal2api$7,
  TestsAndSelectivity: internal2api$8,
  Control: internal2apiControl,
  Religious: internal2apiReligious,
  MinorityServingInst: internal2apiMinorityServingInst,
  Setting: internal2api$4,
  CoalitionMember: internal2apiCoalitionMember,
  ScoirApplyEnabled: internal2api$1
});

const mileRangeMapping = (from, to) => {
  const destination = parseInt(to) > 500 ? '500mi+' : to;
  return `(${from} - ${destination})`.replace('mi', '');
};
var locationFn = pref => {
  const {
    geolocation,
    state,
    country
  } = pref;
  const formattedStates = map(state, s => getLabels('states', s));
  const stateStr = formattedStates.join(', ');
  const formattedCountries = map(country, pref => getLabels('countries', pref));
  const countryStr = formattedCountries.join(', ');
  if (geolocation) {
    let result = `${geolocation.name} ${mileRangeMapping(geolocation.from, geolocation.to)}`;
    if (stateStr) {
      result += `, ${stateStr}`;
    }
    if (countryStr) {
      result += `, ${countryStr}`;
    }
    return result;
  }
  if (stateStr) {
    let result = stateStr;
    if (countryStr) {
      result += `, ${countryStr}`;
    }
    return result;
  }
  if (countryStr) {
    return countryStr;
  }
};

const Display = _ref => {
  let {
    preference
  } = _ref;
  const lastIndex = preference.length - 1;
  return /*#__PURE__*/React.createElement("span", {
    "aria-label": toString(preference)
  }, map(preference, (str, i) => {
    if (i !== lastIndex) {
      return /*#__PURE__*/React.createElement("span", {
        key: i
      }, str, " \xB7 ");
    }
    return /*#__PURE__*/React.createElement("span", {
      key: i
    }, str);
  }));
};
Display.propTypes = {
  preference: PropTypes.array
};
Display.defaultProps = {
  preference: []
};

const Location = _ref => {
  let {
    preference
  } = _ref;
  const strings = map(preference, el => {
    const str = locationFn(el);
    return str;
  });
  return /*#__PURE__*/React.createElement(Display, {
    preference: strings
  });
};
Location.propTypes = {
  preference: PropTypes.array
};

const Undergrads = _ref => {
  let {
    preference
  } = _ref;
  const strings = map(preference, el => {
    const name = el.name;
    return name;
  });
  return /*#__PURE__*/React.createElement(Display, {
    preference: strings
  });
};
Undergrads.propTypes = {
  preference: PropTypes.array
};

const getDisplayLabelForRange = (label, from, to) => `${label} ${from} - ${to}`;
var scoresAcceptanceFn = pref => {
  const labels = [];
  const {
    acceptance,
    act,
    sat
  } = pref;
  if (pref.acceptance) {
    labels.push(getDisplayLabelForRange('Admission Rate', acceptance.from, acceptance.to));
  }
  if (pref.act) {
    labels.push(getDisplayLabelForRange('ACT Range', act.from, act.to));
  }
  if (pref.sat) {
    labels.push(getDisplayLabelForRange('SAT Range', sat.from, sat.to));
  }
  return labels.join(', ');
};

const ScoresAcceptance = _ref => {
  let {
    preference
  } = _ref;
  const strings = map(preference, el => {
    const str = scoresAcceptanceFn(el);
    return str;
  });
  return /*#__PURE__*/React.createElement(Display, {
    preference: strings
  });
};
ScoresAcceptance.propTypes = {
  preference: PropTypes.array
};

var athleticsFn = pref => {
  const {
    name,
    divisions
  } = pref;
  if (divisions) {
    const selectedDivisions = map(filter(divisions, 'selected'), 'name').join(', ');
    return `${name} ${selectedDivisions}`;
  }
  return name;
};

const Athletics = _ref => {
  let {
    preference
  } = _ref;
  const strings = map(preference, el => {
    const str = athleticsFn(el);
    return str;
  });
  return /*#__PURE__*/React.createElement(Display, {
    preference: strings
  });
};
Athletics.propTypes = {
  preference: PropTypes.array
};

const PersonalInterests = _ref => {
  let {
    preference
  } = _ref;
  return /*#__PURE__*/React.createElement(Display, {
    preference: preference
  });
};
PersonalInterests.propTypes = {
  preference: PropTypes.array
};

const TypeAffiliation = _ref => {
  let {
    preference
  } = _ref;
  const strings = map(preference, el => {
    if (!isEmpty(el.coalitionMember)) {
      return "Coalition for College";
    }
    const name = el.schoolType || el.religion || el.minorityServingInst;
    return name;
  });
  return /*#__PURE__*/React.createElement(Display, {
    preference: strings
  });
};
TypeAffiliation.propTypes = {
  preference: PropTypes.array
};

const Academics = _ref => {
  let {
    preference
  } = _ref;
  const strings = map(preference, el => {
    const name = el.focus || el.major;
    return name;
  });
  return /*#__PURE__*/React.createElement(Display, {
    preference: strings
  });
};
Academics.propTypes = {
  preference: PropTypes.array
};

const Setting = _ref => {
  let {
    preference
  } = _ref;
  return /*#__PURE__*/React.createElement(Display, {
    preference: preference
  });
};
Setting.propTypes = {
  preference: PropTypes.array
};

const Rotc$1 = _ref => {
  let {
    preference
  } = _ref;
  return /*#__PURE__*/React.createElement(Display, {
    preference: preference
  });
};
Rotc$1.propTypes = {
  preference: PropTypes.array
};

const Degrees = _ref => {
  let {
    preference
  } = _ref;
  const strings = map(preference, el => {
    const name = getLabels('degrees', el);
    return name;
  });
  return /*#__PURE__*/React.createElement(Display, {
    preference: strings
  });
};
Degrees.propTypes = {
  preference: PropTypes.array
};

const UnivType = _ref => {
  let {
    preference
  } = _ref;
  const strings = map(preference, el => {
    const name = getLabels('univType', el.univType) || getLabels('univType', el.schoolClassifier);
    return name;
  });
  return /*#__PURE__*/React.createElement(Display, {
    preference: strings
  });
};
UnivType.propTypes = {
  preference: PropTypes.array
};

const AppInfo = _ref => {
  let {
    preference
  } = _ref;
  const strings = map(preference, value => {
    if (!isEmpty(value.scoirApplyEnabled) && value.scoirApplyEnabled.includes("T")) {
      return "Apply with Scoir";
    }
    return "";
  });
  const filtered = reject(strings, isEmpty);
  return /*#__PURE__*/React.createElement(Display, {
    preference: filtered
  });
};
AppInfo.propTypes = {
  preference: PropTypes.array
};

const mappers = {
  location: Location,
  undergrads: Undergrads,
  scoresAcceptance: ScoresAcceptance,
  athletics: Athletics,
  personalInterests: PersonalInterests,
  typeAffiliation: TypeAffiliation,
  academics: Academics,
  setting: Setting,
  rotc: Rotc$1,
  degrees: Degrees,
  univType: UnivType,
  appInfo: AppInfo
};
var preferenceLabel = (key, preference) => {
  const mapper = get(mappers, key, noop);
  return mapper({
    preference
  });
};

const useStyles$f = makeStyles(theme => ({
  container: {
    borderBottom: `1px solid ${get(theme, 'palette.grey.100')}`,
    width: 400
  },
  singleColumn: {
    width: '100%'
  },
  title: {
    fontWeight: 'bold',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
}));
const PreferenceGroup$1 = _ref => {
  let {
    title,
    children,
    forceSingleColumn = false
  } = _ref;
  const classes = useStyles$f();
  return /*#__PURE__*/React.createElement(Box, {
    className: cn(classes.container, {
      [classes.singleColumn]: forceSingleColumn
    }),
    pb: 2,
    my: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.title
  }, title), children);
};
PreferenceGroup$1.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  forceSingleColumn: PropTypes.bool
};

const orderedGroupDefinitions = [{
  internalKey: 'academics',
  apiKey: ['AcademicFocus', 'Majors'],
  label: 'Academic Focus'
}, {
  internalKey: 'degrees',
  apiKey: ['Degrees'],
  label: 'Undergraduate Degrees'
}, {
  internalKey: 'univType',
  apiKey: ['UnivType', 'SchoolClassifier'],
  label: 'College Level'
}, {
  internalKey: 'personalInterests',
  apiKey: ['Tags'],
  label: 'Personal Interests & Activities'
}, {
  internalKey: 'location',
  apiKey: ['Location'],
  label: 'Distance & Location'
}, {
  internalKey: 'scoresAcceptance',
  apiKey: ['TestsAndSelectivity'],
  label: 'Test Scores / Admission Rate'
}, {
  internalKey: 'setting',
  apiKey: ['Setting'],
  label: 'Campus Setting'
}, {
  internalKey: 'typeAffiliation',
  apiKey: ['Religious', 'Control', 'CoalitionMember', 'MinorityServingInst'],
  label: 'School Type'
}, {
  internalKey: 'undergrads',
  apiKey: ['UnderGradEnroll'],
  label: 'Undergraduate Students'
}, {
  internalKey: 'athletics',
  apiKey: ['Sports'],
  label: 'Athletics'
}, {
  internalKey: 'rotc',
  apiKey: ['Rotc'],
  label: 'ROTC Programs'
}, {
  internalKey: 'appInfo',
  apiKey: ['ScoirApplyEnabled'],
  label: 'Application Info'
}];
const internalKeyToApiKeyMapping = reduce(orderedGroupDefinitions, (mapping, value) => {
  mapping[value.internalKey] = value.apiKey;
  return mapping;
}, {});
const internalKeyToLabelMapping = reduce(orderedGroupDefinitions, (mapping, value) => {
  mapping[value.internalKey] = value.label;
  return mapping;
}, {});
const internalKeyOrder = map(orderedGroupDefinitions, 'internalKey');
const internalKeyToLabel = key => internalKeyToLabelMapping[key];
const internalKeyToApiKey = key => internalKeyToApiKeyMapping[key];

const SHOULD_HAVE$1 = 'SHOULD_HAVE';
const Context$5 = /*#__PURE__*/React.createContext(null);
Context$5.name = 'DataTransformContext';
const withDataTransformationBindings = Component => {
  const Bindings = props => {
    const {
      preferences,
      mustHavePreferences,
      shouldHavePreferences,
      onUpdate
    } = useContext(Context$5);
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      preferences: preferences,
      mustHavePreferences: mustHavePreferences,
      shouldHavePreferences: shouldHavePreferences,
      onUpdate: onUpdate
    }));
  };
  return Bindings;
};
const withBindings = withDataTransformationBindings;
const withDataTransformation = Component => {
  const DataTransformer = props => {
    const {
      mustHavePreferences,
      shouldHavePreferences,
      onUpdateMustHave,
      onUpdateShouldHave,
      ...rest
    } = props;
    const internalMustHavePreferences = api2internal(mustHavePreferences);
    const internalShouldHavePreferences = api2internal(shouldHavePreferences);
    const mergedInternalPreferences = mapValues(internalMustHavePreferences, (value, key) => {
      return uniq([...value, ...internalShouldHavePreferences[key]]);
    });
    const onInternalUpdate = (internalPreferenceKey, newPreferences, prefType) => {
      const isUpdatingShouldHave = isEqual(prefType, SHOULD_HAVE$1);
      const formattedPreferences = internal2api({
        [internalPreferenceKey]: newPreferences
      });
      const preferences = isUpdatingShouldHave ? shouldHavePreferences : mustHavePreferences;
      const fullPreferences = {
        ...preferences,
        ...pick(formattedPreferences, internalKeyToApiKey(internalPreferenceKey))
      };
      const updateFn = isUpdatingShouldHave ? onUpdateShouldHave : onUpdateMustHave;
      return updateFn(fullPreferences);
    };
    return /*#__PURE__*/React.createElement(Context$5.Provider, {
      value: {
        onUpdate: onInternalUpdate,
        mustHavePreferences: internalMustHavePreferences,
        shouldHavePreferences: internalShouldHavePreferences,
        preferences: mergedInternalPreferences
      }
    }, /*#__PURE__*/React.createElement(Component, rest));
  };
  DataTransformer.displayName = `withDataTransformation(${Component.name})`;
  DataTransformer.propTypes = {
    shouldHavePreferences: PropTypes.object.isRequired,
    mustHavePreferences: PropTypes.object.isRequired,
    onUpdateMustHave: PropTypes.func.isRequired,
    onUpdateShouldHave: PropTypes.func.isRequired
  };
  return DataTransformer;
};

const useStyles$e = makeStyles(() => ({
  expandLabel: {
    fontWeight: 'bold'
  },
  details: {
    display: 'block'
  }
}));
const Expander = _ref => {
  let {
    children,
    collapsed,
    title,
    secondaryInfo,
    labelId,
    labelComponent,
    component: Component
  } = _ref;
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (collapsed && open) {
      setOpen(false);
    }
  }, [collapsed, open]);
  const classes = useStyles$e();
  const expanded = open && !collapsed;
  return /*#__PURE__*/React.createElement(Accordion, {
    expanded: expanded,
    onChange: () => setOpen(!open),
    square: true
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": `cpref-${title}-editor-accordion`,
    expandIcon: /*#__PURE__*/React.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React.createElement(Component, null, /*#__PURE__*/React.createElement(Typography, {
    id: labelId,
    className: classes.expandLabel,
    variant: "subtitle1",
    component: labelComponent
  }, title), !expanded && secondaryInfo && /*#__PURE__*/React.createElement(Typography, null, secondaryInfo))), /*#__PURE__*/React.createElement(AccordionDetails, {
    id: `cpref-${title}-editor-accordion`,
    className: classes.details
  }, children));
};
Expander.defaultProps = {
  component: "div",
  labelComponent: 'label'
};
Expander.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  title: PropTypes.any.isRequired,
  secondaryInfo: PropTypes.any,
  children: PropTypes.any.isRequired,
  labelId: PropTypes.string,
  labelComponent: PropTypes.any,
  component: PropTypes.any
};

const useStyles$d = makeStyles(theme => ({
  actions: {
    borderTop: `1px solid ${get(theme, 'palette.grey.200')}`
  },
  content: {
    backgroundColor: get(theme, 'palette.pageBackground.main')
  },
  title: {
    borderBottom: `1px solid ${get(theme, 'palette.grey.200')}`
  }
}));
const FormModal = _ref => {
  let {
    modalId,
    onClose,
    open,
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(Dialog, _extends({
    fullWidth: true,
    maxWidth: "sm",
    "aria-labelledby": modalId,
    open: open,
    onClose: () => onClose()
  }, rest), children);
};
const Content$1 = _ref2 => {
  let {
    children,
    className,
    ...rest
  } = _ref2;
  const classes = useStyles$d();
  return /*#__PURE__*/React.createElement(DialogContent, _extends({
    className: cn(className, classes.content)
  }, rest), children);
};
const Actions$1 = _ref3 => {
  let {
    children,
    ...rest
  } = _ref3;
  const classes = useStyles$d();
  return /*#__PURE__*/React.createElement(DialogActions, _extends({
    className: classes.actions
  }, rest), children);
};
const Title$1 = _ref4 => {
  let {
    children,
    ...rest
  } = _ref4;
  const classes = useStyles$d();
  return /*#__PURE__*/React.createElement(DialogTitle, _extends({
    className: classes.title
  }, rest), children);
};
FormModal.propTypes = {
  modalId: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};
Content$1.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string
};
Actions$1.propTypes = {
  children: PropTypes.any.isRequired
};
Title$1.propTypes = {
  children: PropTypes.any.isRequired
};
FormModal.Title = Title$1;
FormModal.Content = Content$1;
FormModal.Actions = Actions$1;

const FORM_IDS = {
  academics: 'cpref-academics-form-id',
  degrees: 'cpref-degrees-form-id',
  univType: 'cpref-univType-form-id',
  personalInterests: 'cpref-personalInterests-form-id',
  location: 'cpref-location-form-id',
  scoresAcceptance: 'cpref-scoresAcceptance-form-id',
  setting: 'cpref-setting-form-id',
  typeAffiliation: 'cpref-typeAffiliation-form-id',
  undergrads: 'cpref-undergrads-form-id',
  athletics: 'cpref-athletics-form-id',
  rotc: 'cpref-rotc-form-id',
  appInfo: 'cpref-appInfo-form-id'
};

var mapFacets = facets => mapValues(keyBy(facets, facet => `${camelCase(facet.name)}Facets`), facet => facet.terms);

var InternalContext = /*#__PURE__*/React.createContext(null);

class Provider extends React.Component {
  static propTypes = {
    mustHavePreferences: PropTypes.object.isRequired,
    shouldHavePreferences: PropTypes.object.isRequired,
    facets: PropTypes.array.isRequired,
    canEdit: PropTypes.bool,
    children: PropTypes.any,
    onUpdate: PropTypes.func.isRequired
  };
  render() {
    const {
      mustHavePreferences: mustHave,
      shouldHavePreferences: shouldHave,
      children,
      facets,
      onUpdate,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(InternalContext.Provider, {
      value: {
        ...rest,
        mustHave,
        shouldHave,
        ...mapFacets(facets),
        onUpdateMustHave: preferences => onUpdate(preferences, undefined, undefined),
        onUpdateShouldHave: preferences => onUpdate(undefined, preferences, undefined)
      }
    }, children);
  }
}

var withContext = config => {
  let workingConfig = config;
  if (isString(workingConfig)) {
    workingConfig = [workingConfig];
  }
  if (isArray(workingConfig)) {
    workingConfig = keyBy(workingConfig, identity);
  }
  const mapValueViaConfig = context => reduce(workingConfig, (result, propField, contextField) => {
    result[propField] = get(context, contextField);
    return result;
  }, {});
  return WrappedComponent => {
    const HoC = props => /*#__PURE__*/React.createElement(InternalContext.Consumer, null, value => /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, mapValueViaConfig(value), props)));
    HoC.displayName = `PreferencesContext(${WrappedComponent.displayName || WrappedComponent.name})`;
    return HoC;
  };
};

const ApiBoundAcademicFocusTypeahead = withContext({
  onAcademicFocusSearch: 'onSearch',
  onPageMajors: 'onPageMajors',
  majorsMaxResults: 'maxResults'
})(AcademicFocusTypeahead);
class AcademicsSelector extends React.Component {
  static propTypes = {
    preference: PropTypes.array.isRequired,
    onUpdate: PropTypes.func.isRequired,
    ariaLabelledBy: PropTypes.string.isRequired
  };
  static defaultProps = {
    preference: []
  };
  handleSelection(selection) {
    const value = selection.name;
    const newSelection = {
      [selection.type]: value
    };
    if (findIndex(this.props.preference, newSelection) === -1) {
      const newPreference = update(this.props.preference, {
        $push: [newSelection]
      });
      this.props.onUpdate(newPreference);
    }
  }
  dismissPill(pill) {
    const removeSelection = {
      [pill.type]: pill.displayValue
    };
    const idx = findIndex(this.props.preference, removeSelection);
    const newPreference = update(this.props.preference, {
      $splice: [[idx, 1]]
    });
    this.props.onUpdate(newPreference);
  }
  render() {
    const academics = [];
    each(this.props.preference, academic => {
      if (academic.focus) {
        academics.push({
          type: 'focus',
          displayName: 'Focus',
          displayValue: academic.focus
        });
      } else {
        academics.push({
          type: 'major',
          displayName: 'Major',
          displayValue: academic.major
        });
      }
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "cpref-academics-selector"
    }, /*#__PURE__*/React.createElement(ApiBoundAcademicFocusTypeahead, {
      inputProps: {
        'aria-labelledby': this.props.ariaLabelledBy
      },
      onSelect: selection => this.handleSelection(selection)
    }), /*#__PURE__*/React.createElement(Box, {
      mt: 1,
      className: "rcsc-pill-container"
    }, map(academics, item => {
      const label = `${item.displayName} - ${item.displayValue}`;
      return /*#__PURE__*/React.createElement(Chip, {
        key: label,
        label: label,
        onDelete: () => this.dismissPill(item)
      });
    })));
  }
}

const useExpanderToggle = toggle => {
  const [collapsed, setCollapsed] = useState(false);
  useEffect(() => {
    if (collapsed) {
      setCollapsed(false);
    }
  }, [collapsed, toggle]);
  return [collapsed, setCollapsed];
};

const useStyles$c = makeStyles(theme => ({
  prefCard: {
    backgroundColor: get(theme, 'palette.grey.100')
  },
  button: {
    backgroundColor: get(theme, 'palette.grey.100'),
    border: 0
  }
}));
const PreferenceCards = _ref => {
  let {
    selections,
    onDismiss,
    prefType
  } = _ref;
  const classes = useStyles$c();
  return /*#__PURE__*/React.createElement(React.Fragment, null, map(selections, (pref, i) => {
    return /*#__PURE__*/React.createElement(Box, {
      key: i,
      className: cn('cpref-preference-card', classes.prefCard),
      p: 1,
      mb: 2,
      fontWeight: "bold",
      display: "flex",
      backgroundColor: "grey.100",
      justifyContent: "space-between",
      alignItems: "center"
    }, /*#__PURE__*/React.createElement("span", {
      className: "cpref-preference-card-label"
    }, preferenceLabel(prefType, [pref])), /*#__PURE__*/React.createElement("button", {
      className: cn('cpref-dismiss-button', classes.button),
      onClick: () => onDismiss(i),
      "aria-label": "remove"
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      className: "icon",
      "aria-hidden": "true"
    })));
  }));
};
PreferenceCards.propTypes = {
  selections: PropTypes.array.isRequired,
  onDismiss: PropTypes.func.isRequired,
  prefType: PropTypes.string.isRequired
};

const GroupOutline = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    mb: 2,
    p: 2,
    border: 1,
    borderColor: "grey.100"
  }, children);
};
GroupOutline.propTypes = {
  children: PropTypes.any.isRequired
};

const SearchableSportsTypeahead = withContext({
  onSportsSearch: 'onSearch'
})(SportsTypeahead);
class AthleticsSelector$1 extends React.Component {
  static propTypes = {
    onAddPreference: PropTypes.func.isRequired,
    selections: PropTypes.array,
    preference: PropTypes.object.isRequired,
    onDismiss: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    ariaLabelledBy: PropTypes.string
  };
  static defaultProps = {
    preference: {}
  };
  key = 0;
  selectSport(sport) {
    const divisions = map(slice(sport.tokens, 1), name => ({
      name,
      selected: true
    }));
    this.props.onUpdate({
      name: sport.name,
      divisions
    });
  }
  toggleDivision(division) {
    const divisionIdx = findIndex(this.props.preference.divisions, {
      name: division.label
    });
    const updatedSport = update(this.props.preference, {
      divisions: {
        [divisionIdx]: {
          selected: {
            $set: division.isChecked
          }
        }
      }
    });
    if (some(updatedSport.divisions, 'selected')) {
      this.props.onUpdate(updatedSport);
    } else {
      this.props.onUpdate({});
    }
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "cpref-athletics-selector-comp"
    }, /*#__PURE__*/React.createElement(GroupOutline, null, /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true
    }, /*#__PURE__*/React.createElement(Box, {
      component: "span",
      fontWeight: "bold",
      mb: 1
    }, "Add a preference")), /*#__PURE__*/React.createElement(SearchableSportsTypeahead, {
      key: this.key,
      inputProps: {
        'aria-labelledby': this.props.ariaLabelledBy
      },
      onSelect: sport => this.selectSport(sport),
      onReset: () => this.props.onUpdate({})
    }), /*#__PURE__*/React.createElement(Fragment, null, this.props.preference.divisions && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h3"
    }, "Divisions"), /*#__PURE__*/React.createElement(Checklist, {
      onChange: value => this.toggleDivision(value),
      data: map(this.props.preference.divisions, division => ({
        label: division.name,
        isChecked: division.selected
      })),
      sortByCount: false
    }))), /*#__PURE__*/React.createElement(Box, {
      mt: 2
    }, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      disabled: isEmpty(this.props.preference),
      variant: "contained",
      onClick: () => {
        this.key++;
        this.props.onAddPreference();
      }
    }, "Add"))), /*#__PURE__*/React.createElement(PreferenceCards, {
      prefType: "athletics",
      onDismiss: idx => this.props.onDismiss(idx),
      selections: this.props.selections
    }));
  }
}

const useStyles$b = makeStyles(() => ({
  label: {
    fontWeight: 'normal'
  }
}));
const InputLabel = _ref => {
  let {
    children,
    className,
    ...rest
  } = _ref;
  const classes = useStyles$b();
  return /*#__PURE__*/React.createElement(Typography, _extends({
    className: cn(className, classes.label),
    component: "span",
    variant: "body1"
  }, rest), children);
};
InputLabel.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string
};

const DEFAULT_GEOLOCATION = {
  from: '0',
  to: '1000',
  coordinates: undefined,
  name: undefined
};
const ApiBoundDistanceLocation = withContext({
  onLocationSearch: 'onSearch'
})(DistanceLocation);
class LocationSelector$1 extends React.Component {
  static propTypes = {
    onAddPreference: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    selections: PropTypes.array.isRequired,
    onDismiss: PropTypes.func.isRequired,
    preference: PropTypes.object.isRequired
  };
  static defaultProps = {
    preference: {}
  };
  updateGeolocation(value) {
    let newGeoLocation = undefined;
    if (value) {
      value = {
        ...DEFAULT_GEOLOCATION,
        ...value
      };
      newGeoLocation = {
        name: value.name,
        coords: value.coordinates,
        from: value.from,
        to: value.to
      };
    }
    const newPref = {
      ...this.props.preference,
      geolocation: newGeoLocation
    };
    this.props.onUpdate(newPref);
  }
  updateCountry(newItem) {
    const newTerm = newItem.term;
    const countryPrefs = get(this.props.preference, 'country', []);
    const options = includes(countryPrefs, newTerm) ? pull(countryPrefs, newTerm) : [...countryPrefs, newItem.term];
    const newPref = {
      ...this.props.preference,
      country: options
    };
    this.props.onUpdate(newPref);
  }
  updateState(value) {
    const states = reject(this.props.preference.state, isUndefined);
    let state;
    if (states.indexOf(value) > -1) {
      const idx = states.indexOf(value);
      const splicedStates = update(states, {
        $splice: [[idx, 1]]
      });
      state = splicedStates;
    } else {
      state = [...states, value];
    }
    const newPref = {
      ...this.props.preference,
      state
    };
    this.props.onUpdate(newPref);
  }
  render() {
    const countryOptions = getLocationCategories(this.props.options);
    const geolocation = this.props.preference.geolocation || DEFAULT_GEOLOCATION;
    const states = reject(this.props.preference.state, isUndefined);
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GroupOutline, null, /*#__PURE__*/React.createElement(Typography, {
      gutterBottom: true
    }, /*#__PURE__*/React.createElement(Box, {
      component: "span",
      fontWeight: "bold",
      mb: 2,
      display: "block"
    }, "Add a preference")), /*#__PURE__*/React.createElement(ApiBoundDistanceLocation, {
      onUpdate: value => this.updateGeolocation(value),
      selectedValues: [geolocation]
    }), /*#__PURE__*/React.createElement(Box, {
      mt: 2
    }, /*#__PURE__*/React.createElement(StatesTypeahead$1, {
      selectedValues: states,
      onSelect: value => this.updateState(value)
    })), /*#__PURE__*/React.createElement(Box, {
      component: "fieldset",
      mt: 2,
      mb: 1
    }, /*#__PURE__*/React.createElement(Legend, null, /*#__PURE__*/React.createElement(InputLabel, null, "Country")), /*#__PURE__*/React.createElement(Checklist, {
      sortByCount: false,
      showCount: false,
      onChange: value => this.updateCountry(value),
      data: map(countryOptions, option => ({
        ...option,
        isChecked: includes(this.props.preference.country, option.term)
      }))
    })), /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      disabled: isEqual(geolocation, DEFAULT_GEOLOCATION) && isEmpty(states) && isEmpty(this.props.preference.country),
      variant: "contained",
      onClick: () => this.props.onAddPreference()
    }, "Add")), /*#__PURE__*/React.createElement(PreferenceCards, {
      prefType: 'location',
      onDismiss: i => this.props.onDismiss(i),
      selections: this.props.selections
    }));
  }
}
var LocationSelector$2 = withContext({
  locationCategoryFacets: 'options'
})(LocationSelector$1);

const SearchableInterestsTypeahead = withContext({
  onGetAllInterests: 'onGetAllInterests',
  onPersonalInterestSearch: 'onSearch'
})(PersonalInterestsTypeahead$1);
class PersonalInterestsSelector extends React.Component {
  static propTypes = {
    selectedValues: PropTypes.array,
    onUpdate: PropTypes.func.isRequired,
    ariaLabelledBy: PropTypes.string.isRequired
  };
  static defaultProps = {
    selectedValues: []
  };
  selectInterest(interest) {
    let newValues = [...this.props.selectedValues];
    if (includes(newValues, interest)) {
      newValues = without(newValues, interest);
    } else {
      newValues.push(interest);
    }
    this.props.onUpdate(newValues);
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "personal-interests-pref-comp"
    }, /*#__PURE__*/React.createElement(SearchableInterestsTypeahead, {
      inputProps: {
        'aria-labelledby': this.props.ariaLabelledBy
      },
      selectedValues: this.props.selectedValues,
      placeholder: "e.g. Music, Writing, Hiking, Quidditch",
      onQueryUpdate: val => this.selectInterest(val)
    }));
  }
}

class UndergradsSelector extends React.Component {
  static propTypes = {
    onUpdate: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    selections: PropTypes.array.isRequired
  };
  state = {
    options: []
  };
  componentDidMount() {
    const options = getUndergrads(this.props.options, this.props.selections, 'from');
    this.setState({
      options
    });
  }
  update(item) {
    const options = [...this.state.options];
    const idx = findIndex(options, {
      label: item.label
    });
    options[idx].isChecked = item.isChecked;
    this.setState({
      options
    });
    const selectedOptions = filter(options, {
      isChecked: true
    });
    this.props.onUpdate(selectedOptions);
  }
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Checklist, {
      sortByCount: false,
      showCount: false,
      onChange: value => this.update(value),
      data: this.state.options
    }));
  }
}
var UndergradsSelector$1 = withContext({
  underGradEnrollFacets: 'options'
})(UndergradsSelector);

class SimpleSelector extends React.Component {
  static propTypes = {
    onUpdate: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    onFormatLabel: PropTypes.func.isRequired,
    isExclusive: PropTypes.bool,
    disableUpdate: PropTypes.bool,
    selectedValues: PropTypes.array
  };
  state = {
    options: this.props.onFormatLabel(this.props.options)
  };
  componentDidUpdate(prevProps) {
    const shouldUndoDisableUpdate = !this.props.disableUpdate && prevProps.disableUpdate;
    const updatedOptions = !isUndefined(this.props.selectedValues) && !isEqual(this.props.selectedValues, prevProps.selectedValues);
    if (shouldUndoDisableUpdate || updatedOptions) {
      this.setState({
        options: this.props.onFormatLabel(this.props.options)
      });
    }
  }
  update(item) {
    const options = [...this.state.options];
    const idx = findIndex(options, {
      term: item.term
    });
    options[idx].isChecked = item.isChecked;
    if (this.props.isExclusive) {
      const containsCheckedItem = filter(options, {
        isChecked: true
      }).length > 0;
      map(options, (option, index) => {
        if (containsCheckedItem) {
          if (index === idx) {
            option.isDisabled = false;
          } else {
            option.isDisabled = true;
            option.isChecked = false;
          }
        } else {
          option.isDisabled = false;
        }
      });
    } else {
      if (!isUndefined(this.props.disableUpdate)) {
        map(options, option => {
          option.isDisabled = true;
        });
      }
    }
    this.setState({
      options
    });
    const selectedOptions = map(filter(options, {
      isChecked: true
    }), 'term');
    this.props.onUpdate(selectedOptions);
  }
  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Checklist, {
      sortByCount: false,
      showCount: false,
      onChange: value => this.update(value),
      data: this.state.options
    }));
  }
}
const createChecklistSelector = facetsContextKey => withContext({
  [facetsContextKey]: 'options'
})(SimpleSelector);

const SchoolTypeSelector = createChecklistSelector('controlFacets');
const ReligionSelector = createChecklistSelector('religiousFacets');
const CoalitionMemberSelector = createChecklistSelector('coalitionMemberFacets');
const MinorityServingInstSelector = createChecklistSelector('minorityServingInstFacets');
const TypeAffiliationSelector = _ref => {
  let {
    currentSelections,
    onUpdate,
    disableUpdate
  } = _ref;
  const currentSchoolType = map(filter(currentSelections, 'schoolType'), 'schoolType');
  const currentReligion = map(filter(currentSelections, 'religion'), 'religion');
  const currentCoalitionMember = map(filter(currentSelections, 'coalitionMember'), 'coalitionMember');
  const currentMinorityServingInst = map(filter(currentSelections, 'minorityServingInst'), 'minorityServingInst');
  const update = newValue => {
    const values = {
      schoolType: currentSchoolType,
      religion: currentReligion,
      coalitionMember: currentCoalitionMember,
      minorityServingInst: currentMinorityServingInst,
      ...newValue
    };
    onUpdate([...map(values.schoolType, schoolType => ({
      schoolType
    })), ...map(values.religion, religion => ({
      religion
    })), ...map(values.coalitionMember, coalitionMember => ({
      coalitionMember
    })), ...map(values.minorityServingInst, minorityServingInst => ({
      minorityServingInst
    }))]);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Box, {
    component: "fieldset",
    mb: 2
  }, /*#__PURE__*/React.createElement(Legend, null, /*#__PURE__*/React.createElement(InputLabel, null, "Public or Private")), /*#__PURE__*/React.createElement(SchoolTypeSelector, {
    disableUpdate: disableUpdate,
    onFormatLabel: options => checkTermsAgainstStrings(options, currentSchoolType, disableUpdate),
    onUpdate: schoolType => update({
      schoolType
    })
  })), /*#__PURE__*/React.createElement(Box, {
    component: "fieldset",
    mb: 2
  }, /*#__PURE__*/React.createElement(Legend, null, /*#__PURE__*/React.createElement(InputLabel, null, "Religious Affiliation")), /*#__PURE__*/React.createElement(ReligionSelector, {
    disableUpdate: disableUpdate,
    onFormatLabel: options => checkTermsAgainstStrings(options, currentReligion, disableUpdate),
    onUpdate: religion => update({
      religion
    })
  })), /*#__PURE__*/React.createElement(Box, {
    component: "fieldset",
    mb: 2
  }, /*#__PURE__*/React.createElement(Legend, null, /*#__PURE__*/React.createElement(InputLabel, null, "Special-Mission")), /*#__PURE__*/React.createElement(CoalitionMemberSelector, {
    disableUpdate: disableUpdate,
    onFormatLabel: options => getCoalitionMember(options, currentCoalitionMember),
    onUpdate: coalitionMember => update({
      coalitionMember
    })
  }), /*#__PURE__*/React.createElement(MinorityServingInstSelector, {
    disableUpdate: disableUpdate,
    onFormatLabel: options => getMinorityServingInstCategories(options, currentMinorityServingInst),
    onUpdate: minorityServingInst => update({
      minorityServingInst
    })
  })));
};
TypeAffiliationSelector.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  currentSelections: PropTypes.array.isRequired,
  disableUpdate: PropTypes.bool.isRequired
};

const ScoirApplyEnabledSelector = createChecklistSelector('scoirApplyEnabledFacets');
const AppInfoSelector = _ref => {
  let {
    currentSelections,
    onUpdate,
    disableUpdate
  } = _ref;
  const currentScoirApplyEnabled = map(filter(currentSelections, 'scoirApplyEnabled'), 'scoirApplyEnabled');
  const update = newValue => {
    const values = {
      scoirApplyEnabled: currentScoirApplyEnabled,
      ...newValue
    };
    onUpdate([...map(values.scoirApplyEnabled, scoirApplyEnabled => ({
      scoirApplyEnabled
    }))]);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Box, {
    component: "fieldset",
    mb: 2
  }, /*#__PURE__*/React.createElement(ScoirApplyEnabledSelector, {
    disableUpdate: disableUpdate,
    onFormatLabel: options => getBooleanData(options, currentScoirApplyEnabled, 'Apply with Scoir'),
    onUpdate: scoirApplyEnabled => update({
      scoirApplyEnabled
    })
  })));
};
AppInfoSelector.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  currentSelections: PropTypes.array.isRequired,
  disableUpdate: PropTypes.bool.isRequired
};

const defaultRanges = {
  sat: {
    from: MIN_SAT,
    to: MAX_SAT
  },
  act: {
    from: MIN_ACT,
    to: MAX_ACT
  },
  acceptance: {
    from: MIN_ACCEPTANCE_RATE,
    to: MAX_ACCEPTANCE_RATE
  }
};
class ScoresAcceptanceSelector extends React.Component {
  static propTypes = {
    selection: PropTypes.object,
    onUpdate: PropTypes.func.isRequired
  };
  updateRange(type, from, to) {
    const updatedRange = {
      from,
      to
    };
    const newScoresAcceptance = {
      ...this.props.selection
    };
    const isDefaultRange = isEqual(defaultRanges[type], updatedRange);
    newScoresAcceptance[type] = isDefaultRange ? undefined : updatedRange;
    this.props.onUpdate([newScoresAcceptance]);
  }
  render() {
    const {
      selection
    } = this.props;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement(Legend, null, /*#__PURE__*/React.createElement(InputLabel, null, "Average SAT Score")), /*#__PURE__*/React.createElement(SATRangeSlider, {
      defaultMinValue: get(selection, 'sat.from', defaultRanges.sat.from),
      defaultMaxValue: get(selection, 'sat.to', defaultRanges.sat.to),
      onUpdateRange: (minRange, maxRange) => this.updateRange('sat', minRange, maxRange)
    })), /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement(Legend, null, /*#__PURE__*/React.createElement(InputLabel, {
      gutterBottom: true
    }, "Average ACT Score")), /*#__PURE__*/React.createElement(ACTRangeSlider, {
      defaultMinValue: get(selection, 'act.from', defaultRanges.act.from),
      defaultMaxValue: get(selection, 'act.to', defaultRanges.act.to),
      onUpdateRange: (minRange, maxRange) => this.updateRange('act', minRange, maxRange)
    })), /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement(Legend, null, /*#__PURE__*/React.createElement(InputLabel, {
      gutterBottom: true
    }, "Admission Rate")), /*#__PURE__*/React.createElement(AcceptanceRateSlider, {
      defaultMinValue: get(selection, 'acceptance.from', defaultRanges.acceptance.from),
      defaultMaxValue: get(selection, 'acceptance.to', defaultRanges.acceptance.to),
      onUpdateRange: (minRange, maxRange) => this.updateRange('acceptance', minRange, maxRange)
    })));
  }
}

const PreferenceGroup = _ref => {
  let {
    onUpdate,
    comp: Comp,
    selections,
    ...rest
  } = _ref;
  const [newPref, setNewPref] = useState({});
  const handleUpdate = () => {
    const newPrefs = [...selections, {
      ...newPref
    }];
    onUpdate(newPrefs);
    setNewPref({});
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Comp, _extends({}, rest, {
    onAddPreference: () => handleUpdate(),
    selections: selections,
    preference: newPref,
    onUpdate: preference => setNewPref(preference)
  })));
};
PreferenceGroup.defaultProps = {
  selections: []
};
PreferenceGroup.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  comp: PropTypes.any.isRequired,
  selections: PropTypes.array.isRequired
};

const builder = function () {
  for (var _len = arguments.length, flow = new Array(_len), _key = 0; _key < _len; _key++) {
    flow[_key] = arguments[_key];
  }
  return (selection, item) => reduce(flow, (result, fn) => fn(selection, result), item);
};
const keyed = key => (selection, item) => item[key];
const fallback = (selection, item) => item || selection;
const unique = iteratee => (selection, item) => uniqBy(item, iteratee);
const ignore = fn => (selection, item) => reject(item, fn);
const mapping = {
  personalInterests: builder(keyed('personalInterests'), fallback),
  academics: builder(keyed('academics'), fallback, unique(item => item.focus || item.major)),
  degrees: keyed('degrees'),
  univType: keyed('univType'),
  location: builder(keyed('location'), fallback, ignore(item => isEmpty(omitBy(item, isEmpty)))),
  undergrads: builder(keyed('undergrads'), fallback),
  athletics: builder(keyed('athletics'), fallback, ignore(item => isUndefined(item) || isEmpty(item))),
  scoresAcceptance: keyed('scoresAcceptance'),
  typeAffiliation: keyed('typeAffiliation'),
  setting: keyed('setting'),
  rotc: keyed('rotc'),
  appInfo: keyed('appInfo')
};
var typeAdditionHelperFactory = groupType => get(mapping, groupType, noop);

const useStyles$a = makeStyles(theme => ({
  collapseButton: {
    marginRight: theme.spacing(1)
  }
}));
const {
  Title,
  Content,
  Actions
} = FormModal;
const RotcSelector = createChecklistSelector('rotcFacets');
const SettingSelector$1 = createChecklistSelector('settingFacets');
const DegreeSelector = createChecklistSelector('degreesFacets');
const UnivTypeSelector$1 = createChecklistSelector('univTypeFacets');
const MUST_HAVE = 'MUST_HAVE';
const SHOULD_HAVE = 'SHOULD_HAVE';
const MODAL_ID = 'cpref-edit-form';
const PreferenceSelectorModal = _ref => {
  let {
    onUpdate,
    preferences,
    shouldHavePreferences,
    show,
    onClose,
    tntSearchFilterEnabled = false
  } = _ref;
  const [hasError, setHasError] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [collapsed, setCollapsed] = useExpanderToggle();
  const classes = useStyles$a();
  const saveSelection = _ref2 => {
    let {
      prefKey,
      value,
      prefType = MUST_HAVE
    } = _ref2;
    const additionHelper = typeAdditionHelperFactory(prefKey);
    if (hasError) {
      setHasError(false);
    }
    const preferencesCopy = {
      ...preferences,
      [prefKey]: value
    };
    const newPrefs = additionHelper(preferences[prefKey], preferencesCopy);
    return onUpdate(prefKey, newPrefs, prefType).catch(() => setHasError(true));
  };
  const updateSelection = _ref3 => {
    let {
      prefKey,
      value
    } = _ref3;
    const keyExistsInShould = !isEmpty(get(shouldHavePreferences, prefKey));
    setIsUpdating(true);
    saveSelection({
      prefKey,
      value
    }).then(() => {
      if (keyExistsInShould) {
        saveSelection({
          prefKey,
          value: [],
          prefType: SHOULD_HAVE
        });
      }
    }).then(() => setIsUpdating(false));
  };
  const dismissPref = (prefKey, i) => {
    const selections = update(preferences[prefKey], {
      $splice: [[i, 1]]
    });
    updateSelection({
      prefKey,
      value: selections
    });
  };
  const closeModal = () => {
    if (hasError) {
      setHasError(false);
    }
    onClose();
  };
  return /*#__PURE__*/React.createElement(FormModal, {
    modalId: MODAL_ID,
    open: show,
    onClose: () => closeModal()
  }, /*#__PURE__*/React.createElement(Title, {
    id: MODAL_ID,
    onClose: closeModal
  }, "Edit Preferences"), /*#__PURE__*/React.createElement(Content, {
    className: "cpref-preference-modal-body"
  }, /*#__PURE__*/React.createElement(Expander, {
    collapsed: collapsed,
    title: "Academic Focus",
    labelId: FORM_IDS.academics,
    secondaryInfo: preferenceLabel('academics', preferences.academics)
  }, /*#__PURE__*/React.createElement(AcademicsSelector, {
    ariaLabelledBy: FORM_IDS.academics,
    preference: preferences.academics,
    onUpdate: value => {
      updateSelection({
        prefKey: 'academics',
        value
      });
    }
  })), /*#__PURE__*/React.createElement(Expander, {
    collapsed: collapsed,
    component: "fieldset",
    labelComponent: Legend,
    title: internalKeyToLabel('degrees'),
    labelId: FORM_IDS.degrees,
    secondaryInfo: preferenceLabel('degrees', preferences.degrees)
  }, /*#__PURE__*/React.createElement(DegreeSelector, {
    className: "cpref-degrees-selector",
    onFormatLabel: options => getDegrees(options, [...preferences.degrees], isUpdating),
    facetsContextKey: "degreesFacets",
    disableUpdate: isUpdating,
    selectedValues: preferences.degrees,
    onUpdate: value => updateSelection({
      prefKey: 'degrees',
      value
    })
  })), tntSearchFilterEnabled && /*#__PURE__*/React.createElement(Expander, {
    collapsed: collapsed,
    component: "fieldset",
    labelComponent: Legend,
    title: internalKeyToLabel('univType'),
    labelId: FORM_IDS.univType,
    secondaryInfo: preferenceLabel('univType', preferences.univType)
  }, /*#__PURE__*/React.createElement(UnivTypeSelector$1, {
    className: "cpref-univType-selector",
    onFormatLabel: options => getUnivTypes(options, [...preferences.univType], isUpdating),
    facetsContextKey: "univTypeFacets",
    disableUpdate: isUpdating,
    selectedValues: preferences.univType,
    onUpdate: value => updateSelection({
      prefKey: 'univType',
      value
    })
  })), /*#__PURE__*/React.createElement(Expander, {
    collapsed: collapsed,
    labelId: FORM_IDS.personalInterests,
    title: internalKeyToLabel('personalInterests'),
    secondaryInfo: preferenceLabel('personalInterests', preferences.personalInterests)
  }, /*#__PURE__*/React.createElement(PersonalInterestsSelector, {
    ariaLabelledBy: FORM_IDS.personalInterests,
    selectedValues: preferences.personalInterests,
    onUpdate: value => updateSelection({
      prefKey: 'personalInterests',
      value
    })
  })), /*#__PURE__*/React.createElement(Expander, {
    collapsed: collapsed,
    title: "Distance & Location",
    labelId: FORM_IDS.location,
    component: Legend,
    labelComponent: "p",
    secondaryInfo: preferenceLabel('location', preferences.location)
  }, /*#__PURE__*/React.createElement(PreferenceGroup, {
    className: "cpref-location-selector",
    comp: LocationSelector$2,
    selections: preferences.location,
    onDismiss: idx => dismissPref('location', idx),
    onUpdate: value => updateSelection({
      prefKey: 'location',
      value
    })
  })), /*#__PURE__*/React.createElement(Expander, {
    collapsed: collapsed,
    labelId: FORM_IDS.scoresAcceptance,
    labelComponent: Legend,
    component: "fieldset",
    title: "Tests Scores & Admission Rate",
    secondaryInfo: preferenceLabel('scoresAcceptance', preferences.scoresAcceptance)
  }, /*#__PURE__*/React.createElement(ScoresAcceptanceSelector, {
    selection: head(get(preferences, 'scoresAcceptance', [])),
    onUpdate: value => updateSelection({
      prefKey: 'scoresAcceptance',
      value
    })
  })), /*#__PURE__*/React.createElement(Expander, {
    collapsed: collapsed,
    labelId: FORM_IDS.setting,
    labelComponent: Legend,
    component: "fieldset",
    title: internalKeyToLabel('setting'),
    secondaryInfo: preferenceLabel('setting', preferences.setting)
  }, /*#__PURE__*/React.createElement(SettingSelector$1, {
    className: "cpref-setting-selector",
    disableUpdate: isUpdating,
    onUpdate: value => updateSelection({
      prefKey: 'setting',
      value
    }),
    onFormatLabel: options => checkTermsAgainstStrings(options, [...preferences.setting], isUpdating)
  })), /*#__PURE__*/React.createElement(Expander, {
    collapsed: collapsed,
    title: "School Type",
    labelId: FORM_IDS.typeAffiliation,
    labelComponent: "p",
    secondaryInfo: preferenceLabel('typeAffiliation', preferences.typeAffiliation)
  }, /*#__PURE__*/React.createElement(TypeAffiliationSelector, {
    disableUpdate: isUpdating,
    currentSelections: get(preferences, 'typeAffiliation', []),
    onUpdate: value => updateSelection({
      prefKey: 'typeAffiliation',
      value
    })
  })), /*#__PURE__*/React.createElement(Expander, {
    collapsed: collapsed,
    labelId: FORM_IDS.undergrads,
    labelComponent: Legend,
    component: "fieldset",
    title: internalKeyToLabel('undergrads'),
    secondaryInfo: preferenceLabel('undergrads', preferences.undergrads)
  }, /*#__PURE__*/React.createElement(UndergradsSelector$1, {
    selections: [...get(preferences, 'undergrads', [])],
    onUpdate: value => updateSelection({
      prefKey: 'undergrads',
      value
    })
  })), /*#__PURE__*/React.createElement(Expander, {
    collapsed: collapsed,
    title: internalKeyToLabel('athletics'),
    labelId: FORM_IDS.athletics,
    secondaryInfo: preferenceLabel('athletics', preferences.athletics)
  }, /*#__PURE__*/React.createElement(PreferenceGroup, {
    className: "cpref-athletics-selector",
    comp: AthleticsSelector$1,
    selections: preferences.athletics,
    onDismiss: idx => dismissPref('athletics', idx),
    onUpdate: value => updateSelection({
      prefKey: 'athletics',
      value
    })
  })), /*#__PURE__*/React.createElement(Expander, {
    collapsed: collapsed,
    title: internalKeyToLabel('rotc'),
    labelComponent: Legend,
    component: "fieldset",
    labelId: FORM_IDS.rotc,
    secondaryInfo: preferenceLabel('rotc', preferences.rotc)
  }, /*#__PURE__*/React.createElement(RotcSelector, {
    prefType: "rotc",
    className: "cpref-rotc-selector",
    onFormatLabel: options => checkTermsAgainstStrings(options, [...preferences.rotc]),
    facetsContextKey: 'rotcFacets',
    onUpdate: value => updateSelection({
      prefKey: 'rotc',
      value
    })
  })), /*#__PURE__*/React.createElement(Expander, {
    collapsed: collapsed,
    title: internalKeyToLabel('appInfo'),
    labelComponent: Legend,
    component: "fieldset",
    labelId: FORM_IDS.appInfo,
    secondaryInfo: preferenceLabel('appInfo', preferences.appInfo)
  }, /*#__PURE__*/React.createElement(AppInfoSelector, {
    disableUpdate: isUpdating,
    currentSelections: get(preferences, 'appInfo', []),
    onUpdate: value => updateSelection({
      prefKey: 'appInfo',
      value
    })
  }))), /*#__PURE__*/React.createElement(Actions, null, hasError && /*#__PURE__*/React.createElement(Box, {
    "aria-live": "polite",
    className: "text-danger text-center error-message",
    component: "p",
    textAlign: "left",
    m: 0,
    maxWidth: 375
  }, "An error occurred while updating the preferences. Please try again later."), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "space-between",
    p: 2
  }, /*#__PURE__*/React.createElement(Box, {
    mr: 2
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('collapse-button', classes.collapseButton),
    color: "primary",
    onClick: () => setCollapsed(true)
  }, "Collapse All")), /*#__PURE__*/React.createElement(Button, {
    className: "done-button",
    variant: "contained",
    color: "primary",
    onClick: () => closeModal()
  }, "Done"))));
};
PreferenceSelectorModal.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  preferences: PropTypes.object.isRequired,
  shouldHavePreferences: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  tntSearchFilterEnabled: PropTypes.bool
};

const getHasPreference = prefArr => some(prefArr, el => !isEmpty(el));
const PreferenceSelectorModalTrigger = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    preferences,
    mustHavePreferences,
    shouldHavePreferences,
    onUpdate
  } = useContext(Context$5);
  const hasPreferences = getHasPreference(mustHavePreferences) || getHasPreference(shouldHavePreferences);
  return !hasPreferences && /*#__PURE__*/React.createElement("div", {
    className: "cpref-preference-selector-modal-trigger"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "cpref-preference-selector-button",
    color: "primary",
    variant: "contained",
    startIcon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faUserEdit,
      size: "xs"
    }),
    onClick: () => setIsOpen(true)
  }, "Add Preferences"), /*#__PURE__*/React.createElement(PreferenceSelectorModal, {
    show: isOpen,
    preferences: preferences,
    mustHavePreferences: mustHavePreferences,
    shouldHavePreferences: shouldHavePreferences,
    onUpdate: onUpdate,
    onClose: () => setIsOpen(false)
  }));
};

const sortKeysMagically = preferences => reduce(internalKeyOrder, (result, orderKey) => {
  if (!isEmpty(preferences[orderKey])) {
    result.push({
      key: orderKey,
      value: preferences[orderKey]
    });
  }
  return result;
}, []);
const PreferenceList = _ref => {
  let {
    preferences,
    canEdit,
    hidePreferenceList,
    forceSingleColumn = false
  } = _ref;
  const orderedPreferences = sortKeysMagically(preferences);
  return /*#__PURE__*/React.createElement(React.Fragment, null, canEdit && /*#__PURE__*/React.createElement(PreferenceSelectorModalTrigger, null), !hidePreferenceList && /*#__PURE__*/React.createElement(Box, {
    mt: 2,
    ml: 2,
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between"
  }, map(orderedPreferences, prefGroup => /*#__PURE__*/React.createElement(PreferenceGroup$1, {
    key: prefGroup.key,
    title: internalKeyToLabel(prefGroup.key),
    forceSingleColumn: forceSingleColumn
  }, preferenceLabel(prefGroup.key, prefGroup.value)))));
};
PreferenceList.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  preferences: PropTypes.object.isRequired,
  hidePreferenceList: PropTypes.bool,
  forceSingleColumn: PropTypes.bool
};
PreferenceList.defaultProps = {
  canEdit: false
};
var PreferenceList$1 = withContext(['canEdit', 'hidePreferenceList'])(PreferenceList);

var preferenceDisplayHelper = prefs => {
  const internal = api2internal(prefs);
  const sortedKeys = sortKeysMagically(internal);
  const labels = [];
  forEach(sortedKeys, prefGroup => {
    forEach(prefGroup.value, pref => {
      if (!isUndefined(pref)) {
        const label = preferenceLabel(prefGroup.key, [pref]);
        labels.push(label);
      }
    });
  });
  return labels;
};

const useClasses = makeStyles((theme) => {
    return {
        chip: {
            borderColor: '#007DAA80',
            background: '#FFFFFF',
            cursor: 'pointer',
            '&:hover': {
                borderColor: theme.palette.primary.main,
            },
        },
        selected: {
            borderColor: theme.palette.primary.main,
            background: 'rgba(0, 125, 170, 0.08)',
        },
        chipText: {
            wordWrap: 'break-word',
        },
        disabled: {
            borderColor: '#D9D9D9',
            cursor: 'not-allowed',
        },
    };
});
const SelectableIconChips = ({ options, gridItemProps, onSelect }) => {
    const classes = useClasses();
    return (jsx(Grid$1, Object.assign({ container: true, spacing: 2 }, { children: map$1(options, (option, idx) => {
            const { title, subtitle, icon, faIcon, value, selected, disabled } = option;
            return (createElement(Grid$1, Object.assign({ item: true }, gridItemProps, { key: idx }),
                jsxs(Box$1, Object.assign({ p: 1, pt: 2.25, width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", textAlign: "center", borderRadius: "4px", border: 1, role: "button", "aria-label": selected ? `Selected: ${title} ${subtitle || ''}` : `Not selected: ${title} ${subtitle || ''}`, "aria-live": "polite", tabIndex: 0, onKeyDown: (e) => (e.key === 'Enter' || e.key === ' ') && onSelect(value, option), onClick: () => !disabled && onSelect(value, option), className: cn(classes.chip, {
                        [classes.selected]: selected,
                        [classes.disabled]: disabled,
                    }) }, { children: [icon || (jsx(Box$1, Object.assign({ height: "34px", width: "100%", fontSize: "24px" }, { children: jsx(FontAwesomeIcon, { icon: faIcon }) }))), jsxs(Box$1, Object.assign({ mt: 1, mb: 2, display: "flex", flexDirection: "column", justifyContent: "center", textAlign: "center", className: classes.chipText }, { children: [jsx(Typography$1, Object.assign({ variant: "button", color: "textPrimary" }, { children: title })), subtitle && (jsx(Typography$1, Object.assign({ variant: "caption", color: "textPrimary" }, { children: subtitle })))] }))] }))));
        }) })));
};

const SelectorContext = React.createContext({});

const useOptions$2 = ({ fieldName, withoutTerms }) => {
    const { options } = useContext(SelectorContext);
    const facet = get$1(options, fieldName);
    const terms = get$1(facet, 'terms', []);
    return useMemo(() => {
        return filter$1(terms, (term) => {
            return !includes$1(withoutTerms, term.term);
        });
    }, [terms, withoutTerms]);
};
const useCurrentValue = (fieldName) => {
    const { data } = useContext(SelectorContext);
    return get$1(data, fieldName, []);
};
const useOnUpdateData = () => {
    const { onUpdateDataFields } = useContext(SelectorContext);
    return onUpdateDataFields;
};
const useHasHiddenFacets$2 = (facetNames) => {
    const { hasHiddenFacets } = useContext(SelectorContext);
    return hasHiddenFacets(facetNames);
};
const getMissingFn = (fnName) => {
    return () => {
        throw new Error(`SelectorContextProvider is missing API function: prop = apiCalls.${fnName}`);
    };
};
const useAPIFn = (fnName) => {
    const { apiCalls } = useContext(SelectorContext);
    return useMemo(() => {
        return get$1(apiCalls, [fnName], getMissingFn(fnName));
    }, [apiCalls, fnName]);
};
const useAcceptanceLikelihoodLabels = () => {
    const { acceptanceLikelihoodLabels } = useContext(SelectorContext);
    return acceptanceLikelihoodLabels;
};
const useSelectivityLabels = () => {
    const { selectivityLabels } = useContext(SelectorContext);
    return selectivityLabels;
};
const useCollegeMatchLevel = () => {
    const { collegeMatchLevel } = useContext(SelectorContext);
    return collegeMatchLevel;
};
const useSupportsAcceptanceLikelihoodFilters = () => {
    const { supportsAcceptanceLikelihoodFilters } = useContext(SelectorContext);
    return supportsAcceptanceLikelihoodFilters;
};

const Typeahead$2 = (props) => {
    return (jsx(Box$1, Object.assign({ position: "relative", zIndex: 2 }, { children: jsx(ControlledAutocomplete, Object.assign({ disableCloseOnSelect: true, disablePortal: true, clearOnSelect: true, multiple: true, showLoading: false, noOptionsText: "No results found...", loadingText: "Loading...", variant: "outlined" }, props)) })));
};

const getSanitizedTerm = term => term.replace(/[^a-zA-Z0-9]+/gi, '');
const SubstringHighlighter = _ref => {
  let {
    term,
    value
  } = _ref;
  const regex = new RegExp(getSanitizedTerm(term), 'gi');
  const matches = value.match(regex);
  if (isEmpty(term) || isNull(matches)) return value;
  return /*#__PURE__*/React.createElement(React.Fragment, null, map(value.split(regex), (part, idx) => {
    const match = matches[idx];
    return isEmpty(match) ? part : /*#__PURE__*/React.createElement(React.Fragment, {
      key: idx
    }, part, /*#__PURE__*/React.createElement("strong", null, match));
  }));
};
SubstringHighlighter.propTypes = {
  term: PropTypes.string,
  value: PropTypes.string
};

const academicFocusType = 'Academic Focus';
const generalMajorsType = 'General Majors';
const specificMajorsType = 'Specific Majors';
const academicFocusFieldName = 'Keyword';
const majorsFieldName = 'Majors';
const getAcademicFocusOption = name => {
  return {
    name,
    type: academicFocusType,
    fieldName: academicFocusFieldName
  };
};
const getGeneralMajorOption = (name, children) => {
  let childNames;
  if (!isEmpty(children)) {
    if (children.length > 3) {
      childNames = map(children.slice(0, 2), _ref => {
        let {
          CipName
        } = _ref;
        return CipName;
      }).join('; ');
      childNames += `; and ${children.length - 2} more`;
    } else {
      childNames = map(children, _ref2 => {
        let {
          CipName
        } = _ref2;
        return CipName;
      }).join('; ');
    }
  }
  return {
    name,
    type: generalMajorsType,
    fieldName: majorsFieldName,
    subTitle: childNames
  };
};
const getSpecificMajorOption = name => {
  return {
    name,
    type: specificMajorsType,
    fieldName: majorsFieldName
  };
};
const ingestSelection = (selected, selectedAcademicFocus) => {
  const af = keyBy(selectedAcademicFocus);
  return map(selected, option => {
    if (af[option]) {
      return getAcademicFocusOption(option);
    } else if (new RegExp(/\(All\)$/i).test(option)) {
      return getGeneralMajorOption(option);
    } else {
      return getSpecificMajorOption(option);
    }
  });
};
const search$1 = (onAcademicSearch, val) => onAcademicSearch(val).then(_ref3 => {
  let {
    Keywords,
    GeneralMajors,
    Majors
  } = _ref3;
  const options = [];
  forEach(Keywords, _ref4 => {
    let {
      Keyword
    } = _ref4;
    options.push(getAcademicFocusOption(Keyword));
  });
  forEach(GeneralMajors, _ref5 => {
    let {
      CipName,
      Children
    } = _ref5;
    options.push(getGeneralMajorOption(CipName, Children));
  });
  forEach(Majors, _ref6 => {
    let {
      CipName
    } = _ref6;
    options.push(getSpecificMajorOption(CipName));
  });
  return options;
}).catch(noop);
const AcademicFocusMajorsTypeahead = _ref7 => {
  let {
    placeholder,
    onAcademicFocusMajorsChange,
    selectedAcademicFocus,
    selected,
    onAcademicSearch,
    ...rest
  } = _ref7;
  const selectedOptions = ingestSelection(selected, selectedAcademicFocus);
  const selectedRef = useRef(selectedOptions);
  const onSelect = useCallback(val => {
    const values = {
      [academicFocusFieldName]: [],
      [majorsFieldName]: []
    };
    val.forEach(option => {
      const {
        fieldName,
        name
      } = option;
      values[fieldName].push(name);
    });
    onAcademicFocusMajorsChange({
      majors: values[majorsFieldName],
      keywords: values[academicFocusFieldName]
    });
  }, [onAcademicFocusMajorsChange]);
  return /*#__PURE__*/React.createElement(Typeahead$2, _extends({
    onSearch: value => search$1(onAcademicSearch, value),
    placeholder: placeholder,
    label: placeholder,
    defaultValue: selectedRef.current,
    "aria-label": "Search for an academic focus",
    onChange: onSelect,
    groupBy: option => get(option, 'type', ''),
    getOptionSelected: (option, value) => {
      const v = get(value, 'name', value);
      const o = get(option, 'name');
      const ot = get(option, 'type');
      const vt = get(value, 'type', ot);
      const nameMatch = v === o;
      const typeMatch = ot === vt;
      return nameMatch && typeMatch;
    },
    renderTags: (value, getTagProps) => /*#__PURE__*/React.createElement(ScrollWrapper, {
      maxHeight: "120px"
    }, value.map((option, index) => {
      const label = get(option, 'name', option);
      return /*#__PURE__*/React.createElement(Chip$1, _extends({
        key: index,
        color: "primary",
        label: label
      }, getTagProps({
        index
      })));
    })),
    renderOption: (option, state) => {
      const name = get(option, 'name', '');
      const term = get(state, 'inputValue', '');
      const checked = get(state, 'selected', '');
      const subTitle = get(option, 'subTitle', '');
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Checkbox, {
        edge: "start",
        color: "primary",
        checked: checked,
        disableRipple: true,
        inputProps: {
          'aria-labelledby': name
        }
      }), /*#__PURE__*/React.createElement(Box, {
        marginLeft: 2
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: "body1"
      }, /*#__PURE__*/React.createElement(SubstringHighlighter, {
        term: term,
        value: name
      })), !isEmpty(subTitle) && /*#__PURE__*/React.createElement(Typography, {
        variant: "body2",
        color: "textSecondary"
      }, "Includes ", subTitle)));
    }
  }, rest));
};
AcademicFocusMajorsTypeahead.propTypes = {
  onAcademicFocusMajorsChange: PropTypes.func,
  placeholder: PropTypes.string,
  selected: PropTypes.array,
  selectedAcademicFocus: PropTypes.array,
  onAcademicSearch: PropTypes.func
};

const ACADEMIC_FOCUS$1 = 'AcademicFocus';
const ADMISSIONS = 'Admissions';
const ACCEPTANCE_LIKELIHOOD$1 = 'AcceptanceLikelihood';
const ACT$1 = 'ACTAvg';
const APP_METHOD$1 = 'ApplicationMethod';
const COALITION_MEMBER$2 = 'CoalitionMember';
const CONTROL$1 = 'Control';
const DEGREES$1 = 'Degrees';
const DISTANCE = 'Distance';
const INTERESTS$1 = 'Tags';
const LOCATION$1 = 'Location';
const LOCATION_CATEGORY$1 = 'LocationCategory';
const MAJORS$1 = 'Majors';
const MINORITY_SERVING$1 = 'MinorityServingInst';
const RELIGIOUS$1 = 'Religious';
const ROTC$1 = 'Rotc';
const SAT$1 = 'SATAvg';
const SCHOOL_SIZE$1 = 'UnderGradEnroll';
const SCHOOL_TYPE = 'SchoolType';
const SCOIR_APPLY_APPLICANT_TYPES$1 = 'ScoirApplyApplicantTypes';
const SELECTIVITY_LEVEL$1 = 'SelectivityLevel';
const SELECTIVITY$1 = 'Selectivity';
const SETTING$1 = 'Setting';
const SPORTS$1 = 'Sports';
const STATE$1 = 'State';
const TEST_OPTIONAL$2 = 'TestOptional';
const UNIV_TYPE$1 = 'UnivType';
const SCHOOL_CLASSIFIER = 'SchoolClassifier';
const NEW_DEGREES_LABELS = {
    bachelors: "Bachelor's",
    associates: 'Associate',
    certificate: 'Certificate',
    masters: "Master's",
    doctorate: 'Doctorate',
};
const DEGREES_LABELS = {
    bachelors: "4-Year Bachelor's",
    associates: '2-Year Associate',
};
const UNIV_TYPE_LABELS = {
    '4year': '4-Year',
    '2year': '2-Year',
    lessthan2year: 'Less than 2-Year',
};
const UNIV_TYPE_SUB_LABELS = {
    '4year': "Offers Bachelor's degrees typically completed in four years",
    '2year': 'Offers Associate degrees and vocational training programs typically completed within two years',
    lessthan2year: 'Offers Certificate programs typically lasting less than two years',
};
const SCHOOL_CLASSIFIER_LABELS = {
    careerandtrade: 'Career & Trade',
};
const SCHOOL_CLASSIFIER_SUB_LABELS = {
    careerandtrade: 'Offers specialized hands-on training and certification programs',
};
const COALITION_MEMBER_LABELS = {
    t: 'Coalition for College',
};
const COALITION_MEMBER_SUB_LABELS = {
    t: 'Colleges committed to making college affordable and ensuring on-time graduation with minimal debt.',
};
const MINORITY_SERVING_LABELS = {
    hbcu: 'HBCUs',
};
const MINORITY_SERVING_SUB_LABELS = {
    hbcu: 'Historically Black Colleges founded before 1964 that foster a supportive atmosphere for students.',
};
const CONTROL_SUB_LABELS = {
    public: 'Government funded for lower cost, more majors, and research opportunities, but less financial aid.',
    privatenotforprofit: 'Funded by various sources to fuel educational programs and mission fulfillment.',
    privateforprofit: 'Profit generated by offering career-based programs and not accepting state or federal aid.',
};
const DISPLAY_TEXT = {
    [ROTC$1]: {
        Title: 'ROTC Programs',
        Description: "The Reserve Officers' Training Corps (ROTC) is a college program that prepares students to become officers in the U.S. Military while seeking a degree.",
    },
    [ACADEMIC_FOCUS$1]: {
        Title: 'Academic Focus',
        Description: '',
    },
    [APP_METHOD$1]: {
        Title: 'Application Method',
        Description: '',
    },
    [DEGREES$1]: {
        Title: 'Degrees',
        Description: '',
    },
    [ADMISSIONS]: {
        Title: 'Admissions',
        Description: '',
    },
    [LOCATION$1]: {
        Title: 'Location',
    },
    [SCHOOL_SIZE$1]: {
        Title: 'School Size',
        Description: 'Number of students seeking an undergraduate degree',
    },
    [SETTING$1]: {
        Title: 'Campus Setting',
        Description: 'Whether you’re dorming or not, college is where you’ll be living everyday. Think about what you’d be close to, access to public transportation, and cost-of-living.',
    },
    [DISTANCE]: {
        Title: 'Distance',
    },
    [INTERESTS$1]: {
        Title: 'Student Life',
    },
    [SCHOOL_TYPE]: {
        Title: 'School Type',
    },
    [SPORTS$1]: {
        Title: 'Varsity Athletics',
    },
};
const API_CALL_NAMES = {
    onAcademicFocusesKeywordSearch: 'onAcademicFocusesKeywordSearch',
    onAcademicMajorsSearch: 'onAcademicMajorsSearch',
    onLocationSearch: 'onLocationSearch',
    onAllTagsSearch: 'onAllTagsSearch',
    onTagsSearch: 'onTagsSearch',
    onSportSearch: 'onSportSearch',
};

const Typeahead$1 = () => {
    const onUpdate = useOnUpdateData();
    const onAcademicMajorsSearch = useAPIFn(API_CALL_NAMES.onAcademicMajorsSearch);
    const academicFocus = useCurrentValue(ACADEMIC_FOCUS$1);
    const majors = useCurrentValue(MAJORS$1);
    const onAcademicFocusMajorsChange = useCallback(({ keywords, majors }) => {
        onUpdate([ACADEMIC_FOCUS$1, MAJORS$1], [keywords, majors]);
    }, [onUpdate]);
    const selected = useMemo(() => {
        return [...academicFocus, ...majors];
    }, [academicFocus, majors]);
    return (jsx(AcademicFocusMajorsTypeahead, { placeholder: "Focuses & Majors", onAcademicFocusMajorsChange: onAcademicFocusMajorsChange, variant: "outlined", selected: selected, selectedAcademicFocus: academicFocus, multiple: true, value: ingestSelection(selected, academicFocus), disablePortal: true, onAcademicSearch: onAcademicMajorsSearch }));
};

const useAcademicFocuses = (onFail) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(!isEmpty$1(data));
    const [loaded, setLoaded] = useState(false);
    const onAcademicFocusesKeywordSearch = useAPIFn(API_CALL_NAMES.onAcademicFocusesKeywordSearch);
    useEffect(() => {
        if (!loaded && !loading) {
            setLoading(true);
            onAcademicFocusesKeywordSearch()
                .then((response = []) => {
                setLoading(false);
                setLoaded(true);
                setData(response);
            })
                .catch(() => {
                setLoading(false);
                setLoaded(true);
                if (onFail) {
                    onFail();
                }
            });
        }
    }, [onFail, loaded, loading, onAcademicFocusesKeywordSearch]);
    return useMemo(() => {
        return {
            loading,
            data: data || [],
        };
    }, [data, loading]);
};

const useStyles$9 = makeStyles({
  skeletonChip: {
    borderRadius: '32px'
  }
});
const ChipsLoadingSkeleton = () => {
  const classes = useStyles$9();
  const count = random(12, 20);
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    height: "200px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignContent: "flex-start",
    fontSize: "24px",
    "aria-label": "loading options"
  }, times(count, idx => {
    const width = random(90, 125);
    return /*#__PURE__*/React.createElement(Box, {
      key: idx,
      m: 0.5,
      display: "inline-block",
      role: "progressbar"
    }, /*#__PURE__*/React.createElement(Skeleton, {
      variant: "rect",
      width: width,
      height: 40,
      animation: "wave",
      className: classes.skeletonChip
    }));
  }));
};

const muiFocusClass = '&.MuiChip-clickable.MuiChip-outlinedPrimary:focus';
const muiFocusVisibleClass = '&.MuiChip-clickable.MuiChip-outlinedPrimary:focus-visible';
const muiFocusWithinClass = '&.MuiChip-clickable.MuiChip-outlinedPrimary:focus-within';
const muiHoverClass = '&.MuiChip-clickable.MuiChip-outlinedPrimary:hover';
const muiClasses = [muiFocusClass, muiFocusWithinClass, muiHoverClass].join(', ');
const useStyles$8 = makeStyles(theme => ({
  unselectedChip: {
    [muiClasses]: {
      backgroundColor: '#fff'
    },
    [muiFocusVisibleClass]: {
      backgroundColor: 'rgba(20, 135, 176, 0.05)'
    }
  },
  selectedChip: {
    backgroundColor: '#D9EEF8',
    [muiClasses]: {
      backgroundColor: '#D9EEF8'
    },
    [muiFocusVisibleClass]: {
      backgroundColor: 'rgba(20, 135, 176, 0.2)'
    }
  },
  chipIcon: {
    paddingLeft: '6px',
    marginLeft: '4px',
    // override chip icon for changing from regular to solid
    width: '14px!important',
    boxSizing: 'content-box'
  },
  chipLabel: {
    textOverflow: 'initial',
    color: theme.palette.common.black
  }
}));
const ChipComponent = _ref => {
  let {
    label,
    onClick,
    isSelected,
    disabled,
    icon
  } = _ref;
  const classes = useStyles$8();
  return /*#__PURE__*/React.createElement(Chip$1, {
    classes: {
      root: isSelected ? classes.selectedChip : classes.unselectedChip,
      label: classes.chipLabel
    },
    label: label,
    "aria-label": `${isSelected ? 'Selected:' : 'Not Selected:'} ${label}`,
    "aria-live": "polite",
    color: disabled ? 'default' : 'primary',
    onClick: () => !disabled && onClick(label),
    variant: "outlined",
    icon: icon && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      className: classes.chipIcon,
      icon: icon
    })
  });
};
ChipComponent.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  icon: PropTypes.any,
  disabled: PropTypes.bool
};

const ChipSelector = _ref => {
  let {
    loading,
    options,
    selected,
    onUpdateSelection
  } = _ref;
  const selectedObj = useMemo(() => keyBy(selected, 'value'), [selected]);
  const onToggle = useCallback(option => {
    const {
      value
    } = option;
    const alreadySelected = !isEmpty(selectedObj[value]);
    let newOptions = [...selected];
    if (alreadySelected) {
      newOptions = filter(newOptions, option => option.value !== value);
    } else {
      newOptions.push(option);
    }
    onUpdateSelection(newOptions, option);
  }, [selected, selectedObj, onUpdateSelection]);
  return loading ? /*#__PURE__*/React.createElement(ChipsLoadingSkeleton, null) : /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1
  }, map(options, option => {
    const {
      disabled,
      label,
      value,
      icon,
      selectedIcon
    } = option;
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      key: value
    }, /*#__PURE__*/React.createElement(ChipComponent, {
      label: label,
      disabled: disabled,
      onClick: () => onToggle(option),
      isSelected: !isEmpty(selectedObj[value]),
      icon: !isEmpty(selectedObj[value]) ? selectedIcon : icon
    }));
  }));
};
ChipSelector.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    icon: PropTypes.any,
    selectedIcon: PropTypes.any
  })),
  selected: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    icon: PropTypes.any
  })),
  onUpdateSelection: PropTypes.func,
  loading: PropTypes.bool
};

const ShowHide = ({ isExpandedByDefault = false, collapsedHeight, isEmpty, hideButton = false, moreLabel = 'Show more', lessLabel = 'Show less', onClickHide, buttonVariant, children, }) => {
    const { open: isExpanded, onOpen: onExpand, onClose: onCollapse } = useOpenClose(isExpandedByDefault || hideButton);
    const onClick = useCallback(() => {
        if (isExpanded) {
            onCollapse();
            if (onClickHide)
                onClickHide();
        }
        else
            onExpand();
    }, [isExpanded, onCollapse, onClickHide, onExpand]);
    const buttonText = isExpanded ? lessLabel : moreLabel;
    return isEmpty ? null : (jsxs(React.Fragment, { children: [jsx(Collapse$1, Object.assign({ in: isExpanded, collapsedSize: collapsedHeight }, { children: children })), !hideButton && (jsx(Box$1, Object.assign({ mt: 3, mb: 1 }, { children: jsx(Button$1, Object.assign({ color: "primary", variant: buttonVariant || 'outlined', onClick: onClick }, { children: buttonText })) })))] }));
};

const fociToOptions = (foci) => {
    return map$1(foci, (focus) => {
        const label = get$1(focus, 'Keyword', focus);
        const icons$1 = icons[label];
        const option = {
            label,
            value: label,
            icon: (icons$1 === null || icons$1 === void 0 ? void 0 : icons$1.icon) || null,
            selectedIcon: (icons$1 === null || icons$1 === void 0 ? void 0 : icons$1.selectedIcon) || null,
        };
        return option;
    });
};
const AcademicFocusChips = ({ all, selected = [], previewCount = 10, onUpdateSelection, showHideProps, boxProps, }) => {
    const { data, loading } = useAcademicFocuses();
    const updateSelected = useCallback((selected) => {
        onUpdateSelection(map$1(selected, (option) => option.value));
    }, [onUpdateSelection]);
    const optionsA = useMemo(() => (all ? fociToOptions(data) : fociToOptions(data.slice(0, previewCount))), [data, previewCount, all]);
    const optionsB = useMemo(() => (all ? [] : fociToOptions(data.slice(previewCount, data.length))), [data, previewCount, all]);
    const selectedOptions = useMemo(() => fociToOptions(selected), [selected]);
    const hideAboveTheFold = previewCount < 1 && !all;
    return (jsxs(Fragment$1, { children: [hideAboveTheFold ? null : (jsx(ChipSelector, { loading: loading, options: optionsA, selected: selectedOptions, onUpdateSelection: updateSelected })), optionsB.length === 0 ? null : (jsx(ShowHide, Object.assign({}, showHideProps, { children: jsx(Box$1, Object.assign({}, boxProps, { children: jsx(ChipSelector, { loading: loading, options: optionsB, selected: selectedOptions, onUpdateSelection: updateSelected }) })) })))] }));
};

const Chips = ({ previewCount, all }) => {
    const onUpdate = useOnUpdateData();
    const academicFocus = useCurrentValue(ACADEMIC_FOCUS$1);
    const onAcademicFocusChange = useCallback((value) => {
        onUpdate([ACADEMIC_FOCUS$1], [value]);
    }, [onUpdate]);
    return (jsx(AcademicFocusChips, { selected: academicFocus, onUpdateSelection: onAcademicFocusChange, previewCount: previewCount, showHideProps: {
            moreLabel: 'Show Academic Focuses',
            lessLabel: 'Hide Academic Focuses',
        }, all: all }));
};

const TITLE = DISPLAY_TEXT[ACADEMIC_FOCUS$1].Title;
const AcademicFocusDropdown = () => {
    const onUpdate = useOnUpdateData();
    const academicFocus = useCurrentValue(ACADEMIC_FOCUS$1);
    const onAcademicFocusMajorsChange = useCallback(({ keywords, majors }) => {
        onUpdate([ACADEMIC_FOCUS$1, MAJORS$1], [keywords, majors]);
    }, [onUpdate]);
    return (jsx(Dropdown, Object.assign({ fieldLabel: TITLE, buttonLabel: TITLE, selectionLabels: academicFocus, id: "college-search-filter-bar-focus", onClear: () => {
            onAcademicFocusMajorsChange({});
        } }, { children: jsx(Box$1, Object.assign({ mx: 2, mb: 2 }, { children: jsx(Chips, { all: true }) })) })));
};

const AcademicFocus = () => {
    return (jsxs(Box$1, Object.assign({ mb: -2 }, { children: [jsx(Box$1, Object.assign({ mb: 1 }, { children: jsx(Typeahead$1, {}) })), jsx(Chips, { previewCount: 0 })] })));
};
AcademicFocus.Typeahead = Typeahead$1;
AcademicFocus.Chips = Chips;
AcademicFocus.Dropdown = AcademicFocusDropdown;

const SubsectionText = (_a) => {
    var { title, description } = _a, rest = __rest(_a, ["title", "description"]);
    return (jsx(Box$1, Object.assign({ mb: 2 }, rest, { children: jsxs(ListSubheader$1, Object.assign({ role: "sectionhead", disableSticky: true, disableGutters: true }, { children: [jsx(Typography$1, Object.assign({ variant: "subtitle2", color: "textPrimary" }, { children: title })), description && (jsx(Typography$1, Object.assign({ variant: "body2", color: "textSecondary" }, { children: description })))] })) })));
};

const LIKELIHOOD_TITLE = 'Acceptance Likelihood';
const LIKELIHOOD_DESCRIPTION = 'Based on your academic profile and the selectivity of individual colleges';
const SELECTIVITY_TITLE = 'Selectivity';
const SELECTIVITY_DESCRIPTION = 'Calculated by dividing the number of admitted students by the number of applicants';

const MOST = {
    title: 'Most Selective',
    labelFieldName: 'Most',
    legacyValue: { from: '1', to: '20' },
    icons: {
        inactive: faTachometerSlowest,
        active: faTachometerSlowest$1,
    },
    value: 6,
};
const HIGHLY = {
    title: 'Highly Selective',
    labelFieldName: 'Highly',
    legacyValue: { from: '20', to: '40' },
    value: 5,
    icons: {
        inactive: faTachometerSlow,
        active: faTachometerSlow$1,
    },
};
const VERY = {
    title: 'Very Selective',
    labelFieldName: 'Very',
    legacyValue: { from: '40', to: '70' },
    value: 4,
    icons: {
        inactive: faTachometerAverage,
        active: faTachometerAverage$1,
    },
};
const SELECTIVE = {
    title: 'Selective',
    labelFieldName: 'Selective',
    legacyValue: { from: '70', to: '100' },
    value: 3,
    icons: {
        inactive: faTachometerFast,
        active: faTachometerFast$1,
    },
};
const SOMEWHAT = {
    title: 'Somewhat Selective',
    labelFieldName: 'Somewhat',
    value: 2,
    icons: {
        inactive: faTachometerFastest,
        active: faTachometerFastest$1,
    },
};
const OPEN = {
    title: 'Open Admission',
    labelFieldName: 'Open',
    value: 1,
    icons: {
        inactive: faVoteYea,
        active: faVoteYea$1,
    },
};
const optionsByLegacyValue = {
    [MOST.legacyValue.from]: MOST,
    [HIGHLY.legacyValue.from]: HIGHLY,
    [VERY.legacyValue.from]: VERY,
    [SELECTIVE.legacyValue.from]: SELECTIVE,
};
({
    [MOST.value]: MOST,
    [HIGHLY.value]: HIGHLY,
    [VERY.value]: VERY,
    [SELECTIVE.value]: SELECTIVE,
    [SOMEWHAT.value]: SOMEWHAT,
    [OPEN.value]: OPEN,
});

const getLevelFromLegacy = (legacySelectivity, levels) => {
    const result = isArray$1(levels) ? [...levels] : [];
    forEach$1(legacySelectivity, (legacyOption) => {
        const from = legacyOption.from;
        const option = get$1(optionsByLegacyValue, from);
        const value = get$1(option, 'value');
        if (value && !result.includes(value)) {
            result.push(value);
        }
    });
    return result;
};

const useSelectedOptions$1 = () => {
    const legacySelectivity = useCurrentValue(SELECTIVITY$1);
    const levels = useCurrentValue(SELECTIVITY_LEVEL$1);
    const selectivityLevels = useMemo(() => {
        return getLevelFromLegacy(legacySelectivity, levels);
    }, [legacySelectivity, levels]);
    return selectivityLevels;
};

const useOnSelect$1 = () => {
    const onUpdate = useOnUpdateData();
    const selectedOptions = useSelectedOptions$1();
    return useCallback((value, option) => {
        const updated = option.selected
            ? filter$1(selectedOptions, (current) => current !== value)
            : [...selectedOptions, value];
        onUpdate([SELECTIVITY_LEVEL$1, SELECTIVITY$1, ACCEPTANCE_LIKELIHOOD$1], [updated, [], []]);
    }, [selectedOptions, onUpdate]);
};
const useOnSelectLegacy = () => {
    const onUpdate = useOnUpdateData();
    return useCallback((value) => {
        const updated = {
            from: `${value[0]}`,
            to: `${value[1]}`,
        };
        onUpdate([SELECTIVITY$1, SELECTIVITY_LEVEL$1, ACCEPTANCE_LIKELIHOOD$1], [[updated], [], []]);
    }, [onUpdate]);
};

const options$2 = [MOST, HIGHLY, VERY, SELECTIVE, SOMEWHAT, OPEN];
const getOptions$5 = (selectedOptions, labels) => {
  return options$2.map(option => {
    const selected = selectedOptions.includes(option.value);
    const faIcon = option.icons[selected ? 'active' : 'inactive'];
    const title = labels[option.labelFieldName] || option.title;
    return {
      ...option,
      title,
      faIcon,
      selected
    };
  });
};
const useOptions$1 = () => {
  const selectedOptions = useSelectedOptions$1();
  const labels = useSelectivityLabels();
  return useMemo(() => getOptions$5(selectedOptions, labels), [selectedOptions, labels]);
};

const getDefaultLabel = value => `${value}`;
const Range = _ref => {
  let {
    from,
    to,
    title,
    onChange,
    min,
    max,
    getLabel = getDefaultLabel,
    ...rest
  } = _ref;
  const [displayValue, setDisplayValue] = useState([from, to]);
  const lastValue = useRef([from, to]);
  const defaultValue = useRef([from, to]);
  const id = useMemo(() => `range-slider-${random(1, 2000)}`, []);
  const fromDisplay = displayValue[0];
  const toDisplay = displayValue[1];
  const marks = [{
    value: fromDisplay,
    label: getLabel(fromDisplay)
  }, {
    value: toDisplay,
    label: getLabel(toDisplay)
  }];
  const onSelect = useCallback(() => {
    const fromChanged = lastValue.current[0] !== displayValue[0];
    const toChanged = lastValue.current[1] !== displayValue[1];
    const hasChanged = fromChanged || toChanged;
    if (hasChanged) {
      onChange(displayValue);
      lastValue.current = displayValue;
    }
  }, [onChange, displayValue]);
  const changeDisplay = useCallback((e, value) => {
    setDisplayValue(value);
  }, []);
  useGranularEffect(() => {
    const fromReset = from === min && fromDisplay != min;
    const toReset = to === max && toDisplay != max;
    if (fromReset || toReset) {
      setDisplayValue([min, max]);
    }
  }, [from, to], [min, max]);
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, {
    mt: 1,
    mb: 2
  }, /*#__PURE__*/React.createElement(Typography, {
    id: id,
    gutterBottom: true
  }, title)), /*#__PURE__*/React.createElement(Box, {
    px: 0.5
  }, /*#__PURE__*/React.createElement(Slider, _extends({
    "aria-labelledby": id,
    valueLabelFormat: getLabel,
    defaultValue: defaultValue.current,
    marks: marks,
    valueLabelDisplay: "auto",
    onChangeCommitted: () => {
      onSelect();
    },
    onChange: changeDisplay,
    min: min,
    max: max
  }, rest, {
    value: displayValue
  }))));
};
Range.propTypes = {
  from: PropTypes.number,
  to: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  title: PropTypes.string,
  onChange: PropTypes.func,
  getLabel: PropTypes.func
};

const useStyles$7 = makeStyles(() => ({
    border: {
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 4,
    },
}));
const Subsection = ({ children }) => {
    const classes = useStyles$7();
    return jsx(ListItem$1, Object.assign({ className: classes.border }, { children: children }));
};

const useHasSelectivity = () => {
  const hasLegacyFilter = useCurrentValue(SELECTIVITY$1).length > 0;
  const hasFilter = useCurrentValue(SELECTIVITY_LEVEL$1).length > 0;
  return hasFilter || hasLegacyFilter;
};

const SelectivitySelector = () => {
    const options = useOptions$1();
    const onSelect = useOnSelect$1();
    return (jsx(SelectableIconChips, { options: options, gridItemProps: { md: 4, xs: 6 }, onSelect: onSelect }));
};
const getNumber = (otherwise, value) => {
    if (isNumber$1(value))
        return value;
    return isString$1(value) ? parseInt(value, 10) : otherwise;
};
const useLegacyCurrentValue = () => {
    const currentValue = useCurrentValue(SELECTIVITY$1);
    const value = head$1(currentValue);
    const v = [getNumber(0, value === null || value === void 0 ? void 0 : value.from), getNumber(100, value === null || value === void 0 ? void 0 : value.to)];
    return v;
};
const LegacyRange = () => {
    const currentValue = useLegacyCurrentValue();
    const onSelect = useOnSelectLegacy();
    const initialValue = useRef(currentValue).current;
    return (jsx(Subsection, { children: jsx(Box$1, Object.assign({ mx: 1.5, width: '100%' }, { children: jsx(Range, { title: "Admission Rate", step: 1, min: 0, max: 100, getAriaValueText: (value) => `${value}%`, from: get$1(initialValue, '[0]', 0), to: get$1(initialValue, '[1]', 100), getLabel: (value) => `${value}%`, value: currentValue, onChange: onSelect }) })) }));
};
SelectivitySelector.LegacyRange = LegacyRange;

const SAT_MIN = 400;
const SAT_MAX = 1600;
const ACT_MIN = 1;
const ACT_MAX = 36;
const TEST_SCORES_TITLE = 'Average Test Scores of Admitted Students';

const useSelections = () => {
  const currentSATValue = useCurrentValue(SAT$1);
  const currentACTValue = useCurrentValue(ACT$1);
  return useMemo(() => {
    const sat = head(currentSATValue);
    const act = head(currentACTValue);
    return {
      sat,
      act,
      satFrom: parseInt(get(sat, 'from', SAT_MIN)),
      satTo: parseInt(get(sat, 'to', SAT_MAX)),
      actFrom: parseInt(get(act, 'from', ACT_MIN)),
      actTo: parseInt(get(act, 'to', ACT_MAX))
    };
  }, [currentSATValue, currentACTValue]);
};

const useHasTestScores = () => {
  const {
    satFrom,
    satTo,
    actFrom,
    actTo
  } = useSelections();
  return satFrom !== SAT_MIN || satTo !== SAT_MAX || actFrom !== ACT_MIN || actTo !== ACT_MAX;
};

const getValue = (value, range) => {
  const a = value[0];
  const b = value[1];
  const c = a !== range[0];
  const d = b !== range[1];
  const isTouched = c || d;
  const obj = {
    from: a.toString(),
    to: b.toString()
  };
  return !isTouched ? [] : [obj];
};

const getAriaValueTextACT = value => `Average ACT range: ${value}`;
const getAriaValueTextSAT = value => `Average SAT range: ${value}`;
const TestScores = () => {
  const onUpdate = useOnUpdateData();
  const {
    satFrom,
    satTo,
    actFrom,
    actTo
  } = useSelections();
  const hasASelection = useHasTestScores();
  const onACTChange = useCallback(value => {
    onUpdate([ACT$1], [getValue(value, [ACT_MIN, ACT_MAX])]);
  }, [onUpdate]);
  const onSATChange = useCallback(value => {
    onUpdate([SAT$1], [getValue(value, [SAT_MIN, SAT_MAX])]);
  }, [onUpdate]);
  const onClickHide = useCallback(() => {
    if (hasASelection) onUpdate([SAT$1, ACT$1], [[], []]);
  }, [hasASelection, onUpdate]);
  return /*#__PURE__*/React.createElement(ShowHide, {
    isExpandedByDefault: hasASelection,
    moreLabel: "Add Test Score Ranges",
    lessLabel: "Clear Test Score Ranges",
    collapsedHeight: "0px",
    onClickHide: onClickHide,
    buttonVariant: "text"
  }, /*#__PURE__*/React.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React.createElement(Box, {
    mb: 2
  }, /*#__PURE__*/React.createElement(SubsectionText, {
    title: TEST_SCORES_TITLE
  })), /*#__PURE__*/React.createElement(Subsection, null, /*#__PURE__*/React.createElement(Box, {
    mx: 1.5,
    width: '100%'
  }, /*#__PURE__*/React.createElement(Range, {
    title: "ACT",
    step: 1,
    min: ACT_MIN,
    max: ACT_MAX,
    getAriaValueText: getAriaValueTextACT,
    from: actFrom,
    to: actTo,
    value: [actFrom, actTo],
    onChange: onACTChange
  }))), /*#__PURE__*/React.createElement(Box, {
    my: 2
  }), /*#__PURE__*/React.createElement(Subsection, null, /*#__PURE__*/React.createElement(Box, {
    mb: 1,
    mx: 1.5,
    width: '100%'
  }, /*#__PURE__*/React.createElement(Range, {
    title: "SAT",
    step: 10,
    min: SAT_MIN,
    max: SAT_MAX,
    from: satFrom,
    to: satTo,
    value: [satFrom, satTo],
    getAriaValueText: getAriaValueTextSAT,
    onChange: onSATChange
  })))));
};

const Selectivity = ({ hideSelectivitySubheader, legacySelectivity }) => {
    return (jsxs(React.Fragment, { children: [hideSelectivitySubheader ? null : (jsx(SubsectionText, { title: SELECTIVITY_TITLE, description: SELECTIVITY_DESCRIPTION })), legacySelectivity ? jsx(SelectivitySelector.LegacyRange, {}) : jsx(SelectivitySelector, {}), jsx(TestScores, {})] }));
};

const useSelectedOptions = () => {
  return useCurrentValue(ACCEPTANCE_LIKELIHOOD$1);
};

const FarReach = {
  defaultTitle: 'Far Reach',
  acceptanceLikelihoodLabelName: 'FarReach',
  value: 5,
  icon: faStars,
  iconSelected: faStars$1
};
const Reach = {
  defaultTitle: 'Reach',
  acceptanceLikelihoodLabelName: 'Reach',
  value: 4,
  icon: faMoonStars,
  iconSelected: faMoonStars$1
};
const Level = {
  defaultTitle: 'Level',
  acceptanceLikelihoodLabelName: 'Level',
  value: 3,
  icon: faBullseyeArrow,
  iconSelected: faBullseyeArrow$1
};
const Likely = {
  defaultTitle: 'Likely',
  acceptanceLikelihoodLabelName: 'Likely',
  value: 2,
  icon: faSmile,
  iconSelected: faSmile$1
};
const VeryLikely = {
  defaultTitle: 'Very Likely',
  acceptanceLikelihoodLabelName: 'VeryLikely',
  value: 1,
  icon: faSmileWink,
  iconSelected: faSmileWink$1
};
const getOption = (option, customLabels, selectedOptions) => {
  const {
    value,
    acceptanceLikelihoodLabelName,
    defaultTitle,
    iconSelected,
    icon
  } = option;
  const selected = selectedOptions.includes(value);
  return {
    value,
    selected,
    faIcon: selected ? iconSelected : icon,
    title: get(customLabels, acceptanceLikelihoodLabelName, defaultTitle)
  };
};

const getOptions$4 = collegeMatchLevel => {
  switch (collegeMatchLevel) {
    case undefined:
      return [];
    case 0:
      return [];
    case 6:
      return [Level, Likely, VeryLikely];
    case 5:
      return [Reach, Level, Likely, VeryLikely];
    case 2:
      return [FarReach, Reach, Level, Likely];
    case 1:
      return [FarReach, Reach, Level];
    default:
      return [FarReach, Reach, Level, Likely, VeryLikely];
  }
};
const useOptions = () => {
  const selectedOptions = useSelectedOptions();
  const customLabels = useAcceptanceLikelihoodLabels();
  const collegeMatchLevel = useCollegeMatchLevel();
  return useMemo(() => {
    const optionsToUse = getOptions$4(collegeMatchLevel);
    const optionValues = {};
    const options = optionsToUse.map(opt => {
      const option = getOption(opt, customLabels, selectedOptions);
      optionValues[option.value] = true;
      return option;
    });
    return {
      options,
      optionValues
    };
  }, [selectedOptions, customLabels, collegeMatchLevel]);
};

const useCleanUpOutOfRangeOptions = (selectedOptions, optionValues) => {
  const onUpdate = useOnUpdateData();
  const hasRun = useRef(false);
  useEffect(() => {
    if (!hasRun.current) {
      const updated = [];
      forEach(selectedOptions, selectedOption => {
        if (optionValues[selectedOption]) {
          updated.push(selectedOption);
        }
      });
      if (selectedOptions.length !== updated.length) {
        onUpdate([ACCEPTANCE_LIKELIHOOD$1], [updated]);
      }
      hasRun.current = true;
    }
  }, [selectedOptions, optionValues, onUpdate]);
};

const useOnSelect = () => {
  const onUpdate = useOnUpdateData();
  const selectedOptions = useSelectedOptions();
  return useCallback((value, option) => {
    const updated = option.selected ? without(selectedOptions, value) : uniq([...selectedOptions, value]);
    onUpdate([ACCEPTANCE_LIKELIHOOD$1, SELECTIVITY$1, SELECTIVITY_LEVEL$1], [updated, [], []]);
  }, [selectedOptions, onUpdate]);
};

const AcceptanceLikelihood = () => {
  const selectedOptions = useSelectedOptions();
  const {
    options,
    optionValues
  } = useOptions();
  const onSelect = useOnSelect();
  useCleanUpOutOfRangeOptions(selectedOptions, optionValues);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SubsectionText, {
    title: LIKELIHOOD_TITLE,
    description: LIKELIHOOD_DESCRIPTION
  }), /*#__PURE__*/React.createElement(SelectableIconChips, {
    options: options,
    gridItemProps: {
      md: 4,
      xs: 6
    },
    onSelect: onSelect
  }));
};

const AdmissionsFilterContext = /*#__PURE__*/React.createContext();
const AdmissionsFilterProvider = _ref => {
  let {
    children
  } = _ref;
  const hasSelectivity = useHasSelectivity();
  const hasTestScores = useHasTestScores();
  const shouldDefaultToAcceptanceLikelihood = !hasSelectivity && !hasTestScores;
  const [showAcceptanceLikelihood, setShowAcceptanceLikelihood] = useState(shouldDefaultToAcceptanceLikelihood);
  const supportsAcceptanceLikelihoodFilters = useSupportsAcceptanceLikelihoodFilters();
  return /*#__PURE__*/React.createElement(AdmissionsFilterContext.Provider, {
    value: {
      showAcceptanceLikelihood,
      setShowAcceptanceLikelihood,
      supportsAcceptanceLikelihoodFilters
    }
  }, children);
};
AdmissionsFilterProvider.propTypes = {
  children: PropTypes.node.isRequired
};

const useStyles$6 = makeStyles(() => ({
  selected: {
    backgroundColor: `rgba(0, 125, 170, 0.08)`,
    '&:hover': {
      backgroundColor: `rgba(0, 125, 170, 0.08)`
    }
  }
}));
const childrenProptypes = {
  children: PropTypes.node.isRequired
};
const WithoutSupportForAcceptanceLikelihood = _ref => {
  let {
    children
  } = _ref;
  const {
    supportsAcceptanceLikelihoodFilters
  } = useContext(AdmissionsFilterContext);
  return !supportsAcceptanceLikelihoodFilters ? children : null;
};
const WithSupportForAcceptanceLikelihood = _ref2 => {
  let {
    children
  } = _ref2;
  const {
    supportsAcceptanceLikelihoodFilters
  } = useContext(AdmissionsFilterContext);
  return supportsAcceptanceLikelihoodFilters ? children : null;
};
const SelectivityEnabled = _ref3 => {
  let {
    children
  } = _ref3;
  const {
    showAcceptanceLikelihood
  } = useContext(AdmissionsFilterContext);
  return !showAcceptanceLikelihood ? children : null;
};
const LikelihoodEnabled = _ref4 => {
  let {
    children
  } = _ref4;
  const {
    showAcceptanceLikelihood
  } = useContext(AdmissionsFilterContext);
  return showAcceptanceLikelihood ? children : null;
};
const AcceptanceLikelihoodOrSelectivitySelector = () => {
  const {
    showAcceptanceLikelihood,
    setShowAcceptanceLikelihood
  } = useContext(AdmissionsFilterContext);
  const classes = useStyles$6();
  return /*#__PURE__*/React.createElement(Box, {
    mb: 3
  }, /*#__PURE__*/React.createElement(ButtonGroup, {
    disableRipple: true,
    color: "primary",
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn({
      [classes.selected]: showAcceptanceLikelihood
    }),
    onClick: () => setShowAcceptanceLikelihood(true),
    "aria-label": `Show ${LIKELIHOOD_TITLE} filters`
  }, LIKELIHOOD_TITLE), /*#__PURE__*/React.createElement(Button, {
    className: cn({
      [classes.selected]: !showAcceptanceLikelihood
    }),
    onClick: () => setShowAcceptanceLikelihood(false),
    "aria-label": `Show ${SELECTIVITY_TITLE} filters`
  }, SELECTIVITY_TITLE)));
};
WithoutSupportForAcceptanceLikelihood.propTypes = childrenProptypes;
WithSupportForAcceptanceLikelihood.propTypes = childrenProptypes;
SelectivityEnabled.propTypes = childrenProptypes;
LikelihoodEnabled.propTypes = childrenProptypes;

const AdmissionsSelector = ({ legacySelectivity, hideSelectivitySubheader }) => {
    return (jsxs(AdmissionsFilterProvider, { children: [jsxs(WithSupportForAcceptanceLikelihood, { children: [jsx(AcceptanceLikelihoodOrSelectivitySelector, {}), jsxs(Box$1, Object.assign({ mt: 2 }, { children: [jsx(LikelihoodEnabled, { children: jsx(AcceptanceLikelihood, {}) }), jsx(SelectivityEnabled, { children: jsx(Selectivity, { legacySelectivity: legacySelectivity, hideSelectivitySubheader: hideSelectivitySubheader }) })] }))] }), jsx(WithoutSupportForAcceptanceLikelihood, { children: jsx(Selectivity, { legacySelectivity: legacySelectivity, hideSelectivitySubheader: hideSelectivitySubheader }) })] }));
};

const DEFAULT_MESSAGE = 'Expand your search to see more filters';
const ExpandYourSearch = (_a) => {
    var { facetNames, message = DEFAULT_MESSAGE } = _a, rest = __rest(_a, ["facetNames", "message"]);
    const isMissingFacet = useHasHiddenFacets$2(facetNames);
    return !isMissingFacet ? null : (jsx(Box$1, Object.assign({}, rest, { children: jsx(Typography$1, Object.assign({ variant: "body2", color: "textSecondary" }, { children: message })) })));
};

const ToggleRow = _ref => {
  let {
    title,
    subtitle,
    selected,
    onToggle,
    inputProps
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    mt: 3
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, title), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, subtitle)), /*#__PURE__*/React.createElement(Box, {
    p: 1
  }, /*#__PURE__*/React.createElement(Switch, {
    disableRipple: false,
    checked: selected,
    onChange: onToggle,
    inputProps: inputProps,
    color: "primary"
  })));
};
ToggleRow.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  selected: PropTypes.bool,
  onToggle: PropTypes.func,
  inputProps: PropTypes.object
};

const TRUE = 'T';
const getIsTrue = (value) => head$1(value) === TRUE;
const TestOptional = () => {
    const onUpdate = useOnUpdateData();
    const facet = useOptions$2({ fieldName: TEST_OPTIONAL$2 });
    const hasFacet = useMemo(() => some$1(facet, (term) => term.term === TRUE), [facet]);
    const currentValue = useCurrentValue(TEST_OPTIONAL$2);
    const selected = getIsTrue(currentValue);
    const onToggle = useCallback(() => {
        const value = selected ? [] : [TRUE];
        onUpdate([TEST_OPTIONAL$2], [value]);
    }, [selected, onUpdate]);
    const ariaLabel = useMemo(() => `Test-Optional: ${selected ? 'enabled' : 'disabled'}`, [selected]);
    return !hasFacet ? null : (jsx(Box$1, Object.assign({ mb: 2 }, { children: jsx(ToggleRow, { title: "Test-Optional", subtitle: "Only show colleges where submitting test scores as part of the application is optional.", selected: selected, onToggle: onToggle, inputProps: { 'aria-label': ariaLabel } }) })));
};

const VALUE_COMMON = 'Common Application';
const VALUE_FIRST = 'first';
const VALUE_TRANSFER = 'transfer';
const COMMON_ICON_UNSELECTED = faPaperPlane;
const COMMON_ICON_SELECTED = faPaperPlane$1;

const useScoirApplyApplicantTypeFacets = () => {
    return useOptions$2({ fieldName: SCOIR_APPLY_APPLICANT_TYPES$1 }) || [];
};
const useHasTerm = (term) => {
    const terms = useScoirApplyApplicantTypeFacets();
    return useMemo(() => {
        return some$1(terms, (current) => current.term === term);
    }, [terms, term]);
};

const useTransferOption = () => {
    const currentValue = useCurrentValue(SCOIR_APPLY_APPLICANT_TYPES$1);
    const selected = useMemo(() => includes$1(currentValue, VALUE_TRANSFER), [currentValue]);
    const hasTermTransfer = useHasTerm(VALUE_TRANSFER);
    return useMemo(() => {
        return !hasTermTransfer
            ? undefined
            : {
                selected,
                fieldName: SCOIR_APPLY_APPLICANT_TYPES$1,
                title: 'Applying as a Transfer',
                subtitle: 'Only show colleges that accept transfer applications via Scoir',
                value: VALUE_TRANSFER,
            };
    }, [selected, hasTermTransfer]);
};

const TransferOption = () => {
    const onUpdate = useOnUpdateData();
    const transferOption = useTransferOption();
    const currentValue = useCurrentValue(SCOIR_APPLY_APPLICANT_TYPES$1);
    const firstSelected = useMemo(() => includes$1(currentValue, VALUE_FIRST), [currentValue]);
    const transferSelected = useMemo(() => includes$1(currentValue, VALUE_TRANSFER), [currentValue]);
    const scoirApplySelected = firstSelected || transferSelected;
    const shouldShow = scoirApplySelected && !!transferOption;
    const ariaLabel = useMemo(() => {
        return `Applying as a Transfer: ${(transferOption === null || transferOption === void 0 ? void 0 : transferOption.selected) ? 'enabled' : 'disabled'}`;
    }, [transferOption]);
    const onSelect = useCallback(() => {
        const value = transferSelected ? [VALUE_FIRST] : [VALUE_TRANSFER];
        return onUpdate([SCOIR_APPLY_APPLICANT_TYPES$1], [value]);
    }, [onUpdate, transferSelected]);
    return !shouldShow ? null : (jsx(ToggleRow, { title: transferOption === null || transferOption === void 0 ? void 0 : transferOption.title, subtitle: transferOption === null || transferOption === void 0 ? void 0 : transferOption.subtitle, selected: transferOption === null || transferOption === void 0 ? void 0 : transferOption.selected, onToggle: onSelect, inputProps: {
            'aria-label': ariaLabel,
        } }));
};

const arrayValueToggle = (array, value) => {
    return produce(array, (draft) => {
        const alreadySelected = includes$1(draft, value);
        if (alreadySelected) {
            remove$1(draft, (current) => isEqual$1(current, value));
        }
        else {
            draft.push(value);
        }
    });
};

const useScoirApplyOption = () => {
    const currentValue = useCurrentValue(SCOIR_APPLY_APPLICANT_TYPES$1);
    const firstSelected = useMemo(() => includes$1(currentValue, VALUE_FIRST), [currentValue]);
    const transferSelected = useMemo(() => includes$1(currentValue, VALUE_TRANSFER), [currentValue]);
    const selected = firstSelected || transferSelected;
    const { displayScoirApplyIcon: DisplayScoirApplyIcon } = useContext(SelectorContext);
    const hasTermFirst = useHasTerm(VALUE_FIRST);
    const icon = useMemo(() => {
        return (jsx(Box$1, Object.assign({ textAlign: "center", fontSize: "24px", height: "34px" }, { children: jsx(DisplayScoirApplyIcon, { isScoirApplyEnabled: true }) })));
    }, [DisplayScoirApplyIcon]);
    return useMemo(() => {
        return !hasTermFirst
            ? undefined
            : {
                selected,
                fieldName: SCOIR_APPLY_APPLICANT_TYPES$1,
                title: 'Scoir',
                value: VALUE_FIRST,
                icon,
            };
    }, [selected, hasTermFirst, icon]);
};

const useCommonAppOption = () => {
    const currentValue = useCurrentValue(APP_METHOD$1);
    const selected = useMemo(() => includes$1(currentValue, VALUE_COMMON), [currentValue]);
    const terms = useOptions$2({ fieldName: APP_METHOD$1 });
    const hasTerm = useMemo(() => {
        return some$1(terms, (current) => current.term === 'Common Application');
    }, [terms]);
    return useMemo(() => {
        return !hasTerm
            ? undefined
            : {
                selected,
                title: 'Common App',
                fieldName: APP_METHOD$1,
                value: VALUE_COMMON,
                faIcon: selected ? COMMON_ICON_SELECTED : COMMON_ICON_UNSELECTED,
            };
    }, [selected, hasTerm]);
};

const useAppMethodSelectorOptions = ({ scoirApply, common }) => {
    const scoirApplyOption = useScoirApplyOption();
    const commonAppOption = useCommonAppOption();
    return useMemo(() => {
        const options = [];
        if (scoirApply && scoirApplyOption)
            options.push(scoirApplyOption);
        if (common && commonAppOption)
            options.push(commonAppOption);
        return options;
    }, [scoirApplyOption, commonAppOption, scoirApply, common]);
};

const getUpdatedValue = ({ currentValues, option }) => {
    const { fieldName, value, selected } = option;
    const current = currentValues[fieldName];
    const isDeselectingFirstYearScoirApplyApplicantType = fieldName === SCOIR_APPLY_APPLICANT_TYPES$1 && selected && value === VALUE_FIRST;
    if (isDeselectingFirstYearScoirApplyApplicantType) {
        return [];
    }
    return arrayValueToggle(current, value);
};
const AppMethod = ({ scoirApply = true, common = true }) => {
    const onUpdate = useOnUpdateData();
    const currentAppMethodValue = useCurrentValue(APP_METHOD$1);
    const currentScoirApplyValue = useCurrentValue(SCOIR_APPLY_APPLICANT_TYPES$1);
    const options = useAppMethodSelectorOptions({ scoirApply, common });
    const onSelect = useCallback((_, option) => {
        const currentValues = {
            [APP_METHOD$1]: currentAppMethodValue,
            [SCOIR_APPLY_APPLICANT_TYPES$1]: currentScoirApplyValue,
        };
        const newValue = getUpdatedValue({ currentValues, option });
        return onUpdate([option.fieldName], [newValue]);
    }, [onUpdate, currentAppMethodValue, currentScoirApplyValue]);
    return (jsx(SelectableIconChips, { gridItemProps: { xs: 6 }, options: options, onSelect: onSelect }));
};

const ApplicationMethodSelector = ({ scoirApply = true, common = true, testOptional = true, transfer = true }) => {
    const facetNames = useMemo(() => {
        const names = [];
        if (scoirApply)
            names.push(SCOIR_APPLY_APPLICANT_TYPES$1);
        if (common)
            names.push(APP_METHOD$1);
        if (testOptional)
            names.push(TEST_OPTIONAL$2);
        return names;
    }, [common, scoirApply, testOptional]);
    return (jsxs(Box$1, Object.assign({ pb: 2 }, { children: [jsx(ExpandYourSearch, { facetNames: facetNames, mb: 3 }), !testOptional ? null : jsx(TestOptional, {}), !scoirApply && !common ? null : (jsx(AppMethod, { scoirApply: scoirApply, common: common })), !transfer ? null : jsx(TransferOption, {})] })));
};

const actionTypes = {
    INITIALIZE: 'INITIALIZE',
    NEW_ITEM: 'NEW_ITEM',
    REMOVE_NEW_ITEM: 'REMOVE_NEW_ITEM',
    REMOVE_ITEM: 'REMOVE_ITEM',
    FOCUS_ITEM: 'FOCUS_ITEM',
};

const initialState = {
    focusedItemIndex: null,
    isAdding: false,
};
const reducer$1 = (state, action) => {
    switch (action.type) {
        case actionTypes.INITIALIZE:
            return produce(state, (draft) => {
                const hasItems = action.payload.lastItemIndex > -1;
                const noFocus = hasItems && !action.payload.onlySecondStage;
                draft.focusedItemIndex = noFocus ? null : 0;
            });
        case actionTypes.NEW_ITEM:
            return produce(state, (draft) => {
                draft.isAdding = true;
                draft.focusedItemIndex = null;
            });
        case actionTypes.REMOVE_NEW_ITEM:
            return produce(state, (draft) => {
                draft.isAdding = false;
            });
        case actionTypes.FOCUS_ITEM:
            return produce(state, (draft) => {
                draft.focusedItemIndex = action.payload;
                draft.isAdding = false;
            });
        default:
            return state;
    }
};

const useInitialize = (lastItemIndex, dispatch, onlySecondStage) => {
    const hasInitialized = useRef(false);
    useEffect(() => {
        if (hasInitialized.current)
            return;
        hasInitialized.current = true;
        dispatch({ type: actionTypes.INITIALIZE, payload: { lastItemIndex, onlySecondStage } });
    }, [dispatch, lastItemIndex, onlySecondStage]);
};

const useCloseAddOnComplete = (length, onCloseCreateStage) => {
    const lastLength = useRef(length);
    useEffect(() => {
        if (length !== lastLength.current) {
            lastLength.current = length;
            onCloseCreateStage();
        }
    }, [length, onCloseCreateStage]);
};

const useRepeater = (currentValue, onlySecondStage) => {
    const [{ focusedItemIndex, isAdding }, dispatch] = useReducer(reducer$1, initialState);
    const length = size$1(currentValue);
    useInitialize(length, dispatch, onlySecondStage);
    const onAddItem = useCallback(() => {
        dispatch({ type: actionTypes.NEW_ITEM });
    }, []);
    const onCloseCreateStage = useCallback(() => {
        dispatch({ type: actionTypes.REMOVE_NEW_ITEM });
    }, []);
    const onAddComplete = useCallback(() => {
        onCloseCreateStage();
        dispatch({ type: actionTypes.FOCUS_ITEM, payload: length - 1 });
    }, [length, onCloseCreateStage]);
    const onEditItem = useCallback((index) => {
        dispatch({ type: actionTypes.FOCUS_ITEM, payload: index });
    }, []);
    useCloseAddOnComplete(length, onAddComplete);
    return {
        items: currentValue,
        focusedItemIndex,
        isAdding,
        onAddItem,
        onCloseCreateStage,
        onEditItem,
    };
};

const Context$4 = React.createContext({});

const Header = ({ title, subtitle, icon }) => {
    return (jsxs(Box$1, Object.assign({ flexGrow: 1, display: "flex", alignItems: "center" }, { children: [!icon ? null : (jsx(Box$1, Object.assign({ display: "flex", justifyContent: "flex-start", color: "#000", width: '40px' }, { children: jsx(FontAwesomeIcon, { icon: icon }) }))), jsxs(Box$1, Object.assign({ flexGrow: 1 }, { children: [jsx(Typography$1, Object.assign({ variant: "body1" }, { children: title })), jsx(Typography$1, Object.assign({ variant: "body2" }, { children: subtitle }))] }))] })));
};
const StageFrame = ({ header, children, onEdit, onRemove, collapsed }) => {
    return (jsxs(Box$1, Object.assign({ border: "1px solid rgba(0,0,0,0.23)" }, { children: [jsxs(Box$1, Object.assign({ bgcolor: "#EBF5F9", display: "flex", alignItems: "center", justifyContent: "center", p: 2 }, { children: [jsx(Header, Object.assign({}, header)), jsxs(Box$1, Object.assign({ display: "flex", alignItems: "center", pl: 2 }, { children: [!collapsed ? null : (jsx(Button$1, Object.assign({ onClick: onEdit, color: "primary" }, { children: "Edit" }))), jsx(Button$1, Object.assign({ onClick: onRemove, color: "primary" }, { children: "Remove" }))] }))] })), collapsed ? null : jsx(Box$1, Object.assign({ p: 2 }, { children: children }))] })));
};

const CreateStage = ({ Component, title }) => {
    const { onCloseCreateStage } = useContext(Context$4);
    return (jsx(StageFrame, Object.assign({ header: { title }, onRemove: onCloseCreateStage }, { children: jsx(Component, {}) })));
};

const EditStages = ({ editingSubtitle, fieldName, currentValue, getHeaderFromValue, Component }) => {
    const { focusedItemIndex, onEditItem } = useContext(Context$4);
    const onUpdate = useOnUpdateData();
    const onRemoveItem = useCallback((index) => {
        const newValue = filter$1(currentValue, (_, i) => i !== index);
        onUpdate([fieldName], [newValue]);
        onEditItem(null);
    }, [fieldName, onUpdate, currentValue, onEditItem]);
    const frames = useMemo(() => {
        return map$1(currentValue, (value, index) => {
            const isEditing = index === focusedItemIndex;
            const header = getHeaderFromValue(value);
            return (jsx(Box$1, Object.assign({ mb: 3 }, { children: jsx(StageFrame, Object.assign({ header: {
                        title: header.title,
                        subtitle: isEditing ? editingSubtitle : header.subtitle,
                        icon: header.icon,
                    }, collapsed: !isEditing, onEdit: () => {
                        onEditItem(index);
                    }, onRemove: () => {
                        onRemoveItem(index);
                    } }, { children: jsx(Component, { value: value }) })) }), index));
        });
    }, [currentValue, focusedItemIndex, Component, getHeaderFromValue, editingSubtitle, onEditItem, onRemoveItem]);
    return jsx(Fragment$1, { children: frames });
};

const AddButton = ({ addFirstButtonLabel, disableRepitition }) => {
    const { items, isAdding, onAddItem } = useContext(Context$4);
    const hasItems = items.length > 0;
    const label = useMemo(() => {
        return hasItems ? 'Add Another' : addFirstButtonLabel;
    }, [hasItems, addFirstButtonLabel]);
    const hasReachedLimit = disableRepitition && hasItems;
    const shouldHide = isAdding || hasReachedLimit;
    return shouldHide ? null : (jsx(Button$1, Object.assign({ variant: "outlined", color: "primary", onClick: onAddItem, startIcon: jsx(FontAwesomeIcon, { icon: faPlus }) }, { children: label })));
};

const Repeater = ({ addFirstButtonLabel, editingSubtitle = '', fieldName, getHeaderFromValue, CreateStageComponent, EditStageComponent, disableRepitition, onlySecondStage, }) => {
    const currentValue = useCurrentValue(fieldName);
    const value = useRepeater(currentValue, onlySecondStage);
    return (jsxs(Context$4.Provider, Object.assign({ value: value }, { children: [jsx(EditStages, { fieldName: fieldName, editingSubtitle: editingSubtitle, currentValue: currentValue, Component: EditStageComponent, getHeaderFromValue: getHeaderFromValue }), value.isAdding ? (jsx(CreateStage, { Component: CreateStageComponent, title: addFirstButtonLabel })) : (jsx(AddButton, { addFirstButtonLabel: addFirstButtonLabel, disableRepitition: disableRepitition }))] })));
};

const getDisplayName = (value) => {
    return value.replace(/\s\([wW]\)/, " (Women's)").replace(/\s\([mM]\)/, " (Men's)");
};

//All sport values in our system need an icon
const athleticsIcons = {
    'Acrobatics and Tumbling': faChild$1,
    Gymnastics: faChild$1,
    Baseball: faBaseball$1,
    Softball: faBaseball$1,
    Basketball: faBasketballHoop,
    'Beach Volleyball': faVolleyballBall$1,
    'Water Polo': faVolleyballBall$1,
    Volleyball: faVolleyballBall$1,
    Bowling: faBowlingPins$1,
    Cheerleading: faMegaphone$1,
    Cricket: faCricket$1,
    'Cross Country': faRunning$1,
    'Indoor Track': faRunning$1,
    'Track, Indoor': faRunning$1,
    'Outdoor Track': faRunning$1,
    'Track, Outdoor': faRunning$1,
    Triathalon: faRunning$1,
    Esports: faGamepadAlt$1,
    Equestrian: faHorseSaddle$1,
    Polo: faHorseSaddle$1,
    Fencing: faSwords$1,
    'Field Hockey': faFieldHockey$1,
    Football: faFootballBall$1,
    'Lightweight Football': faFootballBall$1,
    'Football, Lightweight': faFootballBall$1,
    Rugby: faFootballBall$1,
    Golf: faGolfClub$1,
    'Ice Hockey': faHockeySticks$1,
    Lacrosse: faCircle$1,
    'Lightweight Crew': faWater$1,
    'Crew, Lightweight': faWater$1,
    'Lightweight Rowing': faWater$1,
    'Rowing, Lightweight': faWater$1,
    Rowing: faWater$1,
    Sailing: faWater$1,
    Pistol: faBullseye$1,
    Rifle: faBullseye$1,
    Rodeo: faSkullCow,
    Skiing: faSkiing$1,
    Soccer: faFutbol$1,
    Squash: faRacquet$1,
    Tennis: faRacquet$1,
    Wrestling: faHandsHelping$1,
    'Swimming and Diving': faSwimmer$1,
    'Synchronized Swimming': faSwimmer$1,
};

const getIcon$1 = (value) => {
    const key = value.replace(/\s\(.+\)/g, ''); // get rid of parentheticals: "Soccer (Women's)" -> "Soccer"
    return get$1(athleticsIcons, key);
};

const getOptions$3 = sport => {
  let onlyOneCheckedIndex = -1;
  const selected = [];
  const options = map(get(sport, 'Divisions', []), (division, index) => {
    const checked = get(division, 'Selected', false);
    if (checked) {
      if (onlyOneCheckedIndex === -1) {
        // first time we hit a checked item it could be the only one
        onlyOneCheckedIndex = index;
      } else {
        // secondtime we get a checked item, its no longer the only one
        onlyOneCheckedIndex = -2;
      }
    }
    const value = get(division, 'Name', get(division, 'label'));
    const option = {
      Name: value,
      label: value,
      value
    };
    if (checked) {
      selected.push(option);
    }
    return option;
  });
  if (onlyOneCheckedIndex > -1) {
    // only one checked item, so disable it
    options[onlyOneCheckedIndex].disabled = true;
    selected[0].disabled = true;
  }
  return {
    options,
    selected
  };
};
const buildNewSport = value => {
  const tokens = value.tokens;
  const Name = value.name;
  const Divisions = [];
  forEach(tokens, token => {
    if (token !== Name) {
      Divisions.push({
        Name: token,
        Selected: true,
        label: token
      });
    }
  });
  return {
    value,
    Name,
    Divisions
  };
};
const toggleDivision = (sport, updatedDivision) => {
  const updatedDivisionName = get(updatedDivision, 'Name');
  const divisions = map(get(sport, 'Divisions', []), division => {
    return get(division, 'Name') === updatedDivisionName ? {
      ...division,
      Selected: !division.Selected
    } : division;
  });
  return {
    ...sport,
    Divisions: divisions
  };
};
const getSportsQuery = (selectedSport, updatedDivision) => {
  if (selectedSport == undefined) {
    return undefined;
  }
  let newSport = selectedSport;
  if (isEmpty(get(selectedSport, 'Divisions'))) {
    newSport = buildNewSport(selectedSport);
  }
  if (updatedDivision != undefined) {
    newSport = toggleDivision(selectedSport, updatedDivision);
  }
  const divisions = get(newSport, 'Divisions', []);
  const hasSelectedDivisions = some(divisions, ['Selected', true]);
  // This clears the sport filter because the backend is not
  // correctly handling when no divisions are selected
  return hasSelectedDivisions ? [newSport] : undefined;
};

const AthleticsTypeahead = ({ selectedSport }) => {
    const onUpdate = useOnUpdateData();
    const currentValue = useCurrentValue(SPORTS$1);
    const onSportSearch = useAPIFn(API_CALL_NAMES.onSportSearch);
    const selectedSportName = get$1(selectedSport, 'Name', '');
    const selectedValueNames = useMemo(() => {
        return keyBy$1(currentValue, 'Name');
    }, [currentValue]);
    const onChangeSport = useCallback((value) => {
        const newValue = getSportsQuery(value) || [];
        const updated = [...currentValue, ...newValue];
        onUpdate([SPORTS$1], [updated]);
    }, [onUpdate, currentValue]);
    const onSearchFn = useCallback((term) => {
        return onSportSearch(term).then((results) => {
            const filtered = filter$1(results, (result) => {
                return !selectedValueNames[result.name];
            });
            return Promise.resolve(filtered);
        });
    }, [onSportSearch, selectedValueNames]);
    return (jsx(Box$1, Object.assign({ my: 1, position: "relative", zIndex: 3 }, { children: jsx(SimpleAutocomplete, { value: selectedSportName, defaultValue: selectedSportName, "aria-label": "Add Athletic", label: "Add Athletic", onChange: onChangeSport, onSearch: onSearchFn, renderOption: ({ value }) => {
                const icon = getIcon$1(value);
                return (jsxs(Box$1, Object.assign({ width: "100%", display: "flex", alignItems: "center", justifyContent: "flex-start" }, { children: [jsx(Box$1, Object.assign({ display: "flex", justifyContent: "flex-start", alignSelf: "center", width: '40px', color: "#000" }, { children: !icon ? null : jsx(FontAwesomeIcon, { icon: icon }) })), getDisplayName(value)] })));
            } }) })));
};

const Divisions = ({ selectedSport }) => {
    const onUpdate = useOnUpdateData();
    const currentValue = useCurrentValue(SPORTS$1);
    const { options, selected } = useMemo(() => getOptions$3(selectedSport), [selectedSport]);
    const onSelectDivision = useCallback((_, division) => {
        const newDivisions = head$1(getSportsQuery(selectedSport, division)) || [];
        const updatedValue = map$1(currentValue, (val) => {
            if (val.Name === selectedSport.Name) {
                return newDivisions;
            }
            return val;
        });
        onUpdate([SPORTS$1], [updatedValue]);
    }, [onUpdate, selectedSport, currentValue]);
    return (jsx(ChipSelector, { selected: selected, options: options, onUpdateSelection: onSelectDivision }));
};

const getDivisions = (currentValue) => {
    const Divisions = get$1(currentValue, 'Divisions', []);
    const filtered = filter$1(Divisions, ['Selected', true]);
    return map$1(filtered, ({ Name }) => Name).join(' • ');
};
const getHeaderFromValue$1 = (value) => {
    return {
        title: getDisplayName(value.Name),
        subtitle: getDivisions(value),
        icon: getIcon$1(value.Name),
    };
};
const CreateStageComponent$1 = () => {
    return jsx(AthleticsTypeahead, {});
};
const EditStageComponent$1 = ({ value }) => {
    return jsx(Divisions, { selectedSport: value });
};
const AthleticsSelector = ({ addFirstButtonLabel, disableRepitition }) => {
    const currentValue = useCurrentValue(SPORTS$1);
    const hasCurrentValue = !isEmpty$1(currentValue);
    const showJustTypeahead = disableRepitition && !hasCurrentValue;
    return showJustTypeahead ? (jsx(AthleticsTypeahead, {})) : (jsx(Repeater, { fieldName: SPORTS$1, onlySecondStage: disableRepitition, addFirstButtonLabel: addFirstButtonLabel, disableRepitition: disableRepitition, editingSubtitle: "Select 1 or more divisions", getHeaderFromValue: getHeaderFromValue$1, CreateStageComponent: CreateStageComponent$1, EditStageComponent: EditStageComponent$1 }));
};

const useCurrentDegrees = () => {
    return useCurrentValue(DEGREES$1);
};
const useCurrentUnivType = () => {
    return useCurrentValue(UNIV_TYPE$1);
};
const useCurrentSchoolClassifier = () => {
    return useCurrentValue(SCHOOL_CLASSIFIER);
};
const useHideUnivType = () => {
    const univTypeOptions = useOptions$2({ fieldName: UNIV_TYPE$1 });
    return univTypeOptions.length === 0;
};
const useHideSchoolClassifier = () => {
    const schoolClassifierOptions = useOptions$2({ fieldName: SCHOOL_CLASSIFIER });
    return schoolClassifierOptions.length === 0;
};

const getFilterOptions = ({ filter, terms, labels, subtitles }) => {
    return map$1(terms, (term) => {
        const value = get$1(term, 'term');
        // Sanitizing the string of special chars helps it match the expected value stored in different envs
        const sanitizedValueString = value.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '');
        return {
            title: get$1(labels, sanitizedValueString, term.label),
            subtitle: get$1(subtitles, sanitizedValueString),
            checked: includes$1(filter, value),
            value,
        };
    });
};

const degreeIcons = {
    Certificate: { icon: faFileCertificate, selectedIcon: faFileCertificate$1 },
    Associates: { icon: faAward, selectedIcon: faAward$1 },
    Bachelors: { icon: faDiploma, selectedIcon: faDiploma$1 },
    Masters: { icon: faStar, selectedIcon: faStar$1 },
    Doctorate: { icon: faMedal, selectedIcon: faMedal$1 },
};
const getDegreeChipOptions = (options) => {
    return options.map((option) => {
        var _a, _b;
        const { title, value } = option;
        return {
            label: title,
            value,
            icon: ((_a = degreeIcons[value]) === null || _a === void 0 ? void 0 : _a.icon) || null,
            selectedIcon: ((_b = degreeIcons[value]) === null || _b === void 0 ? void 0 : _b.selectedIcon) || null,
        };
    });
};

const DegreesSelector$1 = () => {
    const onUpdate = useOnUpdateData();
    const currentDegreesValue = useCurrentDegrees();
    const dregreesOptions = useOptions$2({ fieldName: DEGREES$1 });
    const hideUnivType = useHideUnivType();
    const filteredDegreesOptions = useMemo(() => {
        const o = getFilterOptions({
            terms: dregreesOptions,
            filter: currentDegreesValue,
            labels: hideUnivType ? DEGREES_LABELS : NEW_DEGREES_LABELS,
        });
        const orderedOptions = orderBy(o, ['title'], ['desc']);
        return getDegreeChipOptions(orderedOptions);
    }, [dregreesOptions, currentDegreesValue, hideUnivType]);
    const onSelectDegree = useCallback((_, option) => {
        const newValue = option.value;
        const newSelections = arrayValueToggle(currentDegreesValue, newValue);
        onUpdate([DEGREES$1], [newSelections]);
    }, [currentDegreesValue, onUpdate]);
    const selectedDegreeOptions = useMemo(() => {
        return map$1(currentDegreesValue, (degree) => {
            return {
                label: degree,
                value: degree,
            };
        });
    }, [currentDegreesValue]);
    const hasOptions = !isEmpty$1(filteredDegreesOptions);
    return !hasOptions ? null : (jsxs(Fragment$1, { children: [jsx(SubsectionText, { title: "Degrees Offered", mb: 0 }), jsx(Box$1, { children: jsx(ChipSelector, { options: filteredDegreesOptions, selected: selectedDegreeOptions, onUpdateSelection: onSelectDegree }) })] }));
};

const UnivTypeSelector = ({ indented }) => {
    const onUpdate = useOnUpdateData();
    const currentUnivTypeValue = useCurrentUnivType();
    const univTypeOptions = useOptions$2({ fieldName: UNIV_TYPE$1 });
    const hideUnivType = useHideUnivType();
    const univTypeFilteredOptions = useMemo(() => {
        return getFilterOptions({
            terms: univTypeOptions,
            filter: currentUnivTypeValue,
            labels: UNIV_TYPE_LABELS,
            subtitles: UNIV_TYPE_SUB_LABELS,
        });
    }, [univTypeOptions, currentUnivTypeValue]);
    const onSelectUnivType = useCallback((newValue) => {
        const newSelections = arrayValueToggle(currentUnivTypeValue, newValue);
        onUpdate([UNIV_TYPE$1], [newSelections]);
    }, [currentUnivTypeValue, onUpdate]);
    return hideUnivType ? null : (jsxs(Box$1, { children: [jsx(SubsectionText, { title: "College Level", mb: 0 }), jsx(Checklist, { options: univTypeFilteredOptions, isTwoColumnAtSm: false, onSelect: onSelectUnivType, listSubheaderProps: { disableGutters: false }, indented: indented })] }));
};

const SchoolClassifierSelector = ({ indented }) => {
    const onUpdate = useOnUpdateData();
    const currentSchoolClassifierValue = useCurrentSchoolClassifier();
    const schoolClassifierOptions = useOptions$2({ fieldName: SCHOOL_CLASSIFIER });
    const hideSchoolClassifier = useHideSchoolClassifier();
    const schoolClassifierFilteredOptions = useMemo(() => {
        return getFilterOptions({
            terms: schoolClassifierOptions,
            filter: currentSchoolClassifierValue,
            labels: SCHOOL_CLASSIFIER_LABELS,
            subtitles: SCHOOL_CLASSIFIER_SUB_LABELS,
        });
    }, [schoolClassifierOptions, currentSchoolClassifierValue]);
    const onSelectSchoolClassifier = useCallback((newValue) => {
        const newSelections = arrayValueToggle(currentSchoolClassifierValue, newValue);
        onUpdate([SCHOOL_CLASSIFIER], [newSelections]);
    }, [currentSchoolClassifierValue, onUpdate]);
    return hideSchoolClassifier ? null : (jsxs(Box$1, { children: [jsx(SubsectionText, { title: "Special Focus", mb: 0 }), jsx(Checklist, { options: schoolClassifierFilteredOptions, isTwoColumnAtSm: false, onSelect: onSelectSchoolClassifier, listSubheaderProps: { disableGutters: false }, indented: indented })] }));
};

const getFacetNames = (hideUnivType, hideSchoolClassifier) => {
    const relevantFacetNames = [DEGREES$1];
    if (!hideUnivType) {
        relevantFacetNames.push(UNIV_TYPE$1);
    }
    if (!hideSchoolClassifier) {
        relevantFacetNames.push(SCHOOL_CLASSIFIER);
    }
    return relevantFacetNames;
};
const Selector = ({ tntSearchFilterEnabled }) => {
    const univTypeOptions = useOptions$2({ fieldName: UNIV_TYPE$1 });
    const hideUnivType = tntSearchFilterEnabled && univTypeOptions.length === 0;
    const hideSchoolClassifier = useHideSchoolClassifier();
    const relevantFacetNames = useMemo(() => {
        return getFacetNames(hideUnivType, hideSchoolClassifier);
    }, [hideUnivType, hideSchoolClassifier]);
    return (jsxs(Fragment$1, { children: [jsx(ExpandYourSearch, { facetNames: relevantFacetNames }), hideUnivType ? null : jsx(UnivTypeSelector, {}), hideSchoolClassifier ? null : jsx(SchoolClassifierSelector, {}), jsx(DegreesSelector$1, {})] }));
};

const getSanitizedValue = (value) => {
    const lowerCaseValue = value.toLowerCase();
    const sanitizedValue = lowerCaseValue.replace(/[^a-z0-9]/g, '');
    return sanitizedValue;
};
const DegreesSelectorDropdown = (props) => {
    const onUpdate = useOnUpdateData();
    const currentDegreesValue = useCurrentDegrees();
    const currentUnivTypeValue = useCurrentUnivType();
    const currentSchoolClassifierValue = useCurrentSchoolClassifier();
    const degreeSelections = useMemo(() => {
        return map$1(currentDegreesValue, (degree) => {
            const sanitizedDegree = getSanitizedValue(degree);
            return NEW_DEGREES_LABELS[sanitizedDegree];
        });
    }, [currentDegreesValue]);
    const univTypeSelections = useMemo(() => {
        return map$1(currentUnivTypeValue, (univType) => {
            const sanitizedUnivType = getSanitizedValue(univType);
            return UNIV_TYPE_LABELS[sanitizedUnivType];
        });
    }, [currentUnivTypeValue]);
    const schoolClassifierSelections = useMemo(() => {
        return map$1(currentSchoolClassifierValue, (schoolClassifier) => {
            const sanitizedSchoolClassifier = getSanitizedValue(schoolClassifier);
            return SCHOOL_CLASSIFIER_LABELS[sanitizedSchoolClassifier];
        });
    }, [currentSchoolClassifierValue]);
    const selections = [...univTypeSelections, ...schoolClassifierSelections, ...degreeSelections];
    const onClear = useCallback(() => {
        onUpdate([DEGREES$1, UNIV_TYPE$1, SCHOOL_CLASSIFIER], []);
    }, [onUpdate]);
    return (jsx(Dropdown, Object.assign({ fieldLabel: "Degree", buttonLabel: "Degree", id: "college-search-filter-bar-degree", selectionLabels: selections, onClear: onClear }, { children: jsx(Box$1, Object.assign({ px: 2, pb: 2 }, { children: jsx(Selector, Object.assign({}, props, { isTwoColumnAtSm: false })) })) })));
};

const DegreesSelector = (props) => {
    return jsx(Selector, Object.assign({}, props));
};
DegreesSelector.Dropdown = DegreesSelectorDropdown;

const XS = 'x-small';
const SM$1 = 'small';
const MD$1 = 'medium';
const LG$1 = 'large';
const DISTANCES = [XS, SM$1, MD$1, LG$1];
const TITLES$2 = {
    [XS]: 'Close by',
    [SM$1]: '1–2 Hour Drive',
    [MD$1]: 'Long Drive',
    [LG$1]: 'Cross Country',
};
const SUBTITLES$1 = {
    [XS]: '0–25 mi',
    [SM$1]: '25–150 mi',
    [MD$1]: '150–500 mi',
    [LG$1]: '500–1000 mi',
};
const ICONS$2 = {
    [XS]: faMapMarkerAlt$1,
    [SM$1]: faCar,
    [MD$1]: faRv,
    [LG$1]: faPlaneDeparture,
};
const SELECTED_ICONS$1 = {
    [XS]: faMapMarkerAlt,
    [SM$1]: faCar$1,
    [MD$1]: faRv$1,
    [LG$1]: faPlaneDeparture$1,
};
const VALUES$1 = {
    [XS]: { from: 0, to: 25 },
    [SM$1]: { from: 25, to: 150 },
    [MD$1]: { from: 150, to: 500 },
    [LG$1]: { from: 500, to: 1000 },
};

const getOptions$2 = (selectedDistances) => {
    const options = map$1(DISTANCES, (distance, index) => {
        const isSelected = includes$1(selectedDistances, distance);
        return {
            title: TITLES$2[distance],
            subtitle: SUBTITLES$1[distance],
            faIcon: isSelected ? SELECTED_ICONS$1[distance] : ICONS$2[distance],
            value: distance,
            selected: isSelected,
        };
    });
    return options;
};
const getMatchingDistances = (selectedLocation) => {
    const selectedFrom = parseInt(get$1(selectedLocation, 'from', '0mi').replace('mi', ''));
    const selectedTo = parseInt(get$1(selectedLocation, 'to', `1000mi`).replace('mi', ''));
    const distances = [];
    forEach$1(DISTANCES, (distance) => {
        const value = VALUES$1[distance];
        if (selectedFrom <= value.from && selectedTo >= value.to) {
            distances.push(distance);
        }
    });
    return DISTANCES.length === distances.length ? [] : distances;
};
const getLocationQuery = (selectedLocation, selectedDistances) => {
    if (selectedLocation === undefined) {
        return undefined;
    }
    const from = min(map$1(selectedDistances, (dist) => {
        return get$1(VALUES$1[dist], 'from');
    }));
    const to = max(map$1(selectedDistances, (dist) => {
        return get$1(VALUES$1[dist], 'to');
    }));
    return {
        name: get$1(selectedLocation, 'name', ''),
        coordinates: selectedLocation.coordinates,
        from: from === undefined ? '0mi' : `${from}mi`,
        to: to === undefined ? '1000mi' : `${to}mi`,
    };
};

const getCoordinatesArray = (str) => {
    const arr = `${str}`.match(/[0-9.-]+/g);
    return arr && arr.map((str) => parseFloat(str));
};
const StartingPointTypeahead = ({ onUpdate, onSearch, selectedValues }) => {
    const value = useMemo(() => {
        return head$1(selectedValues);
    }, [selectedValues]);
    const selectedRef = useRef(value);
    const onChange = useCallback((value) => {
        value === null
            ? onUpdate(undefined)
            : onUpdate({
                name: get$1(value, 'name'),
                coordinates: getCoordinatesArray(get$1(value, 'value')),
            });
    }, [onUpdate]);
    return (jsx(Box$1, Object.assign({ my: 1 }, { children: jsx(Typeahead$2, { defaultValue: selectedRef.current, value: value, "aria-label": "Enter Starting Point", label: "Enter Starting Point", onChange: onChange, onSearch: onSearch, filterSelectedOptions: true, multiple: false, clearOnSelect: false, disableCloseOnSelect: false }) })));
};

const Typeahead = ({ currentValue, disableRepitition }) => {
    const onUpdate = useOnUpdateData();
    const currentLocationValue = useCurrentValue(LOCATION$1);
    const onLocationSearch = useAPIFn(API_CALL_NAMES.onLocationSearch);
    const onUpdateLocation = useCallback((value) => {
        const newLocation = getLocationQuery(value);
        const shouldClear = isUndefined$1(newLocation) && disableRepitition;
        const updated = shouldClear ? [] : [...currentLocationValue, newLocation];
        onUpdate([LOCATION$1], [updated]);
    }, [onUpdate, currentLocationValue, disableRepitition]);
    return (jsx(StartingPointTypeahead, { onUpdate: onUpdateLocation, onSearch: onLocationSearch, selectedValues: currentValue }));
};

const Distance = ({ currentLocationValue }) => {
    const onUpdate = useOnUpdateData();
    const currentValue = useCurrentValue(LOCATION$1);
    const selectedDistances = useMemo(() => getMatchingDistances(currentLocationValue), [currentLocationValue]);
    const options = useMemo(() => getOptions$2(selectedDistances), [selectedDistances]);
    const onSelectDistance = useCallback((value) => {
        const newSelections = arrayValueToggle(selectedDistances, value);
        const newLocation = getLocationQuery(currentLocationValue, newSelections);
        const newValue = map$1(currentValue, (val) => {
            if (val.name === (currentLocationValue === null || currentLocationValue === void 0 ? void 0 : currentLocationValue.name)) {
                return newLocation;
            }
            return val;
        });
        onUpdate([LOCATION$1], [newValue]);
    }, [onUpdate, selectedDistances, currentLocationValue, currentValue]);
    return isEmpty$1(currentLocationValue) ? null : (jsx(SelectableIconChips, { gridItemProps: { xs: 3 }, options: options, onSelect: onSelectDistance }));
};

const getDistanceValue = (str) => {
    const numStr = str.replace('mi', '');
    return parseInt(numStr).toLocaleString();
};
const getHeaderFromValue = (value = {}) => {
    const { from, to, name } = value;
    const title = name ? `${getDistanceValue(from)} - ${getDistanceValue(to)} mi from ${name}` : '';
    return { title };
};
const CreateStageComponent = () => {
    return jsx(Typeahead, { currentValue: [] });
};
const EditStageComponent = ({ value }) => {
    return jsx(Distance, { currentLocationValue: value });
};
const DistanceSelector = ({ addFirstButtonLabel, disableRepitition }) => {
    const currentValue = useCurrentValue(LOCATION$1);
    const currentLocationValue = head$1(currentValue);
    return disableRepitition ? (jsxs("div", { children: [jsx(Box$1, Object.assign({ mb: 2 }, { children: jsx(Typeahead, { currentValue: currentValue, disableRepitition: true }) })), jsx(Distance, { currentLocationValue: currentLocationValue })] })) : (jsx(Repeater, { fieldName: LOCATION$1, addFirstButtonLabel: addFirstButtonLabel, disableRepitition: disableRepitition, getHeaderFromValue: getHeaderFromValue, CreateStageComponent: CreateStageComponent, EditStageComponent: EditStageComponent }));
};

const CITY = 'City';
const SUBURBAN = 'Suburban';
const RURAL = 'Rural';
const TOWN = 'Town';
const TITLES$1 = {
    [CITY]: 'City',
    [SUBURBAN]: 'Suburban',
    [RURAL]: 'Rural',
    [TOWN]: 'Town',
};
const FA_ICONS = {
    [CITY]: faCity,
    [SUBURBAN]: faCarBuilding,
    [RURAL]: faTrees,
    [TOWN]: faHouse,
    default: faUniversity,
};
const FA_ICONS_SELECTED = {
    [CITY]: faCity$1,
    [SUBURBAN]: faCarBuilding$1,
    [RURAL]: faTrees$1,
    [TOWN]: faHouse$1,
    default: faUniversity$1,
};

const getTitles$1 = (selectedSettings) => map$1(selectedSettings, (setting) => get$1(TITLES$1, setting, setting));

const sizes = {
    City: 4,
    Suburban: 3,
    Town: 2,
    Rural: 1,
};
const useSelectableIconChipOptions$1 = ({ currentValue, terms }) => {
    return useMemo(() => {
        const list = map$1(terms, (term) => {
            const value = get$1(term, 'term', '');
            const isSelected = includes$1(currentValue, value);
            const selectedIcon = get$1(FA_ICONS_SELECTED, value);
            const unselectedIcon = get$1(FA_ICONS, value);
            const faIcon = isSelected ? selectedIcon : unselectedIcon;
            const title = get$1(term, 'label', value);
            return {
                title,
                faIcon,
                value,
                selected: isSelected,
            };
        });
        return sortBy(list, ({ title }) => {
            const size = get$1(sizes, title, 0);
            return -size;
        });
    }, [currentValue, terms]);
};
const SettingSelector = ({ gridItemProps = { xs: 3 } }) => {
    const onUpdate = useOnUpdateData();
    const options = useOptions$2({
        fieldName: SETTING$1,
        withoutTerms: ['Not available', 'Not Available', ''],
    });
    const currentValue = useCurrentValue(SETTING$1);
    const onSelect = useCallback((value) => {
        const newValue = arrayValueToggle(currentValue, value);
        onUpdate([SETTING$1], [newValue]);
    }, [currentValue, onUpdate]);
    const selectableIconChipsOptions = useSelectableIconChipOptions$1({
        currentValue,
        terms: options,
    });
    return (jsxs(Fragment$1, { children: [jsx(ExpandYourSearch, { facetNames: [SETTING$1], pb: 2 }), jsx(SelectableIconChips, { options: selectableIconChipsOptions, onSelect: onSelect, gridItemProps: gridItemProps })] }));
};
const SettingDropdown = () => {
    const onUpdate = useOnUpdateData();
    const onClear = useCallback(() => {
        onUpdate([SETTING$1], [undefined]);
    }, [onUpdate]);
    const currentValue = useCurrentValue(SETTING$1);
    const selectedLabels = useMemo(() => getTitles$1(currentValue), [currentValue]);
    return (jsx(Dropdown, Object.assign({ fieldLabel: "Campus Setting", buttonLabel: "Setting", id: "college-search-filter-bar-setting", selectionLabels: selectedLabels, onClear: onClear }, { children: jsx(Box$1, Object.assign({ mx: 2, mb: 2 }, { children: jsx(SettingSelector, { gridItemProps: { xs: 6 } }) })) })));
};
SettingSelector.Dropdown = SettingDropdown;

const INTERNATIONAL$1 = 'International';
const US = 'Domestic';
const LABELS = {
    [INTERNATIONAL$1]: 'International & Territories',
    [US]: 'United States of America',
};
const getInternationalOption = (currentValue) => {
    return {
        title: LABELS[INTERNATIONAL$1],
        value: INTERNATIONAL$1,
        selected: includes$1(currentValue, INTERNATIONAL$1),
        subtitle: 'Outside the USA',
        faIcon: faGlobe,
    };
};
const getUSOption = (currentValue) => {
    return {
        title: LABELS[US],
        value: US,
        selected: includes$1(currentValue, US),
        subtitle: 'Any state in the USA',
        faIcon: faFlagUsa,
    };
};
const getOptions$1 = (currentValue) => {
    return [getUSOption(currentValue), getInternationalOption(currentValue)];
};

const CountryIconChips = () => {
    const onUpdate = useOnUpdateData();
    const currentValue = useCurrentValue(LOCATION_CATEGORY$1);
    const options = getOptions$1(currentValue);
    const onSelectLocationCategory = useCallback((value, option) => {
        const newValue = option.selected ? without$1(currentValue, value) : [...currentValue, value];
        onUpdate([LOCATION_CATEGORY$1], [newValue]);
    }, [currentValue, onUpdate]);
    return (jsxs(Box$1, Object.assign({ mb: 2 }, { children: [jsx(SubsectionText, { title: "Country" }), jsx(SelectableIconChips, { options: options, onSelect: onSelectLocationCategory, gridItemProps: { xs: 6 } })] })));
};

const MidwestIcon = (props) => (jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 41, height: 31, fill: "none" }, props, { children: [jsx("path", { fill: "#040404", d: "m39.888 15.476-.625.416-.399.233-.348.382-.415.398-.332.083-.3.05-.563.265-.216.017-.349-.315-.531.066-.266-.15-.244-.138-.502.072-1.046.166-.797.125.133 1.502.182 1.41.266 2.408.058.496.423-.014.25-.083.345.155.212.448.528-.002.194.218.181-.007.26-.138.258.038.203.15.177-.22.24-.132.213-.07.067.282.182.1.357.24.224-.008.118-.118-.007-.142.166-.15.017-.514.1-.398.156-.148.156.093.084.124.125-.018-.044-.248-.058-.066v-.249l.1-.133.232-.348.133-.15.216.05.232-.166.316-.348.232-.399.021-.557.05-.515v-.481l-.116-.316.1-.149.094-.098-.144-1.01-.299-1.989Z" }), jsx("path", { fill: "#040404", fillRule: "evenodd", d: "m24.693 3.668-.188.21.165.118.211-.094.34-.2.529-.527-.047-.047-.235.058-.552.4-.223.082Zm8.727 3.767-.066-.257-.1-.05.033-.116.166-.017.224-.025s.133.175.166.191c.033.017.042.166.042.166l-.133.125-.332-.017Zm3.02 6.217-.331-.847-.233-.93-.249-.332-.265-.182-.166.116-.399.183-.199.514-.282.382-.116.066-.15-.066s-.265-.15-.248-.216c.016-.066.05-.514.05-.514l.348-.133.083-.349.066-.265.25-.166-.034-1.03-.166-.232-.133-.083-.083-.216.083-.083.166.034.017-.166-.25-.233-.132-.265h-.266l-.464-.15-.565-.348h-.282l-.066.066-.1-.05-.315-.232-.299.182-.299.233.033.365.1.033.216.05.05.083-.266.083-.265.033-.15.183-.033.216.033.166.033.564-.365.216-.066-.017v-.431l.132-.25.067-.248-.083-.083-.2.083-.099.431-.282.116-.183.2-.016.1.066.082-.066.266-.233.05v.116l.083.249-.116.63-.166.415.067.482.05.116-.084.249-.033.083-.033.282.365.614.299.664.15.498-.084.482-.1.614-.248.53-.034.283-.334.317.453-.017 2.199-.232.747-.102.01.172.703-.125 1.058-.154.396-.047.014-.06.016-.15.216-.382.206-.179-.023-.518.164-.164.112-.035.023-.366.157-.31.108.062.017.066.083.016.199-.1-.033-.979Zm-13.312-6.84-.073.06.382.529.81.117.845.223.293.106 1.245.282.21.234.364.141.2 1.056.14.106.121.106.327-.718.1-.415.199-.449.083-.016.116.166h.066l.465-.25.15.167.05.016.132-.116.116-.315.25-.083.713-.067.2-.265.53-.017.598.133h.182l.332-.15.233.017.216-.066.381.05.083.033.133-.033-.133-.1-.132-.066-.332-.316V6.2l-.15-.05-.116.116-.63.166-.2.05-.299-.083-.05-.033v-.581l-.149-.017-.266.133-.464.199-.68.033-.35.116-.414.366-.166.1h-.117l-.132.082-.166-.05-.166-.132-.15.1-.398.016-.282-.282-.15-.316-.149-.116-.332-.1h-.232l-.133-.132-.365.298-.1.117-.083-.05.033-.266.25-.332.049-.249.232-.083.15-.315.382-.1.033-.1-.116-.115-.482.05-.448.248-.232.233-.133.182-.183.083-.199.299-.017.133-.448.216-.249.199-.614.1-.066.066v.1l-.365.232-.283.083Z", clipRule: "evenodd" }), jsx("path", { fill: "#040404", d: "m13.179 8.562-.038-.77-.204-.751-.188-1.401-.047-1.01-.204-.319-.164-.55V2.706l.07-.399-.217-.564-2.919-.058-1.909-.067-2.722-.133-2.561-.193-.13 1.461-.14 1.55-.232 2.561-.05 1.132 5.833.386 5.822.18ZM13.332 16.315l-.098-.11-.156-.373.187-.38.108-.57-.265-.212-.03-.282.06-.307.221-.083.03-.588-.006-3.09-.064-.305-.422-.368-.101-.205v-.197l.195-.131.157-.19.019-.28-5.892-.164-5.768-.4-.079.543-.165 1.63-.138 1.842L.96 14.62l1.646.106 2.016.117 1.848.134 2.441.134 1.104-.08.293.235.444.305.1.078.364-.092.416-.03.281-.007.32.124.467.148.322.18.063.198.094.195.072-.05h.08Z" }), jsx("path", { fill: "#040404", d: "m14.507 20.814.141.274.01.219.241.382.28.324h-.519l-4.465-.096-4.188-.092-2.175-.098.11-2.19-3.428-.282.446-4.519 1.597.106 2.065.117 1.831.117 2.442.118 1.103-.047.211.235.493.305.118.094.446-.141.399-.047.282-.024.187.141.517.165.305.164.047.164.094.212h.188l.081.004.101.535.282.825.127.476.218.392.054.507.148.439.056.664" }), jsx("path", { fill: "#040404", d: "m22.962 16.156.018.2.235.117.117.129.035.13.4.328.07.223-.082.294-.153.364-.082.281-.223.165-.177.059-.563.152-.07.235-.082.234.059.14.176.177v.376l-.223.164-.047.153v.258l-.153.047-.176.14-.047.153.047.177-.141.123-.236-.276-.152-.27-.857.082-1.044.059-2.57.07-1.339.024-.962.023-.136.013-.17-.46-.023-.68-.164-.422-.07-.54-.235-.376-.094-.493-.282-.775-.117-.551-.141-.223-.164-.282.187-.446.141-.587-.281-.211-.047-.282.094-.258h1.361l5.094-.07 2.04-.07.19.281.189.27.047.082-.188.282.047.434.258.399.305.187.247.024.134.223ZM28.284 26.344l.007-.293.05-.465.232-.299.183-.398.265-.432-.05-.597-.182-.282-.034-.332.084-.565-.05-.713-.133-1.644-.133-1.577-.1-1.203.316.091.15.1.115-.033.216-.2.29-.165.524-.017 2.257-.233.573-.054.154 1.638.437 3.783.06.593-.037.232.126.184.01.141-.26.164-.362.16-.33.056-.06.5-.47.34-.288.412.034.244-.06.157h-.342l-.162-.166-.256.13-.276.154.017.314-.123.026-.048-.104-.223-.154-.333.137-.16.309-.147-.083-.15-.164-.458.05-.574.1-.299.158Z" }), jsx("path", { fill: "#040404", d: "M28.22 26.42v-.37l.027-.499.244-.322.183-.387.265-.396-.038-.54-.206-.363-.01-.344.072-.541-.085-.737-.11-1.62-.132-1.542-.095-1.195-.028-.095-.083-.265-.133-.382-.166-.183-.149-.265-.024-.564-1.017.135-2.793.176-.892-.044.023.243.235.07.094.118.047.188.399.352.07.235-.07.352-.188.375-.07.259-.235.188-.188.07-.54.14-.07.189-.07.21.07.142.188.164-.024.423-.188.164-.07.164v.282l-.188.047-.164.117-.024.141.024.211-.176.135-.106.288.047.375.235.752.751.774.563.376-.023.446.094.14.657.048.282.14-.07.376-.235.61-.07.33.234.398.657.54.47.07.211.517.211.329-.094.305.165.422.187.212.2-.082.07-.222.21-.148.332-.113.317.122.295.11.082-.022-.007-.128-.11-.284.045-.244.234-.16.243-.102.12-.043-.06-.136-.079-.223.128-.13.1-.278ZM13.238 8.644l-.047-.868-.188-.751-.188-1.385-.047-1.01-.188-.352-.164-.516V2.705l.07-.399-.187-.56 3.094.004.033-.846.067-.017.232.05.2.083.082.564.15.63.166.167h.498l.033.15.647.032v.216H18l.034-.133.116-.116.232-.066.133.1h.299l.398.265.548.249.249.05.05-.1.149-.05.05.3.265.132.05-.05.133.017v.216l.266.1h.315l.166-.084.332-.332.265-.05.083.183.05.133h.1l.1-.083.912-.033.183.315h.066l.074-.111.456-.038-.063.234-.405.188-.95.417-.49.206-.315.266-.249.365-.232.398-.183.083-.465.515-.132.017-.395.3-.289.325-.023.305.023.799-.164.164-.54.423-.188.587.258.374.047.26-.117.304-.024.376.047.727.352.422h.306l.257.236.33.14.375.517.728.515.188.212.023.565-2.113.07-6.187.048-.034-3.663-.047-.306-.423-.352-.117-.188v-.164l.211-.164.141-.141.024-.329Z" }), jsx("path", { fill: "#040404", d: "m27.721 15.7.038-.305-.166-.465-.066-.631-.116-.249.1-.315.082-.3.15-.265-.067-.348-.066-.365.05-.183.199-.25.017-.281-.083-.133.066-.266.05-.332.282-.58.299-.698.016-.232-.033-.1-.083.05-.431.648-.283.414-.199.183-.083.232-.15.083-.115.2-.15-.034-.016-.182.133-.25.215-.48.183-.166.113-.236-.168-.093-.14-.14-.165-1.057-.375-.117-.141-.235-1.291-.282-.258-.117-.845-.235-.846-.117-.428-.555-.054.13-.116-.017-.067-.117-.282-.083-.116.017-.183.1-.1-.067.067-.199.2-.315.116-.116-.2-.15-.215.083-.3.2-.763.331-.299.067-.298-.05-.101-.09-.217.29-.024.283v.868l-.117.164-.54.4-.235.61.047.023.258.212.07.328-.187.329v.399l.047.68.305.306h.352l.188.328.352.047.4.587.727.423.211.281.094.763.07.34.235.165.024.141-.212.352.024.329.258.399.258.117.305.047.138.142h.942l2.677-.153 1.032-.14ZM21.853 21.074l-.259-.317-.117-.235-.798.07-1.01.048-2.605.094-1.385.023-.81.012-.235.012.13.258-.024.235.258.399.317.422.317.282.235.023.14.094v.305l-.187.165-.047.235.21.352.26.305.257.188.141 1.197-.07 3.627.023.48.047.554 2.406-.012 2.383-.07 2.136-.083 1.197-.024.223.352-.07.34-.318.246-.058.19.552.046.4-.07.176-.564.067-.602.238-.208.176-.152.211-.106.012-.294.059-.176-.106-.18-.282.015-.223-.27-.14-.433.082-.259-.2-.352-.188-.47-.493-.082-.715-.575-.177-.422.082-.329.212-.622.047-.294-.2-.105-.704-.082-.106-.176-.011-.435-.564-.352-.716-.798-.235-.751-.023-.434.082-.235Z" }), jsx("path", { fill: "#040404", d: "m16.472 28.837-1.296.02-4.732-.046-4.575-.211-2.529-.13.425-6.645 2.242.082 4.155.141 4.53.047h.524l.333.331.285.024.091.11v.206l-.188.165-.047.267.228.369.258.322.258.204.108 1.148-.07 3.596Z" })] })));

const SvgComponent$2 = (props) => (jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 29, height: 31, fill: "none" }, props, { children: [jsx("path", { fill: "#040404", d: "m20.536 21.588-.07-.608-.117-.63-.245-.853.83-.222.233.163.49.631.42.643-.42.222-.187-.024-.163.257-.35.28-.421.14ZM20.409 21.62l-.09-.607-.118-.63-.233-.865-.6.13-3.155.69.094.479.21 1.051v1.168l-.163.327.264.305.717-.491.514-.468.28-.303.117.093.397-.21.748-.164 1.018-.504Z" }), jsx("path", { fill: "#040404", fillRule: "evenodd", d: "m20.419 17.055-2.523.608-.982.186-.747.129-.094 1.53.058.715 3.154-.69.736-.151.945-.271.299.262.49.63.398.655.298-.145-.07-.327.117-.21.42-.21.117.443-.07.258-.35.21v.14l.28-.21.561-.655.56-.28.608-.21-.046-.35-.14-.421-.281-.35-.257-.117-.304.023-.07.07.14.187.21-.117.304.234.117.397-.257.257-.327.14-.514-.07-.56-.864-.328-.374h-.257l-.163.117-.28-.374.046-.21.35-.748-.417-.638-.54.24-.304.468-.327.093Zm3.86 3.67.315-.1.066-.247.148.016.15.33-.183.067-.561.016.066-.082Zm-1.354.115.33-.38h.232l.264.215-.347.149-.314.149-.165-.133ZM27.638 6.775l.28.304.328.537v.28l-.304.678-.28.093-.491.444-.7.795h-.188c-.093 0-.14-.304-.14-.304l-.257.023-.14.21-.35.21-.14.211.233.21-.07.094-.07.397-.28-.023V10.7l-.047-.187-.21.047-.258-.467-.304.187.187.21.047.163-.117.187.047.444.023.234-.233.374-.42.07-.048.42-.77.444-.188.07-.233-.21-.444.514.14.467-.21.187-.024.631-.162.905-.356-.167-.07-.444-.56-.164-.047-.397-1.052-3.388-.607-1.971.206-.017.218.059v-.374l.117-.794.374-.678.21-.584-.28-.35v-.865l.117-.14.117-.397-.024-.21-.023-.701.257-.701.42-1.285.304-.608h.187l.187.023v.164l.187.327.397.094.117-.117v-.14l.584-.421.257-.257.21.023.865.35.28.141 1.309 4.322h.864l.117.28.023.702.421.327h.117l.023-.07-.07-.164.397-.023Zm-3.025 4.357.222-.222.199.152.081.35-.245.129-.257-.41Zm1.227-.584-.257-.269.198-.327.292-.105.117.257-.128.117s-.035.245-.035.292c0 .046-.187.035-.187.035Z", clipRule: "evenodd" }), jsx("path", { fill: "#040404", d: "m21.508 16.183.126-.156.157-.476-.367-.132-.07-.444-.561-.163-.047-.397-1.051-3.388-.665-2.102h-.13l-.093.233-.094-.07-.14-.14-.21.28-.007.727.045.82.28.397v.584l-.537.731-.374.164v.164l.163.257v1.238l-.116 1.332-.024.7.14.188-.023.654-.07.257.21.128 2.369-.678.327-.093.222-.37.54-.245Z" }), jsx("path", { fill: "#040404", d: "m16.24 17.816-.118-.818-.345-1.44-.094-.047-.42-.187.117-.421-.117-.304-.39-.67.14-.561-.117-.748-.35-.934-.117-.712L18.223 10l.047.841.28.397v.584l-.538.585-.373.163v.164l.163.257v1.238l-.117 1.332-.023.7.14.188-.023.654-.07.257.095.226-1.005.199-.56.032Z" }), jsx("path", { fill: "#040404", d: "m13.966 22.975-.164-.14-.374-.023-.327-.28-.235-.887-.5.014-.353-.392-2.802.633-6.215 1.262-1.088.178-.107-.935.206-.163.187-.164.14-.233.258-.164.28-.257.07-.233.304-.397.163-.14-.023-.14-.187-.445-.257-.023-.28-.888.42-.257.631-.21.584-.187.467-.07.912-.024.28.187.234.024.303-.187.374-.164.748-.07.304-.257.257-.467.233-.28h.304l.28-.164.024-.327-.21-.304-.047-.21.163-.304v-.21h-.257l-.257-.117-.117-.164-.023-.374.841-.794.094-.117.21-.42.42-.655.398-.537.304-.35.348-.264.446-.18.794-.187.467.023.655-.21 1.093-.3.075.72.35.935.118.747-.14.561.373.654.117.304-.117.42.42.188.094.046.444 1.59-.077.73-.07 1.566.116.794.117.514.21 1.052v1.168l-.163.327.266.288.115.243-.28.257.046.186.187-.046.21-.187.328-.374.163-.093.234.093.327.023 1.145-.56.42-.398.187-.21.608.234-.491.514-.56.42-1.029.771-.374.14-.84.281-.585.164-.17-.078-.035-.533.07-.397-.023-.303-.407-.246-.654-.14-.56-.164-.538-.257Z" }), jsx("path", { fill: "#040404", d: "m13.9 23.106-.304.35v.445l-.28.444-.023.233.187.187-.024.35-.327.164.117.398.023.163.397.047.14.374.515.35.35.234v.117l-.467.444-.234.327-.21.397-.327.187-.175.105-.035.175-.088.377.157.324.468.42.7.328.585.093.023.21-.117.14.047.398h.117l.304-.35.116-.701.398-.584.444-.935.163-.794-.093-.164-.024-1.355-.233-.49-.164.116-.397.047-.07-.07.163-.14.304-.28.01-.159-.056-.496.07-.398-.024-.303-.373-.164-.655-.14-.56-.164-.538-.257Z" }), jsx("path", { fill: "#040404", d: "m13.04 28.328.163-.093.328-.089.21-.397.233-.327.468-.444v-.117l-.35-.233-.515-.351-.14-.374-.397-.047-.023-.163-.117-.397.327-.164.023-.35-.187-.187.024-.234.28-.444v-.444l.339-.35.03-.157-.373-.023-.327-.28-.35-.772-.435-.134-.337-.31-2.687.585-6.215 1.261-1.285.21-.071-1.023-.793.814-.187.07-.608.434.421 2.766.359 1.407.516 2.783.472-.092 1.727-.217 5.481-1.108 2.15-.408 1.2-.234.038-.035.304-.233.304-.099Z" })] })));

const SvgComponent$1 = (props) => (jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 50, height: 31, fill: "none" }, props, { children: [jsx("path", { fill: "#040404", fillRule: "evenodd", d: "m41.609 20.49-.195-.628-.444-.028-.439-.039-.081.063.138.389-.028.412-.328-.07-.014-.249-.393-.002-.467.057-1.846.111-.93.056-.694-.044-.125-.125-.222-.333-.467-.024-.582.055-2.193.25-.874.111-.028.264.153.152.222.167.02.69.299-.052.513-.18.514-.042.374-.055.653.152.693.333.139.125.25.097.139.167.027.236.278-.111h.333l.305-.167.32-.305.263.014.041-.097-.069-.084.014-.166.347-.07h.222l.25.125.36.125.209.32.236.083.097.291.291.139.139.222.166.056.444.11.111.264.264.32v.818l-.125.402.028.236.11.417.154.346.069-.041.125-.389-.222-.083-.028-.055.139-.056.388.083.014.139-.277.472-.18.208.305.32.222.263.25.458.25.333.18.43.152.028.139-.18.152.096.222.347.056.305.264.375.07-.11.332.027.305.194.292.444.07.292.027.25.097.083.111.041.208-.083.125-.139.333-.014.264-.125.236-.277-.042-.167-.028-.208.056-.166-.028-.167.208-.11.028-.292-.056-.153-.041-1.027-.111-.652-.389-.707-.305-.5-.222-.458-.25-.25-.25-.638.07-.111.097-.111-.139-.25-.347-.319-.416-.472-.32-.54-.457-.806-.32-.836Zm2.145 10.397-.104-.09.215-.132.291-.167.375-.36.278-.451.124-.396.084-.243.062-.041-.014.291-.083.146-.215.569-.32.333-.457.36-.236.181Z", clipRule: "evenodd" }), jsx("path", { fill: "#040404", d: "m41.915 17.067-.153.083-.222-.111-.055-.18-.111-.306-.194-.18-.222-.056-.14-.416-.235-.514-.36-.166-.181-.167-.111-.222-.18-.166-.195-.111-.194-.25-.264-.194-.388-.153-.042-.125-.208-.25-.042-.124-.291-.444-.291.013-.347-.208-.111-.11-.028-.153.07-.167.194-.083-.028-.18.527-.222.777-.389.624-.07 1.416-.041.194.167.139.277.375-.042 1.082-.125.25.07 1.082.652.868.697-.466.469-.222.527-.041.541-.14.07-.096.236-.208.055-.18.305-.237.236-.194.292-.139.069-.305.291-.25.014.084.278-.43.471-.181.112Z" }), jsx("path", { fill: "#040404", d: "m35.768 12.349-.416.069-.722.097-.735.076v.188l.014.18.055.292.292.68.208.846.125.527.138.416.125.597.18.541.223.292.041.291.167.07.014.18-.153.416-.042.278-.013.166.138.375.028.458-.07.208.056.07.125.069.056.291.222.333.124.125.68.014.93-.056 1.846-.11.467-.059.393.003.014.25.222.069.028-.375-.14-.388.098-.139.5.07.427.027-.067-.541.194-.86.125-.361-.041-.222.286-.536-.044-.116-.164.06-.222-.11-.056-.181-.11-.305-.195-.18-.222-.056-.139-.417-.25-.543-.362-.167-.18-.166-.111-.222-.18-.167-.195-.11-.194-.25-.264-.195-.388-.152-.042-.125-.208-.25-.041-.125-.292-.421-.291.014-.355-.262-.11-.11-.029-.153.07-.167.202-.106-.098-.105.007-.025-.5.084-.596.069-.583.042Z" }), jsx("path", { fill: "#040404", d: "m30.273 21.687-.139-1.304-.236-1.61.014-1.207.07-2.664-.014-1.43.014-.55.666-.032 2.386-.222.766-.057-.012.187.014.18.055.292.291.68.208.846.125.528.14.416.124.597.18.54.223.292.041.291.167.07.014.18-.153.417-.042.277-.014.167.14.374.027.458-.07.208.056.07.125.07.089.217h-.541l-.583.055-2.193.25-.893.12-.009.323.153.152.222.167.05.681-.476.22-.236-.027.236-.166v-.084l-.263-.513-.195-.056-.125.375-.11.236-.056-.014h-.236Z" }), jsx("path", { fill: "#040404", fillRule: "evenodd", d: "m48.145 7.645-.147-.404-.441.1-.975.24-1.694.358-1.71.344-1.471.222-1.358.166-.612.111-.389-.062v.34l-.042.18-.25.222-.138.305-.194-.027-.18.055-.195.306s-.097-.028-.167-.028c-.069 0-.069-.097-.069-.097l-.056.014-.333.332-.055.264-.375.18-.36.306-.334.125-.36.236-.056.319-.236.055-.152.125-.043.348.583-.041.596-.07.5-.083.139-.028.527-.222.777-.388.624-.07 1.416-.041.255.181.138.278.367-.065 1.083-.124.25.069 1.082.652.854.704.468-.115.402-.041.042-.208.166-.555.292-.403.555-.458.444-.208.236-.055.097.041h.11l.264-.416.167-.305-.111.041-.194.195-.056-.14h-.36l.166-.54-.07-.111h-.166V9.67l-.028-.11.139.11.125.014.208.028.32-.139.11-.25.056-.18.222-.11.027-.362-.069-.055.208-.014-.055-.194-.208-.208-.306-.555Zm.41 2.213-.222.215.09.014.097-.104.243-.209.291-.131.014-.292-.035-.381-.235-.472-.063.02.056.16.125.201.055.528-.014.173-.132.056-.27.222Z", clipRule: "evenodd" }), jsx("path", { fill: "#040404", d: "m36.406 9.143-4.454.43-1.353.153-.396.044-.332-.002v.332l-.722.042-.597.056-.952.004-.023.501-.183.539-.086.259-.115.376-.028.222-.347.194.125.305-.083.375-.084.068.623-.017 2.068-.166.458-.014.694-.042 2.386-.222.873-.07.723-.083.721-.097.417-.07-.011-.386.152-.125.236-.056.056-.319.36-.236.333-.125.361-.305.375-.18.075-.303.372-.333.055-.014s0 .097.07.097.166.028.166.028l.194-.305.18-.056.195.028.139-.305.181-.193.052-.083.015-.337-.127-.025-.209.166-.68.014-1.029.163-.844.073ZM47.161 1.4l.051-.18.002-.104-.11-.007-.18.139-.124.125.124.36.195.486.18.833.139.54.43-.013.527-.104-.194-.632-.083.042-.306-.208-.152-.402-.167-.306-.194-.083-.18-.305.042-.18Z" }), jsx("path", { fill: "#040404", fillRule: "evenodd", d: "m47.887 3.647.527-.111-.019.417-.172.346-.571.24-.117-.046-.278-.36-.139.07-.333-.041-.222-.292.028-.291.139-.111-.139-.153-.097.167-.042.014-.027-.306.18-.083-.042-.472-.152-.027-.028-.098.111-.319.125-.139-.042-.083-.166.139-.167.111s-.041.125-.041.18c0 .056-.125.195-.125.195l.11.11.015.181-.111.458.18.472.208.18v.153l.125.18-.083.18-.18-.027-.264-.083-.37.005-.435-.117-.056-.152v-.18l.153-.223.066-.342.11-.213-.248-.169-.121.174-.098-.046-.472-.111v-.25l-.354-.146-.104-.132-.166-.152-.25-.125-.141-.097-.159.042-.172.124-.222.18-.25.028-.11-.055-.154.222-.124.125-.209.053-.194.224-.18.209-.028.027-.083-.485-.097-.43 3.214-.649 1.277-.242.645-.14.11.378.194.486.18.832.159.61.498-.014Zm-.803.875-.097-.215.16-.041.062.2s.062.237.062.265c0 .027-.076.104-.076.104l-.097-.16-.014-.153Z", clipRule: "evenodd" }), jsx("path", { fill: "#040404", d: "m41.514 2.391.095.425.093.593.306-.236.194-.264.218-.053.125-.125.153-.222.1.056.25-.028.223-.18.172-.125.158-.042.112.087.192.096.166.153.118.11-.012.402-.486-.264-.388-.153-.014.458-.042.18-.139.237-.055.138-.264.209-.041.194-.292.028-.028.263-.097.472h-.222L42 4.73l-.14-.235-.152.014-.028.374-.18.57-.43.929.069.11-.014.237-.18.166-.125-.027-.278.208-.222-.084-.152.403-.375.083c-.056.014-.208-.11-.208-.11l-.208.193-.222.056-.25-.07-.111-.11-.188-.26-.27-.17-.222-.237-.25-.319-.055-.194-.222-.125-.07-.139-.02-.45.187-.008.166-.069.014-.236.139-.125.014-.43.083-.333.111-.055.111.097.042.152.152-.083.042-.139-.097-.152v-.208l.083-.111.194-.292.111-.125.18.042.195-.139.264-.291.194-.333.028-.486.041-.43v-.402l-.097-.264.084-.125.11-.111.3 1.702.397-.065.97-.133Z" }), jsx("path", { fill: "#040404", d: "m38.529 7.185-.2.23-.36.306-.37.506-.152.153v.18l-.333.18-.486.292-.302.033-4.452.42-1.353.153-.396.044-.332-.002-.02.362-.702.013-.597.055-.895.018.164-.02.188-.15.176-.099.02-.274.078-.157-.138-.218.07-.164.193-.153.18-.055.237.11.305.112.097-.028.014-.194-.111-.208.028-.195.166-.124.222-.056.139-.055-.07-.153-.055-.167.097-.069.09-.284.257-.146.5-.083.305-.042.125.167.152.069.153-.278.25-.124.166.138.07.097.18-.041-.014-.292.25-.138.097-.07.097.139h.403l.07-.18-.029-.195.25-.305.403-.333.041-.388.236-.028.333-.153.236-.166-.028-.167-.125-.125.049-.187.354-.02.208-.07.25.138.138.375.5.028.153.153.18.013.208-.124.264.041.11.125.237-.222.152-.111h.14l.055.236.152.083.208.19.014.472.07.139.221.125.056.194.25.32.222.235.291.17Z" }), jsx("path", { fill: "#040404", fillRule: "evenodd", d: "m9.17 10.33-1.947-.093.103-.002-.118-.003-.138 1.61-.333 4.768-.196 2.04-2.493-.137-2.492-.235-.687-.059.056.401.167.042.222.25.125.375.402.194.11.277.611.68.111.139.43.18.098.18.139.084.041.236.278.555v.694l.194.402.638.666.444.18.153.167v.056l.333.194.166.055.153.098.222.083.208-.208.375-.528.083-.319.194-.277.306-.125.388-.153.264.194.638.056.583.097.222.18v.098l.222.263.513.458.014.125.153.167.07.36.457 1.055-.014.166.361.223.305.568.292.375.277.111.14.194-.112.375.056.083.11.056-.027.291-.056.056.056.194.277.166.111.555.18.333.653.292.444.097.36.264.278.055.111-.041.472.097.486.333.263-.167.084-.125-.153-.236-.083-.527-.153-.597-.07-.208.07-.388.097-.333.111-.389.125-.472-.194-.166.083-.167.347-.027.333-.472.291-.056.5-.305.153-.125.54-.291.486-.208.458-.278.236-.18.486-.458.11-.07.181-.124.222-.167.084-.166.846-.389.486-.136-.052-.377.118-.233.073-.628.031-.216-.082-.245.227-.377.06-.643-.046-.087-.047-.247-.332-.54-.092-.349-.23-.394-.045-.348-.059-.818-.028-.833-.044-.87-.167-.084-.282.076-.21-.14-.236-.121-.302-.092-.247-.144-.122-.16-.143-.026-.206.108h-.367l-.032-.096h-.056l-.263.135-.163-.065h-.318l-.073.216-.184.065-.283-.065-.286-.104-.381-.086-.098-.163h-.03l-.17.353-.228.018-.399-.17-.037-.162-.202-.013-.13-.032-.237.155-.265-.1.014-.169-.092-.027-.175-.24-.24-.03-.278.134-.188-.156-.34-.046-.23-.07-.366-.089.025-.292-.098-.035-.137.063-.15-.042-.076-.074-.059.108-.155-.022-.15-.07-.372-.328-.006-.18.026-1.557.2-2.014-2.669-.098Zm6.603 19.378.048.61.077-.02-.014-.126-.042-.444-.222-.617-.076-.527.027-.444.174-.57.374-.561.41-.57-.056-.02-.27.305-.299.465-.284.59-.132.707.049.604.236.617Z", clipRule: "evenodd" }), jsx("path", { fill: "#040404", d: "m30.184 21.704-.022.108h-.444l-.125-.07-.18-.027-.583.166-.153-.069-.222.36-.094.067-.097-.213-.098-.334-.294-.274.098-.648-.06-.078-.156.02-.707.058-2.08.059-.039-.137.059-.687.294-.53.452-.785-.079-.177h.098l.06-.274-.197-.157.02-.157-.177-.393-.025-.459.118-.228-.034-.372-.118-.256.118-.117-.118-.177.04-.157.078-.53.255-.235-.059-.177.314-.451.235-.079v-.216l-.058-.117.235-.452.236-.098.009-.293.744-.006 2.068-.167.393-.02v.547l.015 1.43-.07 2.664-.014 1.207.236 1.61.128 1.321Z" }), jsx("path", { fill: "#040404", d: "m27.3 11.231-.331.08-.53-.039.059-.255.275-.235.039-.197-.157-.255-.942.04-1.786.078-2.001.059-2.002.04.137.588v.706l.118.942.02 3.248.196.167.255-.118.236.098.037.886 1.964-.012 1.62-.069.868-.017.098-.18-.024-.304-.157-.255.137-.127-.137-.216.059-.215.117-.482.216-.176-.059-.197.314-.46.236-.118-.01-.128-.03-.157.246-.48.206-.108.033-.295.152-.106.073-.364-.115-.344.347-.204.047-.173.107-.367.068-.279Z" }), jsx("path", { fill: "#040404", d: "m8.793 9.31-.918-.04-.552-.041.022.017-.06.895 1.885.12 2.752.112-.2 2.096-.04 1.531.02.137.373.314.176.098.06-.02.058-.176.118.157h.176v-.117l.236.117-.04.334.354.02.216.098.353.058.216.157.196-.176.294.059.216.294h.079v.196l.196.06.196-.197.157.059h.216l.079.216.412.157.117-.06.157-.353h.098l.099.177.353.059.314.118.255.078.157-.078.059-.216h.373l.176.078.236-.176h.098l.059.137h.353l.137-.177.157.04.177.216.275.157.274.078.167.096-.034-3.194-.117-.942-.014-.762-.124-.561-.066-.616-.006-.328-1.042.028-3.984-.04-3.865-.176-2.085-.118ZM28.265 22.221l-.089-.224-.098-.266-.284-.304.078-.579-.01-.098-.108.03-.707.078-2.148.04-.059-.206.079-.726.284-.51.432-.747-.049-.205.108-.059.04-.167-.197-.177-.01-.167-.157-.373-.039-.51-.835.01-1.648.079-1.906.002.003.822.058.805.06.333.215.353.079.432.372.471.02.275.059.059-.059.726-.255.431.137.177-.059.216-.058.628-.118.275.01.31.403-.13.693-.028.889.305.555.097.319-.125.277.097.278.084.07-.18-.279-.098-.221.042-.236-.139s.014-.111.069-.125c.056-.014.264-.083.264-.083l.152.125.153-.084.277.056.125.208.028.194.389.028.152.153-.07.139-.11.069.139.139.721.305.305-.111.084-.208.222-.056.152-.125.111.084.07.25-.195.069.056.055.291-.11.195-.292.069-.042-.18-.027.069-.14-.014-.124.18-.042.098-.11.055.069s-.014.263.056.263.36.056.36.056l.347.166.084.125h.25l.096.083.195-.263v-.125h-.111l-.292-.236-.5-.07-.277-.194.097-.236.195.028.014-.055-.153-.084v-.041h.277l.153-.264-.11-.166-.029-.236-.125.014-.166.18-.056.222-.263-.055-.084-.153.153-.167.174-.152-.031-.063Z" }), jsx("path", { fill: "#040404", fillRule: "evenodd", d: "m42.926 8.241 4.994-1.08-.31-.515-.498.145-.135-.129.22-.118-.043-.217-.152-.153-.01-.121-.196-.133-.008-.138.231.008.02-.12-.106-.067.04-.166-.117-.094.038-.403-.075-.103-.274-.034-.185-.18-.416-.08-.254-.084-.336-.124-.168-.11-.042-.206.043-.15.108-.113.075-.316-.111-.154-.7-.253.04-.225-.348-.119s.002.44-.056.411l-.843-.328-.008.435-.129.288-.109.2-.221.202-.09.235-.24.049-.166.65-.337.026-.187-.21-.106.045-.053.492-.453 1.054-.086.16.083.11-.03.178-.242.316-.155-.042-.245.183-.223-.047-.161.391-.336.123-.218-.115-.192.112-.218.098-.325-.083-.339-.384-.906.987-.13.184v.178l-.727.425.766-.082.72-.083.63-.02.222-.165.573.032 3.212-.453Zm4.785-3.675.013.167-.066.266-.136.359-.038.467.126.399.185-.165.157-.427-.04-.291.037-.394.25-.324.066-.276-.553.219Z", clipRule: "evenodd" })] })));

const SvgComponent = (props) => (jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 20, height: 31, fill: "none" }, props, { children: [jsx("path", { fill: "#040404", fillRule: "evenodd", d: "m12.469 27.115.316.133.109-.016.083-.2-.034-.175-.216-.025-.208.092-.05.191Zm-.525.192.1-.183.117-.017.017.041-.109.159h-.125Zm2.298.608-.191-.284.033-.091.3-.15.108.183.1.192.15.091-.05.075-.191.008-.075-.066-.059.025-.125.017Zm.85.174.066-.1.242.05.033-.025.317.034-.017.066-.133.075-.225-.016-.283-.084Zm.374.467-.1-.2v-.067l.192.017.083.108-.016.083-.159.059Zm.259-.259.116-.15.242.126.224.058.225.141v.1l-.183.092-.25.05-.125-.075-.25-.341Zm.94.733-.083.067.017.108.083.092-.025.05-.108.158-.117.05.009.133.108.092.083.291-.033.125.017.233.183.133.091.009.117-.15.125-.167.158-.091.075.033.216-.075.2-.166.017-.067-.208-.133-.1-.225-.083-.125-.175-.108-.392-.184-.175-.083ZM8.148 28.372l-.084-.05.017-4.396-.225-.15-.25-.1-.1.042-.108.033-.266-.133-.075.05-.325-.216-.366-.034-.1-.075-.017-.191-.2-.017-.083.083-.033-.058.025-.058-.1-.108-.183-.125h-.059l-.141.158-.233.008-.05-.041-.059.008-.191.108-.142.033-.083-.05-.191.125-.059.159-.191.183-.217.008-.091-.033H3.8l-.15.1.125.216.15.242.042.2-.025.083.025.058.175.1-.05.042.05.166.116.225-.091.05-.259-.092-.141-.083.025-.075.075-.108-.075-.058-.133-.017-.2.033.008.084h-.033l-.05-.05h-.108l-.35.024-.025.042.1.192.108.091-.033.125-.025.2.183.191.258.009.183.091.1.025.167-.041.133-.042.058.1s-.016.025-.05.05c-.033.025-.05.175-.05.175l-.041.225-.117.066h-.083l-.05-.033-.083-.033-.167.125-.125.016-.016-.125-.134-.058-.141.067-.1.191-.133.083-.233.167-.05.258.058.142.067-.025.041.025-.058.058-.008.108-.109.042v.05l.109.183.033.2.075.066h.316l.042-.075.05.05v.225l.033.092-.067.008-.074.05.033.1-.025.133-.075.075.133.017.108-.059.209-.008.016.1.058.025.067-.067.075.3.075.009.008-.15.05-.05.067.016.033.125.175-.033.083-.067-.016.134-.084.075-.116.233-.1.191-.208.075-.067.192h-.042l-.033-.025-.066.016-.175.034-.158.05-.117.141-.05.017-.083-.067-.142-.008-.091.041-.15.034-.109.108-.224.083-.325-.033-.158.067v.1l.083.058.05-.05.117-.034.133.059.108.016.083-.041.108-.067h.167l.15-.1.175.067.15-.05.183-.067-.017.125h.05l.042-.116.166-.009.142.05.025-.058.075-.075-.092-.067.275-.116.275-.058.108-.059.4-.216.333-.217.141-.166-.041-.108-.117-.05.017-.084.158-.133.216-.075.059-.116.091-.134.125-.174.258-.142.192.017.066.133h-.141l-.05-.067-.225.117-.008.041v.092l-.117.2-.05.125.117.033v.067l-.192.033.025.108.242.009.175-.109.091-.108.158-.108.142.091.066-.058.067.042.025.1.067.016.2-.224-.034-.084-.166.142.075-.225-.05-.017-.059.15-.025-.233.184-.075.183-.017.141.3.109.017.333.2.033-.025h.283l.291.125.192.058.15-.058.091-.084v.084l-.066.166.208.133.25.134.133.15.175.124.133-.033.025.017-.108.066v.117l.083.058.083.15.034.191.108.026.183.308.075.066v-.058l-.017-.291.042.024.033.192.05.192.059-.026.041-.174h.042v.258l.075.075-.092.1s.034.058.067.075c.033.016.05-.05.05-.05l.05.116s.083.142.108.175c.025.033.066.05.066.05l.042-.042-.066-.091-.025-.084.108.067.1.1.058-.025-.008-.191-.075-.142.041-.042.092.059.141.075.075.158.084.041.091-.116.05-.175-.025-.158-.05-.225-.266-.108-.258-.092-.075-.191-.117-.142-.141-.2-.175-.308-.2-.091-.058-.125-.1-.059-.033-.15-.159-.108-.1.075-.058.009-.075.083-.016.158-.034.008-.175.1-.025-.133-.358-.35-.008-.15h-.133l-.075.059-.158-.009Zm-5.887-2.68-.108-.276-.142-.033-.075-.075-.058-.125-.092.125.009.134h.124l.092.074.092.209.15.016.008-.05Zm-.242 1.448.192.042.191.05.042.05-.083.191-.158-.008-.175-.183-.009-.142Zm-1.007-.591-.058-.133h-.05v.1l.108.158.058-.042-.058-.083Zm-.766 3.63.175-.116.175-.05.133.016.025.084.1.025.1-.1-.017-.084.141-.033.15.133-.058.092-.225.058-.141-.025-.192-.058-.225.075-.083.016-.058-.033Zm2.606-.133-.083-.1.116-.05.075.067-.108.083Zm.067.058.058-.116.108.016-.041.1h-.125Zm1.29-.008-.075-.092.084-.066.041.1-.05.058Zm.375-.733.058.3.15.042.258-.15.225-.133-.083-.125.025-.125-.109.066-.15-.041.084-.058.1.041.2-.091.025-.075-.125-.042.041-.1-.141.1-.242.183-.25.15-.066.058Zm2.306-1.099-.124.075-.017-.116.091-.05.05.091Z", clipRule: "evenodd" }), jsx("path", { fill: "#040404", d: "m18.185 7.965-.543-.042-1.653-.17-.836-.106-1.46-.212-1.025-.153-.073.576-.197 1.25-.271 1.566-.08.541-.085.613.336.047 1.333.13 1.06.118 1.894.212 1.227.147.232-2.276.074-1.307.067-.934Z" }), jsx("path", { fill: "#040404", d: "m18.31 6.857.033-.574.116-1.277c.024-.259.056-.436.071-.793l.048-.75-1.58-.145-1.507-.183-1.507-.208-1.665-.275-.95-.175-1.685-.357-.23 1.1.176.388-.07.236.094.235.165.071.238.555.139.163.023.06.177.058.023.106-.365.907v.13l.13.164h.047l.247-.153.036-.059.082.036-.012.27.142.648.153.13.047.035.094.118-.024.176.036.177.059.047.117-.118h.142l.164.083.13-.047h.212l.188.082.142-.024.023-.153.153-.035.07.07.024.166.092.07.08-.596 1.065.153 1.452.204.852.098 1.62.178.566.078.054-.794.073-.276Z" }), jsx("path", { fill: "#040404", d: "M8.29 9.88c-1.165-.224-.73-.147-1.09-.224l.228-.902.224-.912.07-.218.13-.306-.065-.118-.13.006-.04-.053.023-.06.018-.158.23-.283.094-.023.059-.06.03-.164.046-.035.2-.3.2-.224.012-.195-.176-.135-.068-.227.02-.497.189-.848.23-1.072.194-.694.04-.196.669.13-.215 1.108.152.397-.054.235.103.236.164.087.23.505.139.196.032.06.176.058.024.131-.357.865.017.171.137.149.097.024.248-.186.018-.026.008.044.013.213.133.664.178.138.023.044.11.126-.04.143.036.193.1.047.11-.084.132-.025.173.082.13-.03.195-.009.205.083.142-.015.048-.12.128-.085.038.087.032.115.118.13-.194 1.236-.265 1.494-.214-.016-.421-.08-.506-.093-.626-.123-.645-.129-.437-.095-.477-.086-.476-.091Z" }), jsx("path", { fill: "#040404", fillRule: "evenodd", d: "m6.982 20.48.197-.026.076-.104.038-.1-.164-.004-.056-.091.04-.088-.003-.317.115-.069.138-.133.022-.253.084-.18.1-.108.169-.088.066-.038.039-.076-.045-.046-.05-.078-.048-.276-.15-.27.006-.143-.114-.167-.772-1.197-1.001-1.479-1.155-1.701-.654-1.007.092-.371.351-1.337.418-1.619-.637-.171-.695-.177-.647-.212-.389-.106-.589-.153-.363-.124-.081.243-.008.383-.267.608-.158.133-.017.058-.091.042-.075.216-.042.167.142.216.083.217.058.183-.016.333-.092.158-.033.3-.05.192.091.2.142.233.116.25.067.208-.017.166-.016.025v.108l.291.325-.025.125-.033.117-.033.1.008.424.108.192.1.133.142.025.05.141-.059.184-.108.083H1.52l-.042.2.025.15.167.224.083.275.075.242.066.158.175.3.075.133.025.15.083.05v.125l-.041.1-.092.366-.025.1.125.141.217.025.233.092.2.108h.15l.15.158.133.25.058.117.2.108.25.041.074.109.034.166-.075.034.016.05.167.041.142.008.15.242.2.216.04.117.134.216.017.167v.483l.025.091.516.075 1.016.142.716.05Zm-4.53-2.561.067.079-.008.066-.167-.004-.029-.062-.033-.075.17-.004Zm.163-.034-.063.034.042.075.083.083.233.012.046-.033-.158-.063-.183-.108Zm1.003 1.053.092.121.041.05.08.03.029-.076-.05-.091-.138-.104-.054.008v.063Zm.017.608-.092-.162-.025.004v.112c0 .021.038.096.038.096l.066.063.075-.013-.062-.1Z", clipRule: "evenodd" }), jsx("path", { fill: "#040404", d: "m7.034 20.518-.135.11-.017.076.025.05.974.55.625.39.757.442.866.516.633.125 1.294.14.13-.645.194-1.403.359-2.724.219-1.595-1.267-.189-1.401-.236-1.722-.325-.15.932-.024.023-.088.136-.13-.006-.065-.141-.14-.018-.048-.059h-.047l-.047.03-.1.053-.006.359-.012.088-.03.648-.076.111-.03.171.142.253.065.3.04.054.054.03-.006.117-.082.07-.177.089-.1.1-.077.188-.03.253-.146.142-.106.035-.006.3-.024.089.024.04.188.03-.03.142-.076.111-.194.048Z" }), jsx("path", { fill: "#040404", d: "m7.184 9.705 1.08.233.5.1.478.094.34.084-.028.302-.183.893-.21 1.029-.1.5-.113.684-.162.846-.181.808-.102.524-.127.864-.023.056-.056.128-.096-.006-.057-.142-.14-.026-.073-.05-.105.016-.047.038-.067.07-.022.359-.029.088-.02.623-.069.088-.097-.116-.747-1.172-1.001-1.495-1.172-1.743-.638-.957.085-.338.359-1.337.406-1.614 1.731.419.707.153M12.969 16.49l-1.27-.179-1.368-.252-1.742-.31.082-.471.165-.783.17-.854.112-.7.1-.46.195-1.054.182-.9.057-.288.655.116.619.106.53.095.43.07.189.025-.077.548-.119.678.402.048.845.093.423.044-.11 1.131-.164 1.163-.194 1.433-.085.572-.027.13ZM19.44 13.786l.074-1.096-1.653-.158-1.26-.14-1.919-.211-1.066-.13-.135 1.143-.165 1.153-.193 1.442-.078.572-.013.142 1.748.196 1.944.22 1.646.163.855.043M14.501 22.76l-.033-.315.445.027 1.52.158 1.462.074.102-1.15.192-2.878.057-.999.104.018v-.57l-1.66-.124-1.902-.228-1.775-.212-.216 1.584-.36 2.74-.192 1.387-.106.686.796.102.067-.516.858.133.641.084ZM7.166 9.66l.221-.922.24-.921.054-.218.122-.29-.032-.06-.13-.002-.066-.086.024-.075.026-.168.23-.282.094-.057.059-.059.076-.183.209-.292.183-.2.012-.177-.168-.127-.063-.233-.681-.192-.778-.183-.794.006-.024-.07-.283.105-.23-.03-.123-.082-.065.036-.241-.012-.088-.07-.271-.107-.041.006-.224-.076-.1.094-.318-.018-.306-.212.035-.041.012-.4-.118-.2-.212-.03-.035-.13-.121-.024-.3.107-.116.333-.166.516-.167.333-.258.724-.333.7-.416.65-.1.149-.042.441-.066.308.14.182.346.116.597.17.405.13.64.188.686.184.678.184" }), jsx("path", { fill: "#040404", d: "M7.447 5.027c-.432-.117-.695-.156-.991-.147-.222.006-.419-.005-.439-.025-.02-.02-.11-.01-.2.022a.61.61 0 0 1-.317.013 2.144 2.144 0 0 0-.268-.058 3.653 3.653 0 0 1-.448-.123c-.201-.066-.416-.098-.543-.082-.3.04-.48-.088-.446-.317.031-.214-.084-.508-.198-.508-.047 0-.115-.04-.15-.089-.037-.049-.14-.093-.23-.097-.092-.005-.184-.034-.207-.065-.067-.093-.048-.197.035-.197.108 0 .162-.165.085-.258-.082-.099-.025-.246.096-.246.085 0 .084-.012-.012-.117-.086-.096-.104-.192-.094-.511.006-.217-.014-.441-.045-.499-.06-.112.026-.552.109-.552.024 0 .105.065.18.145.16.171.312.255.726.4.325.115.445.11.445-.018 0-.044.044-.077.098-.075.059.003.07.016.028.033a.126.126 0 0 0-.07.11c0 .09.161.356.217.356.064 0 .028-.864-.042-.995-.109-.203-.031-.23.342-.121.634.185 2.466.664 3.123.815.354.082.65.154.659.16.008.007-.036.174-.098.371-.156.495-.561 2.41-.561 2.652 0 .239.012.238-.784.023Z" }), jsx("path", { fill: "#040404", fillRule: "evenodd", d: "M4.984.962 4.759.887 4.7.929 4.684.97l.125.25.058.133-.092.183v.117l.034.075-.042.092.025.166.05.067-.008.066-.075.009-.034-.1-.058-.125-.091-.075.016-.108.117-.025-.017-.092-.016-.058-.109.066-.066.059v.125l-.117.008-.175-.05-.15-.075-.158-.033-.233-.109-.167-.1-.141-.133-.125-.15-.108-.025-.117.483.092.167v.408l-.034.15.075.366.142.142-.225.033-.008.191.133.059-.083.208-.142.017-.016.15.116.15.092-.05.148.027.13.032.018.121.212.038.11.2-.004.409-.01.041.248.196.293.017.092-.077.257.068.074.01.246.09.097.07.216.012.082-.027.14.091.205.013.274-.098.081.08.704-.032.802.175.68.2.017-.483.164-.831.23-1.072.21-.71.052-.2-.78-.176-1.183-.291-1.033-.292-.44-.1-.5-.141Zm-.608.225-.104.008.025.129.079.117.037-.034.017-.075.087.03s-.075.116-.075.133c0 .016.046.012.046.012l.07-.02.038-.105-.033-.041.08-.088-.042-.079H4.48l-.08.083-.024-.07Z", clipRule: "evenodd" })] })));

const NORTHEAST$1 = 'NORTHEAST';
const SOUTH$1 = 'SOUTH';
const WEST$1 = 'WEST';
const MIDWEST$1 = 'MIDWEST';
const N = 'Northeast';
const S = 'South';
const W = 'West';
const M = 'Midwest';
const getStates$1 = (regionName) => {
    var _a, _b;
    const region = regions.find((region) => {
        return region.name === regionName;
    });
    return ((_b = (_a = region === null || region === void 0 ? void 0 : region.states) === null || _a === void 0 ? void 0 : _a.map((state) => {
        return state.value;
    })) !== null && _b !== void 0 ? _b : []);
};
const DELIMITER = ', ';
const STATES = {
    [NORTHEAST$1]: getStates$1(N),
    [SOUTH$1]: getStates$1(S),
    [WEST$1]: getStates$1(W),
    [MIDWEST$1]: getStates$1(M),
};
const STATES_STRINGS = {
    [NORTHEAST$1]: STATES[NORTHEAST$1].join(DELIMITER),
    [SOUTH$1]: STATES[SOUTH$1].join(DELIMITER),
    [WEST$1]: STATES[WEST$1].join(DELIMITER),
    [MIDWEST$1]: STATES[MIDWEST$1].join(DELIMITER),
};
const isSelected = (filter, region) => {
    const selection = mapKeys(filter);
    const states = STATES[region];
    return every(states, (state) => !isUndefined$1(selection[state]));
};
const getOptions = (filter) => {
    const options = [
        {
            title: N,
            subtitle: STATES_STRINGS[NORTHEAST$1],
            icon: (jsx(Box$1, Object.assign({ textAlign: "center" }, { children: jsx(SvgComponent$2, {}) }))),
            value: STATES[NORTHEAST$1],
            selected: isSelected(filter, NORTHEAST$1),
        },
        {
            title: S,
            subtitle: STATES_STRINGS[SOUTH$1],
            icon: (jsx(Box$1, Object.assign({ textAlign: "center" }, { children: jsx(SvgComponent$1, {}) }))),
            value: STATES[SOUTH$1],
            selected: isSelected(filter, SOUTH$1),
        },
        {
            title: W,
            subtitle: STATES_STRINGS[WEST$1],
            icon: (jsx(Box$1, Object.assign({ textAlign: "center" }, { children: jsx(SvgComponent, {}) }))),
            value: STATES[WEST$1],
            selected: isSelected(filter, WEST$1),
        },
        {
            title: M,
            subtitle: STATES_STRINGS[MIDWEST$1],
            icon: (jsx(Box$1, Object.assign({ textAlign: "center" }, { children: jsx(MidwestIcon, {}) }))),
            value: STATES[MIDWEST$1],
            selected: isSelected(filter, MIDWEST$1),
        },
    ];
    return options;
};

const RegionsIconChips = ({ dropdownSize }) => {
    const onUpdate = useOnUpdateData();
    const currentValue = useCurrentValue(STATE$1);
    const options = getOptions(currentValue);
    const onSelectMultipleStates = useCallback((value, option) => {
        const newValue = option.selected ? without$1(currentValue, ...value) : uniq$1(union(currentValue, value));
        onUpdate([STATE$1], [newValue]);
    }, [currentValue, onUpdate]);
    return (jsxs(Box$1, Object.assign({ mb: 2 }, { children: [jsx(SubsectionText, { title: "Regions of the United States" }), jsx(SelectableIconChips, { options: options, onSelect: onSelectMultipleStates, gridItemProps: {
                    xs: 6,
                    sm: dropdownSize ? 6 : 3,
                } })] })));
};

const stateAbbrevs$1 = Object.keys(statesByAbbrev);
function isAbbrev$1(val) {
    return stateAbbrevs$1.includes(val);
}
const onSearch = async (term) => {
    const t = term.toLowerCase();
    return filter$1(states$1, (state) => state.name.toLowerCase().includes(t));
};
const getOptionsByValue = (value) => map$1(value, (v) => {
    if (isAbbrev$1(v)) {
        return statesByAbbrev[v];
    }
    return;
});
const getValues$1 = (value) => map$1(value, (v) => v.value);
const placeholder$1 = 'Specific US States';
const StatesTypeahead = () => {
    const onUpdate = useOnUpdateData();
    const currentValue = useCurrentValue(STATE$1);
    const onSelect = useCallback((val) => {
        const values = getValues$1(val);
        onUpdate([STATE$1], [values]);
    }, [onUpdate]);
    return (jsx(Typeahead$2, { "aria-label": placeholder$1, placeholder: placeholder$1, label: placeholder$1, onSearch: onSearch, value: getOptionsByValue(currentValue), filterSelectedOptions: true, onChange: onSelect, getOptionLabel: (opt) => { var _a; return (_a = opt === null || opt === void 0 ? void 0 : opt.name) !== null && _a !== void 0 ? _a : ''; }, renderTags: (value, getTagProps) => (jsx(ScrollWrapper, Object.assign({ maxHeight: "120px" }, { children: value.map((option, index) => {
                return (jsx(Chip$2, Object.assign({ color: "primary", label: get$1(option, 'name') }, getTagProps({ index })), index));
            }) }))) }));
};

const stateAbbrevs = Object.keys(statesByAbbrev);
function isAbbrev(val) {
    return stateAbbrevs.includes(val);
}
const optionalize = (arr) => {
    return map$1(arr, (s) => {
        if (isAbbrev(s)) {
            const state = statesByAbbrev[s];
            return {
                label: get$1(state, 'name'),
                value: get$1(state, 'value'),
            };
        }
        return {
            label: get$1(s, 'name', ''),
            value: get$1(s, 'value', ''),
        };
    });
};
const options$1 = states$1.map((state) => ({
    label: state.name,
    value: state.value,
}));
const getValues = (value) => map$1(value, (v) => v.value);
const StateChips = () => {
    const onUpdate = useOnUpdateData();
    const currentValue = useCurrentValue(STATE$1);
    const onSelect = useCallback((val) => {
        const values = getValues(val);
        onUpdate([STATE$1], [values]);
    }, [onUpdate]);
    return (jsxs(List$1, { children: [jsx(ListSubheader$1, Object.assign({ role: "sectionhead", disableSticky: true, disableGutters: true }, { children: "United States" })), jsx(ChipSelector, { options: options$1, selected: optionalize(currentValue), onUpdateSelection: onSelect })] }));
};

const LocationDropdown = () => {
    const onUpdate = useOnUpdateData();
    const currentStates = useCurrentValue(STATE$1);
    const currentCountry = useCurrentValue(LOCATION_CATEGORY$1);
    const countryLabels = useMemo(() => currentCountry.map((v) => LABELS[v]), [currentCountry]);
    const selectionLabels = useMemo(() => {
        return [...currentStates, ...countryLabels];
    }, [currentStates, countryLabels]);
    const onClear = useCallback(() => {
        onUpdate([STATE$1, LOCATION_CATEGORY$1], [undefined, undefined]);
    }, [onUpdate]);
    return (jsx(Dropdown, Object.assign({ fieldLabel: "Location", buttonLabel: "Location", id: "college-search-filter-bar-location", selectionLabels: selectionLabels, onClear: onClear }, { children: jsxs(Box$1, Object.assign({ mt: 2, mb: 1, mx: 2 }, { children: [jsx(CountryIconChips, {}), jsx(Box$1, Object.assign({ mt: 2 }, { children: jsx(RegionsIconChips, { dropdownSize: true }) })), jsx(StateChips, {})] })) })));
};

const LocationSelector = () => {
    return (jsxs(Fragment$1, { children: [jsx(CountryIconChips, {}), jsx(RegionsIconChips, {}), jsx(StatesTypeahead, {})] }));
};
LocationSelector.CountryIconChips = CountryIconChips;
LocationSelector.RegionsIconChips = RegionsIconChips;
LocationSelector.StatesTypeahead = StatesTypeahead;
LocationSelector.StatesChips = StateChips;
LocationSelector.Dropdown = LocationDropdown;

const ARMY = 'Army';
const AF = 'Air Force';
const NAVY = 'Navy';
const ICONS$1 = {
    [AF]: faFighterJet,
    [ARMY]: faShieldAlt,
    [NAVY]: faAnchor,
};
const SELECTED_ICONS = {
    [AF]: faFighterJet$1,
    [ARMY]: faShieldAlt$1,
    [NAVY]: faAnchor$1,
};

const useSelectableIconChipOptions = ({ currentValue, terms }) => {
    const sortedTerms = useMemo(() => {
        return sortBy(terms, ['label']);
    }, [terms]);
    return useMemo(() => {
        return map$1(sortedTerms, (term) => {
            const value = get$1(term, 'term', '');
            const isSelected = includes$1(currentValue, value);
            return {
                title: get$1(term, 'label', value),
                faIcon: value && (isSelected ? get$1(SELECTED_ICONS, value) : get$1(ICONS$1, value)),
                value,
                selected: isSelected,
            };
        });
    }, [currentValue, sortedTerms]);
};
const Rotc = () => {
    const onUpdate = useOnUpdateData();
    const options = useOptions$2({ fieldName: ROTC$1 });
    const currentValue = useCurrentValue(ROTC$1);
    const onSelect = useCallback((value) => {
        const newValue = arrayValueToggle(currentValue, value);
        onUpdate([ROTC$1], [newValue]);
    }, [currentValue, onUpdate]);
    const selectableIconChipsOptions = useSelectableIconChipOptions({
        currentValue,
        terms: options,
    });
    return (jsxs(Fragment$1, { children: [jsx(ExpandYourSearch, { facetNames: [ROTC$1], pb: 2 }), jsx(SelectableIconChips, { options: selectableIconChipsOptions, onSelect: onSelect, gridItemProps: { xs: 4 } })] }));
};

const SpecialMission = () => {
    const onUpdate = useOnUpdateData();
    const currentCoalitionMemberValue = useCurrentValue(COALITION_MEMBER$2);
    const currentMinorityServingInstValue = useCurrentValue(MINORITY_SERVING$1);
    const coalitionMemberTerms = useOptions$2({ fieldName: COALITION_MEMBER$2, withoutTerms: ['F'] });
    const minorityServingInstTerms = useOptions$2({ fieldName: MINORITY_SERVING$1 });
    const coalitionMemberOptions = useMemo(() => {
        return getFilterOptions({
            terms: coalitionMemberTerms,
            filter: currentCoalitionMemberValue,
            labels: COALITION_MEMBER_LABELS,
            subtitles: COALITION_MEMBER_SUB_LABELS,
        });
    }, [coalitionMemberTerms, currentCoalitionMemberValue]);
    const minorityServingInstOptions = useMemo(() => {
        return getFilterOptions({
            terms: minorityServingInstTerms,
            filter: currentMinorityServingInstValue,
            labels: MINORITY_SERVING_LABELS,
            subtitles: MINORITY_SERVING_SUB_LABELS,
        });
    }, [minorityServingInstTerms, currentMinorityServingInstValue]);
    const specialMissionOptions = useMemo(() => {
        return concat(coalitionMemberOptions, minorityServingInstOptions);
    }, [coalitionMemberOptions, minorityServingInstOptions]);
    const onSpecialMissonSelect = useCallback((newValue) => {
        if (newValue === 'T') {
            const newSelections = arrayValueToggle(currentCoalitionMemberValue, newValue);
            onUpdate([COALITION_MEMBER$2], [newSelections]);
        }
        else {
            const newSelections = arrayValueToggle(currentMinorityServingInstValue, newValue);
            onUpdate([MINORITY_SERVING$1], [newSelections]);
        }
    }, [currentCoalitionMemberValue, currentMinorityServingInstValue, onUpdate]);
    return (jsx(Checklist, { title: "Special-Mission", options: specialMissionOptions, isTwoColumnAtSm: true, onSelect: onSpecialMissonSelect }));
};

const FundingSource = () => {
    const onUpdate = useOnUpdateData();
    const currentControlValue = useCurrentValue(CONTROL$1);
    const controlTerms = useOptions$2({ fieldName: CONTROL$1 });
    const controlOptions = useMemo(() => {
        const options = getFilterOptions({
            terms: controlTerms,
            filter: currentControlValue,
            subtitles: CONTROL_SUB_LABELS,
        });
        return options;
    }, [controlTerms, currentControlValue]);
    const onControlSelect = useCallback((newValue) => {
        const newSelections = arrayValueToggle(currentControlValue, newValue);
        onUpdate([CONTROL$1], [newSelections]);
    }, [currentControlValue, onUpdate]);
    return (jsx(Checklist, { title: "Funding Source", options: controlOptions, isTwoColumnAtSm: true, onSelect: onControlSelect }));
};

const getFilterFn = (currentReligiousValue) => {
    return (option) => {
        return currentReligiousValue.includes(option.value);
    };
};
const Religious = () => {
    const onUpdate = useOnUpdateData();
    const currentReligiousValue = useCurrentValue(RELIGIOUS$1);
    const religiousTerms = useOptions$2({ fieldName: RELIGIOUS$1 });
    const religiousOptions = useMemo(() => {
        const options = map$1(religiousTerms, ({ label, term }) => {
            return {
                label,
                value: term,
            };
        });
        return sortBy(options, 'label');
    }, [religiousTerms]);
    const selectedListPreview = useMemo(() => {
        return filter$1(religiousOptions, getFilterFn(currentReligiousValue));
    }, [currentReligiousValue, religiousOptions]);
    const onReligiousSelect = useCallback((_, option) => {
        const newSelections = arrayValueToggle(currentReligiousValue, option.value);
        onUpdate([RELIGIOUS$1], [newSelections]);
    }, [currentReligiousValue, onUpdate]);
    return (jsxs(Fragment$1, { children: [jsx(SubsectionText, { title: "Religious Affiliation", mb: 0 }), jsx(ChipSelector, { selected: selectedListPreview, options: religiousOptions, onUpdateSelection: onReligiousSelect })] }));
};

const SchoolType = () => {
    const facetNames = useMemo(() => {
        return [CONTROL$1, RELIGIOUS$1, COALITION_MEMBER$2, MINORITY_SERVING$1];
    }, []);
    return (jsxs("div", { children: [jsx(ExpandYourSearch, { facetNames: facetNames }), jsx(FundingSource, {}), jsx(Religious, {}), jsx(SpecialMission, {})] }));
};

/**
 * This is a list of terms that the UI does not show to the user.
 */
const IGNORED_TERMS$1 = {
    CoalitionMember: ['F'],
    TestOptional: ['F'],
    ScoirApplyApplicantTypes: ['transfer'],
};
const getFacetCounts$1 = (facets) => {
    return reduce$1(facets, (facetCounts, facet) => {
        const ignoredTerms = get$1(IGNORED_TERMS$1, facet.name, []);
        const terms = filter$1(facet.terms, (term) => {
            return !includes$1(ignoredTerms, term.term);
        });
        const facetSize = size$1(terms);
        return Object.assign(Object.assign({}, facetCounts), { [facet.name]: facetSize });
    }, {});
};
/**
 * This hook takes in an object of facets and fetches the full list of facets when it initializes
 * Then as the facets change, the function returned can be used to figure out by facetname if certain filters aren't available
 * @param {object} facets
 * @returns function
 */
const useHasHiddenFacets$1 = (facets) => {
    const [allFacetCounts, setAllFacetCounts] = useState({});
    const currentFacetCounts = useMemo(() => getFacetCounts$1(facets), [facets]);
    const hasSetAllFacetCounts = useRef(false);
    const hasHiddenFacets = useCallback((facetNames) => {
        return reduce$1(facetNames, (answer, facetName) => {
            const currentCount = get$1(currentFacetCounts, facetName, 0);
            const totalCount = get$1(allFacetCounts, facetName, 0);
            if (currentCount < totalCount) {
                return true;
            }
            return answer;
        }, false);
    }, [currentFacetCounts, allFacetCounts]);
    useEffect(() => {
        if (facets.length && !hasSetAllFacetCounts.current) {
            setAllFacetCounts(getFacetCounts$1(facets));
            hasSetAllFacetCounts.current = true;
        }
    }, [facets]);
    return hasHiddenFacets;
};

const SelectorContextProvider = ({ apiCalls = {}, data = {}, onUpdateData, facets = [], acceptanceLikelihoodLabels = {}, collegeMatchLevel = 0, selectivityLabels = {}, children, supportsAcceptanceLikelihoodFilters = false, displayScoirApplyIcon = () => null, }) => {
    const onUpdateDataFields = useCallback((fields, values = []) => {
        const updatedData = produce(data, (draft) => {
            fields.forEach((field, idx) => {
                const value = values[idx];
                const isRemoved = isEmpty$1(value) || isNull$1(value);
                draft[field] = isRemoved ? undefined : value;
            });
        });
        onUpdateData(updatedData);
    }, [onUpdateData, data]);
    const facetsByName = useMemo(() => {
        return reduce$1(facets, (acc, option) => {
            acc[option.name] = option;
            return acc;
        }, {});
    }, [facets]);
    const hasHiddenFacets = useHasHiddenFacets$1(facets);
    return (jsx(SelectorContext.Provider, Object.assign({ value: {
            data,
            options: facetsByName,
            onUpdateDataFields,
            hasHiddenFacets,
            apiCalls,
            acceptanceLikelihoodLabels,
            collegeMatchLevel,
            selectivityLabels,
            supportsAcceptanceLikelihoodFilters,
            displayScoirApplyIcon,
        } }, { children: children })));
};

const useOnUpdate = () => {
    const onUpdate = useOnUpdateData();
    return useCallback((value) => {
        onUpdate([INTERESTS$1], [value]);
    }, [onUpdate]);
};

const placeholder = 'Interests & Activities';
const PersonalInterestsTypeahead = () => {
    const onUpdate = useOnUpdate();
    const onTagsSearch = useAPIFn(API_CALL_NAMES.onTagsSearch);
    const currentInterestsValue = useCurrentValue(INTERESTS$1);
    const selectedRef = useRef(currentInterestsValue);
    const onSearch = useCallback((val) => {
        return onTagsSearch(val)
            .then((categories) => {
            const options = [];
            forEach$1(categories, (category) => {
                const categoryName = get$1(category, 'Category');
                const tags = get$1(category, 'Tags');
                options.push(...map$1(tags, (tag) => {
                    return { name: tag, type: categoryName };
                }));
            });
            return options;
        })
            .catch(noop$1);
    }, [onTagsSearch]);
    const onSelect = useCallback((values) => {
        const newVal = map$1(values, (value) => {
            return get$1(value, 'name', value);
        });
        onUpdate(newVal);
    }, [onUpdate]);
    return (jsx(Typeahead$2, { "aria-label": "Search for an personal interests", placeholder: placeholder, label: placeholder, onSearch: onSearch, defaultValue: selectedRef.current, value: currentInterestsValue, onChange: onSelect, groupBy: (option) => get$1(option, 'type', ''), getOptionSelected: (option, value) => {
            const v = get$1(value, 'name', value);
            const o = get$1(option, 'name');
            const ot = get$1(option, 'type');
            const vt = get$1(value, 'type', ot);
            const nameMatch = v === o;
            const typeMatch = ot === vt;
            return nameMatch && typeMatch;
        }, renderTags: (value, getTagProps) => (jsx(ScrollWrapper, Object.assign({ maxHeight: "120px" }, { children: value.map((option, index) => {
                const label = get$1(option, 'name', option);
                return (jsx(Chip$2, Object.assign({ color: "primary", label: label }, getTagProps({ index })), index));
            }) }))), renderOption: (option, state) => {
            const name = get$1(option, 'name', '');
            const term = get$1(state, 'inputValue', '');
            const checked = get$1(state, 'selected', '');
            return (jsxs(React.Fragment, { children: [jsx(Checkbox$1, { edge: "start", color: "primary", checked: checked, disableRipple: true, inputProps: { 'aria-labelledby': name } }), jsx(Box$1, Object.assign({ marginLeft: 2 }, { children: jsx(Typography$1, Object.assign({ variant: "body1" }, { children: jsx(SubstringHighlighter, { term: term, value: name }) })) }))] }));
        } }));
};

const useAllTags = () => {
    const [allInterests, setAllInterests] = useState([]);
    const onAllTagsSearch = useAPIFn(API_CALL_NAMES.onAllTagsSearch);
    const hasRun = useRef(false);
    useEffect(() => {
        let unmounted = false;
        if (hasRun.current)
            return;
        hasRun.current = true;
        onAllTagsSearch()
            .then((interests) => {
            if (unmounted)
                return;
            setAllInterests(interests);
        })
            .catch(noop$1);
        return () => {
            unmounted = true;
        };
    }, [onAllTagsSearch]);
    return allInterests;
};

const cultures = {
    Afghani: true,
    African: true,
    'African American': true,
    Arabic: true,
    Armenian: true,
    Asian: true,
    'Asian American': true,
    Australian: true,
    Bangaladeshi: true,
    Bengali: true,
    Bosnian: true,
    Brazilian: true,
    British: true,
    Cambodian: true,
    Canadian: true,
    Chinese: true,
    Columbian: true,
    Cuban: true,
    'Culture - General': true,
    Dominican: true,
    'East Asian': true,
    Egyptian: true,
    Ethiopian: true,
    European: true,
    Filipino: true,
    French: true,
    German: true,
    Ghanaian: true,
    Greek: true,
    Guyanese: true,
    Haitian: true,
    Hawaiian: true,
    Hindu: true,
    Hispanic: true,
    Indian: true,
    Indonesian: true,
    Iranian: true,
    Irish: true,
    Israeli: true,
    Italian: true,
    Japanese: true,
    Jewish: true,
    Jordinian: true,
    Korean: true,
    Kurdish: true,
    Kuwaiti: true,
    Latino: true,
    Lebanese: true,
    Macedonian: true,
    Malaysian: true,
    Meditation: true,
    Mexican: true,
    'Middle Eastern': true,
    'Multi Cultural': true,
    'Native American': true,
    Nepalese: true,
    Nepali: true,
    Nigerian: true,
    Nordic: true,
    'Pacific Islander': true,
    Pakistani: true,
    Paraguayan: true,
    Persian: true,
    Polish: true,
    Polynesian: true,
    Portuguese: true,
    Punjabi: true,
    Religion: true,
    Romanian: true,
    Russian: true,
    Saudi: true,
    Scandinavian: true,
    Scotland: true,
    Singaporean: true,
    Slavic: true,
    'South Asian': true,
    'Southeast Asian': true,
    Spanish: true,
    Swedish: true,
    Syrian: true,
    Taiwanese: true,
    Thai: true,
    Turkish: true,
    Ukrainian: true,
    Venezuelan: true,
    Vietnamese: true,
};

const getIcon = (tag, isSelected) => {
    const culturesIncluded = get$1(cultures, tag, false);
    const iconName = culturesIncluded ? 'Culture' : tag;
    const iconIndex = get$1(icons, iconName);
    try {
        const icon = isSelected ? iconIndex.selectedIcon : iconIndex.icon;
        return icon;
    }
    catch (_a) {
        return isSelected ? faGlobe$1 : faGlobe;
    }
};
const Tags = ({ tags, selectedInterests, hasOpenCategory, onChange }) => {
    const selectedInterestsObj = useMemo(() => {
        const tags = {};
        forEach$1(selectedInterests, (tag) => {
            tags[tag] = true;
        });
        return tags;
    }, [selectedInterests]);
    const tagsDisplay = useMemo(() => {
        return map$1(tags, (tag) => {
            const isChecked = get$1(selectedInterestsObj, tag, false);
            return (jsx(Box$1, Object.assign({ pr: 1, pb: 1, display: "inline-block" }, { children: jsx(ChipComponent, { label: tag, isSelected: isChecked, onClick: () => onChange(tag), icon: getIcon(tag, isChecked) }) }), tag));
        });
    }, [tags, selectedInterestsObj, onChange]);
    return !hasOpenCategory ? null : (jsx(Box$1, Object.assign({ width: "100%", px: 2, pt: 2 }, { children: tagsDisplay })));
};

const useStyles$5 = makeStyles((theme) => ({
    toggleButton: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    bold: {
        fontWeight: 'bold',
    },
    previousIcon: {
        marginRight: theme.spacing(1),
    },
    numSelected: {
        display: 'inline-block',
        marginRight: theme.spacing(0.5),
    },
    selectedInfo: {
        fontWeight: 'normal',
        fontStyle: 'italic',
        color: get$1(theme, 'palette.text.disabled'),
    },
}));
const CategoryListItem = ({ category, openCategory, onClick, hasOpenCategory, hasSelections, numSelected, }) => {
    const classes = useStyles$5();
    return (jsxs(ListItem$1, Object.assign({ button: true, className: classes.toggleButton, onClick: onClick }, { children: [jsxs(Box$1, Object.assign({ display: "flex", alignItems: "center" }, { children: [!openCategory ? null : (jsx(ChevronLeftIcon, { className: cn(classes.previousIcon), "aria-hidden": "true" })), jsx(Typography$1, Object.assign({ className: cn({ [classes.bold]: hasOpenCategory }), component: "span" }, { children: category.Category }))] })), jsxs(Box$1, Object.assign({ display: "flex", alignItems: "center" }, { children: [!hasSelections ? null : (jsx("span", Object.assign({ className: classes.selectedInfo }, { children: jsxs(Typography$1, Object.assign({ component: "span", className: classes.numSelected }, { children: [jsx("strong", { children: numSelected }), " selected"] })) }))), openCategory ? null : jsx(ChevronRightIcon, { "aria-hidden": "true" })] }))] })));
};

const Category = ({ category, selectedInterests, openCategory, onClick, onChange }) => {
    const numSelected = size$1(intersection$1(selectedInterests, category.Tags));
    const hasSelections = numSelected > 0;
    const hasOpenCategory = isEqual$1(openCategory, category.Category);
    const shouldShow = !openCategory || hasOpenCategory;
    return !shouldShow ? null : (jsxs(React.Fragment, { children: [jsx(CategoryListItem, { category: category, openCategory: openCategory, onClick: onClick, hasOpenCategory: hasOpenCategory, hasSelections: hasSelections, numSelected: numSelected }), !isUndefined$1(openCategory) ? null : jsx(Divider$1, {}), jsx(Tags, { tags: category.Tags, selectedInterests: selectedInterests, hasOpenCategory: hasOpenCategory, onChange: onChange })] }));
};

const Categories$1 = ({ onChange, categories, selectedInterests }) => {
    const [openCategory, setOpenCategory] = useState();
    const handleToggle = useCallback((newCategory) => {
        const value = isEqual$1(newCategory, openCategory) ? undefined : newCategory;
        setOpenCategory(value);
    }, [openCategory]);
    const listItems = useMemo(() => {
        return map$1(categories, (category) => {
            const categoryString = category.Category;
            const hasOpenCategory = isEqual$1(openCategory, categoryString);
            if (!openCategory || hasOpenCategory) {
                return (jsx(Category, { category: category, openCategory: openCategory, selectedInterests: selectedInterests, onClick: () => handleToggle(category.Category), onChange: onChange }, categoryString));
            }
        });
    }, [categories, openCategory, selectedInterests, handleToggle, onChange]);
    return (jsx(List$1, Object.assign({ className: "category-explorer", dense: true }, { children: listItems })));
};

const CategoryExplorer = _ref => {
  let {
    categories,
    selectedInterests,
    onChange
  } = _ref;
  const [open, setOpen] = useState(false);
  return /*#__PURE__*/React.createElement(Box, {
    border: 1,
    borderColor: "divider"
  }, /*#__PURE__*/React.createElement(List, {
    dense: true,
    "aria-label": "Student Life - Interest Categories"
  }, /*#__PURE__*/React.createElement(ListItem, {
    "aria-label": "Student Life - Interest Categories"
  }, /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement("strong", null, "Categories")), /*#__PURE__*/React.createElement(ListItemSecondaryAction, null, /*#__PURE__*/React.createElement(Button, {
    onClick: () => setOpen(!open),
    color: "primary"
  }, open ? 'Hide' : 'Show'))), open && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Collapse, {
    in: open,
    timeout: "auto"
  }, /*#__PURE__*/React.createElement(Categories$1, {
    categories: categories,
    selectedInterests: selectedInterests,
    onChange: onChange
  }))));
};
CategoryExplorer.propTypes = {
  onChange: PropTypes.func.isRequired,
  categories: PropTypes.array.isRequired,
  selectedInterests: PropTypes.array.isRequired
};

const Categories = () => {
    const onUpdate = useOnUpdate();
    const currentInterestsValue = useCurrentValue(INTERESTS$1);
    const categories = useAllTags();
    const onChange = useCallback((val) => {
        const newVal = arrayValueToggle(currentInterestsValue, val);
        onUpdate(newVal);
    }, [onUpdate, currentInterestsValue]);
    return isEmpty$1(categories) ? null : (jsx(Box$1, Object.assign({ mt: 2 }, { children: jsx(CategoryExplorer, { categories: categories, selectedInterests: currentInterestsValue, onChange: onChange }) })));
};

const PersonalInterest = () => {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PersonalInterestsTypeahead, null), /*#__PURE__*/React.createElement(Categories, null));
};

const getFromString = arr => {
  return sortBy$1(map(arr, o => parseInt(o.from))).join(',');
};

const SM = 'small';
const MD = 'medium';
const LG = 'large';
const TITLES = {
  [SM]: 'Small',
  [MD]: 'Medium',
  [LG]: 'Large'
};
const SUBTITLES = {
  [SM]: 'Fewer than 2,500 Students',
  [MD]: '2,500–10,000 Students',
  [LG]: '10,000+ Students'
};
const Icon = (letter, selected) => /*#__PURE__*/React.createElement(Box, {
  fontWeight: selected ? 'bold' : undefined,
  fontSize: "24px"
}, letter);
const ICONS = {
  [SM]: selected => Icon('S', selected),
  [MD]: selected => Icon('M', selected),
  [LG]: selected => Icon('L', selected)
};
const VALUES = {
  [SM]: [{
    label: '< 500',
    from: '0',
    to: '499'
  }, {
    label: '500 - 1000',
    from: '500',
    to: '999'
  }, {
    label: '1000 - 1500',
    from: '1000',
    to: '1499'
  }, {
    label: '1500 - 2500',
    from: '1500',
    to: '2499'
  }],
  [MD]: [{
    label: '2500 - 5000',
    from: '2500',
    to: '4999'
  }, {
    label: '5000 - 10000',
    from: '5000',
    to: '9999'
  }],
  [LG]: [{
    label: '10000+',
    from: '10000',
    to: '500000'
  }]
};
const FROM_STRINGS = {
  [SM]: getFromString(VALUES[SM]),
  [MD]: getFromString(VALUES[MD]),
  [LG]: getFromString(VALUES[LG])
};

const getMatchingSizes = arr => {
  const sizes = [];
  const targetStr = getFromString(arr);
  if (targetStr.includes(FROM_STRINGS[SM])) {
    sizes.push(SM);
  }
  if (targetStr.includes(FROM_STRINGS[MD])) {
    sizes.push(MD);
  }
  if (targetStr.includes(FROM_STRINGS[LG])) {
    sizes.push(LG);
  }
  return sizes;
};
const getValuesFromSizes = sizes => {
  let values = [];
  if (sizes.includes(SM)) {
    values = VALUES[SM];
  }
  if (sizes.includes(MD)) {
    values = [...values, ...VALUES[MD]];
  }
  if (sizes.includes(LG)) {
    values = [...values, ...VALUES[LG]];
  }
  return values;
};
const getSelectableIconChipOptions = (availableSizes, selectedSizes) => {
  return map(availableSizes, size => {
    const selected = includes(selectedSizes, size);
    return {
      title: TITLES[size],
      subtitle: SUBTITLES[size],
      icon: ICONS[size](selected),
      value: size,
      selected
    };
  });
};
const getTitles = selectedSizes => map(selectedSizes, size => TITLES[size]);

const SchoolSizeSelector = ({ gridItemProps = { xs: 4 } }) => {
    const onUpdate = useOnUpdateData();
    const options = useOptions$2({ fieldName: SCHOOL_SIZE$1 });
    const currentValue = useCurrentValue(SCHOOL_SIZE$1);
    const availableSizes = useMemo(() => getMatchingSizes(options), [options]);
    const selectedSizes = useMemo(() => getMatchingSizes(currentValue), [currentValue]);
    const onSelect = useCallback((value) => {
        const selections = arrayValueToggle(selectedSizes, value);
        const values = getValuesFromSizes(selections);
        onUpdate([SCHOOL_SIZE$1], [values]);
    }, [selectedSizes, onUpdate]);
    const selectableIconChipsOptions = useMemo(() => getSelectableIconChipOptions(availableSizes, selectedSizes), [availableSizes, selectedSizes]);
    return (jsxs(Fragment$1, { children: [jsx(ExpandYourSearch, { facetNames: [SCHOOL_SIZE$1], mb: 2 }), jsx(SelectableIconChips, { options: selectableIconChipsOptions, onSelect: onSelect, gridItemProps: gridItemProps })] }));
};
const SchoolSizeDropdown = () => {
    const onUpdate = useOnUpdateData();
    const onClear = useCallback(() => {
        onUpdate([SCHOOL_SIZE$1], [undefined]);
    }, [onUpdate]);
    const currentValue = useCurrentValue(SCHOOL_SIZE$1);
    const selectedSizes = useMemo(() => getMatchingSizes(currentValue), [currentValue]);
    const selectedLabels = useMemo(() => getTitles(selectedSizes), [selectedSizes]);
    return (jsx(Dropdown, Object.assign({ fieldLabel: "School Size", buttonLabel: "Size", id: "college-search-filter-bar-size", selectionLabels: selectedLabels, onClear: onClear }, { children: jsx(Box$1, Object.assign({ mx: 2, mb: 2 }, { children: jsx(SchoolSizeSelector, { gridItemProps: { xs: 6 } }) })) })));
};
SchoolSizeSelector.Dropdown = SchoolSizeDropdown;

const Section = (_a) => {
    var { title, subTitle, children } = _a, rest = __rest(_a, ["title", "subTitle", "children"]);
    return (jsx(Box$1, Object.assign({ mb: 2 }, { children: jsx(Paper, Object.assign({ elevation: 0 }, { children: jsxs(Box$1, Object.assign({ px: 3 }, { children: [jsx(SectionTitle, Object.assign({ title: title, subTitle: subTitle }, rest)), jsx(Box$1, Object.assign({ pb: 3 }, { children: children }))] })) })) })));
};

var types = /*#__PURE__*/Object.freeze({
    __proto__: null
});

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    AcademicFocusSelector: AcademicFocus,
    AdmissionsSelector: AdmissionsSelector,
    ApplicationMethodSelector: ApplicationMethodSelector,
    AthleticsSelector: AthleticsSelector,
    DegreesSelector: DegreesSelector,
    DistanceSelector: DistanceSelector,
    SettingSelector: SettingSelector,
    LocationSelector: LocationSelector,
    RotcSelector: Rotc,
    Repeater: Repeater,
    SchoolTypeSelector: SchoolType,
    SelectorContextProvider: SelectorContextProvider,
    StudentLifeSelector: PersonalInterest,
    SchoolSizeSelector: SchoolSizeSelector,
    DISPLAY_TEXT: DISPLAY_TEXT,
    API_CALL_NAMES: API_CALL_NAMES,
    Section: Section,
    types: types
});

const Context$3 = /*#__PURE__*/React.createContext({});

var window$1 = window;

const ACADEMIC_FOCUS = 'AcademicFocus';
const PREFERENCE_SELECTION = 'PreferenceSelection';
const ACT = 'ACTAvg';
const APP_METHOD = 'ApplicationMethod';
const COALITION_MEMBER$1 = 'CoalitionMember';
const CONTROL = 'Control';
const DEGREES = 'Degrees';
const UNIV_TYPE = 'UnivType';
const LOCATION = 'Location';
const STATE = 'State';
const LOCATION_CATEGORY = 'LocationCategory';
const MAJORS = 'Majors';
const MINORITY_SERVING = 'MinorityServingInst';
const RELIGIOUS = 'Religious';
const ROTC = 'Rotc';
const SAT = 'SATAvg';
const SCHOOL_SIZE = 'UnderGradEnroll';
const SCOIR_APPLY_APPLICANT_TYPES = 'ScoirApplyApplicantTypes';
const SELECTIVITY_LEVEL = 'SelectivityLevel';
const SELECTIVITY = 'Selectivity';
const SETTING = 'Setting';
const SPORTS = 'Sports';
const TEST_OPTIONAL$1 = 'TestOptional';
const INTERESTS = 'Tags';
const ACCEPTANCE_LIKELIHOOD = 'AcceptanceLikelihood';
const CURRENT_USER = 'CurrentUser';
const PREFERENCE_TYPES = {
  ACADEMIC_FOCUS,
  PREFERENCE_SELECTION,
  ACT,
  APP_METHOD,
  COALITION_MEMBER: COALITION_MEMBER$1,
  CONTROL,
  DEGREES,
  LOCATION,
  STATE,
  LOCATION_CATEGORY,
  MAJORS,
  MINORITY_SERVING,
  RELIGIOUS,
  ROTC,
  SAT,
  SCHOOL_SIZE,
  SCOIR_APPLY_APPLICANT_TYPES,
  SELECTIVITY,
  SELECTIVITY_LEVEL,
  SETTING,
  SPORTS,
  TEST_OPTIONAL: TEST_OPTIONAL$1,
  INTERESTS,
  ACCEPTANCE_LIKELIHOOD
};

const FOUR_YEAR_US_OLD = 'FOUR_YEAR_US_OLD';
const TWO_YEAR_US_OLD = 'TWO_YEAR_US_OLD';
const FOUR_YEAR_US = 'FOUR_YEAR_US';
const TWO_YEAR_US = 'TWO_YEAR_US';
const CAREER_AND_TRADE = 'CAREER_AND_TRADE';
const INTERNATIONAL = 'INTERNATIONAL';
const BLANK_SEARCH = 'BLANK_SEARCH';
const SCOIR_APPLY = 'APPLY_WITH_SCOIR';
const COALITION_MEMBER = 'COALITION_MEMBER';
const SCOIR_APPLY_TRANSFER = 'APPLY_WITH_SCOIR_TRANSFER';
const NORTHEAST = 'NORTHEAST';
const SOUTH = 'SOUTH';
const WEST = 'WEST';
const MIDWEST = 'MIDWEST';
const TEST_OPTIONAL = 'TEST_OPTIONAL';
const getStates = regionName => {
  const region = regions.find(region => {
    return region.name === regionName;
  });
  const states = get(region, 'states', []);
  return states.map(state => {
    return state.value;
  });
};
const PREDEFINED_SEARCHES = {
  [BLANK_SEARCH]: {},
  [FOUR_YEAR_US_OLD]: {
    LocationCategory: ['Domestic'],
    Degrees: ['Bachelors']
  },
  [TWO_YEAR_US_OLD]: {
    LocationCategory: ['Domestic'],
    Degrees: ['Associates']
  },
  [FOUR_YEAR_US]: {
    LocationCategory: ['Domestic'],
    UnivType: ['4 year']
  },
  [TWO_YEAR_US]: {
    LocationCategory: ['Domestic'],
    UnivType: ['2 year']
  },
  [CAREER_AND_TRADE]: {
    LocationCategory: ['Domestic'],
    SchoolClassifier: ['CareerAndTrade']
  },
  [INTERNATIONAL]: {
    LocationCategory: ['International']
  },
  [SCOIR_APPLY]: {
    ScoirApplyApplicantTypes: ['first']
  },
  [SCOIR_APPLY_TRANSFER]: {
    ScoirApplyApplicantTypes: ['transfer']
  },
  [COALITION_MEMBER]: {
    CoalitionMember: ['T']
  },
  [NORTHEAST]: {
    State: getStates('Northeast')
  },
  [SOUTH]: {
    State: getStates('South')
  },
  [WEST]: {
    State: getStates('West')
  },
  [MIDWEST]: {
    State: getStates('Midwest')
  },
  [TEST_OPTIONAL]: {
    TestOptional: ['T']
  }
};

/**
 * This fn gets the query from the params in the url
 * @prop {string} minorityServingInst
 * @prop {string} predefinedFilters
 * @prop {string} prepopulatedNameSearch
 * @prop {string} publicPrivate
 * @prop {string} religious
 * @prop {string} savedQuery
 * @prop {string} setting
 * @param {object} props
 * @returns an object
 */
const getFilterParam = _ref => {
  let {
    minorityServingInst,
    selectivityLevel,
    acceptanceLikelihood,
    predefinedFilters,
    prepopulatedNameSearch,
    publicPrivate,
    religious,
    setting,
    savedQuery,
    careerMajors
  } = _ref;
  let query = {};
  if (!isUndefined(predefinedFilters)) {
    const filters = get(PREDEFINED_SEARCHES, predefinedFilters);
    query = {
      ...query,
      ...filters
    };
  }
  if (!isUndefined(prepopulatedNameSearch)) {
    return undefined;
  }
  if (!isUndefined(publicPrivate)) {
    query = {
      ...query,
      [CONTROL]: [publicPrivate]
    };
  }
  if (!isUndefined(setting)) {
    query = {
      ...query,
      [SETTING]: [setting]
    };
  }
  if (!isUndefined(religious)) {
    query = {
      ...query,
      [RELIGIOUS]: [religious]
    };
  }
  if (!isUndefined(minorityServingInst)) {
    query = {
      ...query,
      [MINORITY_SERVING]: [minorityServingInst]
    };
  }
  if (!isUndefined(selectivityLevel)) {
    query = {
      ...query,
      [SELECTIVITY_LEVEL]: selectivityLevel.split(',').map(Number)
    };
  }
  if (!isUndefined(acceptanceLikelihood)) {
    query = {
      ...query,
      [ACCEPTANCE_LIKELIHOOD]: acceptanceLikelihood.split(',').map(Number)
    };
  }
  if (!isUndefined(careerMajors)) {
    query = {
      ...query,
      [MAJORS]: careerMajors.split('%2C')
    };
  }
  return Object.keys(query).length ? query : savedQuery;
};
const hasFilterParam = _ref2 => {
  let {
    minorityServingInst,
    selectivityLevel,
    acceptanceLikelihood,
    predefinedFilters,
    publicPrivate,
    religious,
    setting,
    careerMajors
  } = _ref2;
  return !isUndefined(predefinedFilters) || !isUndefined(publicPrivate) || !isUndefined(setting) || !isUndefined(religious) || !isUndefined(minorityServingInst) || !isUndefined(selectivityLevel) || !isUndefined(acceptanceLikelihood) || !isUndefined(careerMajors);
};

/**
 * This fn gets the search term from the params in the url
 * @param {string} prepopulatedNameSearch
 * @param {string} savedNameSearch
 * @param {object} props
 * @returns a string
 */
const getNameSearchParam = _ref3 => {
  let {
    prepopulatedNameSearch,
    savedNameSearch
  } = _ref3;
  return prepopulatedNameSearch || savedNameSearch || '';
};

/**
 * This fn gets the search term from the params in the url if no params are set
 * @param {string} prepopulatedNameSearch
 * @param {string} savedNameSearch
 * @param {object} props
 * @returns a string
 */
const getInitialNameSearchParam = _ref4 => {
  let {
    prepopulatedNameSearch,
    savedNameSearch,
    ...rest
  } = _ref4;
  return hasFilterParam(rest) ? '' : prepopulatedNameSearch || savedNameSearch || '';
};

const TYPES = {
  SEARCH_START: 'SEARCH_START',
  SEARCH_COMPLETE: 'SEARCH_COMPLETE',
  SEARCH_ERROR: 'SEARCH_ERROR',
  FILTER_SEARCH: 'FILTER_SEARCH',
  FILTERS_SEARCH: 'FILTERS_SEARCH',
  PAGE_SEARCH: 'PAGE_SEARCH',
  SORT_SEARCH: 'SORT_SEARCH',
  CLEAR_SEARCH: 'CLEAR_SEARCH',
  CLEAR_NAME_SEARCH: 'CLEAR_NAME_SEARCH',
  RESET_SEARCH: 'RESET_SEARCH',
  FILTER_PARAM_CHANGE: 'FILTER_PARAM_CHANGE',
  NAME_PARAM_CHANGE: 'NAME_PARAM_CHANGE',
  FILTER_NAME_SEARCH: 'FILTER_NAME_SEARCH',
  FILTERS_SEARCH_PREFORMED: 'FILTERS_SEARCH_PREFORMED'
};

const decodeString = (str) => {
    if (!str)
        return str;
    try {
        return decodeURIComponent(str);
    }
    catch (e) {
        return str;
    }
};

/**
 * This function returns an object with many of the handlers needed to work with the reducer
 * @param {func} dispatch
 * @returns
 */
const getDispatchFunctions = dispatch => {
  const getFilterSetter = field => {
    return value => {
      dispatch({
        type: TYPES.FILTER_SEARCH,
        value,
        field
      });
    };
  };
  const onFieldsChange = (fields, values, userId) => {
    dispatch({
      type: TYPES.FILTERS_SEARCH,
      fields,
      values,
      userId
    });
  };
  const getDefaultAction = type => () => {
    dispatch({
      type
    });
  };
  return {
    onSetFilters: filters => {
      dispatch({
        type: TYPES.FILTERS_SEARCH_PREFORMED,
        filters
      });
    },
    onSortChange: sort => {
      dispatch({
        type: TYPES.SORT_SEARCH,
        sort
      });
    },
    onPageChange: page => {
      dispatch({
        type: TYPES.PAGE_SEARCH,
        page
      });
    },
    onAcademicFocusMajorsChange: _ref => {
      let {
        keywords,
        majors
      } = _ref;
      onFieldsChange([ACADEMIC_FOCUS, MAJORS], [keywords, majors]);
    },
    onSelectivityChange: selectivity => {
      onFieldsChange([SELECTIVITY, ACCEPTANCE_LIKELIHOOD], [selectivity, []]);
    },
    onSelectivityLevelChange: selectivityLevel => {
      onFieldsChange([SELECTIVITY_LEVEL, SELECTIVITY, ACCEPTANCE_LIKELIHOOD], [selectivityLevel, [], []]);
    },
    onAcceptanceLikelihoodChange: acceptanceLikelihood => {
      onFieldsChange([ACCEPTANCE_LIKELIHOOD, SELECTIVITY_LEVEL, SELECTIVITY, ACT, SAT], [acceptanceLikelihood, [], [], [], []]);
    },
    onACTChange: act => {
      onFieldsChange([ACT, ACCEPTANCE_LIKELIHOOD], [act, []]);
    },
    onSATChange: sat => {
      onFieldsChange([SAT, ACCEPTANCE_LIKELIHOOD], [sat, []]);
    },
    onPresetPreferenceSelection: (preferences, userId) => {
      const fieldChanges = [PREFERENCE_SELECTION, ACADEMIC_FOCUS, MAJORS, SCHOOL_SIZE, SETTING, DEGREES, UNIV_TYPE, INTERESTS, ACCEPTANCE_LIKELIHOOD, SELECTIVITY_LEVEL, SELECTIVITY, MINORITY_SERVING, SPORTS, LOCATION, LOCATION_CATEGORY, RELIGIOUS, ROTC, STATE, COALITION_MEMBER$1, ACT, CONTROL, TEST_OPTIONAL$1, SAT, APP_METHOD, SCOIR_APPLY_APPLICANT_TYPES];
      onFieldsChange(fieldChanges, fieldChanges.map(f => {
        return preferences[f];
      }), userId);
    },
    onResetDefaults: getDefaultAction(TYPES.RESET_SEARCH),
    onClearAll: getDefaultAction(TYPES.CLEAR_SEARCH),
    onClearNameSearch: getDefaultAction(TYPES.CLEAR_NAME_SEARCH),
    onAcademicFocusChange: getFilterSetter(ACADEMIC_FOCUS),
    onApplicationMethodChange: getFilterSetter(APP_METHOD),
    onAthleticsChange: getFilterSetter(SPORTS),
    onCampusSettingChange: getFilterSetter(SETTING),
    onCoalitionMemberChange: getFilterSetter(COALITION_MEMBER$1),
    onDegreeChange: getFilterSetter(DEGREES),
    onUnivTypeChange: getFilterSetter(UNIV_TYPE),
    onLocationCategoryChange: getFilterSetter(LOCATION_CATEGORY),
    onLocationChange: getFilterSetter(LOCATION),
    onMinorityServingChange: getFilterSetter(MINORITY_SERVING),
    onPersonalInterestChange: getFilterSetter(INTERESTS),
    onReligiousChange: getFilterSetter(RELIGIOUS),
    onROTCProgramsChange: getFilterSetter(ROTC),
    onScoirApplyApplicantTypesChange: getFilterSetter(SCOIR_APPLY_APPLICANT_TYPES),
    onSchoolSizeChange: getFilterSetter(SCHOOL_SIZE),
    onSchoolTypeChange: getFilterSetter(CONTROL),
    onStateChange: getFilterSetter(STATE),
    onTestPolicyChange: getFilterSetter(TEST_OPTIONAL$1)
  };
};

const DEFAULT_FILTERS = {
  [DEGREES]: ['Bachelors'],
  [LOCATION_CATEGORY]: ['Domestic']
};
const DEFAULT_SORT = '';
const DISTANCE_SORT = 'distance';
const DEFAULT_PAGE = 1;
const scrollBackToTop = () => {
  window$1.scrollTo(0, 0);
};

/**
 * This fn provides the default values for the reducer when the page loads
 * @param {object} props
 * @returns object of initial reducer state
 */
const getInitialState = props => {
  const filters = props.preferenceSearchFilters || getFilterParam(props) || DEFAULT_FILTERS;
  const nameSearch = getInitialNameSearchParam(props);
  const page = get(props, 'page', DEFAULT_PAGE);
  const sort = get(filters, LOCATION, false) ? 'distance' : DEFAULT_SORT;
  return {
    nameSearch,
    facets: [],
    facetsObj: {},
    filters,
    colleges: [],
    sort,
    page,
    total: 0,
    loading: false,
    userId: null // used to look at another user's saved preferences matches
  };
};
const getHasValue = value => !isEmpty(value) && !isNull(value);
const handleSetValue = (draft, field, value) => {
  if (!getHasValue(value)) {
    draft.filters = omit(draft.filters, [field]);
  } else {
    draft.filters[field] = value;
  }
};
const handleImplicitDistanceSort = draft => {
  const location = get(draft.filters, LOCATION);
  const sort = get(draft, 'sort', DEFAULT_SORT);
  const hasLocation = getHasValue(location);
  const isDefaultSort = sort === DEFAULT_SORT;
  if (hasLocation && isDefaultSort) {
    draft.sort = DISTANCE_SORT;
  }
  if (!hasLocation && sort === DISTANCE_SORT) {
    draft.sort = DEFAULT_SORT;
  }
};

/**
 * This reducer maintains the state of college search
 * @param {object} state
 * @param {object} action
 * @returns a react reducer
 */
const reducer = (state, action) => {
  switch (action.type) {
    case TYPES.SEARCH_START:
      {
        return produce(state, draft => {
          draft.loading = true;
          return draft;
        });
      }
    case TYPES.SEARCH_ERROR:
      {
        return produce(state, draft => {
          draft.loading = false;
          return draft;
        });
      }
    case TYPES.SEARCH_COMPLETE:
      {
        return produce(state, draft => {
          const {
            data
          } = action;
          draft.loading = false;
          draft.colleges = data.colleges;
          draft.facets = data.facets;
          draft.facetsObj = keyBy(data.facets, 'name');
          draft.page = data.page;
          draft.total = data.total;
          return draft;
        });
      }
    case TYPES.FILTER_SEARCH:
      {
        return produce(state, draft => {
          const field = action.field;
          const value = action.value;
          handleSetValue(draft, field, value);
          handleImplicitDistanceSort(draft);
          draft.page = DEFAULT_PAGE;
          scrollBackToTop();
          return draft;
        });
      }
    case TYPES.FILTERS_SEARCH:
      {
        return produce(state, draft => {
          const fields = action.fields;
          const values = action.values;
          fields.forEach((field, idx) => {
            const value = values[idx];
            handleSetValue(draft, field, value);
          });
          handleImplicitDistanceSort(draft);
          draft.page = DEFAULT_PAGE;
          if (action.userId) {
            draft.sort = DEFAULT_SORT;
          }
          draft.userId = action.userId;
          scrollBackToTop();
          return draft;
        });
      }
    case TYPES.FILTERS_SEARCH_PREFORMED:
      {
        return produce(state, draft => {
          draft.filters = action.filters;
          draft.page = DEFAULT_PAGE;
          if (action.userId) {
            draft.sort = DEFAULT_SORT;
          }
          handleImplicitDistanceSort(draft);
          draft.userId = action.userId;
          scrollBackToTop();
          return draft;
        });
      }
    case TYPES.PAGE_SEARCH:
      {
        return produce(state, draft => {
          draft.page = get(action, 'page', 0);
          return draft;
        });
      }
    case TYPES.SORT_SEARCH:
      {
        return produce(state, draft => {
          const defaultValue = get(state.filters, LOCATION, false) ? 'distance' : DEFAULT_SORT;
          draft.sort = get(action, 'sort') || defaultValue;
          draft.page = DEFAULT_PAGE;
          scrollBackToTop();
          return draft;
        });
      }
    case TYPES.CLEAR_SEARCH:
      {
        return produce(state, draft => {
          draft.filters = {};
          draft.sort = DEFAULT_SORT;
          draft.page = DEFAULT_PAGE;
          draft.nameSearch = '';
          scrollBackToTop();
          return draft;
        });
      }
    case TYPES.RESET_SEARCH:
      {
        return produce(state, draft => {
          draft.filters = DEFAULT_FILTERS;
          draft.sort = DEFAULT_SORT;
          draft.page = DEFAULT_PAGE;
          draft.nameSearch = '';
          draft.userId = null;
          scrollBackToTop();
          return draft;
        });
      }
    case TYPES.FILTER_PARAM_CHANGE:
      {
        return produce(state, draft => {
          draft.filters = get(action, 'filters', {});
          draft.nameSearch = '';
          return draft;
        });
      }
    case TYPES.FILTER_NAME_SEARCH:
      {
        return produce(state, draft => {
          draft.filters = get(action, 'filters', {});
          draft.nameSearch = get(action, 'nameSearch', '');
          return draft;
        });
      }
    case TYPES.NAME_PARAM_CHANGE:
      {
        return produce(state, draft => {
          draft.nameSearch = decodeString(get(action, 'nameSearch', ''));
          draft.filters = {};
          return draft;
        });
      }
    case TYPES.CLEAR_NAME_SEARCH:
      {
        return produce(state, draft => {
          draft.nameSearch = '';
          return draft;
        });
      }
  }
};

let lastScrollPosition = {};

// This fn is used by the adjustScrolling fn below
const getPageParam = () => {
  const params = get(window$1, 'location.search', '');
  const page = parseInt(params.replace(new RegExp(/\??(page=)([\d]+)/gi), '$2'));
  return page;
};

// this is the hook that produces the onResetLastScrollPosition fn
const useLastScrollPosition = name => {
  const scrollPosition = useRef(0);
  const page = getPageParam();
  const lastPage = useRef(page);
  const pageChanged = useMemo(() => {
    const changed = lastPage.current !== page;
    if (changed) {
      lastPage.current = page;
    }
    return changed;
  }, [page]);
  const onResetLastScrollPosition = useCallback(() => {
    let y = pageChanged ? 0 : lastScrollPosition[name];
    if (!isNumber(y)) {
      return;
    }
    setTimeout(() => {
      window$1.scrollTo(0, y);
    }, 300);
  }, [name, pageChanged]);
  useEffect(() => {
    const fn = () => {
      if (window$1.scrollY) {
        scrollPosition.current = window$1.scrollY;
      }
    };
    window$1.addEventListener('scroll', fn);
    return () => {
      window$1.removeEventListener('scroll', fn);
      lastScrollPosition[name] = scrollPosition.current;
    };
  }, [name]);
  return onResetLastScrollPosition;
};

const Context$2 = /*#__PURE__*/React.createContext({});

const ApiContextProvider = _ref => {
  let {
    children,
    onSearch,
    ...rest
  } = _ref;
  const onResetLastScrollPosition = useLastScrollPosition();
  const onSearchWithResetScroll = useCallback((filters, params) => {
    return onSearch(filters, params).finally(() => {
      onResetLastScrollPosition();
    });
  }, [onSearch, onResetLastScrollPosition]);
  return /*#__PURE__*/React.createElement(Context$2.Provider, {
    value: {
      ...rest,
      onSearch: onSearchWithResetScroll
    }
  }, children);
};
ApiContextProvider.propTypes = {
  children: PropTypes.node,
  onSearch: PropTypes.func
};
const Context$1 = Context$2;

/** This function puts together the necessary params and payload and does an API call to search for colleges
 * @prop {object} filters
 * @prop {string} sort
 * @prop {number} page
 * @prop {string} nameSearch
 * @prop {func} onStart
 * @prop {func} onError
 * @prop {func} onComplete
 * @param {object} props
 */
const search = async _ref => {
  let {
    filters,
    sort,
    page,
    nameSearch,
    pageSize,
    onStart,
    onError,
    onComplete,
    studentId,
    onSearch
  } = _ref;
  onStart();
  try {
    let params = {
      pageSize,
      sort,
      name: nameSearch,
      from: pageSize * (page - 1),
      studentId: studentId
    };
    const searchResponse = await onSearch(filters, params);
    onComplete({
      colleges: mapData(searchResponse),
      page,
      facets: searchResponse.Facets,
      total: searchResponse.Total
    });
  } catch {
    onError();
  }
};
const saveSearch = _ref2 => {
  let {
    nameSearch,
    userId,
    preferenceSearchFilters,
    filters,
    updateSavedSearch,
    onSaveSearch
  } = _ref2;
  // If userId || preferenceSearch do not save, searching on behalf of another user
  onSaveSearch(filters, nameSearch, userId || preferenceSearchFilters).then(() => {
    updateSavedSearch(filters, nameSearch);
  }).catch(noop);
};

/**
 * This hook does the API call to search for colleges
 * @prop {object} filters
 * @prop {string} sort
 * @prop {number} page
 * @prop {string} nameSearch
 * @prop {func} onStart
 * @prop {func} onError
 * @prop {func} onComplete
 * @param {object} props
 */
const useSearch = _ref3 => {
  let {
    updateSavedSearch,
    filters,
    preferenceSearchFilters,
    sort,
    page,
    pageSize,
    nameSearch,
    userId,
    onStart,
    onError,
    onComplete
  } = _ref3;
  const {
    onSaveSearch,
    onSearch,
    studentId
  } = useContext(Context$1);
  useEffect(() => {
    saveSearch({
      nameSearch,
      userId,
      preferenceSearchFilters,
      filters,
      updateSavedSearch,
      onSaveSearch
    });
    search({
      filters,
      sort,
      page,
      nameSearch,
      pageSize,
      onStart,
      onError,
      onComplete,
      onSearch,
      studentId
    });
  }, [updateSavedSearch, filters, sort, page, nameSearch, userId, pageSize, onStart, onError, onComplete, onSearch, onSaveSearch, preferenceSearchFilters, studentId]);
};

/**
 * This is a list of terms that the UI does not show to the user.
 */
const IGNORED_TERMS = {
  'CoalitionMember': ['F'],
  'TestOptional': ['F'],
  'ScoirApplyApplicantTypes': ['transfer']
};
const getFacetCounts = facets => {
  return reduce(facets, (facetCounts, facet) => {
    const ignoredTerms = get(IGNORED_TERMS, facet.name, []);
    const terms = filter(facet.terms, term => {
      return !includes(ignoredTerms, term.term);
    });
    const facetSize = size(terms);
    return {
      ...facetCounts,
      [facet.name]: facetSize
    };
  }, {});
};

/**
 * This hook takes in an object of facets and fetches the full list of facets when it initializes
 * Then as the facets change, the function returned can be used to figure out by facetname if certain filters aren't available
 * @param {object} facets
 * @returns function
 */
const useHasHiddenFacets = facets => {
  const [allFacetCounts, setAllFacetCounts] = useState({});
  const currentFacetCounts = useMemo(() => getFacetCounts(facets), [facets]);
  const {
    onSearch
  } = useContext(Context$1);
  const hasHiddenFacets = useCallback(facetNames => {
    return reduce(facetNames, (answer, facetName) => {
      const currentCount = get(currentFacetCounts, facetName, 0);
      const totalCount = get(allFacetCounts, facetName, 0);
      if (currentCount < totalCount) {
        return true;
      }
      return answer;
    }, false);
  }, [currentFacetCounts, allFacetCounts]);
  useEffect(() => {
    search({
      filters: {},
      sort: '',
      page: 1,
      pageSize: 25,
      nameSearch: '',
      onStart: noop,
      onComplete: _ref => {
        let {
          facets
        } = _ref;
        setAllFacetCounts(getFacetCounts(facets));
      },
      onError: noop,
      onSearch: onSearch
    });
  }, [onSearch]);
  return hasHiddenFacets;
};

const FIELD_NAMES = {
  PREDEFINED_FILTERS: 'predefinedFilters',
  PUBLIC_PRIVATE: 'publicPrivate',
  SETTING: 'setting',
  RELIGIOUS: 'religious',
  MINORITY_SERVING_INST: 'minorityServingInst',
  CAREER_MAJORS: 'careerMajors',
  ACCEPTANCE_LIKELIHOOD: 'acceptanceLikelihood',
  SELECTIVITY_LEVEL: 'selectivityLevel'
};
const QUERY_PARAM_FIELDS = Object.values(FIELD_NAMES);
const getUsedQueryParamsCleared = filterSearchProps => {
  const queryParamsToClear = {};
  QUERY_PARAM_FIELDS.forEach(field => {
    if (filterSearchProps[field]) {
      queryParamsToClear[field] = '';
    }
  });
  return queryParamsToClear;
};
const getAllQueryParams = filterSearchProps => {
  const queryParams = {};
  QUERY_PARAM_FIELDS.forEach(field => {
    if (filterSearchProps[field]) {
      queryParams[field] = filterSearchProps[field];
    }
  });
  return queryParams;
};
const useQueryParam = (filterSearchProps, queryParam) => {
  return useMemo(() => filterSearchProps[queryParam], [filterSearchProps, queryParam]);
};
const useFilters = filterSearchProps => {
  return useMemo(() => {
    return getFilterParam(getAllQueryParams(filterSearchProps));
  }, [filterSearchProps]);
};
const useFilterParamsChange = (dispatch, onChangeUrlQueryParams, filterSearchProps) => {
  const predefinedFilters = useQueryParam(filterSearchProps, FIELD_NAMES.PREDEFINED_FILTERS);
  const filters = useFilters(filterSearchProps);
  const [previous, setPrevious] = useState(JSON.stringify(filters) || '');
  const [clearing, setClearing] = useState(false);
  const shouldUpdate = useMemo(() => {
    return filters && JSON.stringify(filters) !== previous;
  }, [previous, filters]);
  const onClearFilterParams = useCallback(() => {
    const queryParamsToClear = getUsedQueryParamsCleared(filterSearchProps);
    onChangeUrlQueryParams(queryParamsToClear);
    setClearing(true);
  }, [onChangeUrlQueryParams, filterSearchProps]);
  const update = useCallback(() => {
    dispatch({
      type: TYPES.FILTER_PARAM_CHANGE,
      filters
    });
    setPrevious(JSON.stringify(filters));
    onClearFilterParams();
  }, [dispatch, onClearFilterParams, filters]);
  useEffect(() => {
    if (clearing) {
      setClearing(false);
    } else if (shouldUpdate) {
      update();
    }
  }, [clearing, shouldUpdate, update]);
  const startedWithSomething = useRef(!isEmpty(filters) || !isEmpty(predefinedFilters));
  useEffect(() => {
    if (startedWithSomething.current) {
      onClearFilterParams();
    }
  }, [onClearFilterParams]);
};

const useNameParamsChange = (dispatch, onChangeUrlQueryParams, prepopulatedNameSearch) => {
  const [previous, setPrevious] = useState("");
  const nameSearch = useMemo(() => {
    if (!prepopulatedNameSearch) {
      return previous;
    }
    return getNameSearchParam({
      prepopulatedNameSearch
    });
  }, [prepopulatedNameSearch, previous]);
  const onClearParams = useCallback(() => {
    onChangeUrlQueryParams({
      prepopulatedNameSearch: ''
    });
  }, [onChangeUrlQueryParams]);
  useEffect(() => {
    const hasPrevious = !isEmpty(previous);
    const hasName = !isEmpty(nameSearch);
    const hasChanged = previous !== nameSearch;
    const isReplacingName = hasPrevious && hasName && hasChanged;
    const isAddingName = !hasPrevious && hasName;
    const isRemovingName = !hasName && hasPrevious;
    if (isAddingName || isRemovingName || isReplacingName) {
      dispatch({
        type: TYPES.NAME_PARAM_CHANGE,
        nameSearch
      });
      setPrevious(nameSearch);
      onClearParams();
    }
  }, [nameSearch, previous, dispatch, onClearParams]);
  const startedWithSomething = useRef(!isEmpty(nameSearch));
  useEffect(() => {
    if (startedWithSomething.current) {
      onClearParams();
    }
  }, [onClearParams]);
  useEffect(() => {
    if (previous && !prepopulatedNameSearch) {
      setPrevious('');
    }
  }, [previous, prepopulatedNameSearch]);
};

const getFilter = (filters, FIELD_NAME) => {
  return get(filters, FIELD_NAME, []);
};
const onlyTrue = arr => filter(arr, v => v === 'T');
const getAcademicFocusCount = filters => {
  const a = getFilter(filters, ACADEMIC_FOCUS);
  const b = getFilter(filters, MAJORS);
  return some([!isEmpty(a), !isEmpty(b)]);
};
const getDegreesCount = filters => {
  const a = getFilter(filters, DEGREES);
  return !isEmpty(a);
};
const getSchoolSizeCount = filters => {
  const a = getFilter(filters, SCHOOL_SIZE);
  return !isEmpty(a);
};
const getSettingCount = filters => {
  const a = getFilter(filters, SETTING);
  return !isEmpty(a);
};
const getDistanceCount = filters => {
  const a = getFilter(filters, LOCATION);
  return !isEmpty(a);
};
const getLocationCount = filters => {
  const a = getFilter(filters, LOCATION_CATEGORY);
  const b = getFilter(filters, STATE);
  return some([!isEmpty(a), !isEmpty(b)]);
};
const getAdmissionsCount = filters => {
  const a = getFilter(filters, SELECTIVITY);
  const aa = getFilter(filters, SELECTIVITY_LEVEL);
  const aaa = getFilter(filters, ACCEPTANCE_LIKELIHOOD);
  const b = onlyTrue(getFilter(filters, TEST_OPTIONAL$1));
  const c = getFilter(filters, SAT);
  const d = getFilter(filters, ACT);
  return some([!isEmpty(a), !isEmpty(aa), !isEmpty(aaa), !isEmpty(b), !isEmpty(c), !isEmpty(d)]);
};
const getApplicationMethodCount = filters => {
  const a = getFilter(filters, SCOIR_APPLY_APPLICANT_TYPES);
  const b = getFilter(filters, APP_METHOD);
  return some([!isEmpty(a), !isEmpty(b)]);
};
const getSchoolTypeCount = filters => {
  const a = getFilter(filters, CONTROL);
  const b = getFilter(filters, RELIGIOUS);
  const c = onlyTrue(getFilter(filters, COALITION_MEMBER$1));
  const d = getFilter(filters, MINORITY_SERVING);
  return some([!isEmpty(a), !isEmpty(b), !isEmpty(c), !isEmpty(d)]);
};
const getAthleticsCount = filters => {
  const a = getFilter(filters, SPORTS);
  return !isEmpty(a);
};
const getPersonalInterestCount = filters => {
  const a = getFilter(filters, INTERESTS);
  return !isEmpty(a);
};
const getRotcCount = filters => {
  const a = getFilter(filters, ROTC);
  return !isEmpty(a);
};
const getAppliedFiltersCount = filters => {
  const arr = [getAcademicFocusCount(filters), getDegreesCount(filters), getSchoolSizeCount(filters), getSettingCount(filters), getDistanceCount(filters), getLocationCount(filters), getAdmissionsCount(filters), getApplicationMethodCount(filters), getSchoolTypeCount(filters), getAthleticsCount(filters), getPersonalInterestCount(filters), getRotcCount(filters)];
  return reduce(arr, (sum, x) => {
    return x ? sum + 1 : sum;
  }, 0);
};

const PAGE_SIZE = 25;

/**
 * This component is designed to wrap around the entire search
 * page and act as the data-managing brain for all the query
 * params and filters for searching
 * @prop {node} children
 * @prop {func} onAddSnack
 * @prop {func} updateSavedSearch
 * @prop {func} onChangeUrlQueryParams
 * @param {object} props
 * @returns SearchContextProvider component
 */
const SearchContextProvider = _ref => {
  let {
    children,
    onAddSnack,
    updateSavedSearch,
    onChangeUrlQueryParams,
    prepopulatedNameSearch,
    predefinedFilters,
    publicPrivate,
    setting,
    religious,
    minorityServingInst,
    selectivityLevel,
    acceptanceLikelihood,
    careerMajors,
    page: pageParam,
    savedQuery,
    savedNameSearch,
    displayScoirApplyIcon,
    preferenceSearchFilters,
    tntSearchFilterEnabled
  } = _ref;
  const filterSearchProps = useMemo(() => {
    return {
      prepopulatedNameSearch: decodeString(prepopulatedNameSearch),
      predefinedFilters,
      publicPrivate,
      setting,
      religious,
      minorityServingInst,
      selectivityLevel,
      acceptanceLikelihood,
      careerMajors,
      savedQuery,
      savedNameSearch: decodeString(savedNameSearch),
      page: pageParam,
      preferenceSearchFilters
    };
  }, [prepopulatedNameSearch, predefinedFilters, publicPrivate, setting, religious, minorityServingInst, selectivityLevel, acceptanceLikelihood, careerMajors, savedQuery, savedNameSearch, pageParam, preferenceSearchFilters]);
  const initialState = useMemo(() => {
    return getInitialState(filterSearchProps);
  }, [filterSearchProps]);
  const [{
    filters,
    colleges,
    sort,
    facets,
    facetsObj,
    total,
    page,
    nameSearch,
    userId,
    loading
  }, dispatch] = useReducer(reducer, initialState);
  const hasHiddenFacets = useHasHiddenFacets(facets);
  const onStart = useCallback(() => {
    dispatch({
      type: TYPES.SEARCH_START
    });
  }, []);
  const onSetFiltersAndName = useCallback(_ref2 => {
    let {
      filters,
      nameSearch
    } = _ref2;
    dispatch({
      type: TYPES.FILTER_NAME_SEARCH,
      filters,
      nameSearch
    });
  }, []);
  const onComplete = useCallback(data => {
    dispatch({
      type: TYPES.SEARCH_COMPLETE,
      data
    });
    onChangeUrlQueryParams({
      page: data.page
    });
  }, [onChangeUrlQueryParams]);
  const onError = useCallback(() => {
    dispatch({
      type: TYPES.SEARCH_ERROR
    });
    onAddSnack('College search failed to load');
  }, [onAddSnack]);
  const dispatchFunctions = useMemo(() => {
    return getDispatchFunctions(dispatch);
  }, []);
  useFilterParamsChange(dispatch, onChangeUrlQueryParams, filterSearchProps);
  useNameParamsChange(dispatch, onChangeUrlQueryParams, prepopulatedNameSearch);
  useSearch({
    updateSavedSearch,
    filters,
    preferenceSearchFilters,
    sort,
    page,
    nameSearch,
    userId,
    pageSize: PAGE_SIZE,
    onStart,
    onComplete,
    onError
  });
  const appliedFilterCount = useMemo(() => {
    return getAppliedFiltersCount(filters);
  }, [filters]);
  return /*#__PURE__*/React.createElement(Context$3.Provider, {
    value: {
      filters,
      userId,
      colleges,
      sort,
      facets,
      facetsObj,
      page,
      total,
      nameSearch,
      loading,
      appliedFilterCount,
      ...dispatchFunctions,
      displayScoirApplyIcon,
      pageSize: PAGE_SIZE,
      hasHiddenFacets,
      onSetFiltersAndName,
      tntSearchFilterEnabled
    }
  }, children);
};
SearchContextProvider.propTypes = {
  children: PropTypes.node,
  prepopulatedNameSearch: PropTypes.string,
  predefinedFilters: PropTypes.string,
  publicPrivate: PropTypes.string,
  setting: PropTypes.string,
  religious: PropTypes.string,
  minorityServingInst: PropTypes.string,
  careerMajors: PropTypes.string,
  savedQuery: PropTypes.object,
  savedNameSearch: PropTypes.string,
  page: PropTypes.number,
  updateSavedSearch: PropTypes.func,
  onAddSnack: PropTypes.func,
  onChangeUrlQueryParams: PropTypes.func,
  displayScoirApplyIcon: PropTypes.elementType,
  shouldUseSavedQueryAndNameChange: PropTypes.bool,
  preferenceSearchFilters: PropTypes.object,
  collegeMatchLevel: PropTypes.number,
  selectivityLevel: PropTypes.string,
  acceptanceLikelihood: PropTypes.string,
  tntSearchFilterEnabled: PropTypes.bool
};
const Context = Context$3;

const preferenceOptionsStyles = makeStyles(theme => ({
  iconWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    paddingRight: theme.spacing(1),
    cursor: 'pointer'
  },
  button: {
    minWidth: 'auto'
  },
  avatar: {
    backgroundColor: '#0A6BB8',
    color: 'white'
  },
  hasNoPreferences: {
    opacity: 0.5,
    cursor: 'auto'
  }
}));

/**
 * These are passed in icons for selecting pre-set preferences
 * @prop {array} preferenceOptions
 * @returns PreferenceOptions Component
 */
const PreferenceOptions = _ref => {
  let {
    preferenceOptions,
    setSelectedUserId
  } = _ref;
  const classes = preferenceOptionsStyles();
  const {
    onPresetPreferenceSelection
  } = useContext(Context);
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.iconWrapper
  }, preferenceOptions && preferenceOptions.map((prefObject, i) => {
    const {
      preferences,
      imageURL,
      name,
      tooltip,
      userId,
      disabled
    } = prefObject;
    return /*#__PURE__*/React.createElement(Tooltip, {
      arrow: true,
      key: i,
      title: tooltip || ''
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Button, {
      disabled: disabled,
      className: cn(classes.button, {
        [classes.hasNoPreferences]: disabled
      }),
      onClick: () => {
        if (setSelectedUserId) setSelectedUserId(userId);
        if (preferences) {
          onPresetPreferenceSelection(preferences, userId);
        }
      }
    }, /*#__PURE__*/React.createElement(Avatar, {
      className: classes.avatar,
      sourceUrl: imageURL && imageURL,
      fallbackIcon: head(name),
      variant: "circular",
      size: "xs",
      "aria-label": `${name} Avatar`
    }))));
  }));
};
PreferenceOptions.propTypes = {
  preferenceOptions: PropTypes.array,
  setSelectedUserId: PropTypes.func
};

/* istanbul ignore file */
const {
  Body: Body$2,
  Footer: Footer$2
} = DismissibleDialog;
const useStyles$4 = makeStyles(theme => {
  const xs = theme.breakpoints.down('xs');
  return {
    modal: {
      maxWidth: '640px',
      [xs]: {
        maxWidth: '100%',
        width: '100vw',
        height: '100vh',
        margin: 0
      }
    },
    body: {
      maxHeight: 'calc(100vh - 250px)',
      padding: theme.spacing(1, 3, 1, 1),
      [xs]: {
        padding: theme.spacing(0, 2, 0, 0),
        minHeight: 'calc(100vh - 140px)',
        maxHeight: 'calc(100vh - 140px)'
      },
      '&:first-child': {
        paddingTop: theme.spacing(1),
        [xs]: {
          paddingTop: theme.spacing(0)
        }
      }
    }
  };
});
const PreferenceModal = _ref => {
  let {
    onClose,
    open = false,
    preferencesComponent,
    name
  } = _ref;
  const classes = useStyles$4();
  return /*#__PURE__*/React.createElement(DismissibleDialog, {
    classes: {
      paperScrollBody: classes.modal
    },
    style: {
      zIndex: '19001'
    },
    open: open,
    onClose: onClose,
    headerText: `${name}'s Preferences`
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(Body$2, {
    classes: {
      root: classes.body
    }
  }, preferencesComponent)), /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(Footer$2, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    color: "primary",
    variant: "contained"
  }, "Close"))));
};
PreferenceModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  preferencesComponent: PropTypes.element,
  name: PropTypes.string
};

var FilterBarWithSortContext = /*#__PURE__*/React.createContext({});

const SelectorsComposition = ({ tntSearchFilterEnabled }) => {
    return (jsxs(Box$1, Object.assign({ mt: 2 }, { children: [jsx(Section, Object.assign({ title: DISPLAY_TEXT.AcademicFocus.Title, subTitle: DISPLAY_TEXT.AcademicFocus.Description }, { children: jsx(AcademicFocus, {}) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.Degrees.Title }, { children: jsx(DegreesSelector, { tntSearchFilterEnabled: tntSearchFilterEnabled }) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.UnderGradEnroll.Title, subTitle: DISPLAY_TEXT.UnderGradEnroll.Description }, { children: jsx(SchoolSizeSelector, {}) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.Setting.Title }, { children: jsx(SettingSelector, {}) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.Distance.Title }, { children: jsx(DistanceSelector, { addFirstButtonLabel: "Add Filter", disableRepitition: true }) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.Location.Title }, { children: jsx(LocationSelector, {}) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.Admissions.Title }, { children: jsx(AdmissionsSelector, {}) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.ApplicationMethod.Title }, { children: jsx(ApplicationMethodSelector, {}) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.SchoolType.Title }, { children: jsx(SchoolType, {}) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.Sports.Title }, { children: jsx(AthleticsSelector, { addFirstButtonLabel: "Add Filter", disableRepitition: true }) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.Tags.Title }, { children: jsx(PersonalInterest, {}) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.Rotc.Title, subTitle: DISPLAY_TEXT.Rotc.Description }, { children: jsx(Rotc, {}) }))] })));
};
const SelectorsProvider = ({ children }) => {
    const { filters, facets, onSetFilters, displayScoirApplyIcon } = useContext(Context);
    const { supportsAcceptanceLikelihoodFilters, acceptanceLikelihoodLabels, collegeMatchLevel, selectivityLabels } = useContext(FilterBarWithSortContext);
    const apiCalls = useContext(Context$1);
    return (jsx(SelectorContextProvider, Object.assign({ data: filters, facets: facets, onUpdateData: onSetFilters, apiCalls: {
            [API_CALL_NAMES.onAcademicMajorsSearch]: apiCalls.onAcademicMajorsSearch,
            [API_CALL_NAMES.onAcademicFocusesKeywordSearch]: apiCalls.onAcademicFocusesKeywordSearch,
            [API_CALL_NAMES.onLocationSearch]: apiCalls.onLocationSearch,
            [API_CALL_NAMES.onTagsSearch]: apiCalls.onPersonalInterestSearch,
            [API_CALL_NAMES.onAllTagsSearch]: apiCalls.onAllPersonalInterests,
            [API_CALL_NAMES.onSportSearch]: apiCalls.onSportSearch,
        }, displayScoirApplyIcon: displayScoirApplyIcon, acceptanceLikelihoodLabels: acceptanceLikelihoodLabels, collegeMatchLevel: collegeMatchLevel, selectivityLabels: selectivityLabels, supportsAcceptanceLikelihoodFilters: supportsAcceptanceLikelihoodFilters }, { children: children })));
};
const Dropdowns = ({ tntSearchFilterEnabled }) => {
    return (jsxs(Fragment$1, { children: [jsx(AcademicFocus.Dropdown, {}), jsx(DegreesSelector.Dropdown, { tntSearchFilterEnabled: tntSearchFilterEnabled }), jsx(LocationSelector.Dropdown, {}), jsx(SchoolSizeSelector.Dropdown, {}), jsx(SettingSelector.Dropdown, {})] }));
};

const {
  Body: Body$1,
  Footer: Footer$1
} = DismissibleDialog;
const useStyles$3 = makeStyles(theme => {
  const xs = theme.breakpoints.down('xs');
  return {
    modal: {
      maxWidth: '640px',
      [xs]: {
        maxWidth: '100%',
        width: '100vw',
        height: '100vh',
        margin: 0
      }
    },
    body: {
      maxHeight: 'calc(100vh - 250px)',
      padding: `${theme.spacing(1)}px ${theme.spacing(3)}px`,
      [xs]: {
        padding: `${theme.spacing(0)}px ${theme.spacing(2)}px`,
        maxHeight: 'calc(100vh - 140px)'
      },
      '&:first-child': {
        paddingTop: theme.spacing(1),
        [xs]: {
          paddingTop: theme.spacing(0)
        }
      }
    }
  };
});
const Modal = _ref => {
  let {
    onClose,
    open = false,
    tntSearchFilterEnabled
  } = _ref;
  const classes = useStyles$3();
  const {
    total,
    onClearAll
  } = useContext(Context);
  return /*#__PURE__*/React.createElement(DismissibleDialog, {
    classes: {
      paperScrollBody: classes.modal
    },
    style: {
      zIndex: '19001'
    },
    open: open,
    onClose: onClose,
    headerText: "Filters"
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(Body$1, {
    classes: {
      root: classes.body
    },
    withBackgroundColor: true
  }, /*#__PURE__*/React.createElement(SelectorsComposition, {
    tntSearchFilterEnabled: tntSearchFilterEnabled
  }))), /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(Footer$1, null, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "space-between",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClearAll,
    color: "primary"
  }, "Clear All"), /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    color: "primary",
    variant: "contained"
  }, "Show ", total, " College", total === 1 ? '' : 's')))));
};
Modal.propTypes = {
  open: PropTypes.bool,
  tntSearchFilterEnabled: PropTypes.bool,
  onClose: PropTypes.func.isRequired
};

function pluralize(term) {
  let number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return `${term}${number === 1 ? '' : 's'}`;
}
const AllFilters = () => {
  const {
    open,
    onOpen,
    onClose
  } = useOpenClose();
  const ctx = useContext(Context);
  const appliedFilterCount = get(ctx, 'appliedFilterCount', 0);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onOpen,
    color: "primary",
    id: "college-search-filter-bar-all-filters",
    "aria-label": `All Filters ${appliedFilterCount} ${pluralize('filter', appliedFilterCount)} selected`
  }, /*#__PURE__*/React.createElement(Badge, {
    color: "primary",
    overlap: "rectangular",
    badgeContent: appliedFilterCount
  }, /*#__PURE__*/React.createElement(Box, {
    mr: appliedFilterCount > 0 ? 1 : 0
  }, "All Filters"))), /*#__PURE__*/React.createElement(Modal, {
    onClose: onClose,
    open: open,
    tntSearchFilterEnabled: ctx.tntSearchFilterEnabled
  }));
};

const options = [{
  value: '',
  label: 'Relevance'
}, {
  value: 'Selectivity',
  label: 'Acceptance Rate: 1-100%'
}, {
  value: '-Selectivity',
  label: 'Acceptance Rate: 100-1%'
}, {
  value: '-UnderGradEnroll',
  label: 'Size: Biggest to Smallest'
}, {
  value: 'UnderGradEnroll',
  label: 'Size: Smallest to Biggest'
}, {
  value: 'OutStateSticker',
  label: 'List Price: Lowest to Highest',
  role: 'Parent'
}, {
  value: '-OutStateSticker',
  label: 'List Price: Highest to Lowest',
  role: 'Parent'
}];
const optionsObj = keyBy(options, 'value');
const Sort = _ref => {
  let {
    userRole
  } = _ref;
  const anchorEl = useRef();
  const {
    sort,
    onSortChange
  } = useContext(Context);
  const {
    open,
    onOpen,
    onClose
  } = useOpenClose(false);
  const selectedLabel = get(optionsObj, sort, optionsObj['']).label;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "flex-end",
    maxHeight: "42px",
    mr: 2
  }, /*#__PURE__*/React.createElement(Button, {
    id: 'college-search-sort-btn',
    "aria-controls": "search-sort-menu",
    "aria-haspopup": "true",
    "aria-label": "Sort college search results",
    size: "large",
    color: "primary",
    ref: anchorEl,
    onClick: onOpen,
    startIcon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faSort
    })
  }, selectedLabel), /*#__PURE__*/React.createElement(Box, {
    position: "fixed",
    zIndex: "12"
  }, /*#__PURE__*/React.createElement(Backdrop, {
    onClick: onClose,
    open: open,
    invisible: true
  }, /*#__PURE__*/React.createElement(Menu, {
    id: "search-sort-menu",
    anchorEl: anchorEl.current,
    keepMounted: true,
    open: open,
    onClose: onClose,
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, options.map((_ref2, index) => {
    let {
      label,
      value,
      role
    } = _ref2;
    if (role === userRole || role === undefined) {
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: index,
        "aria-label": `Sort by: ${label}`,
        selected: label === selectedLabel,
        onClick: () => {
          onSortChange(value);
        }
      }, label);
    }
  })))));
};
Sort.propTypes = {
  userRole: PropTypes.string
};

const useStyles$2 = makeStyles(theme => ({
  subContent: {
    marginTop: '100px'
  },
  pageContent: {
    zIndex: 2,
    position: 'relative'
  },
  scrollable: {
    overflowX: 'auto',
    overflowY: 'hidden',
    width: '100%',
    display: 'flex',
    whiteSpace: 'nowrap'
  },
  toolbar: {
    padding: theme.spacing(2)
  },
  preferenceBar: {
    display: 'flex',
    flexDirection: 'row',
    alignitems: 'center',
    gap: theme.spacing(2)
  },
  preferenceButtonContent: {
    display: 'flex',
    flexDirection: 'row',
    alignitems: 'center',
    gap: theme.spacing(1)
  },
  avatar: {
    backgroundColor: '#0A6BB8',
    color: 'white'
  },
  filterButton: {
    alignItems: 'center',
    borderColor: 'rgba(0, 125, 170, 0.5)',
    borderWidth: 1,
    '&:hover': {
      borderWidth: 1,
      borderColor: theme.palette.primary.main,
      background: 'rgba(0, 125, 170, 0.08)'
    }
  },
  icon: {
    fontSize: '16px'
  },
  iconButton: {
    padding: theme.spacing(0.5)
  }
}));

/**
 * The horizontal filter bar at the top of the search page.
 * It allows for filtering on the new and previous search filters.
 * @returns FilterBar component
 */

const FilterBarWithSort = _ref => {
  let {
    marginTop,
    verticalNavOffset,
    selectedUserId,
    handleReset,
    handleMyPreferences,
    updateMyPreferences,
    handleMyPreferencesUpdate,
    setSelectedUserId,
    savedSearch,
    preferenceOptions,
    userRole,
    supportsAcceptanceLikelihoodFilters = false,
    acceptanceLikelihoodLabels = {},
    selectivityLabels = {},
    collegeMatchLevel,
    tntSearchFilterEnabled,
    clearedOnBehalfOf = false
  } = _ref;
  const classes = useStyles$2();
  const containerRef = React.useRef(null);
  const {
    userId,
    onPresetPreferenceSelection
  } = useContext(Context);
  const [prefModalOpen, setPrefModalOpen] = useState(false);

  // Find the selected user, if one is selected
  const selectedUser = preferenceOptions?.find(p => p.userId === selectedUserId || p.userId === userId);
  const isCurrentUser = selectedUser?.role && selectedUser?.role === CURRENT_USER;
  const hasPreferences = selectedUser?.preferences && Object.keys(selectedUser?.preferences).length > 0;
  useEffect(() => {
    const preset = async () => {
      await onPresetPreferenceSelection(selectedUser?.preferences, selectedUserId);
    };
    if (selectedUserId && selectedUserId !== userId) {
      // If the selected user is not the currently selected user, preset the preference search
      preset();
    }
    if (
    // If the selected user's preferences have changes, preset the preference search
    selectedUserId === userId && updateMyPreferences) {
      preset();
      handleMyPreferencesUpdate();
    }
  }, [selectedUserId, selectedUser?.preferences, onPresetPreferenceSelection, userId, updateMyPreferences, handleMyPreferencesUpdate]);
  useEffect(() => {
    // If the user is searching on behalf of a student, and clears the student context
    // Reset the search to the saved search of the current user
    if (clearedOnBehalfOf) {
      onPresetPreferenceSelection(savedSearch || {}, null);
    }
  }, [clearedOnBehalfOf, onPresetPreferenceSelection, savedSearch]);
  return /*#__PURE__*/React.createElement(Box, {
    ref: containerRef,
    className: classes.pageContent
  }, /*#__PURE__*/React.createElement(FilterBarWithSortContext.Provider, {
    value: {
      supportsAcceptanceLikelihoodFilters,
      acceptanceLikelihoodLabels,
      collegeMatchLevel,
      selectivityLabels
    }
  }, /*#__PURE__*/React.createElement(ScrollHideAppBar, {
    marginTop: marginTop,
    appBarProps: {
      variant: 'outlined',
      color: 'inherit',
      'aria-label': 'Search Filter Bar'
    },
    slideProps: {
      appear: false
    }
  }, /*#__PURE__*/React.createElement(Box, {
    key: verticalNavOffset,
    className: classes.scrollable,
    paddingLeft: verticalNavOffset ? `${verticalNavOffset}px` : undefined
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center"
  }, !userId ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Toolbar, {
    className: classes.toolbar
  }, /*#__PURE__*/React.createElement(PreferenceOptions, {
    preferenceOptions: preferenceOptions,
    setSelectedUserId: setSelectedUserId
  }), /*#__PURE__*/React.createElement(SelectorsProvider, null, /*#__PURE__*/React.createElement(Dropdowns, {
    tntSearchFilterEnabled: tntSearchFilterEnabled
  }), /*#__PURE__*/React.createElement(AllFilters, null))), /*#__PURE__*/React.createElement(Sort, {
    userRole: userRole
  })) : /*#__PURE__*/React.createElement(Toolbar, {
    className: classes.toolbar
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.preferenceBar
  }, /*#__PURE__*/React.createElement(Button, {
    className: classes.filterButton,
    color: "primary",
    onClick: () => {
      if (handleReset) handleReset();
      onPresetPreferenceSelection(savedSearch || {}, null);
    },
    variant: "outlined",
    endIcon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      color: "inherit",
      className: classes.icon,
      icon: faTimes$1
    })
  }, /*#__PURE__*/React.createElement(Box, {
    className: classes.preferenceButtonContent
  }, /*#__PURE__*/React.createElement(Avatar, {
    className: classes.avatar,
    sourceUrl: selectedUser?.imageURL,
    fallbackIcon: selectedUser?.name?.charAt(0),
    variant: "circular",
    size: "xs",
    "aria-label": `${selectedUser?.name}'s Avatar`
  }), isCurrentUser ? 'My Matches' : `${selectedUser?.name}'s Matches`)), hasPreferences && /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      if (handleMyPreferences && isCurrentUser) {
        handleMyPreferences();
      } else {
        setPrefModalOpen(true);
      }
    },
    color: "primary",
    id: "college-search-filter-bar-all-filters",
    startIcon: isCurrentUser && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faUserEdit
    })
  }, /*#__PURE__*/React.createElement(Box, null, isCurrentUser ? 'Edit Preferences' : `${selectedUser?.name}'s Preferences`))))), isCurrentUser ? null : /*#__PURE__*/React.createElement(PreferenceModal, {
    open: prefModalOpen,
    preferencesComponent: selectedUser?.preferencesComponent,
    name: selectedUser?.name,
    onClose: () => {
      setPrefModalOpen(false);
    }
  })))));
};
FilterBarWithSort.propTypes = {
  marginTop: PropTypes.number,
  selectedUserId: PropTypes.string,
  handleReset: PropTypes.func,
  handleMyPreferences: PropTypes.func,
  updateMyPreferences: PropTypes.bool,
  handleMyPreferencesUpdate: PropTypes.func,
  setSelectedUserId: PropTypes.func,
  savedSearch: PropTypes.object,
  preferenceOptions: PropTypes.any,
  verticalNavOffset: PropTypes.number,
  userRole: PropTypes.string,
  supportsAcceptanceLikelihoodFilters: PropTypes.bool,
  acceptanceLikelihoodLabels: PropTypes.object,
  selectivityLabels: PropTypes.object,
  collegeMatchLevel: PropTypes.number,
  tntSearchFilterEnabled: PropTypes.bool,
  clearedOnBehalfOf: PropTypes.bool
};

/**
 *
 * @returns EmptyState component
 */
const EmptyState = () => {
  const {
    onClearAll
  } = useContext(Context);
  return /*#__PURE__*/React.createElement(EmptyStateWithAction, {
    title: "No matches found",
    subTitle: "Try removing some filters to expand your search",
    icon: faTelescope,
    actionProps: {
      onClick: () => onClearAll(),
      "aria-label": 'Clear search filters',
      children: 'Clear All Filters'
    }
  });
};

const useStyles$1 = makeStyles({
  backdrop: {
    background: 'rgba(255,255,255,0.5)'
  }
});

/**
 * This component displays a white backdrop and loading indicator
 * @param {object} props
 * @returns Loading scrim
 */
const LoadingState = _ref => {
  let {
    loading = false
  } = _ref;
  const classes = useStyles$1();
  return /*#__PURE__*/React.createElement(Box, {
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 1
  }, /*#__PURE__*/React.createElement(Backdrop, {
    className: classes.backdrop,
    open: loading,
    title: "loading..."
  }, /*#__PURE__*/React.createElement(Box, {
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(CircularProgress, null))));
};
LoadingState.propTypes = {
  loading: PropTypes.bool
};

/**
 * This component is the meat of the new college search page. It provides the search results in an infinite scroll.
 * @prop {node} children
 * @prop {func} onPageChange
 * @prop {arrayOf} colleges
 * @prop {number} total
 * @prop {bool} loading
 * @prop {func} resultTileComponent
 * @returns Results component
 */
const Results = _ref => {
  let {
    resultTileComponent: ResultTile,
    altEmptyStateComponent
  } = _ref;
  const {
    onPageChange,
    colleges,
    total,
    loading,
    pageSize,
    page
  } = useContext(Context);
  return /*#__PURE__*/React.createElement("div", null, total ? colleges.map((college, idx) => {
    return /*#__PURE__*/React.createElement(ResultTile, {
      key: idx,
      college: college,
      index: idx
    });
  }) : !loading ? altEmptyStateComponent || /*#__PURE__*/React.createElement(EmptyState, null) : null, /*#__PURE__*/React.createElement(LoadingState, {
    loading: loading
  }), /*#__PURE__*/React.createElement(Box, {
    p: 2,
    pb: 4,
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Pagination, {
    page: page,
    count: Math.ceil(total / pageSize),
    onChange: (e, page) => {
      onPageChange(page);
    },
    showFirstButton: true,
    showLastButton: true,
    disabled: loading || total <= pageSize
  })));
};
Results.propTypes = {
  resultTileComponent: PropTypes.elementType,
  altEmptyStateComponent: PropTypes.node
};

const BoundPreferenceList = withBindings(PreferenceList$1);
class CollegePreferences extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    titleComponentType: PropTypes.string,
    forceSingleColumn: PropTypes.bool
  };
  static defaultProps = {
    titleComponentType: 'div',
    forceSingleColumn: false
  };
  render() {
    const {
      className,
      forceSingleColumn
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: cn('cpref-college-preference-comp', className)
    }, /*#__PURE__*/React.createElement(BoundPreferenceList, {
      forceSingleColumn: forceSingleColumn
    }));
  }
}
var CollegePreferences$1 = withDataTransformation(CollegePreferences);

const BoundPreferenceSelectorModal = withBindings(PreferenceSelectorModal);
const TransformedModal = withDataTransformation(BoundPreferenceSelectorModal);
withContext({
  mustHave: 'mustHavePreferences',
  shouldHave: 'shouldHavePreferences',
  onUpdateMustHave: 'onUpdateMustHave',
  onUpdateShouldHave: 'onUpdateShouldHave'
})(TransformedModal);

const add = major => internal => ({
  academics: uniqBy([...internal.academics, {
    major
  }], academic => academic.focus || academic.major)
});

const updater = function (apiPreferences) {
  for (var _len = arguments.length, alterations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    alterations[_key - 1] = arguments[_key];
  }
  const internal = reduce(alterations, (internal, alteration) => ({
    ...internal,
    ...alteration(internal)
  }), api2internal(apiPreferences));
  return internal2api(internal);
};
updater.addMajor = add;

const translateLocation = (fieldName, data, draft) => {
    const dataLocationField = get$1(data, fieldName, []);
    dataLocationField.forEach((value) => {
        draft[fieldName].push(value);
    });
};
// transformer for input of location
const inputLocation = (data, draft) => {
    const Location = get$1(data, 'Location', []);
    if (!isEmpty$1(Location)) {
        draft.Location = [];
        draft.LocationCategory = [];
        draft.State = [];
        Location.forEach((location) => {
            if (!isEmpty$1(location.Location))
                draft.Location.push(location.Location);
            if (!isEmpty$1(location.LocationCategory))
                translateLocation('LocationCategory', location, draft);
            if (!isEmpty$1(location.State))
                translateLocation('State', location, draft);
        });
    }
};
// transformer for input of ScoirApply
const inputScoirApply = (data, draft) => {
    const scoirApplyEnabled = get$1(data, 'ScoirApplyEnabled', []);
    if (!isEmpty$1(scoirApplyEnabled)) {
        draft.ScoirApplyApplicantTypes = [];
        if (scoirApplyEnabled.includes('T')) {
            draft.ScoirApplyApplicantTypes.push('first');
        }
        delete draft.ScoirApplyEnabled;
    }
};
// transformer for input of ApplicantInfo
const inputApplicantInfo = (data, draft) => {
    const applicationMethod = get$1(data, 'ApplicantInfo', []);
    if (!isEmpty$1(applicationMethod)) {
        const usedAppMethods = {};
        const usedTestOptional = {};
        draft.ApplicationMethod = [];
        draft.TestOptional = [];
        applicationMethod.forEach((info) => {
            const method = get$1(info, 'ApplicationMethod', []);
            method.forEach((value) => {
                if (usedAppMethods[value])
                    return;
                usedAppMethods[value] = true;
                draft.ApplicationMethod.push(value);
            });
            const testOptional = get$1(info, 'TestOptional', '').replace('Y', 'T').replace('N', 'F');
            if (testOptional && !usedTestOptional[testOptional])
                draft.TestOptional.push(testOptional);
        });
        delete draft.ApplicantInfo;
    }
};
// transformer for input of TestsAndSelectivity
const inputTestsAndSelectivity = (data, draft) => {
    const TestsAndSelectivity = get$1(data, 'TestsAndSelectivity', []);
    if (!isEmpty$1(TestsAndSelectivity)) {
        const Selectivity = get$1(TestsAndSelectivity, '[0].Selectivity');
        const SATAvg = get$1(TestsAndSelectivity, '[0].SATAvg');
        const ACTAvg = get$1(TestsAndSelectivity, '[0].ACTAvg');
        if (SATAvg) {
            draft.SATAvg = [SATAvg];
        }
        if (ACTAvg) {
            draft.ACTAvg = [ACTAvg];
        }
        if (Selectivity) {
            draft.Selectivity = [Selectivity];
        }
        delete draft.TestsAndSelectivity;
    }
};
/*
  This function is used to transform the input data to the format that the SelectorContextProvider expects.
  NOTE: If you add a transformer here, one is probably also needed for the output, to transform it back to the original format.
*/
const useInputTransform = (data) => {
    return useMemo(() => {
        return produce(data, (draft) => {
            /* TRANSFORMERS BEGIN */
            inputLocation(data, draft);
            inputScoirApply(data, draft);
            inputApplicantInfo(data, draft);
            inputTestsAndSelectivity(data, draft);
            /* TRANSFORMERS END */
        });
    }, [data]);
};

const outputLocation = (data, draft) => {
    const value = get$1(data, 'Location', []);
    const firstLocation = head$1(value);
    const restOfLocations = value.slice(1);
    draft.Location = reject$1([
        {
            Location: firstLocation,
            LocationCategory: data.LocationCategory,
            State: data.State,
        },
        ...restOfLocations.map((Location) => ({
            Location,
            LocationCategory: [],
            State: [],
        })),
    ], (current) => {
        const location = isEmpty$1(current.Location) || isNull$1(current.Location);
        const category = isEmpty$1(current.LocationCategory) || isNull$1(current.LocationCategory);
        const state = isEmpty$1(current.State) || isNull$1(current.State);
        return location && category && state;
    });
    delete draft.State;
    delete draft.LocationCategory;
};
const outputScoirApply = (data, draft) => {
    const appTypes = get$1(data, 'ScoirApplyApplicantTypes', []);
    const scoirApplyEnabled = appTypes.includes('first');
    const scoirApplyTransfer = appTypes.includes('transfer');
    if (scoirApplyEnabled || scoirApplyTransfer) {
        draft.ScoirApplyEnabled = ['T'];
    }
    else {
        delete draft.ScoirApplyEnabled;
    }
    delete draft.ScoirApplyApplicantTypes;
};
const outputApplicantInfo = (data, draft) => {
    draft.ApplicantInfo = [];
    const applicationMethod = get$1(data, 'ApplicationMethod', []);
    const testOptional = get$1(data, 'TestOptional', []);
    testOptional.forEach((testOpt) => {
        draft.ApplicantInfo.push({
            TestOptional: testOpt === 'T' ? 'Y' : 'N',
            ApplicationMethod: applicationMethod,
        });
    });
    delete draft.ApplicationMethod;
    delete draft.TestOptional;
};
const outputTestsAndSelectivity = (data, draft) => {
    const Selectivity = head$1(get$1(data, 'Selectivity', []));
    const SATAvg = head$1(get$1(data, 'SATAvg', []));
    const ACTAvg = head$1(get$1(data, 'ACTAvg', []));
    if (!Selectivity && !SATAvg && !ACTAvg) {
        draft.TestsAndSelectivity = [];
    }
    else {
        draft.TestsAndSelectivity = [
            {
                Selectivity,
                SATAvg,
                ACTAvg,
            },
        ];
    }
    delete draft.SATAvg;
    delete draft.ACTAvg;
    delete draft.SelectivityLevel;
    delete draft.Selectivity;
    delete draft.AcceptanceLikelihood;
};
/*
  This function is used to transform the input data to the format that the SelectorContextProvider expects.
  NOTE: If you add a transformer here, one is probably also needed for the output, to transform it back to the original format.
*/
const useOutputTransform = (onUpdatePreferences) => {
    return useCallback((data) => {
        const output = produce(data, (draft) => {
            /* TRANSFORMERS BEGIN */
            outputLocation(data, draft);
            outputScoirApply(data, draft);
            outputApplicantInfo(data, draft);
            outputTestsAndSelectivity(data, draft);
            /* TRANSFORMERS END */
        });
        onUpdatePreferences(output);
    }, [onUpdatePreferences]);
};

const { Body, Footer } = DismissibleDialog;
const p = (y, x, theme) => `${theme.spacing(y)}px ${theme.spacing(x)}px`;
const useStyles = makeStyles((theme) => {
    const xs = theme.breakpoints.down('xs');
    return {
        modal: {
            maxWidth: '640px',
            [xs]: {
                '&.MuiDialog-paperWidthSm.MuiDialog-paperScrollBody': {
                    maxWidth: '100vw !important',
                },
                maxWidth: '100vw',
                width: '100vw',
                height: '100vh',
                margin: 0,
            },
        },
        body: {
            maxHeight: 'calc(100vh - 250px)',
            padding: p(1, 3, theme),
            [xs]: {
                padding: p(0, 2, theme),
                maxHeight: 'calc(100vh - 140px)',
            },
            '&:first-child': {
                paddingTop: theme.spacing(1),
                [xs]: {
                    paddingTop: theme.spacing(0),
                },
            },
        },
    };
});
const EditPreferencesModal = ({ open, onClose, facets, preferences, onUpdatePreferences, acceptanceLikelihoodLabels, collegeMatchLevel, selectivityLabels, supportsAcceptanceLikelihoodFilters, tntSearchFilterEnabled, onAcademicMajorsSearch, onAcademicFocusesKeywordSearch, onLocationSearch, onTagsSearch, onAllTagsSearch, onSportSearch, displayScoirApplyIcon, }) => {
    const classes = useStyles();
    const data = useInputTransform(preferences);
    const onUpdate = useOutputTransform(onUpdatePreferences);
    return (jsxs(DismissibleDialog, Object.assign({ open: open, onClose: onClose, classes: { paperScrollBody: classes.modal }, headerText: "Edit Preferences" }, { children: [jsx(Body, Object.assign({ withBackgroundColor: true, classes: { root: classes.body } }, { children: jsx(Box$1, Object.assign({ mt: 2 }, { children: jsxs(SelectorContextProvider, Object.assign({ data: data, facets: facets, onUpdateData: onUpdate, apiCalls: {
                            onAcademicMajorsSearch,
                            onAcademicFocusesKeywordSearch,
                            onLocationSearch,
                            onTagsSearch,
                            onAllTagsSearch,
                            onSportSearch,
                        }, displayScoirApplyIcon: displayScoirApplyIcon, acceptanceLikelihoodLabels: acceptanceLikelihoodLabels, collegeMatchLevel: collegeMatchLevel, selectivityLabels: selectivityLabels, supportsAcceptanceLikelihoodFilters: supportsAcceptanceLikelihoodFilters }, { children: [jsx(Section, Object.assign({ title: DISPLAY_TEXT.AcademicFocus.Title, subTitle: DISPLAY_TEXT.AcademicFocus.Description }, { children: jsx(AcademicFocus, {}) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.Degrees.Title }, { children: jsx(DegreesSelector, { tntSearchFilterEnabled: tntSearchFilterEnabled }) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.UnderGradEnroll.Title, subTitle: DISPLAY_TEXT.UnderGradEnroll.Description }, { children: jsx(SchoolSizeSelector, {}) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.Setting.Title }, { children: jsx(SettingSelector, {}) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.Distance.Title }, { children: jsx(DistanceSelector, { addFirstButtonLabel: "Add Preference" }) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.Location.Title }, { children: jsx(LocationSelector, {}) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.Admissions.Title }, { children: jsx(AdmissionsSelector, { legacySelectivity: true, hideSelectivitySubheader: true }) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.ApplicationMethod.Title }, { children: jsx(ApplicationMethodSelector, { common: false, testOptional: false, transfer: false }) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.SchoolType.Title }, { children: jsx(SchoolType, {}) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.Sports.Title }, { children: jsx(AthleticsSelector, { addFirstButtonLabel: "Add Preference" }) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.Tags.Title }, { children: jsx(PersonalInterest, {}) })), jsx(Section, Object.assign({ title: DISPLAY_TEXT.Rotc.Title, subTitle: DISPLAY_TEXT.Rotc.Description }, { children: jsx(Rotc, {}) }))] })) })) })), jsx(Box$1, Object.assign({ width: "100%" }, { children: jsx(Footer, { children: jsx(Box$1, Object.assign({ display: "flex", justifyContent: "flex-end", width: "100%" }, { children: jsx(Button$1, Object.assign({ onClick: onClose, color: "primary", variant: "contained" }, { children: "Done" })) })) }) }))] })));
};

const PreferencesProvider = Provider;
const PreferencesWithContext = withContext({
  mustHave: 'mustHavePreferences',
  shouldHave: 'shouldHavePreferences',
  onUpdateMustHave: 'onUpdateMustHave',
  onUpdateShouldHave: 'onUpdateShouldHave'
})(CollegePreferences$1);
const Preferences = props => /*#__PURE__*/React.createElement(PreferencesWithContext, props);
const preferenceUpdater = updater;

export { ResultTile as AbstractCollegeResultTile, AbstractCollegeSearch, ApiContextProvider, CURRENT_USER, ChipSelector, CollegeSearchProvider, Context$3 as Context, Dropdown, EditPreferencesModal, FilterBarWithSort, PREFERENCE_TYPES, Preferences, PreferencesProvider, Results, SearchContextProvider, SelectableIconChips, index as Selectors, icons as academicFocusIcons, getDefaultQuery, mapData, preferenceDisplayHelper, preferenceUpdater };
//# sourceMappingURL=index.module.js.map
